export const textIdentifier = {
  "Untitled": {
    "arabic": "بدون عنوان",
    "az": "Başlıqsız",
    "chinese": "無標題",
    "eng": "Untitled",
    "hindi": "शीर्षकहीन",
    "ja": "タイトルなし",
    "jp": null,
    "ky": "Аталышы жок",
    "ru": "Без названия",
    "uz": "Sarlavhasiz",
    "viet": "Không có tiêu đề"
  },
  "study-material": {
    "arabic": "مواد دراسية",
    "az": "Tədris materialı",
    "chinese": "学习材料",
    "eng": "Study Material",
    "hindi": "अध्ययन सामग्री",
    "ja": "学習教材",
    "jp": null,
    "ky": "Окуу материалы",
    "ru": "Учебный материал",
    "uz": "O'quv materiali",
    "viet": "Tài liệu học tập"
  },
  "Search-the-Teacher(s)-by-Email-ID": {
    "arabic": "ابحث عن المعلم(ين) عن طريق معرف البريد الإلكتروني",
    "az": "E-poçt ID-si ilə Müəllim(ləri) axtarın",
    "chinese": "通过电子邮件ID搜索教师",
    "eng": "Search the Teacher(s) by Email ID",
    "hindi": "ईमेल आईडी द्वारा शिक्षकों की खोज करें",
    "ja": "メールIDで先生を検索",
    "jp": null,
    "ky": "Мугалим(дерди) электрондук почта ID аркылуу издеңиз",
    "ru": "Поиск учителя(ей) по идентификатору электронной почты",
    "uz": "O'qituvchilarni elektron pochta IDsi bo'yicha qidiring",
    "viet": null
  },
  "Search-teacher(s)-by-email-ID-to-add-them-to-this-class": {
    "arabic": "ابحث عن المعلم(ين) عن طريق معرف البريد الإلكتروني لإضافتهم إلى هذه الفئة",
    "az": "Müəllim(ləri) bu sinfə əlavə etmək üçün e-poçt ID-si ilə axtarın",
    "chinese": "通过电子邮件ID搜索教师以将他们添加到此班级",
    "eng": "Search teacher(s) by email ID to add them to this class",
    "hindi": "उन्हें इस कक्षा में जोड़ने के लिए ईमेल आईडी से शिक्षकों की खोज करें",
    "ja": "このクラスに追加するためにメールIDで先生を検索",
    "jp": null,
    "ky": "Мугалимдерди(-лерди) бул класска кошуу үчүн электрондук почта ID аркылуу издеңиз",
    "ru": "Найдите учителя(ей) по идентификатору электронной почты, чтобы добавить их в этот класс.",
    "uz": "Ularini bu sinfga qo'shish uchun elektron pochta IDsi bo'yicha o'qituvchilarni qidiring",
    "viet": null
  },
  "are-you-sure-you-want-to-delete-these-classes": {
    "arabic": "هل أنت متأكد أنك تريد حذف هذه الفئات؟",
    "az": "Bu sinif silmək ist ədiyinizdən əminsiniz?",
    "chinese": "您确定要删除这些班级吗？",
    "eng": "Are you sure you want to delete these classes?",
    "hindi": "क्या आप वाकई इन कक्षाओं को हटाना चाहते हैं?",
    "ja": "これらのクラスを削除してもよろしいですか？",
    "jp": null,
    "ky": "Бул класстарды чын эле жок кылгыңыз келеби?",
    "ru": "Вы уверены, что хотите удалить эти классы?",
    "uz": "Ushbu sinflarni o'chirishga ishonchingiz komilmi?",
    "viet": "Bạn có chắc chắn muốn xóa các lớp này không?"
  },
  "remove_class_failed": {
    "arabic": "لا يمكنك حذف هذا الفصل إما لأنك لست منشئه أو لأن الطلاب/المعلمين مسجلين بالفعل.",
    "az": "Siz bu sinifi silə bilməzsiniz, çünki ya siz yaradıcı deyilsiniz, ya da tələbələr/müəllimlər artıq qeydiyyatdan keçiblər.",
    "chinese": "您无法删除此班级，因为您不是创建者，或者学生/老师已经注册。",
    "eng": "You cannot delete this class as either you aren’t the creator or students/teachers are already enrolled.",
    "hindi": "आप इस कक्षा को हटा नहीं सकते क्योंकि या आप निर्माता नहीं हैं या छात्र / शिक्षक पहले से ही नामांकित हैं।",
    "ja": "このクラスを削除できません。作成者ではないか、すでに学生/教師が登録されているためです。",
    "jp": null,
    "ky": "Сиз бул классты жок кыла албайсыз, анткени сиз түзүүчү эмессиз же студенттер/мугалимдер мурунтан эле катталган.",
    "ru": "Вы не можете удалить этот класс, так как вы не являетесь создателем или студенты/учителя уже зарегистрированы.",
    "uz": "Siz bu sinfni o'chira olmaysiz, chunki yaratuvchi emassiz yoki o'qituvchilar allaqachon ro'yxatdan o'tgan.",
    "viet": "Bạn không thể xóa lớp này vì bạn không phải là người tạo hoặc học sinh/giáo viên đã đăng ký."
  },
  "the-selected-class-is-successfully-deleted": {
    "arabic": "تم حذف الفصل المحدد بنجاح",
    "az": "Seçilmiş sinif uğurla silindi",
    "chinese": "所选班级已成功删除",
    "eng": "The selected class is successfully deleted",
    "hindi": "चयनित कक्षा सफलतापूर्वक हटा दी गई है",
    "ja": "選択したクラスは正常に削除されました",
    "jp": null,
    "ky": "Тандалган класс ийгиликтүү жок кылынды",
    "ru": "Выбранный класс успешно удален",
    "uz": "Tanlangan sinf muvaffaqiyatli o'chirildi",
    "viet": "Lớp đã chọn đã được xóa thành công"
  },
  "teacher": {
    "arabic": "مدرس",
    "az": "müəllim",
    "chinese": "老师",
    "eng": "Teacher",
    "hindi": "शिक्षक",
    "ja": "先生",
    "jp": null,
    "ky": "Мугалим",
    "ru": "Учитель",
    "uz": "O'qituvchi",
    "viet": "Giáo viên"
  },
  "teacher-guide": {
    "arabic": "دليل المعلم",
    "az": "Müəllim üçün bələdçi",
    "chinese": "老师指南",
    "eng": "Teacher Guide",
    "hindi": "शिक्षक मार्गदर्शिका",
    "ja": "先生ガイド",
    "jp": null,
    "ky": "Мугалим үчүн колдонмо",
    "ru": "Руководство для учителя",
    "uz": "O'qituvchi qo'llanma",
    "viet": "Hướng dẫn giáo viên"
  },
  "teachers-in": {
    "arabic": "المعلمون في",
    "az": "Müəllimlər daxil",
    "chinese": "老师在",
    "eng": "Teachers in",
    "hindi": "शिक्षकों में",
    "ja": "先生は",
    "jp": null,
    "ky": "Мугалимдер",
    "ru": "Учителя в",
    "uz": "O'qituvchilar",
    "viet": "Giáo viên ở"
  },
  "add-existing-teacher": {
    "arabic": "إضافة معلم موجود",
    "az": "Mövcud Müəllimi əlavə edin",
    "chinese": "添加现有老师",
    "eng": "Add Existing Teacher",
    "hindi": "मौजूदा शिक्षक जोड़ें",
    "ja": "既存の先生を追加",
    "jp": null,
    "ky": "Учурдагы Мугалимди кошуу",
    "ru": "Добавить существующего учителя",
    "uz": "Mavjud o'qituvchini qo'shish",
    "viet": "Thêm giáo viên hiện có"
  },
  "add-teacher": {
    "arabic": "إضافة معلم",
    "az": "Müəllim əlavə edin",
    "chinese": "添加老師",
    "eng": "Add Teacher",
    "hindi": "शिक्षक जोड़ें",
    "ja": "先生を追加",
    "jp": null,
    "ky": "Мугалим кошуу",
    "ru": "Добавить учителя",
    "uz": "O‘qituvchi qo‘shish",
    "viet": "Thêm giáo viên"
  },
  "add-teachers-using-excel": {
    "arabic": "إضافة المعلمين باستخدام Excel",
    "az": "Excel istifadə edərək Müəllimlər əlavə edin",
    "chinese": "使用Excel添加老师",
    "eng": "Add Teachers using Excel",
    "hindi": "Excel द्वारा शिक्षक जोड़ें",
    "ja": "Excelを使用して先生を追加",
    "jp": null,
    "ky": "Мугалимдерди Excel аркылуу кошуу",
    "ru": "Добавить учителей с помощью Excel",
    "uz": "O'qituvchilarni Excel yordamida qo'shish",
    "viet": "Thêm giáo viên bằng cách sử dụng Excel"
  },
  "add-teacher(s)-to-this-class": {
    "arabic": "أضف مدرسين إلى هذه الفئة",
    "az": "Bu sinfə Müəllimlər əlavə edin",
    "chinese": "将老师添加到这个班级",
    "eng": "Add Teachers to this class",
    "hindi": "इस कक्षा में शिक्षक (या शिक्षकों) जोड़ें",
    "ja": "このクラスに先生（複数）を追加",
    "jp": null,
    "ky": "Бул класска Мугалимдерди кошуңуз",
    "ru": "Добавить учителей к этому классу",
    "uz": "Ushbu sinfga O'qituvchilarni qo'shish",
    "viet": "Thêm giáo viên (hoặc giáo viên) vào lớp này"
  },
  "add-teachers": {
    "arabic": "إضافة المعلمين",
    "az": "Müəllimlər əlavə edin",
    "chinese": "添加老师",
    "eng": "Add Teachers",
    "hindi": "शिक्षक जोड़ें",
    "ja": "先生を追加",
    "jp": null,
    "ky": "Класска мугалим кошуу",
    "ru": "Добавить учителей",
    "uz": "O‘qituvchilarni qo‘shish",
    "viet": "Thêm giáo viên"
  },
  "submissions": {
    "arabic": "التقديمات",
    "az": "Təqdimatlar",
    "chinese": "提交",
    "eng": "Submissions",
    "hindi": "प्रस्तुत",
    "ja": "提出する",
    "jp": null,
    "ky": "Тапшыруулар",
    "ru": "Представления",
    "uz": "Taqdimotlar",
    "viet": "Nộp"
  },
  "also-email-credential-to-student": {
    "arabic": "قم أيضًا بإرسال بيانات الاعتماد بالبريد الإلكتروني إلى الطالب",
    "az": "Həmçinin tələbəyə e-poçt etimadnaməsini göndərin",
    "chinese": "也向学生发送凭证",
    "eng": "Also email credential to student",
    "hindi": "छात्र को भी प्रमाणपत्र ईमेल करें",
    "ja": "学生にも資格情報をメールで送信",
    "jp": null,
    "ky": "Ошондой эле студентке электрондук почта",
    "ru": "Также отправьте электронное письмо с данными для подтверждения личности студента",
    "uz": "Shuningdek, o‘quvchi elektron pochta manzili",
    "viet": "Gửi email chứng chỉ cho học sinh"
  },
  "also-email-credential-to-teacher": {
    "arabic": "قم أيضًا بإرسال بيانات الاعتماد عبر البريد الإلكتروني إلى المعلم",
    "az": "Etibarnaməni də müəllimə göndərin",
    "chinese": "也向老师发送凭证",
    "eng": "Also email Credential to teacher",
    "hindi": "शिक्षक को भी प्रमाणपत्र ईमेल करें",
    "ja": "先生にも資格情報をメールで送信",
    "jp": null,
    "ky": "Сырсөздү мугалимге да электрондук кат аркылуу жөнөтүү",
    "ru": "Также отправьте учетные данные учителю по электронной почте",
    "uz": "O'qituvchiga ham akkreditatsiyani yuboring",
    "viet": "Gửi email chứng chỉ cho giáo viên"
  },
  "download": {
    "arabic": "تحميل",
    "az": "Yüklə",
    "chinese": "下载",
    "eng": "Download",
    "hindi": "डाउनलोड",
    "ja": "ダウンロード",
    "jp": null,
    "ky": "Жүктөп алуу",
    "ru": "Скачать",
    "uz": "Yuklab olish",
    "viet": "Tải xuống"
  },
  "initiated-download": {
    "arabic": "تم البدء في التنزيل",
    "az": "Yükləmə başladı",
    "chinese": "开始下载",
    "eng": "Initiated download",
    "hindi": "डाउनलोड प्रारंभ किया",
    "ja": "ダウンロードを開始しました",
    "jp": null,
    "ky": "Жүктөө башталды",
    "ru": "Начата загрузка",
    "uz": "Yuklab olish boshlandi",
    "viet": "Khởi tạo tải xuống"
  },
  "choose-file-and-upload": {
    "arabic": "اختر الملف وقم بتحميله",
    "az": "Fayl və Yüklə seçin",
    "chinese": "選擇文件並上傳",
    "eng": "Choose File and Upload",
    "hindi": "फ़ाइल चुनें और अपलोड करें",
    "ja": "ファイルを選択してアップロード",
    "jp": null,
    "ky": "Файлды тандап, жүктөө",
    "ru": "Выберите Файл и Загрузить",
    "uz": "Faylni tanlang va yuklang",
    "viet": "Chọn tệp và tải lên"
  },
  "download-the-spreadsheet-student-onboarding": {
    "arabic": "قم بتنزيل ملف Excel المقدم من Cerebry واملأ تفاصيل الطالب.",
    "az": "Cerebry tərəfindən təqdim olunan excel faylını endirin və şagird məlumatlarını doldurun.",
    "chinese": "下载Cerebry提供的Excel文件并填写学生详细信息。",
    "eng": "Download the excel file provided by Cerebry and fill up the student details.",
    "hindi": "Cerebry द्वारा प्रदान की गई एक्सेल फ़ाइल डाउनलोड करें और छात्र विवरण भरें।",
    "ja": "Cerebryが提供するExcelファイルをダウンロードして、学生の詳細を入力してください。",
    "jp": null,
    "ky": "Cerebry сунуштаган Excel файлын жүктөп, окуучулардын маалыматтарын толтуруңуз.",
    "ru": "Загрузите файл Excel, предоставленный Cerebry, и заполните данные о студенте.",
    "uz": "Cerebry tomonidan taqdim etilgan Excel faylini yuklab oling va o‘quvchi ma'lumotlarini to'ldiring.",
    "viet": "Tải xuống tệp excel do Cerebry cung cấp và điền thông tin học sinh."
  },
  "download-the-template": {
    "arabic": "تنزيل القالب",
    "az": "Şablonu yükləyin",
    "chinese": "下载模板",
    "eng": "Download the template",
    "hindi": "टेम्पलेट डाउनलोड करें",
    "ja": "テンプレートをダウンロード",
    "jp": null,
    "ky": "Шаблонду жүктөө",
    "ru": "Загрузить шаблон",
    "uz": "Shablonni yuklab oling",
    "viet": "Tải xuống mẫu"
  },
  "uploading...": {
    "arabic": "جاري التحميل...",
    "az": "Yüklənir...",
    "chinese": "上传中...",
    "eng": "Uploading...",
    "hindi": "अपलोड हो रहा है...",
    "ja": "アップロード中...",
    "jp": null,
    "ky": "Жүктөлүүдө...",
    "ru": "Загрузка...",
    "uz": "Yuklanmoqda...",
    "viet": "Đang tải lên..."
  },
  "upload-the-spreadsheet-student-onboarding": {
    "arabic": "قم بإدخال تفاصيل الطلاب كما هو محدد في قالب Excel ثم قم برفع الملف.",
    "az": "Excel şablonunda göstərildiyi kimi tələbələrin təfərrüatlarını daxil edin və sonra faylı yükləyin.",
    "chinese": "按照Excel模板中指定的方式输入学生详细信息，然后上传文件。",
    "eng": "Enter the students' details as specified in the Excel template and then upload the file.",
    "hindi": "एक्सेल टेम्पलेट में निर्दिष्ट छात्रों की जानकारी दर्ज करें और फिर फ़ाइल अपलोड करें।",
    "ja": "Excelテンプレートで指定された学生の詳細を入力してからファイルをアップロードしてください。",
    "jp": null,
    "ky": "Excel шаблонунда көрсөтүлгөндөй окуучулардын маалыматтарын киргизип, файлды жүктөңүз.",
    "ru": "Введите данные студентов, как указано в шаблоне Excel, а затем загрузите файл.",
    "uz": "Excel shablonida ko'rsatilgan talabalar ma'lumotlarini kiriting va so'ng faylni yuklang.",
    "viet": "Nhập thông tin học sinh theo yêu cầu trong mẫu Excel và sau đó tải lên tệp."
  },
  "upload-the-spreadsheet-teacher-onboarding": {
    "arabic": "قم بإدخال بيانات المعلمين كما هو محدد في قالب Excel ثم قم برفع الملف.",
    "az": "Excel şablonunda göstərildiyi kimi müəllimlərin təfərrüatlarını daxil edin və sonra faylı yükləyin.",
    "chinese": "按照Excel模板中指定的方式输入老师详细信息，然后上传文件。",
    "eng": "Enter the teachers' details as specified in the Excel template and then upload the file.",
    "hindi": "एक्सेल टेम्पलेट में निर्दिष्ट शिक्षकों की जानकारी दर्ज करें और फिर फ़ाइल अपलोड करें।",
    "ja": "Excelテンプレートで指定された先生の詳細を入力してからファイルをアップロードしてください。",
    "jp": null,
    "ky": "Excel шаблонунда көрсөтүлгөндөй мугалимдердин маалыматтарын киргизип, файлды жүктөңүз.",
    "ru": "Введите данные учителей, как указано в шаблоне Excel, а затем загрузите файл.",
    "uz": "Excel shablonida ko'rsatilgan o'qituvchilar ma'lumotlarini kiriting va so'ng faylni yuklang.",
    "viet": "Nhập thông tin giáo viên theo yêu cầu trong mẫu Excel và sau đó tải lên tệp."
  },
  "upload-the-spreadsheet-student-onboarding-submessage": {
    "arabic": "بعد تحميل الملف, سوف تتلقى رسالة بريد إلكتروني تحتوي على معلومات الطالب وبيانات الاعتماد التي تم إنشاؤها.",
    "az": "Faylı yüklədikdən sonra şagird məlumatları və yaradılan giriş məlumatlarını ehtiva edən e-poçt alacaqsınız.",
    "chinese": "上传文件后，您将收到一封电子邮件，其中包含学生信息和生成的凭证。",
    "eng": "After uploading the file, you will receive an email with student information and generated credentials.",
    "hindi": "फ़ाइल अपलोड करने के बाद, आपको एक ईमेल मिलेगा जिसमें छात्र जानकारी और उत्पन्न क्रेडेंशियल होगा।",
    "ja": "ファイルをアップロードすると、学生情報と生成された資格情報が記載されたメールが届きます。",
    "jp": null,
    "ky": "Файлды жүктөгөндөн кийин, окуучунун маалыматы жана түзүлгөн сырсөздөр менен электрондук кат аласыз.",
    "ru": "После загрузки файла вы получите электронное письмо с информацией о студенте и сгенерированными учетными данными.",
    "uz": "Fayl yuklangandan so‘ng, o‘quvchining shaxsiy ma’lumotlari va hisob ma’lumotlari ko‘rsatilgan elektron pochta xabari yuboriladi.",
    "viet": "Sau khi tải lên tệp, bạn sẽ nhận được một email với thông tin học sinh và thông tin đăng nhập được tạo ra."
  },
  "upload-the-spreadsheet-teacher-onboarding-submessage": {
    "arabic": "بعد تحميل الملف, سوف تتلقى رسالة بريد إلكتروني تحتوي على معلومات المعلم وبيانات الاعتماد التي تم إنشاؤها.",
    "az": "Faylı yüklədikdən sonra sizə müəllim məlumatları və yaradılan etimadnamələri ilə e-poçt məktubu göndəriləcək.",
    "chinese": "上传文件后，您将收到一封电子邮件，其中包含老师信息和生成的凭证。",
    "eng": "After uploading the file, you will receive an email with teacher information and generated credentials.",
    "hindi": "फ़ाइल अपलोड करने के बाद, आपको एक ईमेल मिलेगा जेक में शिक्षक जानकारी और उत्पन्न क्रेडेंशियल होगा।",
    "ja": "ファイルをアップロードすると、先生情報と生成された資格情報が記載されたメールが届きます。",
    "jp": null,
    "ky": "Файлды жүктөгөндөн кийин, сиз мугалимдин маалыматы жана түзүлгөн ишеним грамоталары менен электрондук кат аласыз.",
    "ru": "После загрузки файла вы получите электронное письмо с информацией об учителе и сгенерированными учетными данными.",
    "uz": "Faylni yuklagandan so'ng, o'qituvchi ma'lumotlari va yaratilgan hisob ma'lumotlari bilan elektron pochta xabarini olasiz.",
    "viet": "Sau khi tải lên tệp, bạn sẽ nhận được một email với thông tin giáo viên và thông tin đăng nhập được tạo ra."
  },
  "success-spreadsheet-student-onboarding": {
    "arabic": "تم تحميل الملف بنجاح.",
    "az": "Fayl uğurla yükləndi.",
    "chinese": "文件上传成功。",
    "eng": "File uploaded successfully.",
    "hindi": "फ़ाइल सफलतापूर्वक अपलोड हुई।",
    "ja": "ファイルのアップロードに成功しました。",
    "jp": null,
    "ky": "Файл ийгиликтүү жүктөлдү",
    "ru": "Файл успешно загружен.",
    "uz": "Fayl muvaffaqiyatli yuklandi.",
    "viet": "Tệp đã được tải lên thành công."
  },
  "success-spreadsheet-teacher-onboarding": {
    "arabic": "تم تحميل الملف بنجاح.",
    "az": "Fayl uğurla yükləndi.",
    "chinese": "文件上传成功。",
    "eng": "File uploaded successfully.",
    "hindi": "फ़ाइल सफलतापूर्वक अपलोड हुई।",
    "ja": "ファイルのアップロードに成功しました。",
    "jp": null,
    "ky": "Файл ийгиликтүү жүктөлдү",
    "ru": "Файл успешно загружен.",
    "uz": "Fayl muvaffaqiyatli yuklandi.",
    "viet": "Tệp đã được tải lên thành công."
  },
  "success-spreadsheet-student-onboarding-submessage": {
    "arabic": "جاري الآن إعداد الطلاب الجدد. سوف تتلقى رسالة بريد إلكتروني قريبًا تتضمن إما",
    "az": "Şagirdlərin qeydiyyatı davam edir. Qısa müddət ərzində ",
    "chinese": "学生入职正在进行中。 您将很快收到一封电子邮件，其中包含",
    "eng": "Student onboarding is in progress. You will receive an email shortly with either",
    "hindi": "छात्र भर्ती प्रगति पर है। आपको जल्द ही एक ईमेल प्राप्त होगा जिसमें",
    "ja": "学生のオンボーディングが進行中です。 すぐにメールが届きます。",
    "jp": null,
    "ky": "Студентке кабыл алуу жүрүп жатат. Бир аздан кийин экөөнө тең электрондук кат аласыз",
    "ru": "Идет процесс приема студентов. Скоро вы получите письмо с",
    "uz": "Talabalarni qabul qilish jarayoni davom etmoqda. Tez orada siz ikkalasi bilan elektron pochta xabarini olasiz",
    "viet": "Quá trình tuyển sinh học sinh đang tiến triển. Bạn sẽ nhận được một email trong thời gian sớm với"
  },
  "success-spreadsheet-teacher-onboarding-submessage": {
    "arabic": "جاري الآن تدريب المعلمين الجدد. سوف تتلقى بريدًا إلكترونيًا قريبًا يتضمن أيًا من",
    "az": "Müəllim qəbulu davam edir. Tezliklə hər ikisi ilə e-poçt alacaqsınız",
    "chinese": "老师入职正在进行中。 您将很快收到一封电子邮件，其中包含",
    "eng": "Teacher onboarding is in progress. You will receive an email shortly with either",
    "hindi": "शिक्षक भर्ती प्रगति पर है। आपको जल्द ही एक ईमेल प्राप्त होगा जिसमें",
    "ja": "先生のオンボーディングが進行中です。 すぐにメールが届きます。",
    "jp": null,
    "ky": "Мугалимдерди кабыл алуу жүрүп жатат. Бир аздан кийин экөөнө тең электрондук кат аласыз",
    "ru": "Идет процесс адаптации учителей. Скоро вы получите письмо с",
    "uz": "O'qituvchilarni qabul qilish jarayoni davom etmoqda. Tez orada siz ikkalasi bilan elektron pochta xabarini olasiz",
    "viet": "Quá trình tuyển sinh giáo viên đang tiến triển. Bạn sẽ nhận được một email trong thời gian sớm với"
  },
  "student-data-and-credentials": {
    "arabic": "بيانات الطالب وبياناته",
    "az": "şagirdlərin giriş məlumatları",
    "chinese": "学生数据和凭据",
    "eng": "student data and credentials",
    "hindi": "छात्र डेटा और क्रेडेंशियल",
    "ja": "学生データと資格情報",
    "jp": null,
    "ky": "студенттин маалыматтары жана ишеним грамоталары",
    "ru": "данные и учетные данные студентов",
    "uz": "O‘quvchi ma'lumotlari va hisob ma'lumotlari",
    "viet": "Dữ liệu học sinh và thông tin đăng nhập"
  },
  "teacher-data-and-credentials": {
    "arabic": "بيانات المعلم ومؤهلاته",
    "az": "müəllim məlumatları və etimadnamələri",
    "chinese": "教师数据和凭据",
    "eng": "teacher data and credentials",
    "hindi": "शिक्षक डेटा और क्रेडेंशियल",
    "ja": "先生データと資格情報",
    "jp": null,
    "ky": "мугалимдердин маалыматтары жана ишеним грамоталары",
    "ru": "Данные и учетные данные учителя",
    "uz": "o'qituvchi ma'lumotlari va hisob ma'lumotlari",
    "viet": "Dữ liệu giáo viên và thông tin đăng nhập"
  },
  "error-details-in-file": {
    "arabic": "تفاصيل الخطأ في الملف",
    "az": "fayldakı xəta təfərrüatları",
    "chinese": "文件中的错误详细信息",
    "eng": "error details in file",
    "hindi": "फ़ाइल में त्रुटि विवरण",
    "ja": "ファイルのエラー詳細",
    "jp": null,
    "ky": "файлдагы ката чоо-жайы",
    "ru": "подробности об ошибке в файле",
    "uz": "fayldagi xato tafsilotlari",
    "viet": "Chi tiết lỗi trong tệp"
  },
  "or": {
    "arabic": "أو",
    "az": "və ya",
    "chinese": "要么",
    "eng": "or",
    "hindi": "या",
    "ja": "または",
    "jp": null,
    "ky": "же",
    "ru": "или",
    "uz": "yoki",
    "viet": "hoặc"
  },
  "add-by-excel-file": {
    "arabic": "إضافة بواسطة ملف Excel",
    "az": "Excel faylı ilə əlavə edin",
    "chinese": "通过Excel文件添加",
    "eng": "Add by Excel File",
    "hindi": "एक्सेल फ़ाइल द्वारा जोड़ें",
    "ja": "Excelファイルで追加",
    "jp": null,
    "ky": "Excel файлы менен кошуу",
    "ru": "Добавить через файл Excel",
    "uz": "Excel formatidagi faylni yuklash orqali qo‘shish",
    "viet": "Thêm bằng tệp excel"
  },
  "continue-with-excel": {
    "arabic": "متابعة مع Excel",
    "az": "Excel ilə davam edin",
    "chinese": "使用Excel继续",
    "eng": "Continue with Excel",
    "hindi": "एक्सेल के साथ जारी रखें",
    "ja": "Excelで続行",
    "jp": null,
    "ky": "Excel менен улантуу",
    "ru": "Продолжить с Excel",
    "uz": "Excel orqali davom etish",
    "viet": "Tiếp tục với Excel"
  },
  "congratulations": {
    "arabic": "مبروك",
    "az": "Təbrik edirik",
    "chinese": "恭喜",
    "eng": "Congratulations",
    "hindi": "बधाई हो",
    "ja": "おめでとうございます",
    "jp": null,
    "ky": "Куттуктайбыз",
    "ru": "Поздравления",
    "uz": "Tabriklaymiz",
    "viet": "Chúc mừng"
  },
  "continue-with-username": {
    "arabic": "متابعة مع اسم المستخدم",
    "az": "İstifadəçi adı ilə davam edin",
    "chinese": "使用用户名继续",
    "eng": "Continue with Username",
    "hindi": "उपयोगकर्ता नाम के साथ जारी रखें",
    "ja": "ユーザー名で続行",
    "jp": null,
    "ky": "Колдонуучу аты менен улантуу",
    "ru": "Продолжить с именем пользователя",
    "uz": "Foydalanuvchi nomi orqali davom etish",
    "viet": "Tiếp tục với Tên người dùng"
  },
  "add-a-class": {
    "arabic": "أضف فصلًا",
    "az": "Sinif əlavə edin",
    "chinese": "添加班级",
    "eng": "Add a class",
    "hindi": "कक्षा जोड़ें",
    "ja": "クラスを追加",
    "jp": null,
    "ky": "Класс кошуу",
    "ru": "Добавить класс",
    "uz": "Sinf qo‘shish",
    "viet": "Thêm lớp học"
  },
  "create-multiple-classes": {
    "arabic": "إنشاء فئات متعددة",
    "az": "Birdən çox sinif yaradın",
    "chinese": "創建多個班級",
    "eng": "Create Multiple Classes",
    "hindi": "एकाधिक कक्षाएं बनाएं",
    "ja": "複数のクラスを作成",
    "jp": null,
    "ky": "Бир нече класс түзүү",
    "ru": "Создать несколько классов",
    "uz": "Bir nechta sinf yaratish",
    "viet": "Tạo nhiều lớp học"
  },
  "create-class(es)": {
    "arabic": "إنشاء فئة(فئات)",
    "az": "Sinif(lər) yaradın",
    "chinese": "创建班级",
    "eng": "Create Class(es)",
    "hindi": "कक्षा (कक्षाएं) बनाएं",
    "ja": "クラスを作成",
    "jp": null,
    "ky": "Класстарды түзүү",
    "ru": "Создать класс(ы)",
    "uz": "Sinf(lar)ni yaratish",
    "viet": "Tạo lớp học"
  },
  "upload-logo-here": {
    "arabic": "قم بتحميل الشعار هنا",
    "az": "Loqotipi Bura Yükləyin",
    "chinese": "在這裡上傳標誌",
    "eng": "Upload Logo Here",
    "hindi": "यहां लोगो अपलोड करें",
    "ja": "画像をアップロードする",
    "jp": null,
    "ky": "Логотипти бул жерге жүктөңүз",
    "ru": "Загрузить логотип здесь",
    "uz": "Logotipni bu yerga yuklang",
    "viet": null
  },
  "minutes-ago": {
    "arabic": "منذ دقائق",
    "az": "dəqiqə əvvəl",
    "chinese": "幾分鐘前",
    "eng": "minutes ago",
    "hindi": "मिनट पहले",
    "ja": "分前",
    "jp": null,
    "ky": "мүнөт мурун",
    "ru": "минут назад",
    "uz": "daqiqa oldin",
    "viet": "phút trước"
  },
  "here-you-allow-student-to-reset-test-and-(n)-represent-number-of-times-you-have-allowed-this-student-to-reset-this-test": {
    "arabic": "هنا تسمح للطالب بإعادة تعيين الاختبار و(n) يمثل عدد المرات التي سمحت فيها لهذا الطالب بإعادة تعيين هذا الاختبار",
    "az": "Burada tələbəyə testi sıfırlamağa icazə verirsiniz və (n) bu tələbəyə bu testi sıfırlamağa icazə verdiyinizin sayını göstərir",
    "chinese": "在這裡，您允許學生重置測試，(n) 代表您允許該學生重置此測試的次數",
    "eng": "Here you allow student to reset test and (n) represent number of times you have allowed this student to reset this test",
    "hindi": "यहां आप छात्र को परीक्षा रीसेट करने की अनुमति देते हैं और (n) इस छात्र को इस परीक्षा को रीसेट करने की अनुमति देने की बार दिखाता है",
    "ja": "ここでは、学生がテストをリセットすることを許可し、(n) はこの学生にこのテストをリセットする回数を許可した回数を表します",
    "jp": null,
    "ky": "Бул жерде сиз студентке тестти баштапкы абалга келтирүүгө уруксат бересиз жана (n) бул студентке бул тестти кайра коюуга канча жолу уруксат бергениңизди билдирет",
    "ru": "Здесь вы разрешаете студенту сбрасывать тест, а (n) представляет количество раз, когда вы разрешали этому студенту сбрасывать этот тест.",
    "uz": "Bu yerda siz o‘quvchi testni qayta oʻrnatishga ruxsat berasiz va (n) bu o‘quvchi testni qayta oʻrnatishga necha marta ruxsat berganingizni bildirasiz",
    "viet": "Ở đây bạn cho phép học viên thiết lập lại bài kiểm tra và (n) đại diện cho số lần bạn đã cho phép học viên này thiết lập lại bài kiểm tra này"
  },
  "these-settings-will-be-applied-to-all-classes-that-are-currently-not-live": {
    "arabic": "سيتم تطبيق هذه الإعدادات على جميع الفصول الدراسية التي ليست نشطة حاليًا",
    "az": "Bu parametrlər hazırda yayımlanmayan bütün siniflərə tətbiq olunacaq",
    "chinese": "这些设置将应用于当前未直播的所有班级",
    "eng": "These settings will be applied to all classes that are currently not live",
    "hindi": "इन सेटिंग्स को वर्तमान में लाइव नहीं होने वाली सभी कक्षाओं पर लागू किया जाएगा",
    "ja": "これらの設定は現在ライブではないすべてのクラスに適用されます",
    "jp": null,
    "ky": "Бул жөндөөлөр учурда иштебей турган бардык класстарга колдонулат",
    "ru": "Эти настройки будут применены ко всем классам, которые в данный момент не активны.",
    "uz": "Bu sozlamalar hozirda mavjud boʻlmagan barcha sinflarga qoʻllaniladi",
    "viet": "Các cài đặt này sẽ được áp dụng cho tất cả các lớp không phải là lớp trực tuyến hiện tại"
  },
  "save-to-all-classes": {
    "arabic": "حفظ في جميع الفصول",
    "az": "Bütün siniflərə qeyd edin",
    "chinese": "保存到所有班级",
    "eng": "Save to all classes",
    "hindi": "सभी कक्षाओं में सहेजें",
    "ja": "すべてのクラスに保存",
    "jp": null,
    "ky": "Бардык класстарга сактоо",
    "ru": "Сохранить для всех классов",
    "uz": "Barcha sinflarga saqlang",
    "viet": ""
  },
  "student-list": {
    "arabic": "قائمة الطلاب",
    "az": "Tələbə siyahısı",
    "chinese": "學生名單",
    "eng": "Student List",
    "hindi": "छात्र सूची",
    "ja": "生徒一覧",
    "jp": null,
    "ky": "Студенттердин тизмеси",
    "ru": "Список студентов",
    "uz": "O‘quvchilar ro‘yxati",
    "viet": "Danh sách học sinh"
  },
  "student-login-id": {
    "arabic": "معرف تسجيل الدخول للطالب",
    "az": "Tələbə Giriş ID",
    "chinese": "學生登錄ID",
    "eng": "Student Login ID",
    "hindi": "छात्र लॉगिन आईडी",
    "ja": "生徒ログインID",
    "jp": null,
    "ky": "Студенттин кирүү ID",
    "ru": "Идентификатор входа студента",
    "uz": "o‘quvchi kirish IDsi",
    "viet": "ID đăng nhập học sinh"
  },
  "login-id": {
    "arabic": "معرف تسجيل الدخول",
    "az": "Giriş ID-si",
    "chinese": "登錄ID",
    "eng": "Login ID",
    "hindi": "लॉगिन आईडी",
    "ja": "ログインID",
    "jp": null,
    "ky": "Кирүү ID",
    "ru": "Логин ID",
    "uz": "Foydalanuvchi nomi",
    "viet": "ID đăng nhập"
  },
  "sync": {
    "arabic": "المزامنة",
    "az": "Sinxronizasiya",
    "chinese": "同步",
    "eng": "Sync",
    "hindi": "सिंक",
    "ja": "最新データを取得",
    "jp": null,
    "ky": "Синхрондоштуруу",
    "ru": "Синхронизировать",
    "uz": "Sinxronlash",
    "viet": "Đồng bộ"
  },
  "hours-ago": {
    "arabic": "منذ ساعات",
    "az": "saat əvvəl",
    "chinese": "幾小時前",
    "eng": "hours ago",
    "hindi": "घंटे पहले",
    "ja": "時間前",
    "jp": null,
    "ky": "саат мурун",
    "ru": "часов назад",
    "uz": "soat oldin",
    "viet": "giờ trước"
  },
  "days-ago": {
    "arabic": "منذ ايام",
    "az": "gün əvvəl",
    "chinese": "幾天前",
    "eng": "days ago",
    "hindi": "दिन पहले",
    "ja": "日前",
    "jp": null,
    "ky": "күн мурун",
    "ru": "дней назад",
    "uz": "kun oldin",
    "viet": "ngày trước"
  },
  "months-ago": {
    "arabic": "منذ أشهر",
    "az": "aylar əvvəl",
    "chinese": "幾個月前",
    "eng": "months ago",
    "hindi": "महीने पहले",
    "ja": "ヶ月前",
    "jp": null,
    "ky": "ай мурун",
    "ru": "несколько месяцев назад",
    "uz": "bir necha oy avval",
    "viet": "tháng trước"
  },
  "hide-details": {
    "arabic": "إخفاء التفاصيل",
    "az": "Detalları gizlədin",
    "chinese": "隱藏細節",
    "eng": "Hide Details",
    "hindi": "विवरण छिपाएं",
    "ja": "詳細を非表示",
    "jp": null,
    "ky": "Деталдарды жашыруу",
    "ru": "Скрыть подробности",
    "uz": "Tafsilotlarni yashirish",
    "viet": "Ẩn chi tiết"
  },
  "show-details": {
    "arabic": "إظهار التفاصيل",
    "az": "Təfərrüatları göstərin",
    "chinese": "顯示細節",
    "eng": "Show Details",
    "hindi": "विवरण दिखाएं",
    "ja": "詳細を表示",
    "jp": null,
    "ky": "Деталдарды көрсөтүү",
    "ru": "Показать подробности",
    "uz": "Tafsilotlarni ko'rsatish",
    "viet": "Hiển thị chi tiết"
  },
  "cerebry-activity": {
    "arabic": "نشاط الدماغ",
    "az": "Serebry Fəaliyyəti",
    "chinese": "Cerebry 活動",
    "eng": "Cerebry Activity",
    "hindi": "सिरेब्री गतिविधि",
    "ja": "Cerebry アクティビティ",
    "jp": null,
    "ky": "Cerebry Activity",
    "ru": "Активность мозга",
    "uz": "Miya faoliyati",
    "viet": "Hoạt động Cerebry"
  },
  "display-in-your-time-zone": {
    "arabic": "العرض في منطقتك الزمنية",
    "az": "Saat qurşağınızda göstərin",
    "chinese": "",
    "eng": "Display in your time zone",
    "hindi": "",
    "ja": "",
    "jp": null,
    "ky": "Убакыт алкагыңызда көрсөтүү",
    "ru": "Отображение в вашем часовом поясе",
    "uz": "Vaqt mintaqangizda ko'rsatish",
    "viet": ""
  },
  "date-time": {
    "arabic": "التاريخ/الوقت",
    "az": "Tarix/Vaxt",
    "chinese": "",
    "eng": "Date/Time",
    "hindi": "",
    "ja": "",
    "jp": null,
    "ky": "Дата/Убакыт",
    "ru": "Дата/Время",
    "uz": "Sana/vaqt",
    "viet": ""
  },
  "location-ip-address": {
    "arabic": "الموقع (عنوان IP)",
    "az": "Məkan (IP ünvanı)",
    "chinese": "",
    "eng": "Location (IP Address)",
    "hindi": "",
    "ja": "",
    "jp": null,
    "ky": "Жайгашкан жери (IP дареги)",
    "ru": "Местоположение (IP-адрес)",
    "uz": "Joylashuv (IP-manzil)",
    "viet": ""
  },
  "browser-mobile-pop3-etc": {
    "arabic": "المتصفح, الهاتف المحمول, POP3, وما إلى ذلك.",
    "az": "Brauzer, Mobil, POP3 və s.",
    "chinese": "",
    "eng": "Browser, Mobile, POP3, etc.",
    "hindi": "",
    "ja": "",
    "jp": null,
    "ky": "Браузер, мобилдик, POP3 ж.б.",
    "ru": "Браузер, мобильный, POP3 и т. д.",
    "uz": "Brauzer, mobil, POP3 va boshqalar.",
    "viet": ""
  },
  "access-type": {
    "arabic": "نوع الوصول",
    "az": "Giriş növü",
    "chinese": "訪問類型",
    "eng": "Access Type",
    "hindi": "पहुंच प्रकार",
    "ja": "アクセスタイプ",
    "jp": null,
    "ky": "Кирүү түрү",
    "ru": "Тип доступа",
    "uz": "Kirish turi",
    "viet": "Loại truy cập"
  },
  "activity": {
    "arabic": "نشاط",
    "az": "Fəaliyyət",
    "chinese": "活動",
    "eng": "Activity",
    "hindi": "गतिविधि",
    "ja": "アクティビティ",
    "jp": null,
    "ky": "Активдүүлүк",
    "ru": "Активность",
    "uz": "Faoliyat",
    "viet": "Hoạt động"
  },
  "for": {
    "arabic": "ل",
    "az": "üçün",
    "chinese": "为",
    "eng": "for",
    "hindi": "के लिए",
    "ja": "に",
    "jp": null,
    "ky": "үчүн",
    "ru": "для",
    "uz": "uchun",
    "viet": "cho"
  },
  "The-question-displayed-may-not-be-the-actual-question-variant-that-appeared-for-the-student": {
    "arabic": "قد لا يكون السؤال المعروض هو السؤال الفعلي الذي ظهر للطالب",
    "az": "Göstərilən sual tələbə üçün görünən faktiki sual variantı olmaya bilər",
    "chinese": "显示的问题可能不是为学生显示的实际问题变体",
    "eng": "The question displayed may not be the actual question variant that appeared for the student",
    "hindi": "प्रदर्शित प्रश्न छात्र के लिए प्रदर्शित वास्तविक प्रश्न प्रकार नहीं हो सकता है",
    "ja": "表示される質問は、生徒に対して表示された実際の質問のバリエーションではない可能性があります。",
    "jp": null,
    "ky": "Көрсөтүлгөн суроо студент үчүн пайда болгон чыныгы суроонун варианты болбошу мүмкүн",
    "ru": "Отображаемый вопрос может не соответствовать фактическому варианту вопроса, который появился у студента.",
    "uz": "Ko'rsatilgan savol o‘quvchi uchun paydo bo'lgan haqiqiy savol varianti bo'lmasligi mumkin",
    "viet": "Câu hỏi được hiển thị có thể không phải là biến thể câu hỏi thực sự xuất hiện cho học sinh"
  },
  "loading-content": {
    "arabic": "تحميل المحتوى",
    "az": "Məzmun Yüklənir",
    "chinese": "加載內容",
    "eng": "Loading Content",
    "hindi": "लोड हो रहा है सामग्री",
    "ja": "コンテンツを読み込み中",
    "jp": null,
    "ky": "Мазмун жүктөлүүдө",
    "ru": "Загрузка контента",
    "uz": "Kontentni yuklash",
    "viet": "Đang tải nội dung"
  },
  "first-page-instructions": {
    "arabic": "الصفحة الأولى والتعليمات",
    "az": "Birinci səhifə və Təlimatlar",
    "chinese": null,
    "eng": "First page & Instructions",
    "hindi": null,
    "ja": "表紙と説明",
    "jp": null,
    "ky": "Биринчи бет &amp; нускамалар",
    "ru": "Первая страница и инструкции",
    "uz": "Birinchi sahifa va ko'rsatmalar",
    "viet": "Trang đầu tiên và Hướng dẫn"
  },
  "loading": {
    "arabic": "تحميل",
    "az": "Yüklənir",
    "chinese": "加載中",
    "eng": "Loading",
    "hindi": "लोड हो रहा है",
    "ja": "読み込み中",
    "jp": null,
    "ky": "Жүктөө",
    "ru": "Загрузка",
    "uz": "Yuklanmoqda",
    "viet": "Đang tải"
  },
  "oops-we-are-having-a-technical-difficulty-here": {
    "arabic": "عفواً, نحن نواجه مشكلة فنية هنا.",
    "az": "Vay, biz burada texniki çətinlik çəkirik.",
    "chinese": "糟糕,我們這裡遇到了技術難題。",
    "eng": "Oops, we are having a technical difficulty here.",
    "hindi": "उफ़, हमें यहाँ एक तकनीकी समस्या आ रही है।",
    "ja": "技術的な問題が発生しました",
    "jp": null,
    "ky": "Ой, бул жерде техникалык кыйынчылык болуп жатат.",
    "ru": "Упс, у нас возникли технические неполадки.",
    "uz": "Voy, bizda texnik muammo bor.",
    "viet": "Rất tiếc, chúng tôi đang gặp sự cố kỹ thuật ở đây."
  },
  "please-refresh-or-reload": {
    "arabic": "يرجى التحديث أو إعادة التحميل",
    "az": "Lütfən, təzələyin və ya yenidən yükləyin",
    "chinese": "請刷新或重新加載",
    "eng": "Please refresh or reload",
    "hindi": "कृपया ताज़ा करें या पुनः लोड करें",
    "ja": "再度ページを読み込んでください",
    "jp": null,
    "ky": "Сураныч, жаңыртыңыз же кайра жүктөңүз",
    "ru": "Пожалуйста, обновите или перезагрузите",
    "uz": "Iltimos, yangilang yoki qayta yuklang",
    "viet": "Bạn hãy làm mới hoặc tải lại trang nhé"
  },
  "refresh": {
    "arabic": "ينعش",
    "az": "Yeniləyin",
    "chinese": "刷新",
    "eng": "Refresh",
    "hindi": "ताज़ा करना",
    "ja": "ページを再度読み込む",
    "jp": null,
    "ky": "Жаңылоо",
    "ru": "Обновить",
    "uz": "Yangilash",
    "viet": "Làm mới"
  },
  "close": {
    "arabic": "يغلق",
    "az": "Bağlayın",
    "chinese": "關閉",
    "eng": "Close",
    "hindi": "बंद करना",
    "ja": "閉じる",
    "jp": null,
    "ky": "Жабуу",
    "ru": "Закрывать",
    "uz": "Yopish",
    "viet": "Đóng"
  },
  "question": {
    "arabic": "سؤال",
    "az": "Sual",
    "chinese": "問題",
    "eng": "Question",
    "hindi": "प्रशन",
    "ja": "問題",
    "jp": null,
    "ky": "Суроо",
    "ru": "Вопрос",
    "uz": "Savol",
    "viet": "Câu hỏi"
  },
  "okay,reset": {
    "arabic": "حسنا, إعادة الضبط",
    "az": "Tamam, sıfırla",
    "chinese": "好的，重置",
    "eng": "Okay, Reset",
    "hindi": "ठीक है, रीसेट",
    "ja": "はい、リセット",
    "jp": null,
    "ky": "Макул, Калыбына келтирүү",
    "ru": "Хорошо, сброс",
    "uz": "Yaxshi, qayta o'rnating",
    "viet": "Được, Thiết lập lại"
  },
  "okay": {
    "arabic": "تمام",
    "az": "Tamam",
    "chinese": "好的",
    "eng": "Okay",
    "hindi": "ठीक है",
    "ja": "はい",
    "jp": null,
    "ky": "макул",
    "ru": "Хорошо",
    "uz": "Yaxshi",
    "viet": "Được"
  },
  "hint": {
    "arabic": "تَلمِيح",
    "az": "İpucu",
    "chinese": "暗示",
    "eng": "Hint",
    "hindi": "संकेत",
    "ja": "ヒント",
    "jp": null,
    "ky": "Жөнөкөй түшүнүк",
    "ru": "Намекать",
    "uz": "Yordam olish",
    "viet": "Gợi ý"
  },
  "click-here-to-showcase-all-of-your-bookmarked-questions-You-may-also-create-a-mocktest-from-here": {
    "arabic": "انقر هنا لعرض جميع الأسئلة التي قمت بإضافتها إلى قائمة المفضلة لديك. يمكنك أيضًا إنشاء اختبار تجريبي من هنا",
    "az": "Əlfəcin qoyulmuş bütün suallarınızı göstərmək üçün bura klikləyin. Siz həmçinin buradan sınaq testi yarada bilərsiniz",
    "chinese": "單擊此處展示所有已添加書籤的問題。您也可以從此處創建模擬測試",
    "eng": "Click here to showcase all of your bookmarked questions. You may also create a mock test from here",
    "hindi": "अपने बुकमार्क किए गए सभी प्रश्नों को दिखाने के लिए यहां क्लिक करें। आप यहां से मॉक टेस्ट भी बना सकते हैं",
    "ja": "クリックするとブックマークした問題がまとめて表示され、テストを作成することができます。",
    "jp": null,
    "ky": "Бардык кыстарылган суроолоруңузду көрсөтүү үчүн бул жерди басыңыз. Сиз бул жерден жасалма тест түзө аласыз",
    "ru": "Нажмите здесь, чтобы показать все ваши закладки вопросов. Вы также можете создать пробный тест отсюда",
    "uz": "Belgilangan barcha savollaringizni ko'rsatish uchun shu yerni bosing. Bundan tashqari, bu yerdan soxta test yaratishingiz mumkin",
    "viet": "Nhấp vào đây để hiển thị tất cả các câu hỏi được đánh dấu của bạn. Bạn cũng có thể tạo một bài kiểm tra thử từ đây"
  },
  "exercise": {
    "arabic": "يمارس",
    "az": "Məşq edin",
    "chinese": "鍛煉",
    "eng": "Exercise",
    "hindi": "व्यायाम",
    "ja": "演習問題",
    "jp": null,
    "ky": "Тапшырма",
    "ru": "Упражнение",
    "uz": "Topshiriq",
    "viet": "Bài tập"
  },
  "selected": {
    "arabic": "تم اختياره",
    "az": "Seçildi",
    "chinese": "已選",
    "eng": "Selected",
    "hindi": "चयनित",
    "ja": "選択中:",
    "jp": null,
    "ky": "Тандалган",
    "ru": "Выбрано",
    "uz": "Tanlangan",
    "viet": "Đã chọn"
  },
  "select-a-language-to-display-the-question-in-the-same-language-subsequent-questions-will-also-be-displayed-in-selected-language": {
    "arabic": "حدد لغة لعرض السؤال باللغة نفسها. سيتم أيضًا عرض الأسئلة اللاحقة باللغة المحددة",
    "az": "Sualı eyni dildə göstərmək üçün dil seçin. Sonrakı suallar da seçilmiş dildə göstəriləcək",
    "chinese": "選擇一種語言以用相同的語言顯示問題。後續問題也將以所選語言顯示",
    "eng": "Select a language to display the question in the same language. Subsequent questions will also be displayed in selected language",
    "hindi": "प्रश्न को उसी भाषा में प्रदर्शित करने के लिए भाषा का चयन करें। बाद के प्रश्न भी चयनित भाषा में प्रदर्शित किए जाएंगे",
    "ja": "一度言語を選択すると、出題も同じ言語で行われます。また、以降の問題も選択した言語で表示されます",
    "jp": null,
    "ky": "Суроону бир тилде көрсөтүү үчүн тилди тандаңыз. Кийинки суроолор да тандалган тилде көрсөтүлөт",
    "ru": "Выберите язык для отображения вопроса на том же языке. Последующие вопросы также будут отображаться на выбранном языке",
    "uz": "Savolni bir xil tilda ko'rsatish uchun tilni tanlang. Keyingi savollar tanlangan tilda ham ko'rsatiladi",
    "viet": "Chọn một ngôn ngữ để hiển thị câu hỏi trong cùng một ngôn ngữ. Các câu hỏi tiếp theo cũng sẽ được hiển thị bằng ngôn ngữ đã chọn"
  },
  "select-language": {
    "arabic": "اختر اللغة",
    "az": "Dil seçin",
    "chinese": "選擇語言",
    "eng": "Select Language",
    "hindi": "भाषा का चयन करें",
    "ja": "言語を選択する",
    "jp": null,
    "ky": "Тилди танда",
    "ru": "Выберите язык",
    "uz": "Tilni tanlang",
    "viet": "Chọn ngôn ngữ"
  },
  "select-the-issue-type": {
    "arabic": "حدد نوع المشكلة",
    "az": "Problem növünü seçin",
    "chinese": "選擇問題類型",
    "eng": "Select the issue type",
    "hindi": "मुद्दे का प्रकार चुनें",
    "ja": "問題の種類を選択してください",
    "jp": null,
    "ky": "Маселенин түрүн тандаңыз",
    "ru": "Выберите тип проблемы",
    "uz": "Muammo turini tanlang",
    "viet": "Chọn loại vấn đề"
  },
  "guide-to": {
    "arabic": "دليل إلى",
    "az": "bələdçi",
    "chinese": "指南",
    "eng": "Guide to",
    "hindi": "के लिए मार्गदर्शिका",
    "ja": "ガイド",
    "jp": null,
    "ky": "Гид",
    "ru": "Руководство по",
    "uz": "Qo'l",
    "viet": "Hướng dẫn đến"
  },
  "level": {
    "arabic": "مستوى",
    "az": "səviyyəsi",
    "chinese": "等級",
    "eng": "Level",
    "hindi": "स्तर",
    "ja": "レベル",
    "jp": null,
    "ky": "Деңгээл",
    "ru": "Уровень",
    "uz": "Daraja",
    "viet": "Mức độ"
  },
  "show-broken-concept": {
    "arabic": "إظهار المفهوم المكسور",
    "az": "Qırılmış konsepsiyanı göstərin",
    "chinese": "顯示破碎的概念",
    "eng": "Show broken concept",
    "hindi": "टूटी हुई अवधारणा दिखाएं",
    "ja": "ポイントを表示",
    "jp": null,
    "ky": "Бузулган түшүнүктү көрсөтүү",
    "ru": "Показать сломанную концепцию",
    "uz": "Noto‘g‘ri konsepsiyani ko‘rsatish",
    "viet": "Hiển thị khái niệm bị hỏng"
  },
  "report": {
    "arabic": "تقرير",
    "az": "Hesabat",
    "chinese": "報告",
    "eng": "Report",
    "hindi": "शिकायत करना",
    "ja": "報告",
    "jp": null,
    "ky": "Билдирүү",
    "ru": "Отчет",
    "uz": "Xabar berish",
    "viet": "Báo cáo"
  },
  "show-report":{
    "arabic": "إظهار التقرير",
    "az": "Hesabatı göstərin",
    "chinese": "顯示報告",
    "eng": "Show Report",
    "hindi": "रिपोर्ट दिखाएं",
    "ja": "レポートを表示",
    "jp": null,
    "ky": "Билдирүүнү көрсөтүү",
    "ru": "Показать отчет",
    "uz": "Hisobotni ko‘rish",
    "viet": "Hiển thị báo cáo"
  },
  "reported": {
    "arabic": "تم الإبلاغ عنه",
    "az": "Məlumat verildi",
    "chinese": "已报道",
    "eng": "Reported",
    "hindi": "शिकायत करना",
    "ja": "報告しました",
    "jp": null,
    "ky": "билдирилди",
    "ru": "Сообщается",
    "uz": "Xabar qilingan",
    "viet": "Đã báo cáo"
  },
  "where-do-you-see-an-issue": {
    "arabic": "أين ترى مشكلة؟",
    "az": "Harada problem görürsən",
    "chinese": "你在哪裡看到問題",
    "eng": "Where do you see an issue",
    "hindi": "आपको कहां दिक्कत दिखती है",
    "ja": "どこに問題がありましたか？",
    "jp": null,
    "ky": "Маселени кайдан көрүп жатасыз",
    "ru": "Где вы видите проблему?",
    "uz": "Muammoni qayerda ko'rasiz",
    "viet": "Bạn thấy vấn đề ở đâu"
  },
  "in-the-question": {
    "arabic": "في السؤال",
    "az": "Sualda",
    "chinese": "在問題中",
    "eng": "In the question",
    "hindi": "प्रश्न में",
    "ja": "問題",
    "jp": null,
    "ky": "Суроодо",
    "ru": "В вопросе",
    "uz": "Savolda",
    "viet": "trong câu hỏi"
  },
  "in-the-solution": {
    "arabic": "في الحل",
    "az": "Həlldə",
    "chinese": "在溶液中",
    "eng": "In the solution",
    "hindi": "घोल में",
    "ja": "解答解説",
    "jp": null,
    "ky": "Чечимде",
    "ru": "В растворе",
    "uz": "Yechimda",
    "viet": "trong giải pháp"
  },
  "solution": {
    "arabic": "حل",
    "az": "Həll",
    "chinese": "解決方案",
    "eng": "Solution",
    "hindi": "घोल",
    "ja": "解答解説",
    "jp": null,
    "ky": "Чечим",
    "ru": "Решение",
    "uz": "Yechim",
    "viet": "Giải pháp"
  },
  "both": {
    "arabic": "كلاهما",
    "az": "Hər ikisi",
    "chinese": "兩個都",
    "eng": "Both",
    "hindi": "दोनों",
    "ja": "両方",
    "jp": null,
    "ky": "экөө тең",
    "ru": "Оба",
    "uz": "Ikkalasi ham",
    "viet": "Cả hai"
  },
  "briefly-explain-the-issue(s)": {
    "arabic": "اشرح المشكلة (المشاكل) بإيجاز",
    "az": "Məsələni qısaca izah edin",
    "chinese": "簡要說明問題",
    "eng": "Briefly explain the issue(s)",
    "hindi": "संक्षेप में मुद्दे की व्याख्या करें",
    "ja": "問題を教えてください",
    "jp": null,
    "ky": "Маселени кыскача түшүндүрүңүз",
    "ru": "Кратко объясните проблему(ы)",
    "uz": "Muammo(lar)ni qisqacha tushuntiring",
    "viet": "Giải thích ngắn gọn (các) vấn đề"
  },
  "apply": {
    "arabic": "يتقدم",
    "az": "Müraciət edin",
    "chinese": null,
    "eng": "Apply",
    "hindi": null,
    "ja": "確定",
    "jp": null,
    "ky": "Колдонуу",
    "ru": "Применять",
    "uz": "Murojaat qiling",
    "viet": null
  },
  "cancel": {
    "arabic": "يلغي",
    "az": "Ləğv et",
    "chinese": "取消",
    "eng": "Cancel",
    "hindi": "रद्द करना",
    "ja": "キャンセル",
    "jp": null,
    "ky": "Жокко чыгаруу",
    "ru": "Отмена",
    "uz": "Bekor qilish",
    "viet": "Hủy bỏ"
  },
  "yes-delete": {
    "arabic": "نعم, حذف",
    "az": "Bəli, sil",
    "chinese": "是的，删除",
    "eng": "Yes, Delete",
    "hindi": "हां, हटाएं",
    "ja": "はい、削除",
    "jp": null,
    "ky": "Ооба, жок кылуу",
    "ru": "Да, удалить",
    "uz": "Ha, o‘chirish",
    "viet": "Có, Xóa"
  },
  "deleting...": {
    "arabic": "جاري الحذف...",
    "az": "Silinir...",
    "chinese": "删除中...",
    "eng": "Deleting...",
    "hindi": "हटाया जा रहा है...",
    "ja": "削除中...",
    "jp": null,
    "ky": "Жок кылынууда...",
    "ru": "Удаление...",
    "uz": "O‘chirilmoqda...",
    "viet": "Đang xóa..."
  },
  "submit": {
    "arabic": "يُقدِّم",
    "az": "Təqdim edin",
    "chinese": "提交",
    "eng": "Submit",
    "hindi": "प्रस्तुत",
    "ja": "提出する",
    "jp": null,
    "ky": "Жөнөтүү",
    "ru": "Представлять на рассмотрение",
    "uz": "Yuborish",
    "viet": "Nộp"
  },
  "Clear": {
    "arabic": "واضح",
    "az": "Təmiz",
    "chinese": "清除",
    "eng": "Clear",
    "hindi": "मिटायें",
    "ja": "リセット",
    "jp": null,
    "ky": "Таза",
    "ru": "Прозрачный",
    "uz": "Toza",
    "viet": "Thông thoáng"
  },
  "leaderboard": {
    "arabic": "لوحة المتصدرين",
    "az": "Liderlər lövhəsi",
    "chinese": "排行榜",
    "eng": "Leaderboard",
    "hindi": "प्रस्तुत",
    "ja": "ランキング表",
    "jp": null,
    "ky": "Лидер тактасы",
    "ru": "Таблица лидеров",
    "uz": "Peshqadamlar jadvali",
    "viet": "bảng xếp hạng"
  },
  "notification": {
    "arabic": "إشعار",
    "az": "Bildiriş",
    "chinese": "通知",
    "eng": "Notification",
    "hindi": "अधिसूचना",
    "ja": "学習状況",
    "jp": null,
    "ky": "Эскертме",
    "ru": "Уведомление",
    "uz": "Bildirishnoma",
    "viet": "thông báo"
  },
  "Review": {
    "arabic": "مراجعة",
    "az": "Baxış",
    "chinese": "审查 ",
    "eng": "Review",
    "hindi": "समीक्षा",
    "ja": "確認する",
    "jp": null,
    "ky": "карап чыгуу",
    "ru": "Обзор",
    "uz": "Ko‘rib chiqish",
    "viet": "ôn tập"
  },
  "Resolve": {
    "arabic": "حل",
    "az": "Həll et",
    "chinese": "解决",
    "eng": "Resolve",
    "hindi": "संकल्प",
    "ja": "解決",
    "jp": null,
    "ky": "Чечүү",
    "ru": "Решать",
    "uz": "Yechish",
    "viet": "Giải quyết"
  },
  "Actions": {
    "arabic": "الإجراءات",
    "az": "Fəaliyyətlər",
    "chinese": "行动",
    "eng": "Actions",
    "hindi": "कार्रवाईकल्प",
    "ja": "アクション",
    "jp": null,
    "ky": "Аракеттер",
    "ru": "Действия",
    "uz": "Harakatlar",
    "viet": "hành động"
  },
  "action": {
    "arabic": "فعل",
    "az": "Fəaliyyət",
    "chinese": "行動",
    "eng": "Action",
    "hindi": "कार्रवाई",
    "ja": "アクション",
    "jp": null,
    "ky": "Акция",
    "ru": "Действие",
    "uz": "Harakat",
    "viet": "hành động"
  },
  "Descriptions": {
    "arabic": "الأوصاف",
    "az": "Təsvirlər",
    "chinese": "",
    "eng": "Descriptions",
    "hindi": "विवरण",
    "ja": "詳細",
    "jp": null,
    "ky": "Сүрөттөмөлөр",
    "ru": "Описания",
    "uz": "Tavsiflar",
    "viet": "Mô tả"
  },
  "still-facing-an-issue-decribe-your-issue": {
    "arabic": "هل لا تزال تواجه مشكلة, صف مشكلتك.",
    "az": "Hələ də problemlə üzləşirsiniz, probleminizi təsvir edin.",
    "chinese": "仍然面临问题，请描述您的问题。",
    "eng": "Still facing an issue, describe your issue.",
    "hindi": "अभी भी किसी समस्या का सामना कर रहे हैं, अपनी समस्या का वर्णन करें।",
    "ja": "まだ問題が発生しています。問題を説明してください。",
    "jp": null,
    "ky": "Көйгөй дагы эле болсо, көйгөйүңүздү сүрөттөп бериңиз.",
    "ru": "Если проблема все еще не решена, опишите ее.",
    "uz": "Hali ham muammoga duch kelibsiz, muammongizni ta'riflang.",
    "viet": "Vẫn đang gặp sự cố, mô tả vấn đề của bạn."
  },
  "describe-your-issue": {
    "arabic": "وصف مشكلتك",
    "az": "Probleminizi təsvir edin",
    "chinese": "描述您的问题",
    "eng": "Describe your issue",
    "hindi": "अपनी समस्या का वर्णन करें",
    "ja": "問題を説明してください",
    "jp": null,
    "ky": "Маселеңизди сүрөттөп бериңиз",
    "ru": "Опишите вашу проблему",
    "uz": "Muammoni tavsiflab bering",
    "viet": "Mô tả vấn đề của bạn"
  },
  "describe-the-issue": {
    "arabic": "وصف المشكلة",
    "az": "Məsələni təsvir edin",
    "chinese": "描述问题",
    "eng": "Describe the issue",
    "hindi": "समस्या का वर्णन करें",
    "ja": "問題を説明してください",
    "jp": null,
    "ky": "Маселени сүрөттөп бер",
    "ru": "Опишите проблему",
    "uz": "Muammongizni ta'riflang",
    "viet": "Mô tả vấn đề"
  },
  "still-want-to-escalete-the-issue-describe-your-issue-along-with-the-login-id-of-the-student": {
    "arabic": "هل مازلت تريد تصعيد المشكلة, قم بوصف مشكلتك مع معرف تسجيل الدخول الخاص بالطالب.",
    "az": "Hələ də problemi genişləndirmək istəyirsiniz, probleminizi tələbənin giriş ID-si ilə birlikdə təsvir edin.",
    "chinese": "仍然想要升级问题，请描述您的问题以及学生的登录ID。",
    "eng": "Still want to escalete the issue, describe your issue along with the login ID of the student.",
    "hindi": "अभी भी समस्या को बढ़ाना चाहते हैं, अपनी समस्या का वर्णन करें साथ ही छात्र की लॉगिन आईडी के साथ।",
    "ja": "まだ問題をエスカレートしたい場合は、問題を説明し、学生のログインIDを添えてください。",
    "jp": null,
    "ky": "Маселени дагы эле кеңейтүүнү каалайсыз, студенттин логин идентификатору менен көйгөйүңүздү сүрөттөп бериңиз.",
    "ru": "Все еще хотите решить проблему, опишите ее вместе с идентификатором пользователя учащегося.",
    "uz": "Hali ham muammoga duch kelmoqchisiz, muammongizni o‘quvchi kirish ID si bilan birga ta'riflang.",
    "viet": "Vẫn muốn tăng cấp vấn đề, mô tả vấn đề của bạn cùng với ID đăng nhập của học sinh."
  },
  "currently-no-students-have-started-practicing-in-this-class": {
    "arabic": "لم يبدأ أي طالب في التدريب في هذه الفئة حاليًا",
    "az": "Hazırda bu sinifdə heç bir tələbə praktikaya başlamamışdır",
    "chinese": "目前還沒有學生在這個班級開始練習",
    "eng": "Currently no students have started practising in this class",
    "hindi": "वर्तमान में इस कक्षा में किसी भी छात्र ने अभ्यास शुरू नहीं किया है",
    "ja": "現在、このクラスを受講中の生徒はいません",
    "jp": null,
    "ky": "Учурда бул класста бир дагы окуучу практикалана элек",
    "ru": "В настоящее время ни один студент не начал заниматься в этом классе.",
    "uz": "Hozirda bu sinfda birorta ham o‘quvchi mashq qilishni boshlamagan",
    "viet": "Hiện tại chưa có học viên nào bắt đầu thực hành trong lớp này"
  },
  "students-have-not-started-the-test-yet": {
    "arabic": "لم يبدأ الطلاب الاختبار بعد",
    "az": "tələbələr hələ imtahana başlamayıb",
    "chinese": "學生還沒有開始測試",
    "eng": "students have not started the test yet",
    "hindi": "छात्रों ने अभी तक परीक्षा शुरू नहीं की है",
    "ja": "人が未開始です。",
    "jp": null,
    "ky": "Студенттер тестти башташа элек",
    "ru": "студенты еще не приступили к тесту",
    "uz": "talabalar hali testni boshlamagan",
    "viet": "Học viên chưa bắt đầu bài kiểm tra"
  },
  "students-submitted-the-test-and": {
    "arabic": "قدم الطلاب الاختبار و",
    "az": "tələbələr test təqdim etdi və",
    "chinese": "學生提交了測試",
    "eng": "students submitted the test and",
    "hindi": "छात्रों ने परीक्षा जमा की और",
    "ja": "人の生徒がテストを提出済みで、",
    "jp": null,
    "ky": "студенттер тест тапшырышты жана",
    "ru": "студенты сдали тест и",
    "uz": "talabalar test topshirdilar va",
    "viet": "Học viên đã nộp bài kiểm tra và"
  },
  "students-are-in-this-class": {
    "arabic": "الطلاب في هذا الفصل",
    "az": "tələbələr bu sinifdədir",
    "chinese": "學生在這個班級",
    "eng": "students are in this class",
    "hindi": "छात्र इस कक्षा में हैं",
    "ja": "人の生徒がこのクラスに所属しています。",
    "jp": null,
    "ky": "студенттер бул класста",
    "ru": "студенты в этом классе",
    "uz": "talabalar bu sinfda",
    "viet": "Học viên ở trong lớp học này"
  },
  "questions": {
    "arabic": "أسئلة",
    "az": "suallar",
    "chinese": "問題",
    "eng": "questions",
    "hindi": "प्रशन",
    "ja": "問題",
    "jp": null,
    "ky": "суроолор",
    "ru": "вопросы",
    "uz": "savollar",
    "viet": "câu hỏi"
  },
  "chapters": {
    "arabic": "الفصول",
    "az": "Fəsillər",
    "chinese": "章節",
    "eng": "Chapters",
    "hindi": "अध्याय",
    "ja": "チャプター",
    "jp": null,
    "ky": "Бөлүмдөр",
    "ru": "Главы",
    "uz": "Boblar",
    "viet": "chương"
  },
  "chapter": {
    "arabic": "الفصل",
    "az": "Fəsil",
    "chinese": "章節",
    "eng": "Chapter",
    "hindi": "अध्याय",
    "ja": "チャプター",
    "jp": null,
    "ky": "бөлүм",
    "ru": "Глава",
    "uz": "Bob",
    "viet": "chương"
  },
  "releasing-soon": {
    "arabic": "سيتم إصداره قريبا",
    "az": "Tezliklə Buraxılacaq",
    "chinese": "即將發布",
    "eng": "Releasing Soon",
    "hindi": "जल्द ही रिलीज हो रही है",
    "ja": "公開予定",
    "jp": null,
    "ky": "Жакында чыгарылат",
    "ru": "Скоро релиз",
    "uz": "Tez orada chiqariladi",
    "viet": "Sắp phát hành"
  },
  "undo-bookmark": {
    "arabic": "التراجع عن الإشارة المرجعية",
    "az": "Əlfəcin ləğvi",
    "chinese": "撤消書籤",
    "eng": "Undo Bookmark",
    "hindi": "जल्द ही रिलीज हो रही है",
    "ja": "ブックマークを取り消す",
    "jp": null,
    "ky": "Кыстарманы жокко чыгаруу",
    "ru": "Отменить закладку",
    "uz": "Xatcho‘pni bekor qilish",
    "viet": "Bỏ đánh dấu trang"
  },
  "set-announcement": {
    "arabic": "إعلان المجموعة",
    "az": "Elanı təyin edin",
    "chinese": "設置公告",
    "eng": "Set Announcement",
    "hindi": "घोषणा सेट करें",
    "ja": "お知らせを配信する",
    "jp": null,
    "ky": "Жарыялоо",
    "ru": "Установить объявление",
    "uz": "E'lonni o'rnatish",
    "viet": "Đặt thông báo"
  },
  "set": {
    "arabic": "تعيين",
    "az": "Set",
    "chinese": "放",
    "eng": "Set",
    "hindi": "सेट",
    "ja": "配信",
    "jp": null,
    "ky": "коюу",
    "ru": "Набор",
    "uz": "Oʻrnatish",
    "viet": "Bộ"
  },
  "set-an-announcement-for-your-class": {
    "arabic": "تعيين إعلان لصفك",
    "az": "Sinifiniz üçün bir elan təyin edin",
    "chinese": "為您的班級設置公告",
    "eng": "Set an announcement for your class",
    "hindi": "अपनी कक्षा के लिए एक घोषणा सेट करें",
    "ja": "自分のクラスにお知らせを配信する",
    "jp": null,
    "ky": "Классыңыз үчүн кулактандыруу коюңуз",
    "ru": "Установите объявление для вашего класса",
    "uz": "Sinfingiz uchun e'lon o'rnating",
    "viet": "Đặt thông báo cho lớp học của bạn"
  },
  "your-class": {
    "arabic": "صفك",
    "az": "Sinifiniz",
    "chinese": "你的班",
    "eng": "Your Class",
    "hindi": null,
    "ja": "自分のクラス",
    "jp": null,
    "ky": "Сиздин класс",
    "ru": "Ваш класс",
    "uz": "Sizning sinfingiz",
    "viet": "Lớp của bạn"
  },
  "shown-to-students-when-they-log-into-your-class-in-cerebry": {
    "arabic": "يظهر للطلاب عند تسجيل الدخول إلى صفك في Cerebry",
    "az": "Cerebry-də sinifinizə daxil olduqda tələbələrə göstərilir",
    "chinese": "當學生在 Cerebry 中登錄您的班級時向他們展示",
    "eng": "Shown to students when they log into your class in Cerebry",
    "hindi": "छात्रों को सेरेब्री में आपकी कक्षा में प्रवेश करने पर दिखाया गया",
    "ja": "生徒があなたのクラスにログインした際、生徒側にも表示する",
    "jp": null,
    "ky": "Студенттер Cerebry&#39;де классыңызга киргенде көрсөтүлөт",
    "ru": "Показывается студентам, когда они входят в ваш класс в Cerebry",
    "uz": "Talabalar Cerebry-da sinfingizga kirganlarida ko'rsatiladi",
    "viet": "Hiển thị cho sinh viên khi họ đăng nhập vào lớp học của bạn trong Cerebry"
  },
  "type-your-announcement-here": {
    "arabic": "اكتب اعلانك هنا",
    "az": "Elanınızı bura yazın",
    "chinese": "在此輸入您的公告",
    "eng": "Type your announcement here",
    "hindi": "अपनी घोषणा यहां टाइप करें",
    "ja": "お知らせ内容を入力",
    "jp": null,
    "ky": "Бул жерге жарыяңызды териңиз",
    "ru": "Введите свое объявление здесь",
    "uz": "E'loningizni shu yerga yozing",
    "viet": "Nhập thông báo của bạn ở đây"
  },
  "announcement": {
    "arabic": "إعلان",
    "az": "Elan",
    "chinese": "公告",
    "eng": "Announcement",
    "hindi": "घोषणा",
    "ja": "お知らせ",
    "jp": null,
    "ky": "кулактандыруу",
    "ru": "Объявление",
    "uz": "E'lon",
    "viet": "Thông báo"
  },
  "delete-announcement": {
    "arabic": "حذف الإعلان",
    "az": "Elanı silin",
    "chinese": "刪除公告",
    "eng": "Delete Announcement",
    "hindi": "घोषणा हटाएं",
    "ja": "お知らせを削除する",
    "jp": null,
    "ky": "Жарыяны жок кылуу",
    "ru": "Удалить объявление",
    "uz": "E'lonni o'chirish",
    "viet": "Xóa thông báo"
  },
  "teachers": {
    "arabic": "المعلمون",
    "az": "Müəllimlər",
    "chinese": "老師",
    "eng": "Teachers",
    "hindi": "शिक्षक",
    "ja": "先生",
    "jp": null,
    "ky": "Мугалимдер",
    "ru": "Учителя",
    "uz": "O‘qituvchilar",
    "viet": "Giáo viên"
  },
  "cerebry-is-a-one-stop-solution-for-Math-Teachers": {
    "arabic": "Cerebry - هو الحل الشامل لمعلمي الرياضيات",
    "az": "Cerebry - Riyaziyyat Müəllimlər üçün bir stop həll edir",
    "chinese": "Cerebry - 是數學教師的一站式解決方案",
    "eng": "Cerebry - Is a one stop solution for Math Teachers",
    "hindi": "सेरेब्री - गणित शिक्षकों के लिए एक स्थान पर समाधान है",
    "ja": "「Manabie」は算数・数学の先生向けのワンストップソリューションです。",
    "jp": null,
    "ky": "Cerebry - Математика мугалимдери үчүн бирдиктүү чечим болуп саналат",
    "ru": "Cerebry — универсальное решение для учителей математики",
    "uz": "Cerebry - Matematika o'qituvchilari uchun yagona yechim",
    "viet": "Kyons x Cerebry cung cấp giải pháp toàn diện cho các giáo viên dạy Toán"
  },
  "personalized-chapter-wise-exercises-for-every-student-based-on-their-level-adopts-to-your-existing-course-textbooks-or-the-curriculum's-general-syllabus-result-students-enjoy-practicing-math-without-getting-overwhelmed": {
    "arabic": "تمارين مخصصة لكل فصل على حدة لكل طالب على أساس مستواه. يتم تطبيقها على الكتب المدرسية الحالية أو المنهج الدراسي العام. النتيجة؟ يستمتع الطلاب بممارسة الرياضيات دون الشعور بالإرهاق",
    "az": "Hər bir tələbə üçün səviyyələrinə uyğun olaraq fərdiləşdirilmiş fəsildə müdrik məşqlər. Mövcud kurs dərsliklərinizə və ya kurrikulumun ümumi proqramına uyğun gəlir. Nəticə? Tələbələr riyaziyyatdan məşq etməkdən həzz alırlar",
    "chinese": "根據每個學生的水平為每個學生提供個性化的章節明智練習。採用您現有的課程教科書或課程的一般教學大綱。結果？學生喜歡練習數學而不會不知所措",
    "eng": "Personalized chapter wise exercises for every student based on their level. Adopts to your existing course textbooks or the curriculum's general syllabus. Result? Students enjoy practising Math without getting overwhelmed",
    "hindi": "प्रत्येक छात्र के लिए उनके स्तर के आधार पर वैयक्तिकृत अध्यायवार अभ्यास। आपके मौजूदा पाठ्यक्रम की पाठ्यपुस्तकों या पाठ्यक्रम के सामान्य पाठ्यक्रम को अपनाता है। परिणाम? छात्र बिना अभिभूत हुए गणित का अभ्यास करने का आनंद लेते हैं",
    "ja": "一人ひとりの習熟度に合わせた章毎の演習問題を提供します。また、既存の授業で使っている教材や汎用的なシラバスに準拠するため、生徒は楽しみながら、無理なく数学の学習が可能です。",
    "jp": null,
    "ky": "Ар бир студент үчүн өз деңгээлине жараша жекелештирилген бөлүм акылдуу көнүгүүлөр. Учурдагы окуу китептериңизге же окуу планынын жалпы планына кабыл алынат. Жыйынтыкпы? Студенттер Математика менен машыкканды жакшы көрүшөт",
    "ru": "Персонализированные упражнения по главам для каждого ученика в зависимости от его уровня. Адаптируется к вашим существующим учебникам курса или общей программе обучения. Результат? Учащиеся с удовольствием занимаются математикой, не перегружая себя",
    "uz": "Har bir o‘quvchi uchun o'z darajasiga qarab shaxsiylashtirilgan boblar bo'yicha mashqlar. Mavjud darsliklaringiz yoki o'quv dasturining umumiy dasturiga mos keladi. Natija? Talabalar matematikadan charchamasdan mashq qilishdan zavqlanishadi",
    "viet": "Các bài tập được xây dựng dưới dạng từng chương theo chương trình sách giáo khoa hoặc chương trình hiện hành. Hơn thế nữa, tất cả đều được cá nhân hoá dựa trên lực học của mỗi học sinh, từ đó tạo hứng thú giúp các bạn học Toán mà không bị áp lực."
  },
  "hello-there-Get-started-with-cerebry": {
    "arabic": "مرحبًا بك! ابدأ مع Cerebry",
    "az": "salam! Cerebry ilə başlayın",
    "chinese": "你好呀！開始使用 Cerebry",
    "eng": "Hello there! Get started with Cerebry",
    "hindi": "नमस्ते! सेरेब्री से शुरू करें",
    "ja": "こんにちは！さっそく始めてみましょう",
    "jp": null,
    "ky": "салам! Cerebry менен баштаңыз",
    "ru": "Привет! Начните работу с Cerebry",
    "uz": "Salom! Cerebry bilan boshlang",
    "viet": "Xin chào! Bắt đầu với Cerebry"
  },
  "start-your-14-day-free-trial-now-hurry-up": {
    "arabic": "ابدأ الآن بفترة تجريبية مجانية لمدة 14 يومًا! سارع",
    "az": "14 günlük pulsuz sınaq müddətinizə indi başlayın! Tələsin",
    "chinese": "立即開始您的 14 天免費試用！趕快",
    "eng": "Start your 14-day free trial now! Hurry up",
    "hindi": "अपना 14-दिन का निःशुल्क परीक्षण अभी प्रारंभ करें! जल्दी करो",
    "ja": "今すぐ使える「14日間の無料体験」はこちら！",
    "jp": null,
    "ky": "14 күндүк акысыз сынооңузду азыр баштаңыз! Шашыл",
    "ru": "Начните 14-дневную бесплатную пробную версию прямо сейчас! Поторопитесь",
    "uz": "14 kunlik bepul sinov muddatini hoziroq boshlang! Shoshilmoq",
    "viet": "Bắt đầu dùng thử miễn phí 14 ngày của bạn ngay bây giờ! Nhanh lên"
  },
  "with-an-ai-driven-adaptive-maths-practice-platform-cerebry-is-everything-you-need": {
    "arabic": "مع منصة ممارسة الرياضيات التكيفية المدعومة بالذكاء الاصطناعي, فإن Cerebry هو كل ما تحتاجه",
    "az": "Süni intellektlə idarə olunan Adaptiv Riyaziyyat Təcrübəsi Platforması ilə Cerebry sizə lazım olan hər şeydir",
    "chinese": "借助 AI 驅動的自適應數學練習平台,Cerebry 是您需要的一切",
    "eng": "With an AI-Driven Adaptive Maths practise Platform, Cerebry is everything you need",
    "hindi": "एआई-संचालित एडेप्टिव मैथ्स प्रैक्टिस प्लेटफॉर्म के साथ, सेरेब्री वह सब कुछ है जिसकी आपको जरूरत है",
    "ja": "AIを用いた個別最適型の数学演習ツールであるManabieには、先生が必要なものが全て揃っています。",
    "jp": null,
    "ky": "AI менен башкарылган Адаптивдүү математикалык практикалык платформа менен Cerebry сизге керектүү нерселердин баары",
    "ru": "Cerebry — это все, что вам нужно, с адаптивной платформой для практики математики на основе искусственного интеллекта",
    "uz": "AI tomonidan boshqariladigan moslashuvchan matematik amaliyot platformasi bilan Cerebry sizga kerak bo'lgan hamma narsadir",
    "viet": "Cùng với một nền tảng ứng dụng AI để cá nhân hoá việc học Toán, Kyons x Cerebry là tất cả những gì bạn cần"
  },
  "enter-first-name": {
    "arabic": "أدخل الاسم الأول",
    "az": "ilk adı daxil edin",
    "chinese": "輸入名字",
    "eng": "Enter first name",
    "hindi": "पहला नाम दर्ज करें",
    "ja": "お名前（名）を入力",
    "jp": null,
    "ky": "Атын киргизиңиз",
    "ru": "введите имя",
    "uz": "ismni kiriting",
    "viet": "Nhập tên"
  },
  "enter-last-name": {
    "arabic": "أدخل الاسم الأخير",
    "az": "soyadınızı daxil edin",
    "chinese": "輸入姓氏",
    "eng": "Enter last name",
    "hindi": "अंतिम नाम दर्ज करो",
    "ja": "お名前（姓）を入力",
    "jp": null,
    "ky": "Фамилияны киргизиңиз",
    "ru": "введите фамилию",
    "uz": "familiyani kiriting",
    "viet": "Nhập họ"
  },
  "first": {
    "arabic": "أولاً",
    "az": "birinci",
    "chinese": "第一的",
    "eng": "first",
    "hindi": "पहला",
    "ja": "最初",
    "jp": null,
    "ky": "алгачкы",
    "ru": "первый",
    "uz": "birinchi",
    "viet": "Đầu tiên"
  },
  "first-name": {
    "arabic": "الاسم الأول",
    "az": "Ad",
    "chinese": "名",
    "eng": "First Name",
    "hindi": "पहला नाम",
    "ja": "名",
    "jp": null,
    "ky": "Аты",
    "ru": "Имя",
    "uz": "Ism",
    "viet": "tên"
  },
  "First-name": {
    "arabic": "الاسم الأول",
    "az": "Ad",
    "chinese": "名",
    "eng": "First name",
    "hindi": "पहला नाम",
    "ja": "名",
    "jp": null,
    "ky": "Ысым",
    "ru": "Имя",
    "uz": "Ism",
    "viet": "tên"
  },
  "Last-name": {
    "arabic": "اسم العائلة",
    "az": "Soyadı",
    "chinese": "姓",
    "eng": "Last name",
    "hindi": "अंतिम नाम",
    "ja": "名",
    "jp": null,
    "ky": "Акыркы аты",
    "ru": "Фамилия",
    "uz": "Familiya",
    "viet": "họ"
  },
  "name": {
    "arabic": "اسم",
    "az": "ad",
    "chinese": "姓名",
    "eng": "Name",
    "hindi": "नाम",
    "ja": "お名前",
    "jp": null,
    "ky": "аты",
    "ru": "Имя",
    "uz": "Ism",
    "viet": "Tên"
  },
  "last-name": {
    "arabic": "اسم العائلة",
    "az": "Soyadı",
    "chinese": "姓",
    "eng": "Last Name",
    "hindi": "अंतिम नाम",
    "ja": "お名前(姓)",
    "jp": null,
    "ky": "Фамилиясы",
    "ru": "Фамилия",
    "uz": "Familiya",
    "viet": "họ"
  },
  "last": {
    "arabic": "آخر",
    "az": "sonuncu",
    "chinese": "最後的",
    "eng": "last",
    "hindi": "अंतिम",
    "ja": "最後",
    "jp": null,
    "ky": "акыркы",
    "ru": "последний",
    "uz": "oxirgi",
    "viet": "cuối cùng"
  },
  "enter-email-id": {
    "arabic": "أدخل معرف البريد الإلكتروني",
    "az": "E-poçt identifikatorunu daxil edin",
    "chinese": "輸入電子郵件 ID",
    "eng": "Enter email id",
    "hindi": "ईमेल आईडी दर्ज करें",
    "ja": "メールアドレスを入力",
    "jp": null,
    "ky": "Электрондук почта идентификаторун киргизиңиз",
    "ru": "Введите адрес электронной почты",
    "uz": "Elektron pochta identifikatorini kiriting",
    "viet": "Nhập địa chỉ email"
  },
  "get-started": {
    "arabic": "البدء",
    "az": "Başlayın",
    "chinese": "開始",
    "eng": "Get Started",
    "hindi": "शुरू हो जाओ",
    "ja": "はじめる",
    "jp": null,
    "ky": "Баштоо",
    "ru": "Начать",
    "uz": "Boshlash",
    "viet": "Bắt đầu"
  },
  "by-clicking-button-above-you-agree-to-our": {
    "arabic": "من خلال النقر على الزر أعلاه, فإنك توافق على شروط الاستخدام الخاصة بنا",
    "az": "Yuxarıdakı düyməni basmaqla bizimlə razılaşırsınız",
    "chinese": "點擊上方按鈕,即表示您同意我們的",
    "eng": "By clicking button above, you agree to our",
    "hindi": "ऊपर दिए गए बटन पर क्लिक करके, आप हमारी सहमति देते हैं",
    "ja": "上のボタンをクリックして同意する",
    "jp": null,
    "ky": "Жогорудагы баскычты чыкылдатуу менен, сиз биздин макулдугуңузду билдиресиз",
    "ru": "Нажимая кнопку выше, вы соглашаетесь с нашими",
    "uz": "Yuqoridagi tugmani bosish orqali siz bizning shartlarimizga rozilik bildirasiz",
    "viet": "Bằng cách bấm vào nút bên trên, bạn đã đồng ý với"
  },
  "terms-of-use": {
    "arabic": "شروط الاستخدام",
    "az": "istifadə şərtləri",
    "chinese": "使用條款",
    "eng": "terms of use",
    "hindi": "उपयोग की शर्तें",
    "ja": "利用規約",
    "jp": null,
    "ky": "колдонуу шарттары",
    "ru": "Условия эксплуатации",
    "uz": "foydalanish shartlari",
    "viet": "điều khoản sử dụng"
  },
  "and": {
    "arabic": "و",
    "az": "və",
    "chinese": "和",
    "eng": "and",
    "hindi": "और",
    "ja": "と",
    "jp": null,
    "ky": "жана",
    "ru": "и",
    "uz": "va",
    "viet": "Và"
  },
  "privacy-policy": {
    "arabic": "سياسة الخصوصية",
    "az": "məxfilik siyasəti",
    "chinese": "隱私政策",
    "eng": "privacy policy",
    "hindi": "गोपनीयता नीति",
    "ja": "プライバシーポリシー",
    "jp": null,
    "ky": "купуялык саясаты",
    "ru": "политика конфиденциальности",
    "uz": "Maxfiylik siyosati",
    "viet": "Chính sách bảo mật"
  },
  "hey": {
    "arabic": "يا",
    "az": "hey",
    "chinese": "嘿",
    "eng": "Hey",
    "hindi": "अरे",
    "ja": "やぁ",
    "jp": null,
    "ky": "Эй",
    "ru": "Привет",
    "uz": "Hey",
    "viet": "Này bạn ơi"
  },
  "your-a-14-day-free-trial-account-with-cerebry-has-been-created": {
    "arabic": "تم إنشاء حساب تجريبي مجاني لمدة 14 يومًا مع Cerebry",
    "az": "Cerebry ilə 14 günlük pulsuz sınaq hesabınız yaradıldı",
    "chinese": "您已經創建了一個 14 天的 Cerebry 免費試用帳戶",
    "eng": "your a 14-day free trial account with Cerebry has been created",
    "hindi": "सेरेब्री के साथ आपका 14-दिन का निःशुल्क परीक्षण खाता बना दिया गया है",
    "ja": "14日間無料体験用のアカウントが作成されました",
    "jp": null,
    "ky": "Cerebry менен 14 күндүк акысыз сыноо эсебиңиз түзүлдү",
    "ru": "Ваша 14-дневная бесплатная пробная учетная запись в Cerebry была создана",
    "uz": "Cerebry bilan 14 kunlik bepul sinov hisob qaydnomangiz yaratildi",
    "viet": "Tài khoản dùng thử 14 ngày Kyons x Cerebry của bạn đã được tạo"
  },
  "you-will-need-to-verify-your-email-and-complete-the-activation-process": {
    "arabic": "سوف تحتاج إلى التحقق من بريدك الإلكتروني واستكمال عملية التنشيط",
    "az": "E-poçtunuzu yoxlamalı və aktivləşdirmə prosesini tamamlamalısınız",
    "chinese": "您將需要驗證您的電子郵件並完成激活過程",
    "eng": "You will need to verify your email and complete the activation process",
    "hindi": "आपको अपना ईमेल सत्यापित करना होगा और सक्रियण प्रक्रिया पूरी करनी होगी",
    "ja": "本ツールを有効化するため、メールでの認証が必要です。",
    "jp": null,
    "ky": "Сиз электрондук почтаңызды текшерип, активдештирүү процессин аяктооңуз керек",
    "ru": "Вам необходимо будет подтвердить свой адрес электронной почты и завершить процесс активации.",
    "uz": "Siz elektron pochtangizni tasdiqlashingiz va faollashtirish jarayonini yakunlashingiz kerak",
    "viet": "Bạn cần xác thực email và hoàn tất quá trình kích hoạt tài khoản"
  },
  "open-your-email": {
    "arabic": "افتح بريدك الإلكتروني",
    "az": "E-poçtunuzu açın",
    "chinese": "打開你的電子郵件",
    "eng": "Open your email",
    "hindi": "अपना ईमेल खोलें",
    "ja": "メールを開く",
    "jp": null,
    "ky": "Электрондук почтаңызды ачыңыз",
    "ru": "Откройте свою электронную почту",
    "uz": "Elektron pochtangizni oching",
    "viet": "mở email của bạn"
  },
  "an-email-has-been-sent-to": {
    "arabic": "تم إرسال بريد إلكتروني إلى",
    "az": "e-poçt ünvanına göndərildi",
    "chinese": "一封電子郵件已經發送至",
    "eng": "An email has been sent to",
    "hindi": "एक ईमेल इन्हें भेजी गई है",
    "ja": "メールが送信されました",
    "jp": null,
    "ky": "электрондук кат жөнөтүлдү",
    "ru": "Письмо было отправлено на адрес",
    "uz": "Elektron pochta manziliga xat yuborildi",
    "viet": "một email vừa được gửi tới"
  },
  "with-a-link-to-activate-your-demo-account-if-you-do-not-find-the-email-please-check-your-spam-folder": {
    "arabic": "مع رابط لتفعيل حسابك التجريبي. إذا لم تجد البريد الإلكتروني, يرجى التحقق من مجلد البريد العشوائي",
    "az": "demo hesabınızı aktivləşdirmək üçün bir keçid ilə. E-poçtu tapmasanız, spam qovluğunuzu yoxlayın",
    "chinese": "帶有激活模擬賬戶的鏈接。如果您沒有找到該電子郵件,請檢查您的垃圾郵件文件夾",
    "eng": "with a link to activate your demo account. If you do not find the email, please check your spam folder",
    "hindi": "आपके डेमो खाते को सक्रिय करने के लिए एक लिंक के साथ। यदि आपको ईमेल नहीं मिलता है, तो कृपया अपना स्पैम फ़ोल्डर जांचें",
    "ja": "無料体験用のアカウントを有効にするためのURLが記載されています。メールが見つからない場合、迷惑フォルダに届いている可能性があります。",
    "jp": null,
    "ky": "демо эсебиңизди иштетүү үчүн шилтеме менен. Электрондук катты таппасаңыз, спам папкаңызды текшериңиз",
    "ru": "со ссылкой для активации демо-аккаунта. Если вы не нашли письмо, проверьте папку со спамом",
    "uz": "demo hisobingizni faollashtirish uchun havola bilan. Agar elektron pochtani topmasangiz, spam jildini tekshiring",
    "viet": "cùng với một đường dẫn để kích hoạt tài khoản dùng thử của bạn. Nếu không thể tìm thấy email, hãy kiểm tra thư mục Spam"
  },
  "verify-and-send-again": {
    "arabic": "التحقق ثم الإرسال مرة أخرى",
    "az": "Doğrulayın və Yenidən Göndərin",
    "chinese": "驗證並再次發送",
    "eng": "Verify and Send Again",
    "hindi": "सत्यापित करें और फिर से भेजें",
    "ja": "認証してもう一度送る",
    "jp": null,
    "ky": "Текшерип, кайра жөнөтүңүз",
    "ru": "Проверить и отправить еще раз",
    "uz": "Tekshiring va qayta yuboring",
    "viet": "Xác minh và gửi lại"
  },
  "mail-Sent-check-you-account": {
    "arabic": "تم إرسال البريد! تحقق من حسابك",
    "az": "Məktub göndərildi! hesabınızı yoxlayın",
    "chinese": "郵件已發送！檢查你的帳戶",
    "eng": "Mail Sent! check you account",
    "hindi": "संदेश भेज दिया गया! अपना खाता जांचें",
    "ja": "メールが送信されました！アカウントを確認してください",
    "jp": null,
    "ky": "Почта жөнөтүлдү! эсебиңизди текшериңиз",
    "ru": "Письмо отправлено! проверьте свой аккаунт",
    "uz": "Xat yuborildi! hisobingizni tekshiring",
    "viet": "Thư đã gửi! kiểm tra tài khoản của bạn"
  },
  "mail-not-sent-Pleae-try-again": {
    "arabic": "لم يتم إرسال البريد! يرجى المحاولة مرة أخرى",
    "az": "Poçt göndərilmədi! Yenidən cəhd edin",
    "chinese": "郵件未發送！請再試一次",
    "eng": "Mail not sent! Pleae try again",
    "hindi": "मेल नहीं भेजा गया! कृपया पुन: प्रयास करें",
    "ja": "メールが送信できませんでした！再度お試しください",
    "jp": null,
    "ky": "Почта жөнөтүлгөн жок! Сураныч, кайра аракет кылыңыз",
    "ru": "Письмо не отправлено! Попробуйте еще раз",
    "uz": "Pochta yuborilmadi! Iltimos, qayta urinib ko'ring",
    "viet": "Thư chưa gửi! Vui lòng thử lại"
  },
  "didnt-get-the-email": {
    "arabic": "لم تحصل على البريد الإلكتروني؟",
    "az": "E-poçtu almadınız?",
    "chinese": "沒有收到電子郵件？",
    "eng": "Didn't get the email?",
    "hindi": "ईमेल नहीं मिला?",
    "ja": "メールが届かない場合はこちら",
    "jp": null,
    "ky": "Электрондук кат алган жоксузбу?",
    "ru": "Не получили письмо?",
    "uz": "E-pochtani olmadingizmi?",
    "viet": "Không nhận được email?"
  },
  "send-it-again": {
    "arabic": "أرسلها مرة أخرى",
    "az": "Yenidən göndərin",
    "chinese": "再發一次",
    "eng": "Send it again",
    "hindi": "उसे दोबारा भेजो",
    "ja": "もう一度送信する",
    "jp": null,
    "ky": "Кайра жөнөтүңүз",
    "ru": "Отправить еще раз",
    "uz": "Yana yuboring",
    "viet": "Gửi lại"
  },
  "premium-grade": {
    "arabic": "الدرجة الممتازة",
    "az": "Premium dərəcəli",
    "chinese": "特級",
    "eng": "Premium grade",
    "hindi": "प्रीमियम ग्रेड",
    "ja": "プレミアムグレード",
    "jp": null,
    "ky": "Премиум класс",
    "ru": "Премиум класс",
    "uz": "Premium daraja",
    "viet": "Cao cấp"
  },
  "back": {
    "arabic": "خلف",
    "az": "Geri",
    "chinese": "後退",
    "eng": "Back",
    "hindi": "वापस",
    "ja": "戻る",
    "jp": null,
    "ky": "Артка",
    "ru": "Назад",
    "uz": "Orqaga",
    "viet": "Mặt sau"
  },
  "create-account": {
    "arabic": "إنشاء حساب",
    "az": "Hesab yaradın",
    "chinese": "創建賬戶",
    "eng": "Create Account",
    "hindi": "खाता बनाएं",
    "ja": "アカウントを作成する",
    "jp": null,
    "ky": "Эсеп түзүү",
    "ru": "Зарегистрироваться",
    "uz": "Hisob yaratish",
    "viet": "Tạo tài khoản"
  },
  "create": {
    "arabic": "يخلق",
    "az": "Yaradın",
    "chinese": "創造",
    "eng": "Create",
    "hindi": "बनाएं",
    "ja": "作成する",
    "jp": null,
    "ky": "Түзүү",
    "ru": "Создавать",
    "uz": "Yaratmoq",
    "viet": "Tạo nên"
  },
  "please-enter-first-name": {
    "arabic": "الرجاء إدخال الاسم الأول",
    "az": "Zəhmət olmasa ad daxil edin",
    "chinese": "請輸入名字",
    "eng": "Please enter first name",
    "hindi": "कृपया पहला नाम दर्ज करें",
    "ja": "お名前（名）を入力してください",
    "jp": null,
    "ky": "Атын киргизиңиз",
    "ru": "Пожалуйста, введите имя",
    "uz": "Iltimos, ismingizni kiriting",
    "viet": "Vui lòng nhập tên"
  },
  "please-enter-last-name": {
    "arabic": "الرجاء إدخال الاسم الأخير",
    "az": "Zəhmət olmasa soyadınızı daxil edin",
    "chinese": "請輸入姓氏",
    "eng": "Please enter last name",
    "hindi": "कृपया अंतिम नाम दर्ज करें",
    "ja": "お名前（姓）を入力してください",
    "jp": null,
    "ky": "Фамилияны киргизиңиз",
    "ru": "Пожалуйста, введите фамилию",
    "uz": "Iltimos, familiyani kiriting",
    "viet": "Vui lòng nhập họ"
  },
  "please-enter-email-id": {
    "arabic": "الرجاء إدخال معرف البريد الإلكتروني",
    "az": "Zəhmət olmasa e-poçt id-ni daxil edin",
    "chinese": "請輸入電子郵件 ID",
    "eng": "Please enter email id",
    "hindi": "कृपया ईमेल आईडी दर्ज करें",
    "ja": "メールアドレスを入力してください",
    "jp": null,
    "ky": "Сураныч, электрондук почта идентификаторун киргизиңиз",
    "ru": "Введите адрес электронной почты",
    "uz": "Iltimos, elektron pochta identifikatorini kiriting",
    "viet": "Vui lòng nhập id email"
  },
  "email-already-in-use-with-cerebry": {
    "arabic": "البريد الإلكتروني قيد الاستخدام بالفعل مع Cerebry",
    "az": "E-poçt artıq Cerebry ilə istifadə olunur",
    "chinese": "已在 Cerebry 中使用的電子郵件",
    "eng": "Email already in use with Cerebry",
    "hindi": "ईमेल पहले से ही सेरेब्री के साथ प्रयोग में है",
    "ja": "このメールアドレスは既に使用されています",
    "jp": null,
    "ky": "Электрондук почта Cerebry менен мурунтан эле колдонулууда",
    "ru": "Электронная почта уже используется с Cerebry",
    "uz": "Elektron pochta allaqachon Cerebry bilan ishlatilmoqda",
    "viet": "Email đã được sử dụng với Cerebry"
  },
  "please-enter-phone-number": {
    "arabic": "الرجاء إدخال رقم الهاتف",
    "az": "Zəhmət olmasa telefon nömrəsini daxil edin",
    "chinese": "請輸入電話號碼",
    "eng": "Please enter phone number",
    "hindi": "कृपया फोन नंबर दर्ज करें",
    "ja": "電話番号を入力してください",
    "jp": null,
    "ky": "Телефон номерин киргизиңиз",
    "ru": "Пожалуйста, введите номер телефона",
    "uz": "Iltimos, telefon raqamini kiriting",
    "viet": "Vui lòng nhập số điện thoại"
  },
  "phone-number-is-invalid": {
    "arabic": "رقم الهاتف غير صالح",
    "az": "Telefon nömrəsi yanlışdır",
    "chinese": "電話號碼無效",
    "eng": "Phone Number is invalid",
    "hindi": "फ़ोन नंबर अमान्य है",
    "ja": "電話番号が無効です",
    "jp": null,
    "ky": "Телефон номери жараксыз",
    "ru": "Недействительный номер телефона",
    "uz": "Telefon raqami yaroqsiz",
    "viet": "Số điện thoại không hợp lệ"
  },
  "please-enter-school-name": {
    "arabic": "الرجاء إدخال اسم المدرسة",
    "az": "Məktəbin adını daxil edin",
    "chinese": "請輸入學校名稱",
    "eng": "Please enter school name",
    "hindi": "कृपया स्कूल का नाम दर्ज करें",
    "ja": "学校名を入力してください",
    "jp": null,
    "ky": "Мектептин атын киргизиңиз",
    "ru": "Введите название школы",
    "uz": "Iltimos, maktab nomini kiriting",
    "viet": "Vui lòng nhập tên trường"
  },
  "show-content": {
    "arabic": "إظهار المحتوى",
    "az": "Məzmunu göstərin",
    "chinese": "展示內容",
    "eng": "Show Content",
    "hindi": "सामग्री दिखाओ",
    "ja": "コンテンツを表示する",
    "jp": null,
    "ky": "Мазмунду көрсөтүү",
    "ru": "Показать содержимое",
    "uz": "Kontentni ko'rsatish",
    "viet": "Hiển thị nội dung"
  },
  "password-does-not-match": {
    "arabic": "كلمة المرور غير متطابقة.",
    "az": "Şifrə uyğun gəlmir",
    "chinese": "密碼不匹配",
    "eng": "Password does not match.",
    "hindi": "पासवर्ड मैच नहीं कर रहा है!",
    "ja": "パスワードが一致しません",
    "jp": null,
    "ky": "Сырсөз дал келбейт.",
    "ru": "Пароль не совпадает.",
    "uz": "Parol mos kelmaydi.",
    "viet": "Mật khẩu không hợp lệ"
  },
  "please-fill-all-the-fields": {
    "arabic": "من فضلك إملأ جميع الحقول!",
    "az": "Zəhmət olmasa bütün sahələri doldurun!",
    "chinese": "請填寫所有字段",
    "eng": "Please fill all the fields!",
    "hindi": "कृपया सभी फ़ील्ड भरें",
    "ja": "すべての必須項目を入力してください",
    "jp": null,
    "ky": "Сураныч, бардык талааларды толтуруңуз!",
    "ru": "Пожалуйста, заполните все поля!",
    "uz": "Iltimos, barcha maydonlarni toʻldiring",
    "viet": "Vui long điên vao tât cả cac mục"
  },
  "old-password": {
    "arabic": "كلمة المرور القديمة",
    "az": "Köhnə Şifrə",
    "chinese": "舊密碼",
    "eng": "Old Password",
    "hindi": "पुराना पासवर्ड",
    "ja": "古いパスワード",
    "jp": null,
    "ky": "Эски сырсөз",
    "ru": "Старый пароль",
    "uz": "Eski parol",
    "viet": "Mật khẩu cũ"
  },
  "password": {
    "arabic": "كلمة المرور",
    "az": "parol",
    "chinese": "密碼",
    "eng": "Password",
    "hindi": "पासवर्ड",
    "ja": "パスワード",
    "jp": null,
    "ky": "Купуя сөз",
    "ru": "Пароль",
    "uz": "Parol",
    "viet": "Mật khẩu"
  },
  "new-password": {
    "arabic": "كلمة المرور الجديدة",
    "az": "Yeni Parol",
    "chinese": "新密碼",
    "eng": "New Password",
    "hindi": "नया पासवर्ड",
    "ja": "新しいパスワード",
    "jp": null,
    "ky": "Жаңы сырсөз",
    "ru": "Новый пароль",
    "uz": "Yangi parol",
    "viet": "mật khẩu mới"
  },
  "re-enter-new-password": {
    "arabic": "أعد إدخال كلمة المرور الجديدة",
    "az": "Yeni Şifrəni yenidən daxil edin",
    "chinese": "重新輸入新的密碼",
    "eng": "Re-enter New Password",
    "hindi": "नया पासवर्ड पुनः दर्ज करें",
    "ja": "新しいパスワードを再入力してください",
    "jp": null,
    "ky": "Жаңы сырсөздү кайра киргизиңиз",
    "ru": "Введите новый пароль еще раз",
    "uz": "Yangi parolni qayta kiriting",
    "viet": "Nhập lại mật khẩu mới"
  },
  "change-password": {
    "arabic": "تغيير كلمة المرور",
    "az": "Parolun dəyişdirilməsi",
    "chinese": "更改密碼",
    "eng": "Change Password",
    "hindi": "पासवर्ड बदलें",
    "ja": "パスワードを変更",
    "jp": null,
    "ky": "Сырсөздү өзгөртүү",
    "ru": "Изменить пароль",
    "uz": "Parolni o‘zgartirish",
    "viet": "Đổi mật khẩu"
  },
  "all-fields-are-required": {
    "arabic": "جميع الحقول مطلوبة",
    "az": "Bütün sahələr tələb olunur",
    "chinese": "各個領域都需要",
    "eng": "All-fields-are-required",
    "hindi": "सभी फ़ील्ड आवश्यक हैं",
    "ja": "すべて必須項目です",
    "jp": null,
    "ky": "Бардык талаалар талап кылынат",
    "ru": "Все поля обязательны для заполнения",
    "uz": "Barcha maydonlar talab qilinadi",
    "viet": "Tất cả các mục cần phải được điền!"
  },
  "type-a-name-for-this-class": {
    "arabic": "اكتب اسمًا لهذه الفئة",
    "az": "Bu sinif üçün ad yazın",
    "chinese": "為此類輸入名稱",
    "eng": "Type a name for this class",
    "hindi": "इस वर्ग के लिए एक नाम लिखें",
    "ja": "クラス名を入力してください",
    "jp": null,
    "ky": "Бул класска ат коюңуз",
    "ru": "Введите имя для этого класса",
    "uz": "Sinf nomini kiriting",
    "viet": "Nhập tên cho lớp này"
  },
  "this-name-is-seen-only-by-you-it-is-to-help-you-label-your-classes-eg-'9th-D'-or-'section-B-10th'": {
    "arabic": "*هذا الاسم لا يراه أحد سواك, وهو يساعدك في تصنيف صفوفك. على سبيل المثال: الصف التاسع د أو القسم ب الصف العاشر",
    "az": "*Bu adı ancaq siz görürsünüz. Bu sinfi adlandırmaq üçündür. Məsələn, 9d, 10b və s.",
    "chinese": "*這個名字只有你能看到。它是為了幫助你標記你的類。例如- &#39;9th D&#39; 或 &#39;section B 10th&#39;",
    "eng": "*This name is seen only by you. It is to help you label your classes. Eg- '9th D' or 'section B 10th'",
    "hindi": "*यह नाम केवल आपके द्वारा देखा जाता है। यह आपको अपनी कक्षाओं को लेबल करने में मदद करने के लिए है। उदाहरण- '9वीं डी' या 'सेक्शन बी 10वीं'",
    "ja": "クラス名はあなただけに表示されます。クラスの管理にお使いください。（例：　「9th D」、「Section B 10th」など）",
    "jp": null,
    "ky": "*Бул ысымды сиз гана көрөсүз. Бул сиздин класстарыңызды белгилөөгө жардам берет. Мисалы, &quot;9-D&quot; же &quot;B 10-бөлүм&quot;",
    "ru": "*Это имя видите только вы. Оно поможет вам обозначить свои классы. Например, «9-й D» или «секция B 10-й»",
    "uz": "*Ushbu nomni faqat siz ko'rasiz. Bu sizning sinflaringizni belgilashga yordam beradi. Masalan, “9-D” yoki “B-10-qism”",
    "viet": "*Chỉ mình bạn mới có thể nhìn thấy tên này. Chúng được dùng để phân loại các lớp học. Ví dụ: '9th D' hoặc 'Phần B 10th'"
  },
  "this-name-is-seen-only-by-you-it-is-to-help-you-remember-the-connected-Google-Class": {
    "arabic": "*هذا الاسم لا يراه أحد سواك, وهو يساعدك على تذكر صف Google المتصل",
    "az": "*Bu adı yalnız siz görürsünüz. Bu, bağlı Google Class-ı yadda saxlamağınıza kömək etmək üçündür",
    "chinese": null,
    "eng": "*This name is seen only by you. It is to help you remember the connected Google Class",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "*Бул ысымды сиз гана көрөсүз. Бул туташкан Google Классын эстеп калууга жардам берет",
    "ru": "*Это имя видите только вы. Оно поможет вам запомнить подключенный Google Class",
    "uz": "*Ushbu nomni faqat siz ko'rasiz. U bog'langan Google Classni eslab qolishingizga yordam beradi",
    "viet": null
  },
  "create-class": {
    "arabic": "إنشاء الفصل",
    "az": "Sinif yaradın",
    "chinese": "創建類",
    "eng": "Create Class",
    "hindi": "वर्ग बनाएँ",
    "ja": "クラスを作成する",
    "jp": null,
    "ky": "Класс түзүү",
    "ru": "Создать класс",
    "uz": "Sinf yaratish",
    "viet": "Tạo lớp học"
  },
  "connect-class": {
    "arabic": "ربط الفصل",
    "az": "Sinfi birləşdirin",
    "chinese": null,
    "eng": "Connect Class",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Connect Class",
    "ru": "Подключить класс",
    "uz": "Sinfni ulash",
    "viet": null
  },
  "disconnect-class": {
    "arabic": "افصل خدمة Google Classroom",
    "az": "Google Classroom ilə əlaqəni kəsin",
    "chinese": null,
    "eng": "Disconnect Google Classroom",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Google Классты ажыратыңыз",
    "ru": "Отключить Google Класс",
    "uz": "Google Classroom-ni uzing",
    "viet": null
  },
  "class-you-are-creating": {
    "arabic": "الصف الذي تقوم بإنشائه",
    "az": "Yaratdığınız sinif",
    "chinese": "您正在創建的類",
    "eng": "Class you are creating",
    "hindi": "आप जो वर्ग बना रहे हैं",
    "ja": "作成中のクラス",
    "jp": null,
    "ky": "Сиз түзүп жаткан класс",
    "ru": "Класс, который вы создаете",
    "uz": "Siz yaratayotgan sinf",
    "viet": "Lớp bạn đang tạo"
  },
  "grade": {
    "arabic": "درجة",
    "az": "Dərəcə",
    "chinese": "年級",
    "eng": "Grade",
    "hindi": "श्रेणी",
    "ja": "学年",
    "jp": null,
    "ky": "Баа",
    "ru": "Оценка",
    "uz": "Baho",
    "viet": "Cấp"
  },
  "class-name": {
    "arabic": "اسم الفصل",
    "az": "Sinif Adı",
    "chinese": "班級名稱",
    "eng": "Class Name",
    "hindi": "कक्षा का नाम",
    "ja": "クラス名",
    "jp": null,
    "ky": "Класстын аты",
    "ru": "Имя класса",
    "uz": "Sinf nomi",
    "viet": "Tên lớp"
  },
  "press-confirm-to-get-the-code-for-this-class": {
    "arabic": "اضغط على تأكيد للحصول على الكود الخاص بهذه الفئة",
    "az": "Bu sinif üçün kodu əldə etmək üçün təsdiqləyin",
    "chinese": "按確認以獲取此類的代碼",
    "eng": "Press confirm to get the code for this class",
    "hindi": "इस वर्ग के लिए कोड प्राप्त करने के लिए पुष्टि करें दबाएं",
    "ja": "クラスコードを取得するには確認ボタンを押してください",
    "jp": null,
    "ky": "Бул класстын кодун алуу үчүн ырастоо баскычын басыңыз",
    "ru": "Нажмите «Подтвердить», чтобы получить код для этого класса",
    "uz": "Ushbu sinf uchun kodni olish uchun tasdiqlash tugmasini bosing",
    "viet": "Nhấn xác nhận để nhận mã cho lớp học này"
  },
  "confirm": {
    "arabic": "يتأكد",
    "az": "Təsdiq edin",
    "chinese": "確認",
    "eng": "Confirm",
    "hindi": "पुष्टि करें",
    "ja": "保存",
    "jp": null,
    "ky": "Ырастоо",
    "ru": "Подтверждать",
    "uz": "Tasdiqlash",
    "viet": "Xác nhận"
  },
  "confirmation": {
    "arabic": "تأكيد",
    "az": "Təsdiq",
    "chinese": "確認",
    "eng": "Confirmation",
    "hindi": "पुष्टि",
    "ja": "確認",
    "jp": null,
    "ky": "Ырастоо",
    "ru": "Подтверждение",
    "uz": "Tasdiqlash",
    "viet": "Xác nhận"
  },
  "go-back": {
    "arabic": "عُد",
    "az": "Geri qayıt",
    "chinese": "回去",
    "eng": "Go back",
    "hindi": "वापस जाओ",
    "ja": "戻る",
    "jp": null,
    "ky": "Артка кайтуу",
    "ru": "Возвращаться",
    "uz": "Orqaga qaytish",
    "viet": "Quay lại"
  },
  "class-code": {
    "arabic": "رمز الفصل",
    "az": "Sinif kodu",
    "chinese": "班級代碼",
    "eng": "Class code",
    "hindi": "कक्षा कोड",
    "ja": "クラスコード",
    "jp": null,
    "ky": "Класстын коду",
    "ru": "Код класса",
    "uz": "Sinf kodi",
    "viet": "Mã lớp"
  },
  "share-this-code-with-your-students-to-join-this-class.": {
    "arabic": "شارك هذا الرمز مع طلابك للانضمام إلى هذه الفئة.",
    "az": "Bu sinfə qoşulmaları üçün kodu şagirdinizlə paylaşın.",
    "chinese": "與您的學生分享此代碼以加入此課程。",
    "eng": "Share this code with your students to join this class.",
    "hindi": "इस कक्षा में शामिल होने के लिए इस कोड को अपने छात्रों के साथ साझा करें।",
    "ja": "このクラスに参加するためのコードを生徒に共有する。",
    "jp": null,
    "ky": "Бул класска кошулуу үчүн бул кодду студенттериңиз менен бөлүшүңүз.",
    "ru": "Поделитесь этим кодом со своими учениками, чтобы присоединиться к этому классу.",
    "uz": "Bu kursga qo‘shilish uchun ushbu kodni o‘quvchilaringizga ulashing.",
    "viet": "Chia sẻ mã này cho học sinh của bạn để tham gia lớp học."
  },
  "share-this-code-with-your-students-to-join-this-class(es).": {
    "arabic": "شارك هذا الرمز مع طلابك للانضمام إلى هذه الفصول.",
    "az": "Bu sinfə (siniflərə) qoşulmaları üçün kodu şagirdinizlə paylaşın.",
    "chinese": "與您的學生分享此代碼以加入此課程。",
    "eng": "Share this code with your students to join this class(es).",
    "hindi": "इस कक्षा में शामिल होने के लिए इस कोड को अपने छात्रों के साथ साझा करें।",
    "ja": "このクラスに参加するためのコードを生徒に共有する。",
    "jp": null,
    "ky": "Бул класска кошулуу үчүн бул кодду студенттериңиз менен бөлүшүңүз.",
    "ru": "Поделитесь этим кодом со своими учениками, чтобы присоединиться к этому(им) классу(ам).",
    "uz": "Ushbu kurs(lar)ga qo‘shilish uchun ushbu kodni talabalaringizga ulashing.",
    "viet": "Chia sẻ mã này cho học sinh của bạn để tham gia lớp học."
  },
  "join": {
    "arabic": "ينضم",
    "az": "Qoşul",
    "chinese": null,
    "eng": "Join",
    "hindi": null,
    "ja": null,
    "jp": "参加",
    "ky": "Кошулуу",
    "ru": "Присоединиться",
    "uz": "Qo'shil",
    "viet": null
  },
  "done": {
    "arabic": "منتهي",
    "az": "Tamamlandı",
    "chinese": "完畢",
    "eng": "Done",
    "hindi": "की गई",
    "ja": "完了",
    "jp": null,
    "ky": "Даяр",
    "ru": "Сделанный",
    "uz": "Tayyor",
    "viet": "Xong"
  },
  "are-you-sure-you-want-to-logout": {
    "arabic": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "az": "Çıxmaq istədiyinizə əminsiniz",
    "chinese": "你確定要退出嗎",
    "eng": "Are you sure you want to logout",
    "hindi": "क्या आप लॉग आउट करना चाहते हैं",
    "ja": "本当にログアウトしますか？",
    "jp": null,
    "ky": "Чын эле чыгасызбы",
    "ru": "Вы уверены, что хотите выйти?",
    "uz": "Haqiqatan ham tizimdan chiqmoqchimisiz",
    "viet": "Bạn có chắc chắn bạn muốn thoát"
  },
  "are-you-sure-you-want-to-reset-this-test": {
    "arabic": "هل أنت متأكد أنك تريد إعادة تعيين هذا الاختبار؟",
    "az": "Bu testi sıfırlamaq istədiyinizə əminsiniz",
    "chinese": "您确定要重置此测试吗",
    "eng": "Are you sure you want to Reset this test",
    "hindi": "क्या आप वाकई इस परीक्षण को रीसेट करना चाहते हैं",
    "ja": "本当にこのテストをリセットしますか？",
    "jp": null,
    "ky": "Чын эле бул сыноону баштапкы абалга келтиргиңиз келеби",
    "ru": "Вы уверены, что хотите сбросить этот тест?",
    "uz": "Haqiqatan ham bu testni asl holatiga qaytarmoqchimisiz",
    "viet": "Bạn có chắc chắn bạn muốn đặt lại bài kiểm tra này"
  },
  "logout": {
    "arabic": "تسجيل الخروج",
    "az": "Çıxın",
    "chinese": "登出",
    "eng": "Logout",
    "hindi": "लॉग आउट",
    "ja": "ログアウト",
    "jp": null,
    "ky": "Чыгуу",
    "ru": "Выйти",
    "uz": "Chiqish",
    "viet": "Đăng xuất"
  },
  "username": {
    "arabic": "اسم المستخدم",
    "az": "İstifadəçi adı",
    "chinese": "用戶名",
    "eng": "Username",
    "hindi": "उपयोगकर्ता नाम",
    "ja": "ユーザー名",
    "jp": null,
    "ky": "Колдонуучунун аты",
    "ru": "Имя пользователя",
    "uz": "Foydalanuvchi nomi ",
    "viet": "Tên người dùng"
  },
  "username-should-contain-at-least-3-characters": {
    "arabic": "يجب أن يحتوي اسم المستخدم على 3 أحرف على الأقل",
    "az": "İstifadəçi adı ən azı 3 simvoldan ibarət olmalıdır",
    "chinese": "用戶名應至少包含 3 個字符",
    "eng": "Username should contain at least 3 characters",
    "hindi": "उपयोगकर्ता नाम में कम से कम 3 अक्षर होने चाहिए",
    "ja": "ユーザー名は3文字以上にする必要があります",
    "jp": null,
    "ky": "Колдонуучу аты кеминде 3 символдон турушу керек",
    "ru": "Имя пользователя должно содержать не менее 3 символов.",
    "uz": "Foydalanuvchi nomi eng kamida 3 ta belgidan iborat bo‘lishi kerak",
    "viet": "Tên người dùng phải chứa ít nhất 3 ký tự"
  },
  "enter-your-email-to-get-a-password-reset-link": {
    "arabic": "أدخل بريدك الإلكتروني للحصول على رابط إعادة تعيين كلمة المرور",
    "az": "Parol sıfırlama linkini əldə etmək üçün e-poçtunuzu daxil edin",
    "chinese": "輸入您的電子郵件以獲取密碼重置鏈接",
    "eng": "Enter your email to get a password reset link",
    "hindi": "पासवर्ड रीसेट लिंक प्राप्त करने के लिए अपना ईमेल दर्ज करें",
    "ja": "メールアドレスを入力して、パスワードリセット用のリンクを取得する",
    "jp": null,
    "ky": "Сырсөздү калыбына келтирүү шилтемесин алуу үчүн электрондук почтаңызды киргизиңиз",
    "ru": "Введите свой адрес электронной почты, чтобы получить ссылку для сброса пароля",
    "uz": "Parolni tiklash havolasini olish uchun elektron pochta manzilligingizni kiriting",
    "viet": "Nhập email của bạn để nhận liên kết đặt lại mật khẩu"
  },
  "sign-in-to-proceed": {
    "arabic": "تسجيل الدخول للمتابعة",
    "az": "Davam etmək üçün daxil olun",
    "chinese": "登錄以繼續",
    "eng": "Sign In to proceed",
    "hindi": "आगे बढ़ने के लिए साइन इन करें",
    "ja": "サインインして続行",
    "jp": null,
    "ky": "Улантуу үчүн кириңиз",
    "ru": "Войдите, чтобы продолжить",
    "uz": "Davom etish uchun ro‘yxatdan o‘ting",
    "viet": "Đăng nhập để tiếp tục"
  },
  "email-id": {
    "arabic": "معرف البريد الإلكتروني",
    "az": "E-poçt İd",
    "chinese": "電子郵件ID",
    "eng": "Email Id",
    "hindi": "ईमेल आईडी",
    "ja": "メールアドレス",
    "jp": null,
    "ky": "Email ID",
    "ru": "Идентификатор электронной почты",
    "uz": "Elektron pochta identifikatori",
    "viet": "ID email"
  },
  "or-phone-number": {
    "arabic": "أو رقم الهاتف",
    "az": "və ya telefon nömrəsi",
    "chinese": "或電話號碼",
    "eng": "or phone number",
    "hindi": "या फोन नंबर",
    "ja": "または電話番号",
    "jp": null,
    "ky": "же телефон номери",
    "ru": "или номер телефона",
    "uz": "yoki telefon raqami",
    "viet": "hoặc số điện thoại"
  },
  "phone-number": {
    "arabic": "رقم التليفون",
    "az": "Telefon nömrəsi",
    "chinese": "電話號碼",
    "eng": "Phone Number",
    "hindi": "फोन नंबर",
    "ja": "電話番号",
    "jp": null,
    "ky": "Телефон номери",
    "ru": "Номер телефона",
    "uz": "Telefon raqami",
    "viet": "Số điện thoại"
  },
  "enter-password": {
    "arabic": "أدخل كلمة المرور",
    "az": "Parol daxil edin",
    "chinese": "輸入密碼",
    "eng": "Enter Password",
    "hindi": "पास वर्ड दर्ज करें",
    "ja": "パスワードを入力する",
    "jp": null,
    "ky": "Сырсөз киргизиңиз",
    "ru": "Введите пароль",
    "uz": "Parolni kiriting",
    "viet": "Nhập mật khẩu"
  },
  "don't-have-an-account": {
    "arabic": "ليس لدي حساب",
    "az": "Hesabınız yoxdur",
    "chinese": "沒有帳號",
    "eng": "Don't have an account",
    "hindi": "खाता नहीं है?",
    "ja": "アカウントを持っていない場合",
    "jp": null,
    "ky": "Каттоо эсебиңиз жок",
    "ru": "Нет учетной записи",
    "uz": "Hisobingiz yoʻq",
    "viet": "Không có tài khoản"
  },
  "back-to-login": {
    "arabic": "العودة إلى تسجيل الدخول",
    "az": "Girişə qayıt",
    "chinese": "回到登入",
    "eng": "Back to login",
    "hindi": "लॉगिन पर वापस",
    "ja": "ログインに戻る",
    "jp": null,
    "ky": "Кирүүгө кайра кайтуу",
    "ru": "Вернуться к входу",
    "uz": "Tizimga kirish uchun qaytish",
    "viet": "quay lại đăng nhập"
  },
  "forgot-password": {
    "arabic": "هل نسيت كلمة السر",
    "az": "Şifrəni unutdum",
    "chinese": "忘記密碼",
    "eng": "Forgot Password",
    "hindi": "पासवर्ड भूल गए हैं",
    "ja": "パスワードをお忘れですか？",
    "jp": null,
    "ky": "Forgot Password",
    "ru": "Забыли пароль",
    "uz": "Parolni unutdingizmi",
    "viet": "Quên mật khẩu"
  },
  "code": {
    "arabic": "شفرة",
    "az": "Kod",
    "chinese": "代碼",
    "eng": "Code",
    "hindi": "कोड",
    "ja": "コード",
    "jp": null,
    "ky": "Код",
    "ru": "Код",
    "uz": "Kod",
    "viet": "Mã số"
  },
  "click-here-to-showcase-all-of-your-bookmarked-questions-you-may-also-create-a-mock-test-from-here": {
    "arabic": "انقر هنا لعرض جميع الأسئلة التي قمت بإضافتها إلى قائمة المفضلة لديك. يمكنك أيضًا إنشاء اختبار تجريبي من هنا",
    "az": "Əlfəcin qoyulmuş bütün suallarınızı göstərmək üçün bura klikləyin. Siz həmçinin buradan sınaq testi yarada bilərsiniz",
    "chinese": "單擊此處展示所有已添加書籤的問題。您也可以從此處創建模擬測試",
    "eng": "Click here to showcase all of your bookmarked questions. You may also create a mock test from here",
    "hindi": "अपने बुकमार्क किए गए सभी प्रश्नों को दिखाने के लिए यहां क्लिक करें। आप यहां से मॉक टेस्ट भी बना सकते हैं",
    "ja": "クリックするとブックマークした問題がまとめて表示され、テストを作成することもできます。",
    "jp": null,
    "ky": "Бардык кыстарылган суроолоруңузду көрсөтүү үчүн бул жерди басыңыз. Сиз бул жерден жасалма тест түзө аласыз",
    "ru": "Нажмите здесь, чтобы показать все ваши закладки вопросов. Вы также можете создать пробный тест отсюда",
    "uz": "Belgilangan barcha savollaringizni ko'rsatish uchun shu yerni bosing. Bundan tashqari, bu yerdan soxta test yaratishingiz mumkin",
    "viet": "Nhấp vào đây để hiển thị tất cả các câu hỏi được đánh dấu của bạn. Bạn cũng có thể tạo một bài kiểm tra thử từ đây"
  },
  "select-class": {
    "arabic": "تم اختيار الصف",
    "az": "Sinif Seçildi",
    "chinese": "所選班級",
    "eng": "Class Selected",
    "hindi": "कक्षा चयनित",
    "ja": "クラスを選択する",
    "jp": null,
    "ky": "Тандалган класс",
    "ru": "Класс выбран",
    "uz": "Sinf tanlangan",
    "viet": "Lớp đã chọn"
  },
  "select-class-google": {
    "arabic": "حدد الفصل",
    "az": "Class seçin",
    "chinese": null,
    "eng": "Select Class",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Класс тандаңыз",
    "ru": "Выберите класс",
    "uz": "Sinfni tanlang",
    "viet": null
  },
  "live-Yet-to-start": {
    "arabic": "مباشر / لم يبدأ بعد",
    "az": "Canlı / Hələ Başlamaq üçün",
    "chinese": "生活/尚未開始",
    "eng": "Live / Yet to Start",
    "hindi": "लाइव / अभी तक शुरू करने के लिए",
    "ja": "配信中/未開始",
    "jp": null,
    "ky": "Live / Баштоо үчүн",
    "ru": "В прямом эфире / Еще не началось",
    "uz": "Jonli / Boshlash uchun hali",
    "viet": "Trực tiếp / Chưa bắt đầu"
  },
  "Draft": {
    "arabic": "مسودة",
    "az": "Qaralama",
    "chinese": "草稿",
    "eng": "Draft",
    "hindi": "प्रारूप",
    "ja": "下書き",
    "jp": null,
    "ky": "Долбоор",
    "ru": "Черновик",
    "uz": "Qoralama",
    "viet": "Bản nháp"
  },
  "live": {
    "arabic": "يعيش",
    "az": "Canlı",
    "chinese": "居住",
    "eng": "Live",
    "hindi": "लाइव",
    "ja": "配信中",
    "jp": null,
    "ky": "Жандуу",
    "ru": "Жить",
    "uz": "Jonli efir",
    "viet": "Sống"
  },
  "pdf-is-being-generated-for-print-please-refresh-the-page-and-retry-in-few-minutes": {
    "arabic": "يتم إنشاء ملف PDF للطباعة. يرجى تحديث الصفحة وإعادة المحاولة بعد بضع دقائق",
    "az": "Çap üçün PDF yaradılır. Səhifəni yeniləyin və bir neçə dəqiqədən sonra yenidən cəhd edin",
    "chinese": "正在為打印生成 PDF。請刷新頁面並在幾分鐘後重試",
    "eng": "PDF is being generated for Print. Please refresh the page and retry in few minutes",
    "hindi": "प्रिंट के लिए पीडीएफ तैयार किया जा रहा है। कृपया पृष्ठ को ताज़ा करें और कुछ मिनटों में पुनः प्रयास करें",
    "ja": "印刷用にPDFを生成しています。ページを更新して、数分後に再度お試しください。",
    "jp": null,
    "ky": "PDF басып чыгаруу үчүн түзүлүүдө. Сураныч, баракты жаңыртып, бир нече мүнөттөн кийин кайра аракет кылыңыз",
    "ru": "PDF создается для печати. Пожалуйста, обновите страницу и повторите попытку через несколько минут",
    "uz": "Chop etish uchun PDF yaratilmoqda. Iltimos, sahifani yangilang va bir necha daqiqadan so'ng qayta urinib ko'ring",
    "viet": "PDF đang được tạo để In. Vui lòng làm mới trang và thử lại sau vài phút"
  },
  "no-live-yet-to-start-tests-available-for-this-month": {
    "arabic": "لا توجد اختبارات مباشرة / لم تبدأ بعد متاحة لهذا الشهر",
    "az": "Bu ay üçün Canlı / Hələ Başlamaq üçün Testlər Yoxdur",
    "chinese": "本月沒有實時/尚未開始測試",
    "eng": "No Live / Yet to Start Tests Available for this month",
    "hindi": "इस महीने के लिए कोई लाइव/अभी तक शुरू होने वाले टेस्ट उपलब्ध नहीं हैं",
    "ja": "今月利用可能な配信中/未開始のテストがあります。",
    "jp": null,
    "ky": "Бул айда сыноолорду баштоо үчүн жандуу / азырынча жок",
    "ru": "Нет доступных живых/еще не начавшихся тестов на этот месяц",
    "uz": "Bu oyda testlarni boshlash uchun jonli/hali mavjud emas",
    "viet": "Chưa tới thời điểm kiểm tra / Chưa thể bắt đầu bài kiểm tra trong tháng này"
  },
  "live-yet-to-start": {
    "arabic": "مباشر / لم يبدأ بعد",
    "az": "Canlı / Hələ Başlamaq üçün",
    "chinese": "生活/尚未開始",
    "eng": "Live / Yet to Start",
    "hindi": "लाइव / अभी तक शुरू करने के लिए",
    "ja": "配信中 / 未開始",
    "jp": null,
    "ky": "Live / Баштоо үчүн",
    "ru": "В прямом эфире / Еще не началось",
    "uz": "Jonli / Boshlash uchun hali",
    "viet": "Đang diễn ra bài kiểm tra / Chưa bắt đầu làm bài"
  },
  "draft": {
    "arabic": "مسودة",
    "az": "Qaralama",
    "chinese": "草稿",
    "eng": "Draft",
    "hindi": "प्रारूप",
    "ja": "下書き",
    "jp": null,
    "ky": "Долбоор",
    "ru": "Черновик",
    "uz": "Qoralama",
    "viet": "Bản nháp"
  },
  "current-mock-test": {
    "arabic": "الاختبار التجريبي الحالي",
    "az": "Cari Sınaq Testi",
    "chinese": "當前模擬測試",
    "eng": "Current Mock Test",
    "hindi": "वर्तमान मॉक टेस्ट",
    "ja": "現在のテスト",
    "jp": null,
    "ky": "Учурдагы жасалма тест",
    "ru": "Текущий пробный тест",
    "uz": "Joriy sinov sinovi",
    "viet": "Thử nghiệm giả hiện tại"
  },
  "edit-submission": {
    "arabic": "تعديل الإرسال",
    "az": "Təqdimatı redaktə edin",
    "chinese": "編輯提交",
    "eng": "Edit Submission",
    "hindi": "सबमिशन संपादित करें",
    "ja": "提出物を編集する",
    "jp": null,
    "ky": "Берүүнү түзөтүү",
    "ru": "Редактировать представление",
    "uz": "Taqdimotni tahrirlash",
    "viet": "Chỉnh sửa nội dung gửi"
  },
  "edit": {
    "arabic": "يحرر",
    "az": "Redaktə et",
    "chinese": "编辑",
    "eng": "Edit",
    "hindi": "संपादन करना",
    "ja": "編集",
    "jp": "編集",
    "ky": "Түзөтүү",
    "ru": "Редактировать",
    "uz": "Tahrirlash",
    "viet": "Biên tập"
  },
  "no-draft-exams-available": {
    "arabic": "لا توجد اختبارات مسودة متاحة",
    "az": "Layihə imtahanları yoxdur",
    "chinese": "沒有可用的草稿考試",
    "eng": "No draft exams available",
    "hindi": "नो-ड्राफ्ट-परीक्षा-उपलब्ध",
    "ja": "下書きのテストはありません",
    "jp": null,
    "ky": "Долбоор сынактары жок",
    "ru": "Нет доступных черновых экзаменов",
    "uz": "Hech qanday qoralama imtihonlari mavjud emas",
    "viet": "Không có bài kiểm tra dự thảo nào"
  },
  "yet-to-start": {
    "arabic": "لم تبدأ بعد",
    "az": "Hələ Başlamaq üçün",
    "chinese": "尚未開始",
    "eng": "Yet to Start",
    "hindi": "अभी शुरू होना बाकी है",
    "ja": "未開始",
    "jp": null,
    "ky": "Баштоо үчүн дагы",
    "ru": "Еще не Начало",
    "uz": "Hali Boshlash uchun",
    "viet": "chưa bắt đầu"
  },
  "completed": {
    "arabic": "مكتمل",
    "az": "Tamamlandı",
    "chinese": "完全的",
    "eng": "Completed",
    "hindi": "पूरा हुआ",
    "ja": "完了",
    "jp": null,
    "ky": "Аякталды",
    "ru": "Завершенный",
    "uz": "Bajarildi",
    "viet": "Hoàn thành"
  },
  "review-questions": {
    "arabic": "أسئلة المراجعة",
    "az": "Sualları nəzərdən keçirin",
    "chinese": "檢視問題",
    "eng": "Review Questions",
    "hindi": "समीक्षा प्रश्न",
    "ja": "問題を確認する",
    "jp": null,
    "ky": "Суроолорду карап чыгуу",
    "ru": "Обзорные вопросы",
    "uz": "Savollarni ko‘zdan kechirish",
    "viet": "câu hỏi ôn tập"
  },
  "see-results": {
    "arabic": "شاهد النتائج",
    "az": "Nəticələrə baxın",
    "chinese": "查看結果",
    "eng": "See Results",
    "hindi": "परिणाम देखें",
    "ja": "結果を確認する",
    "jp": null,
    "ky": "Жыйынтыктарды көрүү",
    "ru": "Посмотреть результаты",
    "uz": "Natijalarga qarang",
    "viet": "Xem kết quả"
  },
  "view-submission": {
    "arabic": "عرض التقديم",
    "az": "Təqdimata Baxın",
    "chinese": "查看提交",
    "eng": "View Submission",
    "hindi": "सबमिशन देखें",
    "ja": "提出物を確認する",
    "jp": null,
    "ky": "Берүүнү көрүү",
    "ru": "Посмотреть представление",
    "uz": "Taqdimotni ko'rish",
    "viet": "Xem bài nộp"
  },
  "no-exam-launched-for-this-class": {
    "arabic": "لم يتم إطلاق أي اختبار لهذه الفئة",
    "az": "Bu Sinif üçün İmtahana Başlanılmamışdır",
    "chinese": "這門課沒有考試",
    "eng": "No Exam Launched for this Class",
    "hindi": "इस कक्षा के लिए कोई परीक्षा शुरू नहीं की गई",
    "ja": "このクラスで配信中のテストはありません。",
    "jp": null,
    "ky": "Бул класс үчүн эч кандай сынак башталган жок",
    "ru": "Экзамен для этого класса не начат",
    "uz": "Bu sinf uchun imtihon boshlanmagan",
    "viet": "Không có kỳ thi nào được khởi chạy cho lớp này"
  },
  "till-then-you-can-explore-other-awesome-things": {
    "arabic": "حتى ذلك الحين يمكنك استكشاف أشياء رائعة أخرى",
    "az": "O vaxta qədər başqa zəhmli şeyləri araşdıra bilərsiniz",
    "chinese": "在那之前你可以探索其他很棒的東西",
    "eng": "Till then you can explore other awesome things",
    "hindi": "तब तक आप अन्य भयानक चीजों का पता लगा सकते हैं",
    "ja": "それまでは、他の素晴らしい機能を探究できます",
    "jp": null,
    "ky": "Ага чейин башка укмуштуудай нерселерди изилдей аласыз",
    "ru": "До тех пор вы можете исследовать другие удивительные вещи.",
    "uz": "Ungacha siz boshqa ajoyib narsalarni kashf qilishingiz mumkin",
    "viet": "Cho đến lúc đó bạn có thể khám phá những điều tuyệt vời khác"
  },
  "modify-details": {
    "arabic": "تعديل التفاصيل",
    "az": "Detalları dəyişdirin",
    "chinese": "修改詳細信息",
    "eng": "Modify Details",
    "hindi": "विवरण संशोधित करें",
    "ja": "詳細を変更する",
    "jp": null,
    "ky": "Маалыматты өзгөртүү",
    "ru": "Изменить детали",
    "uz": "Ma’lumotlarni o‘zgartirish",
    "viet": "Chỉnh sửa chi tiết"
  },
  "modify-student-details": {
    "arabic": "تعديل بيانات الطالب",
    "az": "Tələbə təfərrüatlarını dəyişdirin",
    "chinese": "修改學生詳細信息",
    "eng": "Modify Student Details",
    "hindi": "छात्र विवरण संशोधित करें",
    "ja": "生徒の詳細を変更する",
    "jp": null,
    "ky": "Студенттик чоо-жайын өзгөртүү",
    "ru": "Изменить данные студента",
    "uz": "O'quvchi ma'lumotlarini o'zgartirish",
    "viet": "Chỉnh sửa chi tiết sinh viên"
  },
  "go-to-practice-mode": {
    "arabic": "انتقل إلى وضع التدريب",
    "az": "Təcrübə rejiminə keçin",
    "chinese": "進入練習模式",
    "eng": "Go to practise Mode",
    "hindi": "प्रैक्टिस मोड में जाएं",
    "ja": "練習モードへ",
    "jp": null,
    "ky": "Көнүгүү режимине өтүңүз",
    "ru": "Перейти в режим практики",
    "uz": "Amaliyot rejimiga o'ting",
    "viet": "Chuyển đến Chế độ luyện tập"
  },
  "practice-mode": {
    "arabic": "وضع التدريب",
    "az": "Təcrübə rejimi",
    "chinese": "練習模式",
    "eng": "practise Mode",
    "hindi": "अभ्यास मोड",
    "ja": "練習モード",
    "jp": null,
    "ky": "Тренинг режими",
    "ru": "Режим практики",
    "uz": "Tayyorgarlik rejimi",
    "viet": "Chế độ luyện tập"
  },
  "test-mode": {
    "arabic": "وضع الاختبار",
    "az": "Test rejimi",
    "chinese": "測試模式",
    "eng": "Test Mode",
    "hindi": "परीक्षण मोड",
    "ja": "テストモード",
    "jp": null,
    "ky": "Сыноо режими",
    "ru": "Тестовый режим",
    "uz": "Sinov rejimi",
    "viet": "Chê độ kiểm tra"
  },
  "instructions-to-select-classes-to-publish-live-test": {
    "arabic": "تعليمات لاختيار الفصول الدراسية لنشر الاختبار المباشر",
    "az": "Canlı testi dərc etmək üçün dərsləri seçmək üçün təlimatlar",
    "chinese": "選擇課程以發布實時測試的說明",
    "eng": "Instructions to select classes to publish live test",
    "hindi": "लाइव टेस्ट प्रकाशित करने के लिए कक्षाओं का चयन करने के निर्देश",
    "ja": "テストを配信するクラスを設定してください",
    "jp": null,
    "ky": "Түз тестти жарыялоо үчүн класстарды тандоо боюнча нускамалар",
    "ru": "Инструкции по выбору классов для публикации живого теста",
    "uz": "Jonli testni nashr qilish uchun sinflarni tanlash bo'yicha ko'rsatmalar",
    "viet": "Hướng dẫn chọn lớp công bố bài kiểm tra trực tiếp"
  },
  "instructions-for-test": {
    "arabic": "تعليمات الاختبار",
    "az": "Test üçün təlimatlar",
    "chinese": "測試說明",
    "eng": "Instructions for Test",
    "hindi": "टेस्ट के लिए निर्देश",
    "ja": "テストの指示",
    "jp": null,
    "ky": "Сыноо үчүн нускамалар",
    "ru": "Инструкции по тестированию",
    "uz": "Sinov uchun ko'rsatmalar",
    "viet": "hướng dẫn làm kiểm tra"
  },
  "move-to-live": {
    "arabic": "انتقل للعيش",
    "az": "Yaşamaq üçün hərəkət edin",
    "chinese": "搬家住",
    "eng": "Move to live",
    "hindi": "जीने के लिए आगे बढ़ें",
    "ja": "配信する",
    "jp": null,
    "ky": "Жашоо үчүн көч",
    "ru": "Переехать жить",
    "uz": "Yashash uchun harakatlaning",
    "viet": "chuyển thành trực tiếp"
  },
  "you-about-to-move-this-draft-version-of-the-test-into-yet-to-start-state-here-are-some-of-default-settings": {
    "arabic": "أنت على وشك نقل نسخة المسودة هذه من الاختبار إلى حالة لم تبدأ بعد. فيما يلي بعض الإعدادات الافتراضية",
    "az": "Siz testin bu qaralama versiyasını &quot;Hələ başlamaq üçün&quot; vəziyyətinə köçürmək üzrəsiniz. Budur bəzi standart parametrlər",
    "chinese": "您即將將該測試的草稿版本移至“尚未開始”狀態。以下是一些默認設置",
    "eng": "You are about to move this draft version of the test into 'Yet to start' State. Here are some of default settings",
    "hindi": "आप परीक्षण के इस ड्राफ़्ट संस्करण को 'अभी शुरू होना बाकी है' स्थिति में ले जाने वाले हैं. यहां कुछ डिफ़ॉल्ट सेटिंग्स दी गई हैं",
    "ja": "この下書きを「未開始」に移行します。必要な条件を設定してください",
    "jp": null,
    "ky": "Сиз тесттин бул долбоор версиясын &quot;Башталышы үчүн&quot; абалына жылдырганы жатасыз. Бул жерде демейки жөндөөлөрдүн кээ бирлери",
    "ru": "Вы собираетесь перевести этот черновой вариант теста в состояние «Еще не начато». Вот некоторые настройки по умолчанию",
    "uz": "Siz testning ushbu qoralama versiyasini “Hali boshlanmadi” holatiga ko‘chirmoqchisiz. Bu erda bir nechta standart sozlamalar mavjud",
    "viet": "Bạn sắp chuyển phiên bản nháp của bài kiểm tra này sang Trạng thái &#39;Chưa bắt đầu&#39;. Dưới đây là một số cài đặt mặc định"
  },
  "click-on-the-text-field-to-edit-instructions": {
    "arabic": "انقر فوق حقل النص لتحرير التعليمات",
    "az": "Təlimatları redaktə etmək üçün mətn sahəsinə klikləyin",
    "chinese": "單擊文本字段以編輯說明",
    "eng": "Click on the text field to edit instructions",
    "hindi": "निर्देशों को संपादित करने के लिए टेक्स्ट फ़ील्ड पर क्लिक करें",
    "ja": "テキストフィールドをクリックして指示を編集する",
    "jp": null,
    "ky": "Инструкцияларды түзөтүү үчүн текст талаасын басыңыз",
    "ru": "Нажмите на текстовое поле, чтобы редактировать инструкции.",
    "uz": "Ko'rsatmalarni tahrirlash uchun matn maydonini bosing",
    "viet": "Nhấp vào trường văn bản để chỉnh sửa hướng dẫn"
  },
  "classlist-to-remove": {
    "arabic": "قائمة الفصول المراد إزالتها",
    "az": "Silinəcək sinif siyahısı",
    "chinese": "要刪除的類列表",
    "eng": "Classlist to remove",
    "hindi": "निकालने के लिए वर्गसूची",
    "ja": "配信しないクラス",
    "jp": null,
    "ky": "Өчүрүлө турган класс тизмеси",
    "ru": "Список классов для удаления",
    "uz": "O'chirish uchun sinf ro'yxati",
    "viet": "Danh sách lớp cần xóa"
  },
  "removing...": {
    "arabic": "إزالة...",
    "az": "Silinir...",
    "chinese": "移除中...",
    "eng": "Removing...",
    "hindi": "हटाना...",
    "ja": "削除中...",
    "jp": null,
    "ky": "Өчүрүү...",
    "ru": "Удаление...",
    "uz": "O'chirilmoqda...",
    "viet": "Đang xóa..."
  },
  "classlist-to-publish": {
    "arabic": "قائمة الفصول الدراسية للنشر",
    "az": "Dərc ediləcək sinif siyahısı",
    "chinese": "要發布的班級列表",
    "eng": "Classlist to publish",
    "hindi": "प्रकाशित करने के लिए कक्षा सूची",
    "ja": "配信するクラス",
    "jp": null,
    "ky": "Жарыялоо үчүн класс тизмеси",
    "ru": "Список классов для публикации",
    "uz": "Nashr qilinadigan sinflar roʻyxati",
    "viet": "Danh sách lớp để xuất bản"
  },
  "enter-the-text-filed-or-reset-it": {
    "arabic": "أدخل النص الموجود في الملف أو أعد تعيينه",
    "az": "Verilmiş mətni daxil edin və ya onu sıfırlayın",
    "chinese": "輸入提交的文本或重置它",
    "eng": "Enter the text filed or reset it",
    "hindi": "दायर पाठ दर्ज करें या इसे रीसेट करें",
    "ja": "テキストフィールドを入力またはリセットする",
    "jp": null,
    "ky": "Берилген текстти киргизиңиз же аны баштапкы абалга келтириңиз",
    "ru": "Введите текстовое поле или сбросьте его",
    "uz": "Taqdim etilgan matnni kiriting yoki uni qayta o'rnating",
    "viet": "Nhập văn bản đã gửi hoặc đặt lại"
  },
  "publish-to-multiple-classes": {
    "arabic": "النشر إلى فئات متعددة",
    "az": "Birdən çox sinifdə dərc edin",
    "chinese": "發佈到多個類",
    "eng": "Publish to Multiple Classes",
    "hindi": "एकाधिक कक्षाओं में प्रकाशित करें",
    "ja": "複数のクラスに配信する",
    "jp": null,
    "ky": "Бир нече класстарга жарыялоо",
    "ru": "Опубликовать в нескольких классах",
    "uz": "Bir nechta sinflarga nashr qilish",
    "viet": "Xuất bản lên nhiều lớp"
  },
  "click-here": {
    "arabic": "انقر هنا",
    "az": "Bura klikləyin",
    "chinese": "點擊這裡",
    "eng": "Click here",
    "hindi": "यहां क्लिक करें",
    "ja": "ここをクリック",
    "jp": null,
    "ky": "Бул жерди басыңыз",
    "ru": "кликните сюда",
    "uz": "bu yerni bosing",
    "viet": "Bấm vào đây"
  },
  "to-select-classes": {
    "arabic": "لتحديد الفصول الدراسية",
    "az": "sinifləri seçmək üçün",
    "chinese": "選擇班級",
    "eng": "to select classes",
    "hindi": "कक्षाओं का चयन करने के लिए",
    "ja": "してクラスを選択",
    "jp": null,
    "ky": "класстарды тандоо үчүн",
    "ru": "для выбора классов",
    "uz": "sinflarni tanlash uchun",
    "viet": "để chọn các lớp học"
  },
  "enable-test-with-timer": {
    "arabic": "تمكين الاختبار باستخدام المؤقت",
    "az": "Taymer ilə Testi aktivləşdirin",
    "chinese": "启用计时器测试",
    "eng": "Enable Test with timer",
    "hindi": "टाइमर के साथ परीक्षण सक्षम करें",
    "ja": "テストに制限時間を設ける",
    "jp": null,
    "ky": "Таймер менен сыноону иштетүү",
    "ru": "Включить тест с таймером",
    "uz": "Taymer bilan testni yoqish",
    "viet": "Bật Kiểm tra bằng bộ đếm thời gian"
  },
  "enable-test-with-re-attempts": {
    "arabic": "تمكين الاختبار مع المحاولات المتكررة",
    "az": "Yenidən cəhdlərlə Testi aktivləşdirin",
    "chinese": "启用重新尝试测试",
    "eng": "Enable Test with Re-attempts",
    "hindi": "पुनः प्रयास के साथ परीक्षण सक्षम करें",
    "ja": "テストのリトライを有効にする。",
    "jp": null,
    "ky": "Кайра аракет кылуу менен сыноону иштетүү",
    "ru": "Включить тест с повторными попытками",
    "uz": "Qayta urinishlar bilan sinovni yoqing",
    "viet": "Bật thử nghiệm với số lần thử lại"
  },
  "set-duration": {
    "arabic": "تعيين المدة",
    "az": "Müddəti təyin edin",
    "chinese": "设置持续时间",
    "eng": "Set duration",
    "hindi": "अवधि निर्धारित करें",
    "ja": "制限時間を設定する",
    "jp": null,
    "ky": "Узактыгы коюу",
    "ru": "Установить продолжительность",
    "uz": "Davomiylikni belgilang",
    "viet": "Đặt thời lượng"
  },
  "to-set-duration": {
    "arabic": "لتحديد المدة",
    "az": "müddəti təyin etmək",
    "chinese": "设置持续时间",
    "eng": "to set duration",
    "hindi": "अवधि निर्धारित करने के लिए",
    "ja": "して設定",
    "jp": null,
    "ky": "узактыгын орнотуу үчүн",
    "ru": "установить продолжительность",
    "uz": "davomiyligini belgilash uchun",
    "viet": "để đặt thời lượng"
  },
  "click-here-to-set-number-of-re-attempts": {
    "arabic": "انقر هنا لتحديد عدد المحاولات المتكررة",
    "az": "Yenidən cəhdlərin sayını təyin etmək üçün bura klikləyin",
    "chinese": "點擊這裡設置重新嘗試次數",
    "eng": "Click here to set number of re-attempts",
    "hindi": "पुनः प्रयासों की संख्या निर्धारित करने के लिए यहां क्लिक करें",
    "ja": "リトライ回数を設定するにはここをクリック",
    "jp": null,
    "ky": "Кайра аракеттердин санын коюу үчүн бул жерди басыңыз",
    "ru": "Нажмите здесь, чтобы установить количество повторных попыток.",
    "uz": "Qayta urinishlar sonini belgilash uchun shu yerni bosing",
    "viet": "Nhấp vào đây để đặt số lần thử lại"
  },
  "to-set-number-of-re-attempts": {
    "arabic": "لتعيين عدد محاولات إعادة المحاولة",
    "az": "təkrar cəhdlərin sayını təyin etmək üçün",
    "chinese": "设置重新尝试的次数",
    "eng": "to set number of re-attempts",
    "hindi": null,
    "ja": "再試行回数を設定するには",
    "jp": null,
    "ky": "кайра аракет санын коюу",
    "ru": "установить количество повторных попыток",
    "uz": "qayta urinishlar sonini belgilash uchun",
    "viet": "để đặt số lần thử lại"
  },
  "re-attempts": {
    "arabic": "محاولات ثانية",
    "az": "yenidən cəhdlər",
    "chinese": "重新尝试",
    "eng": "re-attempts",
    "hindi": null,
    "ja": "再試行",
    "jp": null,
    "ky": "кайра аракеттер",
    "ru": "повторные попытки",
    "uz": "qayta urinishlar",
    "viet": "thử lại"
  },
  "set-number-of-re-attempts": {
    "arabic": "تعيين عدد المحاولات المتكررة",
    "az": "Yenidən cəhdlərin sayını təyin edin",
    "chinese": "重新尝试",
    "eng": "Set number of re-attempts",
    "hindi": null,
    "ja": "再試行回数を設定する",
    "jp": null,
    "ky": "Кайталануучу аракеттердин санын коюңуз",
    "ru": "Установить количество повторных попыток",
    "uz": "Qayta urinishlar sonini belgilang",
    "viet": "thiết lập số lần thử lại"
  },
  "attempt-count-must-be-between-1-and-100": {
    "arabic": "يجب أن يكون عدد المحاولات بين 1 و 100",
    "az": "Cəhdlərin sayı 1 ilə 100 arasında olmalıdır",
    "chinese": "尝试次数必须介于 1 到 100 之间",
    "eng": "Attempt count must be between 1 and 100",
    "hindi": null,
    "ja": "試行回数は 1 ～ 100 でなければなりません",
    "jp": null,
    "ky": "Аракеттердин саны 1ден 100гө чейин болушу керек",
    "ru": "Количество попыток должно быть от 1 до 100.",
    "uz": "Urinishlar soni 1 dan 100 gacha bo'lishi kerak",
    "viet": "Số lần thử phải nằm trong khoảng từ 1 đến 100"
  },
  "ai-powered": {
    "arabic": "مدعوم بالذكاء الاصطناعي",
    "az": "AI Powered",
    "chinese": "人工智能驱动",
    "eng": "AI Powered",
    "hindi": null,
    "ja": "AI を活用した",
    "jp": null,
    "ky": "AI Powered",
    "ru": "На базе искусственного интеллекта",
    "uz": "AI quvvatlanadi",
    "viet": "Hỗ trợ AI"
  },
  "basic": {
    "arabic": "أساسي",
    "az": "Əsas",
    "chinese": "基本的",
    "eng": "Basic",
    "hindi": null,
    "ja": "基本",
    "jp": null,
    "ky": "Негизги",
    "ru": "Базовый",
    "uz": "Asosiy",
    "viet": "Nền tảng"
  },
  "to-edit-instructions-to-be-provided-on-paper": {
    "arabic": "لتحرير التعليمات التي سيتم تقديمها على الورق",
    "az": "redaktə etmək üçün Kağızda veriləcək Təlimatlar",
    "chinese": "编辑首页和说明",
    "eng": "to edit Instructions to be provided on Paper",
    "hindi": "प्रथम पृष्ठ और निर्देशों को संपादित करने के लिए",
    "ja": "して表紙と説明を編集する",
    "jp": null,
    "ky": "Кагазда берилүүчү нускамаларды түзөтүү",
    "ru": "редактировать Инструкции, которые будут предоставлены на бумажном носителе",
    "uz": "Qog'ozda taqdim etiladigan ko'rsatmalarni tahrirlash",
    "viet": "Để chỉnh sửa Trang đầu & Hướng dẫn"
  },
  "note": {
    "arabic": "ملحوظة",
    "az": "Qeyd",
    "chinese": "筆記",
    "eng": "Note",
    "hindi": "टिप्पणी",
    "ja": "備考",
    "jp": null,
    "ky": "Эскертүү",
    "ru": "Примечание",
    "uz": "Eslatma",
    "viet": "Ghi chú"
  },
  "contact-support": {
    "arabic": "اتصل بالدعم",
    "az": "Dəstək ilə əlaqə saxlayın",
    "chinese": "联系支持",
    "eng": "Contact Support",
    "hindi": "समर्थन से संपर्क करें",
    "ja": "サポートに連絡する",
    "jp": null,
    "ky": "Колдоо кызматына кайрылыңыз",
    "ru": "Связаться со службой поддержки",
    "uz": "Yordam olish",
    "viet": "Liên hệ hỗ trợ"
  },
  "email-id-username": {
    "arabic": "معرف البريد الإلكتروني / اسم المستخدم",
    "az": "E-poçt ID / İstifadəçi adı",
    "chinese": "电子邮件/用户名",
    "eng": "Email ID / Username",
    "hindi": "ईमेल आईडी/उपयोगकर्ता नाम",
    "ja": "メールアドレス/ユーザー名",
    "jp": null,
    "ky": "Электрондук почта ID / Колдонуучунун аты",
    "ru": "Идентификатор электронной почты / Имя пользователя",
    "uz": "Elektron pochta / Foydalanuvchi nomi",
    "viet": "ID Email / Tên người dùng"
  },
  "this-test-can-be-published-to-only-classes-of-the-same-grade-if-you-wish-to-publish-to-classes-of-different-grades-please-contact-customer-support": {
    "arabic": "لا يمكن نشر هذا الاختبار إلا للصفوف من نفس الدرجة. إذا كنت ترغب في النشر لصفوف من درجات مختلفة, يرجى الاتصال بدعم العملاء",
    "az": "Bu Test yalnız eyni sinifdə olan siniflər üçün dərc edilə bilər. Fərqli siniflərdə nəşr etmək istəyirsinizsə, müştəri dəstəyi ilə əlaqə saxlayın",
    "chinese": "該測試只能發布給同年級的班級。如果您想發佈到不同年級的班級,請聯繫客戶支持",
    "eng": "This Test can be published to only classes of the same grade. If you wish to publish to classes of different grades, please contact customer support",
    "hindi": "यह परीक्षा केवल उसी ग्रेड की कक्षाओं के लिए प्रकाशित की जा सकती है। यदि आप विभिन्न ग्रेड की कक्षाओं में प्रकाशित करना चाहते हैं, तो कृपया ग्राहक सहायता से संपर्क करें",
    "ja": "このテストは同学年にのみ配信が可能です。異なる学年に配信を希望する場合は、カスタマーサポートまでお問い合わせください",
    "jp": null,
    "ky": "Бул Тест бир эле класстын класстарына гана жарыяланышы мүмкүн. Эгерде сиз ар кандай класстардагы класстарга жарыялоону кааласаңыз, кардарларды колдоо кызматына кайрылыңыз",
    "ru": "Этот тест может быть опубликован только для классов одного уровня. Если вы хотите опубликовать его для классов разных уровней, свяжитесь со службой поддержки клиентов",
    "uz": "Ushbu test faqat bir xil sinflar uchun e'lon qilinishi mumkin. Agar siz turli darajadagi sinflarga nashr qilmoqchi bo'lsangiz, mijozlarni qo'llab-quvvatlash xizmatiga murojaat qiling",
    "viet": "Bài kiểm tra này chỉ có thể được công bố cho các lớp cùng khối. Nếu bạn muốn xuất bản lên các lớp có cấp độ khác nhau, vui lòng liên hệ với bộ phận hỗ trợ khách hàng"
  },
  "click-on-default-to-switch-back-to-cerebry's-generic-instructions": {
    "arabic": "انقر فوق افتراضي للتبديل مرة أخرى إلى تعليمات Cerebry العامة",
    "az": "Cerebry&#39;nin Ümumi Təlimatlarına qayıtmaq üçün Defolt üzərinə klikləyin",
    "chinese": "點擊 Default 切換回 Cerebry 的 Generic Instructions",
    "eng": "Click on Default to switch back to Cerebry's Generic Instructions",
    "hindi": "सेरेब्री के सामान्य निर्देशों पर वापस जाने के लिए डिफ़ॉल्ट पर क्लिक करें",
    "ja": "「デフォルト」をクリックし、初期設定の説明に戻す。",
    "jp": null,
    "ky": "Cerebry&#39;дин жалпы нускамаларына кайра өтүү үчүн Демейки баскычын чыкылдатыңыз",
    "ru": "Нажмите «По умолчанию», чтобы вернуться к общим инструкциям Cerebry.",
    "uz": "Cerebry-ning umumiy ko'rsatmalariga qaytish uchun Standart-ni bosing",
    "viet": "Nhấp vào Mặc định để quay lại Hướng dẫn chung của Cerebry"
  },
  "default": {
    "arabic": "تقصير",
    "az": "Defolt",
    "chinese": "默認",
    "eng": "Default",
    "hindi": "चूक जाना",
    "ja": "デフォルトに戻す",
    "jp": null,
    "ky": "Демейки",
    "ru": "По умолчанию",
    "uz": "Standart",
    "viet": "Mặc định"
  },
  "save": {
    "arabic": "يحفظ",
    "az": "Saxla",
    "chinese": "節省",
    "eng": "Save",
    "hindi": "बचाना",
    "ja": "保存",
    "jp": null,
    "ky": "Сактоо",
    "ru": "Сохранять",
    "uz": "Saqlash",
    "viet": "Lưu"
  },
  "correct": {
    "arabic": "صحيح",
    "az": "Düzgün",
    "chinese": "正確的",
    "eng": "Correct",
    "hindi": "सही",
    "ja": "正解",
    "jp": null,
    "ky": "Туура",
    "ru": "Правильный",
    "uz": "To'g'ri",
    "viet": "Chính xác"
  },
  "incorrect": {
    "arabic": "غير صحيح",
    "az": "Səhv",
    "chinese": "不正确",
    "eng": "Incorrect",
    "hindi": "ग़लत",
    "ja": "不正解",
    "jp": null,
    "ky": "Туура эмес",
    "ru": "Неправильно",
    "uz": "Noto'g'ri",
    "viet": "Không đúng"
  },
  "partly-correct": {
    "arabic": "صحيح جزئيا",
    "az": "Qismən Düzgün",
    "chinese": "部分正確",
    "eng": "Partly Correct",
    "hindi": "आंशिक रूप से सही",
    "ja": "部分点",
    "jp": null,
    "ky": "Жарым-жартылай туура",
    "ru": "Частично верно",
    "uz": "Qisman to'g'ri",
    "viet": "Đúng một phần"
  },
  "partly-marked": {
    "arabic": "مُميز جزئيًا",
    "az": "Qismən işarələnmişdir",
    "chinese": "部分標記",
    "eng": "Partly marked",
    "hindi": "आंशिक रूप से चिह्नित",
    "ja": "部分点",
    "jp": null,
    "ky": "Жарым-жартылай белгиленген",
    "ru": "Частично отмечено",
    "uz": "Qisman belgilangan",
    "viet": "đánh dấu một phần"
  },
  "wrong": {
    "arabic": "خطأ",
    "az": "Səhv",
    "chinese": "錯誤的",
    "eng": "Wrong",
    "hindi": "गलत",
    "ja": "不正解",
    "jp": null,
    "ky": "туура эмес",
    "ru": "Неправильный",
    "uz": "Noto'g'ri",
    "viet": "Sai"
  },
  "correct-answer": {
    "arabic": "الإجابة الصحيحة",
    "az": "Düzgün Cavab",
    "chinese": "正確答案",
    "eng": "Correct Answer",
    "hindi": "सही उत्तर",
    "ja": "正答",
    "jp": null,
    "ky": "Туура жооп",
    "ru": "Правильный ответ",
    "uz": "To'g'ri javob",
    "viet": "Câu trả lời chính xác"
  },
  "general-instructions": {
    "arabic": "تعليمات عامة",
    "az": "Ümumi Təlimatlar",
    "chinese": "一般說明",
    "eng": "General Instructions",
    "hindi": "सामान्य निर्देश",
    "ja": "テストの説明",
    "jp": null,
    "ky": "Жалпы нускамалар",
    "ru": "Общие инструкции",
    "uz": "Umumiy ko'rsatmalar",
    "viet": "Hướng dẫn chung"
  },
  "make-sure-to-click-'submit-answer'-for-every-question-Forgetting-to-do-so-will-result-in-the-question-being-marked-as-unanswered": {
    "arabic": "تأكد من النقر على إرسال الإجابة لكل سؤال. سيؤدي نسيان القيام بذلك إلى وضع علامة على السؤال باعتباره بلا إجابة.",
    "az": "Hər sual üçün &quot;Cavabı Göndər&quot; düyməsini sıxmağınızdan əmin olun. Bunu unutmaq sualın cavabsız kimi qeyd olunması ilə nəticələnəcək.",
    "chinese": "確保為每個問題單擊“提交答案”。忘記這樣做會導致問題被標記為未回答。",
    "eng": "Make sure to click 'Submit Answer' for every question. Forgetting to do so will result in the question being marked as unanswered.",
    "hindi": "हर प्रश्न के लिए 'जवाब सबमिट करें' पर क्लिक करना सुनिश्चित करें। ऐसा करने में भूल करने का परिणाम होगा प्रश्न को अनुत्तरित के रूप में चिह्नित किया जा रहा है।",
    "ja": "一問ずつ「回答を送信」をクリックしてください。クリックしないと、未回答として採点されます。",
    "jp": null,
    "ky": "Ар бир суроо үчүн &quot;Жооп берүү&quot; баскычын басууну унутпаңыз. Муну унутуп койсоңуз, суроо жоопсуз деп белгиленет.",
    "ru": "Обязательно нажмите «Отправить ответ» для каждого вопроса. Если вы забудете это сделать, вопрос будет отмечен как неотвеченный.",
    "uz": "Har bir savol uchun “Javob yuborish” tugmasini bosganingizga ishonch hosil qiling. Buni unutib qo'ysangiz, savol javobsiz deb belgilanishiga olib keladi.",
    "viet": "Hãy chắc chắn rằng bạn đã bấm “Trả lời“ cho mọi câu hỏi. Nếu không, các câu hỏi sẽ bị đánh dấu là chưa làm"
  },
  "are-you-sure-you-want-to-make-this-exam-live-for-students": {
    "arabic": "هل أنت متأكد من أنك تريد جعل هذا الاختبار مباشرًا للطلاب؟",
    "az": "Bu imtahanı tələbələr üçün canlı etmək istədiyinizə əminsiniz",
    "chinese": "您確定要為學生直播此考試嗎",
    "eng": "Are you sure you want to make this exam live for students",
    "hindi": "क्या आप वाकई इस परीक्षा को छात्रों के लिए लाइव बनाना चाहते हैं",
    "ja": "このテストを生徒に配信してもよろしいですか？",
    "jp": null,
    "ky": "Бул экзаменди студенттер үчүн түз бергиңиз келеби?",
    "ru": "Вы уверены, что хотите сделать этот экзамен доступным для студентов?",
    "uz": "Haqiqatan ham bu imtihonni talabalar uchun jonli o'tkazmoqchimisiz",
    "viet": "Bạn có chắc chắn muốn chuyển bài kiểm tra này thành trực tiếp?"
  },
  "click-here-to-load-this-question": {
    "arabic": "انقر هنا لتحميل هذا السؤال",
    "az": "Bu sualı yükləmək üçün bura klikləyin",
    "chinese": "單擊此處加載此問題",
    "eng": "Click here to load this question",
    "hindi": "इस प्रश्न को लोड करने के लिए यहां क्लिक करें",
    "ja": "クリックしてこの問題を読み込む",
    "jp": null,
    "ky": "Бул суроону жүктөө үчүн бул жерди басыңыз",
    "ru": "Нажмите здесь, чтобы загрузить этот вопрос",
    "uz": "Bu savolni yuklash uchun shu yerni bosing",
    "viet": "Nhấn vào đây để tải câu hỏi này"
  },
  "click-here-to-load-this": {
    "arabic": "انقر هنا لتحميل هذا",
    "az": "Bunu yükləmək üçün bura klikləyin",
    "chinese": "點擊此處加載",
    "eng": "Click here to load this",
    "hindi": "इस को लोड करने के लिए",
    "ja": "読み込む",
    "jp": null,
    "ky": "Муну жүктөө үчүн бул жерди басыңыз",
    "ru": "Нажмите здесь, чтобы загрузить это",
    "uz": "Buni yuklash uchun shu yerni bosing",
    "viet": "Nhấn vào đây để tải cái này"
  },
  "settings": {
    "arabic": "إعدادات",
    "az": "Parametrlər",
    "chinese": "設置",
    "eng": "Settings",
    "hindi": "समायोजन",
    "ja": "設定",
    "jp": null,
    "ky": "Орнотуулар",
    "ru": "Настройки",
    "uz": "Sozlamalar",
    "viet": "Cài đặt"
  },
  "your-last-update-on": {
    "arabic": "آخر تحديث لك على",
    "az": "Son yeniləməniz açıqdır",
    "chinese": "您的最後更新時間",
    "eng": "Your last update on",
    "hindi": "आपका आखिरी अपडेट चालू है",
    "ja": "最終更新",
    "jp": null,
    "ky": "Акыркы жаңыртыңыз",
    "ru": "Ваше последнее обновление",
    "uz": "Sizning oxirgi yangilanishingiz",
    "viet": "Cập nhật cuối cùng vào"
  },
  "update": {
    "arabic": "تحديث",
    "az": "Yeniləyin",
    "chinese": "更新",
    "eng": "Update",
    "hindi": "अपडेट",
    "ja": "更新",
    "jp": null,
    "ky": "Жаңыртуу",
    "ru": "Обновлять",
    "uz": "Yangilash",
    "viet": "Cập nhật"
  },
  "Updating...": {
    "arabic": "جاري التحديث...",
    "az": "Yenilənir...",
    "chinese": "更新中...",
    "eng": "Updating...",
    "hindi": "अपडेट हो रहा है...",
    "ja": "更新中...",
    "jp": null,
    "ky": "Жаңыртылууда...",
    "ru": "Обновление...",
    "uz": "Yangilanmoqda...",
    "viet": "Đang cập nhật..."
  },
  "open-Exam-on": {
    "arabic": "الامتحان المفتوح على",
    "az": "İmtahanı Açın",
    "chinese": "開考時間",
    "eng": "Open Exam On",
    "hindi": "ओपन परीक्षा चालू",
    "ja": "テストの配信日を設定",
    "jp": null,
    "ky": "Экзаменди ачуу күйүк",
    "ru": "Открытый экзамен на",
    "uz": "Imtihonni oching",
    "viet": "Bài kiểm tra Mở"
  },
  "open-student-access-on": {
    "arabic": "فتح وصول الطالب على",
    "az": "Tələbə Girişini Aktiv açın",
    "chinese": "打開學生訪問",
    "eng": "Open Student Access On",
    "hindi": "ओपन स्टूडेंट एक्सेस ऑन",
    "ja": "生徒への配信開始日を設定",
    "jp": null,
    "ky": "Студенттик мүмкүнчүлүктү ачуу",
    "ru": "Открытый студенческий доступ на",
    "uz": "O‘quvchi ruxsatini oching",
    "viet": "Cấp quyền truy cập của sinh viên Bật"
  },
  "no-schedule-set": {
    "arabic": "لم يتم تحديد جدول زمني",
    "az": "Cədvəl təyin olunmayıb",
    "chinese": "未設定時間表",
    "eng": "No schedule set",
    "hindi": "कोई शेड्यूल सेट नहीं है",
    "ja": "配信日時が未設定です",
    "jp": null,
    "ky": "График коюлган жок",
    "ru": "Расписание не установлено",
    "uz": "Jadval sozlanmagan",
    "viet": "Chưa có sự kiện nào"
  },
  "open-results-on": {
    "arabic": "نتائج مفتوحة على",
    "az": "Nəticələri Açın",
    "chinese": "打開結果",
    "eng": "Open Results On",
    "hindi": "परिणाम खोलें",
    "ja": "結果の配信日を設定",
    "jp": null,
    "ky": "Натыйжаларды ачуу Күйүк",
    "ru": "Открыть результаты",
    "uz": "Natijalarni oching",
    "viet": "Mở kết quả trong"
  },
  "marks-out-of": {
    "arabic": "علامات خارج",
    "az": "-dən işarələyir",
    "chinese": "標記出",
    "eng": "marks out of",
    "hindi": "से चिन्हित करता है",
    "ja": "点 ※最大",
    "jp": null,
    "ky": "ичинен белгилейт",
    "ru": "знаки из",
    "uz": "dan belgilaydi",
    "viet": "đánh dấu"
  },
  "out-of": {
    "arabic": "خارج من",
    "az": "-dən",
    "chinese": "在......之外",
    "eng": "out of",
    "hindi": "से चिन्हित करता है",
    "ja": "/",
    "jp": null,
    "ky": "ичинен",
    "ru": "из",
    "uz": "tashqarida",
    "viet": "ra khỏi"
  },
  "marks": {
    "arabic": "علامات",
    "az": "işarələri",
    "chinese": "分數",
    "eng": "marks",
    "hindi": "निशान",
    "ja": "点",
    "jp": null,
    "ky": "белгилер",
    "ru": "знаки",
    "uz": "belgilar",
    "viet": "điểm"
  },
  "mark(s)": {
    "arabic": "العلامة(العلامات)",
    "az": "işarə(lər)",
    "chinese": "分數)",
    "eng": "mark(s)",
    "hindi": "निशान",
    "ja": "点",
    "jp": null,
    "ky": "белги(лер)",
    "ru": "знак(ы)",
    "uz": "belgi(lar)",
    "viet": "Điểm"
  },
  "mark": {
    "arabic": "علامة",
    "az": "işarələyin",
    "chinese": "標記",
    "eng": "mark",
    "hindi": "निशान",
    "ja": "点",
    "jp": null,
    "ky": "белгилөө",
    "ru": "отметка",
    "uz": "belgi",
    "viet": "đánh dấu"
  },
  "unattempted": {
    "arabic": "لم تتم محاولة",
    "az": "cəhdsiz",
    "chinese": "未嘗試",
    "eng": "Unattempted",
    "hindi": "अप्रयास",
    "ja": "未解答",
    "jp": null,
    "ky": "аракетсиз",
    "ru": "Непредпринятый",
    "uz": "Urinishsiz",
    "viet": "Không thử"
  },
  "skipped": {
    "arabic": "تم تخطيه",
    "az": "atladı",
    "chinese": "跳過",
    "eng": "skipped",
    "hindi": "छोड़ा गया",
    "ja": "スキップ",
    "jp": null,
    "ky": "өткөрүп жиберди",
    "ru": "пропущено",
    "uz": "o'tkazib yubordi",
    "viet": "bỏ qua"
  },
  "students-in-the-class": {
    "arabic": "الطلاب في الفصل",
    "az": "sinifdəki tələbələr",
    "chinese": "班上的學生",
    "eng": "students in the class",
    "hindi": "कक्षा में छात्र",
    "ja": "人の生徒がこのクラスに所属しています",
    "jp": null,
    "ky": "класстагы окуучулар",
    "ru": "учащиеся в классе",
    "uz": "sinfdagi talabalar",
    "viet": "Học sinh trong lớp"
  },
  "students": {
    "arabic": "طلاب",
    "az": "Şagirdlər",
    "chinese": "學生",
    "eng": "Students",
    "hindi": "छात्र",
    "ja": "名の生徒",
    "jp": null,
    "ky": "Окуучулар",
    "ru": "Студенты",
    "uz": "O‘quvchilar",
    "viet": "Học sinh"
  },
  "student": {
    "arabic": "طلاب",
    "az": "Şagirdlər",
    "chinese": "學生",
    "eng": "Students",
    "hindi": "छात्र",
    "ja": "生徒",
    "jp": null,
    "ky": "Окуучулар",
    "ru": "Студенты",
    "uz": "O‘quvchilar",
    "viet": "Học sinh"
  },
  "Student": {
    "arabic": "طالب",
    "az": "Şagirdlər",
    "chinese": "學生",
    "eng": "O‘quvchilar",
    "hindi": "छात्र",
    "ja": "生徒",
    "jp": null,
    "ky": "Студенттер",
    "ru": "Студент",
    "uz": "O‘quvchi",
    "viet": "Học sinh"
  },
  "Selected-Student-Details": {
    "arabic": "تفاصيل الطالب المختار",
    "az": "Seçilmiş Tələbə Təfərrüatları",
    "chinese": "所选学生详细信息",
    "eng": "Selected Student Details",
    "hindi": "चयनित छात्र विवरण",
    "ja": "選択された学生の詳細",
    "jp": null,
    "ky": "Тандалган студенттин маалыматы",
    "ru": "Данные выбранного студента",
    "uz": "Tanlangan o‘quvchi tafsilotlari",
    "viet": "Thông tin chi tiết về sinh viên đã chọn"
  },
  "No-student-found": {
    "arabic": "لم يتم العثور على طالب",
    "az": "Tələbə tapılmadı",
    "chinese": "没有找到学生",
    "eng": "No student found",
    "hindi": "कोई छात्र नहीं मिला",
    "ja": "生徒が見つかりませんでした",
    "jp": null,
    "ky": "Студент табылган жок",
    "ru": "Студент не найден",
    "uz": "Hech qanday o‘quvchi topilmadi",
    "viet": "Không tìm thấy học sinh nào"
  },
  "Search": {
    "arabic": "يبحث",
    "az": "Axtar",
    "chinese": "搜索",
    "eng": "Search",
    "hindi": "खोज",
    "ja": "検索",
    "jp": null,
    "ky": "Издөө",
    "ru": "Поиск",
    "uz": "Qidirmoq",
    "viet": "Tìm kiếm"
  },
  "sort-by-score": {
    "arabic": "فرز حسب النتيجة",
    "az": "Hesaba görə çeşidləyin",
    "chinese": "按分數排序",
    "eng": "Sort by Score",
    "hindi": "स्कोर द्वारा क्रमबद्ध करें",
    "ja": "得点順",
    "jp": null,
    "ky": "Упай боюнча сорттоо",
    "ru": "Сортировать по баллам",
    "uz": "Ballar bo'yicha saralash",
    "viet": "Sắp xếp theo Điểm"
  },
  "(ASC)": {
    "arabic": "(التصنيف الأسترالي)",
    "az": "(ASC)",
    "chinese": "(升序)",
    "eng": "(ASC)",
    "hindi": "(एससी)",
    "ja": "(昇順)",
    "jp": null,
    "ky": "(ASC)",
    "ru": "(АСЦ)",
    "uz": "(ASC)",
    "viet": "(Tăng dần)"
  },
  "(DESC)": {
    "arabic": "(تنازلي)",
    "az": "(AÇIQ)",
    "chinese": "(降序)",
    "eng": "(DESC)",
    "hindi": "(डेस्क)",
    "ja": "(降順)",
    "jp": null,
    "ky": "(DESC)",
    "ru": "(убывание)",
    "uz": "(DESC)",
    "viet": "(Giảm dần)"
  },
  "sort-by-first-name": {
    "arabic": "فرز حسب الاسم الأول",
    "az": "Ada görə çeşidləyin",
    "chinese": "按名字排序",
    "eng": "Sort by first Name",
    "hindi": "पहले नाम से क्रमबद्ध करें",
    "ja": "名前（名）で並び替え",
    "jp": null,
    "ky": "Аты боюнча иреттөө",
    "ru": "Сортировать по имени",
    "uz": "Ismi bo‘yicha tartiblangan",
    "viet": "Sắp xếp theo Tên"
  },
  "sort-by-last-name": {
    "arabic": "فرز حسب الاسم الأخير",
    "az": "Soyadı ilə çeşidləyin",
    "chinese": "按姓氏排序",
    "eng": "Sort by last Name",
    "hindi": "अंतिम नाम से क्रमबद्ध करें",
    "ja": "名前（姓）で並び替え",
    "jp": null,
    "ky": "Фамилия боюнча иреттөө",
    "ru": "Сортировать по фамилии",
    "uz": "Familiyasi bo‘yicha tartiblangan",
    "viet": "Sắp xếp theo Họ"
  },
  "low-to-high-score": {
    "arabic": "من الأقل إلى الأعلى",
    "az": "Aşağıdan yüksək hesaba",
    "chinese": "從低到高分",
    "eng": "Low to High Score",
    "hindi": "निम्न से उच्च स्कोर",
    "ja": "得点順（低→高）",
    "jp": null,
    "ky": "Төмөндөн жогорку упайга чейин",
    "ru": "Оценка от низкой к высокой",
    "uz": "Pastdan yuqori ballgacha",
    "viet": "Điểm từ thấp đến cao"
  },
  "high-to-low-score": {
    "arabic": "من أعلى إلى أقل نتيجة",
    "az": "Yüksəkdən aşağıya doğru",
    "chinese": "從高分到低分",
    "eng": "High to Low Score",
    "hindi": "उच्च से निम्न स्कोर",
    "ja": "得点順（高→低）",
    "jp": null,
    "ky": "Жогоркудан Төмөн Упайга чейин",
    "ru": "Оценка от высокой к низкой",
    "uz": "Yuqoridan pastgacha ball",
    "viet": "Điểm từ cao đến thấp"
  },
  "score": {
    "arabic": "نتيجة",
    "az": "Hesab",
    "chinese": "分數",
    "eng": "Score",
    "hindi": "अंक",
    "ja": "得点",
    "jp": null,
    "ky": "Упай",
    "ru": "Счет",
    "uz": "Xol",
    "viet": "Điểm"
  },
  "question-attempted": {
    "arabic": "سؤال تم محاولته",
    "az": "Sual Cəhd",
    "chinese": "問題嘗試",
    "eng": "Question Attempted",
    "hindi": "प्रश्न प्रयास किया गया",
    "ja": "解答数",
    "jp": null,
    "ky": "Суроо аракети",
    "ru": "Вопрос Попытка",
    "uz": "Urinib ko‘rilgan savollar soni",
    "viet": "Câu hỏi đã trả lời"
  },
  "correctly-solved": {
    "arabic": "تم حلها بشكل صحيح",
    "az": "Düzgün həll olunub",
    "chinese": "正確解決",
    "eng": "Correctly Solved",
    "hindi": "सही ढंग से हल किया हुआ",
    "ja": "正答数",
    "jp": null,
    "ky": "Туура чечилген",
    "ru": "Правильно решено",
    "uz": "To‘g‘ri javoblar soni",
    "viet": "Trả lời đúng"
  },
  "wrong-attempt": {
    "arabic": "محاولة خاطئة",
    "az": "Səhv cəhd",
    "chinese": "錯誤的嘗試",
    "eng": "Wrong Attempt",
    "hindi": "गलत प्रयास",
    "ja": "誤答数",
    "jp": null,
    "ky": "Туура эмес аракет",
    "ru": "Неправильная попытка",
    "uz": "Noto‘g‘i urinishlar soni",
    "viet": "Trả lời sai"
  },
  "time-taken": {
    "arabic": "الوقت المستغرق",
    "az": "Alınan vaxt",
    "chinese": "所用的時間",
    "eng": "Time Taken",
    "hindi": "समय लगेगा",
    "ja": "かかった時間",
    "jp": null,
    "ky": "Убакыт алынган",
    "ru": "Время, затраченное",
    "uz": "Sarflangan vaqt",
    "viet": "Thời gian làm bài"
  },
  "the-timing-cannot-be-changed-since-one-or-more-students-are-taking-the-test-live-right-now-if-you-wish-to-change-please-wait-for-until-the-test-is-completed-at-the-student-end": {
    "arabic": "لا يمكن تغيير التوقيت نظرًا لأن طالبًا واحدًا أو أكثر يؤدون الاختبار مباشرةً الآن. إذا كنت ترغب في التغيير, يرجى الانتظار حتى اكتمال الاختبار في نهاية وقت الطالب",
    "az": "Bir və ya bir neçə tələbə hazırda canlı sınaqdan keçdiyi üçün vaxt dəyişdirilə bilməz. Dəyişmək istəyirsinizsə, lütfən, imtahanın tələbənin sonunda tamamlanmasını gözləyin",
    "chinese": "由於一名或多名學生正在現場參加考試,因此時間無法更改。如需更改,請等待學生端測試完成",
    "eng": "The timing cannot be changed since one or more students are taking the test live right now. If you wish to change, please wait for until the test is completed at the student end",
    "hindi": "समय नहीं बदला जा सकता क्योंकि अभी एक या अधिक छात्र लाइव परीक्षा दे रहे हैं। यदि आप बदलना चाहते हैं, तो कृपया छात्र के अंत में परीक्षण पूरा होने तक प्रतीक्षा करें",
    "ja": "現在受験中の生徒がいるため、スケジュールを変更することができません。変更する場合は、生徒がテストを終了するまでお待ちください",
    "jp": null,
    "ky": "Учурда бир же бир нече студент түз эфирде тесттен өтүп жаткандыктан, убакытты өзгөртүү мүмкүн эмес. Эгерде сиз өзгөртүүнү кааласаңыз, студенттин аягында тест бүткүчө күтө туруңуз",
    "ru": "Время не может быть изменено, так как один или несколько студентов сдают тест в прямом эфире прямо сейчас. Если вы хотите изменить время, пожалуйста, подождите, пока тест не будет завершен в конце студента",
    "uz": "Vaqtni o‘zgartirib bo‘lmaydi, chunki hozir bir yoki bir nechta o‘quvchi jonli ravishda test topshirmoqda. Agar siz o'zgartirishni xohlasangiz, o‘quvchi oxirida test tugashini kuting",
    "viet": "Không thể thay đổi thời gian làm bài vì hiện tại có một hoặc nhiều học sinh đang làm bài kiểm tra trực tiếp. Nếu bạn muốn thay đổi, vui lòng đợi cho đến khi bài kiểm tra hoàn thành khi học sinh làm bài xong"
  },
  "student-access-would-be-turned-off-due-to-future-date-clear-all-dates-to-open-student-access-now": {
    "arabic": "سيتم إيقاف وصول الطلاب بسبب تاريخ مستقبلي. امسح كل التواريخ لفتح وصول الطلاب الآن",
    "az": "Gələcək tarixə görə tələbə girişi söndürüləcək. Tələbə Girişini indi açmaq üçün bütün tarixləri silin",
    "chinese": "由於未來的日期,學生訪問將被關閉。清除所有日期以立即打開學生訪問",
    "eng": "Student access would be turned off due to future date. Clear all dates to Open Student Access now",
    "hindi": "भविष्य की तारीख के कारण छात्र की पहुंच बंद कर दी जाएगी। छात्र प्रवेश खोलने के लिए अभी सभी तिथियां साफ़ करें",
    "ja": "未来の日付が設定されているため、生徒のアクセスができなくなります。今すぐ生徒のアクセスを再開するには、全ての日付を消去してください。",
    "jp": null,
    "ky": "Келечектеги датага байланыштуу студенттердин кирүү мүмкүнчүлүгү өчүрүлөт. Студенттик мүмкүнчүлүктү азыр ачуу үчүн бардык даталарды тазалаңыз",
    "ru": "Доступ студентов будет отключен из-за будущей даты. Очистить все даты, чтобы открыть доступ студентов сейчас",
    "uz": "Kelgusi sana tufayli talabalarga kirish oʻchirib qoʻyiladi. O‘quvchi ruxsatini ochish uchun barcha sanalarni tozalang",
    "viet": "Quyền truy cập của sinh viên sẽ bị tắt do các sự kiện trong tương lai. Xóa tất cả các sự kiện để Mở quyền truy cập của học sinh ngay"
  },
  "do-you-want-to-turn-the-student-access-on-when-open-student-access-date-is-already-set": {
    "arabic": "هل تريد تشغيل وصول الطالب عندما يتم تعيين تاريخ وصول الطالب المفتوح بالفعل؟",
    "az": "Açıq Tələbə Giriş Tarixi artıq təyin edildikdə, Tələbə Girişini aktiv etmək istəyirsiniz",
    "chinese": "如果已設置開放學生訪問日期,是否要打開學生訪問",
    "eng": "Do you want to turn the Student Access on when Open Student Access Date is already set",
    "hindi": "जब ओपन स्टूडेंट एक्सेस डेट पहले से ही सेट हो, तो क्या आप स्टूडेंट एक्सेस को चालू करना चाहते हैं",
    "ja": "生徒への配信と同日に、生徒のアクセス権限も付与しますか？",
    "jp": null,
    "ky": "Ачык Студенттик мүмкүндүк алуу күнү мурунтан эле коюлганда Студенттик мүмкүндүктү күйгүзгүңүз келеби?",
    "ru": "Хотите ли вы включить студенческий доступ, если дата открытия студенческого доступа уже установлена?",
    "uz": "Ochiq o‘quvchi kirish sanasi allaqachon belgilangan bo‘lsa, O‘quvchi ruxsatini yoqmoqchimisiz",
    "viet": "Bạn có muốn bật Quyền truy cập của học sinh khi Ngày cấp quyền truy cập của học sinh đã được đặt?"
  },
  "few-or-more-students-have-started-the-exam-are-you-sure-you-want-to-save": {
    "arabic": "لقد بدأ عدد قليل أو أكثر من الطلاب الامتحان, هل أنت متأكد من أنك تريد الحفظ؟",
    "az": "Az və ya daha çox tələbə imtahana başlayıb, qənaət etmək istədiyinizə əminsiniz",
    "chinese": "少數或更多的學生已經開始考試,你確定要保存嗎",
    "eng": "Few or more students have started the exam, are you sure you want to save",
    "hindi": "कुछ या अधिक छात्रों ने परीक्षा शुरू की है, क्या आप सुनिश्चित हैं कि आप बचत करना चाहते हैं",
    "ja": "生徒が既に受験を開始しています。変更を保存してもよろしいですか？",
    "jp": null,
    "ky": "Экзаменди бир нече же бир нече студент баштады, чын эле сактап калгыңыз келеби?",
    "ru": "Несколько или больше студентов приступили к экзамену, вы уверены, что хотите сохранить?",
    "uz": "Bir necha yoki undan ortiq o‘quvchi imtihonni boshladi, saqlamoqchimisiz",
    "viet": "Một hoặc nhiều học sinh đã bắt đầu làm bài kiểm tra, bạn có chắc chắn muốn lưu chứ?"
  },
  "please-select-a-open-student-access-on-date-after-the-open-exam-on-date": {
    "arabic": "الرجاء تحديد تاريخ وصول الطالب المفتوح بعد تاريخ الامتحان المفتوح",
    "az": "Lütfən, Açıq İmtahandan sonra Açıq Tələbə Giriş Tarixini seçin",
    "chinese": "請在配信考試日期之後選擇一個開放學生訪問日期",
    "eng": "Please select a Open Student Access On date after the Open Exam on date",
    "hindi": "कृपया ओपन परीक्षा ऑन डेट के बाद ओपन स्टूडेंट एक्सेस ऑन डेट चुनें",
    "ja": "生徒へのアクセス権限付与日は、テスト配信日より後に設定してください。",
    "jp": null,
    "ky": "Сураныч, Студенттин Ачык Сынактан кийинки күнүн тандаңыз",
    "ru": "Пожалуйста, выберите дату Открытого доступа для студентов после даты Открытого экзамена",
    "uz": "Iltimos, Ochiq imtihondan keyin Ochiq Talabalar Kirish sanasini tanlang",
    "viet": "Vui lòng đặt ngày Mở quyền Truy cập cho Học sinh sau ngày Mở quyền Truy cập vào kỳ thi"
  },
  "please-select-a-close-student-access-on-date-after-the-open-exam-on-date": {
    "arabic": "الرجاء تحديد تاريخ إغلاق وصول الطالب بعد تاريخ الامتحان المفتوح",
    "az": "Lütfən, Açıq İmtahandan sonra Tələbə Girişini Bağlamaq tarixini seçin",
    "chinese": "請在開放考試日期之後選擇關閉學生訪問日期",
    "eng": "Please select a Close Student Access On date after the Open Exam on date",
    "hindi": "कृपया ओपन परीक्षा ऑन डेट के बाद क्लोज स्टूडेंट एक्सेस ऑन डेट चुनें",
    "ja": "生徒のアクセス権限停止日は、テスト配信日より後に設定してください。",
    "jp": null,
    "ky": "Сураныч, Ачык сынактан кийин Студенттик Мүмкүнчүлүктү жабуу күнүн тандаңыз",
    "ru": "Пожалуйста, выберите дату закрытия доступа для студентов после даты открытого экзамена.",
    "uz": "Iltimos, Ochiq imtihondan keyin talabalarga kirishni yopish sanasini tanlang",
    "viet": "Vui lòng chọn một Close Student Access On date after the Open Exam on date"
  },
  "open-student-access-now": {
    "arabic": "افتح باب الوصول للطلاب الآن",
    "az": "Tələbə Girişini indi açın",
    "chinese": "立即開放學生訪問",
    "eng": "Open Student Access now",
    "hindi": "विद्यार्थी प्रवेश अभी खोलें",
    "ja": "生徒へのアクセス権限を今すぐ付与する",
    "jp": null,
    "ky": "Студенттик мүмкүнчүлүктү азыр ачыңыз",
    "ru": "Откройте студенческий доступ сейчас",
    "uz": "Talaba ruxsatini hozir oching",
    "viet": "Mở quyền truy cập của sinh viên ngay bây giờ"
  },
  "toggle-on-to-enable-access-to-test-now": {
    "arabic": "قم بتشغيله لتمكين الوصول إلى الاختبار الآن",
    "az": "İndi test etmək üçün girişi aktiv etmək üçün Aktivləşdirin",
    "chinese": "開啟以啟用訪問權限以立即進行測試",
    "eng": "Toggle On to enable access to test now",
    "hindi": "परीक्षण के लिए अभी पहुंच सक्षम करने के लिए टॉगल चालू करें",
    "ja": "オンに切り替えて、今すぐテストへアクセスを可能にする",
    "jp": null,
    "ky": "Азыр сыноо мүмкүнчүлүгүн иштетүү үчүн күйгүзүңүз",
    "ru": "Включите, чтобы разрешить доступ к тестированию прямо сейчас",
    "uz": "Hozir sinovdan oʻtish uchun ruxsatni yoqish uchun yoqing",
    "viet": "Bật để cho phép truy cập vào bài kiểm tra"
  },
  "student-access": {
    "arabic": "وصول الطالب",
    "az": "Tələbə Girişi",
    "chinese": "學生訪問",
    "eng": "Student Access",
    "hindi": "छात्र प्रवेश",
    "ja": "生徒のアクセス権限",
    "jp": null,
    "ky": "Студенттик мүмкүнчүлүк",
    "ru": "Доступ для студентов",
    "uz": "Talabalarga kirish",
    "viet": "Quyền truy cập của sinh viên"
  },
  "set-the-start-date-for-when-you-want-to-enable-student-access-for-this-test": {
    "arabic": "قم بتعيين تاريخ البدء الذي تريد فيه تمكين وصول الطلاب لهذا الاختبار",
    "az": "Bu test üçün tələbə girişini aktivləşdirmək istədiyiniz zaman üçün Başlama tarixini təyin edin",
    "chinese": "設置您希望允許學生訪問此測試的開始日期",
    "eng": "Set the Start Date for when you want to enable student access for this test",
    "hindi": "जब आप इस परीक्षा के लिए छात्र की पहुंच को सक्षम करना चाहते हैं, तो उसके लिए प्रारंभ तिथि सेट करें",
    "ja": "このテストへの、生徒のアクセス権限付与日を設定する。",
    "jp": null,
    "ky": "Студенттин бул тестке кирүү мүмкүнчүлүгүн иштеткиңиз келген учурга Башталыш күнүн коюңуз",
    "ru": "Установите начальную дату, когда вы хотите разрешить студентам проходить этот тест.",
    "uz": "Talabalarning ushbu testga kirishiga ruxsat berish uchun boshlanish sanasini belgilang",
    "viet": "Đặt Ngày bắt đầu khi bạn muốn cho phép học sinh truy cập vào bài kiểm tra này"
  },
  "set-the-start-date-for-when-you-want-to-enable-student-access-for-this-topic": {
    "arabic": "قم بتعيين تاريخ البدء الذي تريد فيه تمكين وصول الطلاب لهذا الموضوع",
    "az": "Bu mövzu üçün tələbə girişini aktivləşdirmək istədiyiniz zaman Başlama tarixini təyin edin",
    "chinese": "設置您希望允許學生訪問此主題的時間的開始日期",
    "eng": "Set the Start Date for when you want to enable student access for this topic",
    "hindi": "जब आप इस विषय के लिए छात्र पहुंच को सक्षम करना चाहते हैं, तो उसके लिए प्रारंभ तिथि निर्धारित करें",
    "ja": "このトピックへの生徒のアクセス権限付与日を設定する。",
    "jp": null,
    "ky": "Бул темага студенттердин кирүү мүмкүнчүлүгүн иштетүү үчүн баштоо күнүн коюңуз",
    "ru": "Установите начальную дату, когда вы хотите разрешить студентам доступ к этой теме.",
    "uz": "Ushbu mavzu uchun talabalarga ruxsat berishni xohlagan vaqtingiz uchun Boshlanish sanasini belgilang",
    "viet": "Đặt Ngày bắt đầu khi bạn muốn cho phép sinh viên truy cập vào chủ đề này"
  },
  "you-have-chosen-a-start-time-in-the-future-hence-the-student-access-would-be-turned-off": {
    "arabic": "لقد اخترت وقت البدء في المستقبل, وبالتالي سيتم إيقاف تشغيل وصول الطلاب",
    "az": "Siz gələcəkdə başlama vaxtı seçmisiniz, ona görə də Tələbə girişi söndürüləcək",
    "chinese": "您選擇了未來的開始時間,因此學生訪問權限將被關閉",
    "eng": "You have chosen a start time in the future, hence the Student access would be turned off",
    "hindi": "आपने भविष्य में प्रारंभ समय चुना है, इसलिए छात्र पहुंच बंद कर दी जाएगी",
    "ja": "未来の開始時刻を選択したため、生徒のアクセス権限が停止されます",
    "jp": null,
    "ky": "Сиз келечекте башталуу убактысын тандадыңыз, андыктан Студенттик мүмкүнчүлүк өчүрүлөт",
    "ru": "Вы выбрали время начала в будущем, поэтому доступ для студентов будет отключен.",
    "uz": "Kelajakda boshlanish vaqtini tanladingiz, shuning uchun Talabalar kirishi oʻchirib qoʻyiladi",
    "viet": "Bạn đã chọn thời gian bắt đầu ở tương lai, do đó quyền truy cập của Sinh viên sẽ bị tắt"
  },
  "close-student-access-on": {
    "arabic": "إغلاق وصول الطالب",
    "az": "Tələbə Girişini Bağlayın",
    "chinese": "關閉學生訪問權限",
    "eng": "Close Student Access On",
    "hindi": "विद्यार्थी पहुँच को बंद करें",
    "ja": "生徒のアクセス権限を停止する",
    "jp": null,
    "ky": "Студенттик мүмкүнчүлүктү жабуу",
    "ru": "Закрыть доступ для студентов",
    "uz": "Talabalar ruxsatini yoping",
    "viet": "Bật Đóng quyền truy cập của sinh viên"
  },
  "setting-the-End-date-will-disable-students-access-to-this-test": {
    "arabic": "سيؤدي تحديد تاريخ الانتهاء إلى تعطيل وصول الطلاب إلى هذا الاختبار",
    "az": "Bitmə tarixinin təyin edilməsi tələbələrin bu testə girişini dayandıracaq",
    "chinese": "設置結束日期將禁止學生訪問此測試",
    "eng": "Setting the End Date will disable students access to this test",
    "hindi": "समाप्ति तिथि सेट करने से छात्रों की इस परीक्षा तक पहुंच अक्षम हो जाएगी",
    "ja": "配信終了日を設定すると、このテストへの生徒のアクセス権限が停止されます",
    "jp": null,
    "ky": "Аяктоо күнүн коюу студенттердин бул тестке кирүү мүмкүнчүлүгүн өчүрөт",
    "ru": "Установка даты окончания лишит студентов доступа к этому тесту.",
    "uz": "Tugash sanasini belgilash talabalarning ushbu testga kirishini o‘chirib qo‘yadi",
    "viet": "Đặt Ngày kết thúc sẽ vô hiệu hóa quyền truy cập của học sinh vào bài kiểm tra này"
  },
  "setting-the-End-date-will-disable-students-access-to-this-topic": {
    "arabic": "سيؤدي تحديد تاريخ الانتهاء إلى تعطيل وصول الطلاب إلى هذا الموضوع",
    "az": "Bitmə tarixinin təyin edilməsi tələbələrin bu mövzuya girişini dayandıracaq",
    "chinese": "設置結束日期將禁止學生訪問該主題",
    "eng": "Setting the End Date will disable students access to this topic",
    "hindi": "समाप्ति तिथि निर्धारित करने से छात्रों की इस विषय तक पहुंच अक्षम हो जाएगी",
    "ja": "配信終了日を設定すると、このトピックへの生徒のアクセス権限が停止されます。",
    "jp": null,
    "ky": "Аяктоо күнүн коюу студенттердин бул темага кирүү мүмкүнчүлүгүн өчүрөт",
    "ru": "Установка даты окончания отключит доступ студентов к этой теме.",
    "uz": "Tugash sanasini belgilash talabalarning ushbu mavzuga kirishini o'chirib qo'yadi",
    "viet": "Đặt Ngày kết thúc sẽ vô hiệu hóa quyền truy cập của sinh viên vào chủ đề này"
  },
  "end-time-should-be-later-than-start-time": {
    "arabic": "يجب أن يكون وقت الانتهاء لاحقًا لوقت البدء",
    "az": "Bitmə vaxtı başlanğıc vaxtından gec olmalıdır",
    "chinese": "結束時間應晚於開始時刻",
    "eng": "End time should be later than start time",
    "hindi": "समाप्ति समय प्रारंभ समय के बाद का होना चाहिए",
    "ja": "終了時間は開始時間より遅くしてください",
    "jp": null,
    "ky": "Аяктоо убактысы башталгыч убакыттан кеч болушу керек",
    "ru": "Время окончания должно быть позже времени начала.",
    "uz": "Tugash vaqti boshlanish vaqtidan kechroq bo'lishi kerak",
    "viet": "Thời gian kết thúc phải muộn hơn thời gian bắt đầu"
  },
  "end-time": {
    "arabic": "وقت النهاية",
    "az": "Bitmə vaxtı",
    "chinese": "时间结束",
    "eng": "End Time",
    "hindi": "अंत समय",
    "ja": "終了時間",
    "jp": null,
    "ky": "Аяктоо убактысы",
    "ru": "Время окончания",
    "uz": "Tugash vaqti",
    "viet": "Thời gian kết thúc"
  },
  "start-time": {
    "arabic": "وقت البدء",
    "az": "Başlama vaxtı",
    "chinese": "開始時間",
    "eng": "Start Time",
    "hindi": "प्रारंभ समय",
    "ja": "開始時間",
    "jp": null,
    "ky": "Баштоо убактысы",
    "ru": "Время начала",
    "uz": "Boshlanish vaqti",
    "viet": "Thời gian bắt đầu"
  },
  "total-attempts": {
    "arabic": "مجموع المحاولات",
    "az": "Ümumi cəhdlər",
    "chinese": "总尝试次数",
    "eng": "Total Attempts",
    "hindi": "कुल प्रयास",
    "ja": "合計解答回数",
    "jp": null,
    "ky": "Жалпы аракет",
    "ru": "Всего попыток",
    "uz": "Jami urinishlar",
    "viet": "Tổng số lần thử"
  },
  "please-select-an-end-time-in-the-future": {
    "arabic": "الرجاء تحديد وقت النهاية في المستقبل",
    "az": "Gələcəkdə bitmə vaxtını seçin",
    "chinese": "請選擇未來的結束時間",
    "eng": "Please select an end time in the future",
    "hindi": "कृपया भविष्य में समाप्ति समय चुनें",
    "ja": "未来の終了時刻を選択してください",
    "jp": null,
    "ky": "Келечекте аяктоо убактысын тандаңыз",
    "ru": "Пожалуйста, выберите время окончания в будущем",
    "uz": "Kelajakda tugash vaqtini tanlang",
    "viet": "Vui lòng chọn thời gian kết thúc ở tương lai"
  },
  "end-time-should-be-later-than-open-exam-time": {
    "arabic": "يجب أن يكون وقت الانتهاء لاحقًا لوقت الامتحان المفتوح",
    "az": "Bitmə vaxtı açıq imtahan vaxtından gec olmalıdır",
    "chinese": "結束時間應晚於配信考試時間",
    "eng": "End time should be later than open exam time",
    "hindi": "समाप्ति समय खुली परीक्षा के समय के बाद का होना चाहिए",
    "ja": "終了時間はテスト開始時間より遅くしてください",
    "jp": null,
    "ky": "Аяктоо убактысы ачык сынак убактысынан кечирээк болушу керек",
    "ru": "Время окончания должно быть позже времени начала экзамена.",
    "uz": "Tugash vaqti ochiq imtihon vaqtidan kechroq bo'lishi kerak",
    "viet": "Thời gian kết thúc phải muộn hơn thời gian thi mở"
  },
  "please-select-an-end-time-later-than-open-exam-time": {
    "arabic": "الرجاء تحديد وقت انتهاء لاحق عن وقت الامتحان المفتوح",
    "az": "Açıq imtahan vaxtından gec bitmə vaxtını seçin",
    "chinese": "請選擇晚於配信考試時間的結束時間",
    "eng": "Please select an end time later than open exam time",
    "hindi": "कृपया किसी अंतिम समय को खुली परीक्षा के समय के बाद चुनें",
    "ja": "終了時間はテスト開始時間より遅くしてください",
    "jp": null,
    "ky": "Сураныч, ачык сынак убактысынан кечирээк бүтүрүү убакытын тандаңыз",
    "ru": "Пожалуйста, выберите время окончания позже, чем время начала экзамена.",
    "uz": "Iltimos, ochiq imtihon vaqtidan kechroq tugash vaqtini tanlang",
    "viet": "Vui lòng chọn thời gian kết thúc muộn hơn thời gian bắt đầu kiểm tra"
  },
  "please-enter-a-valid-end-date-and-time": {
    "arabic": "الرجاء إدخال تاريخ ووقت انتهاء صالحين",
    "az": "Lütfən, etibarlı bitmə tarixi və vaxtı daxil edin",
    "chinese": "請輸入有效的結束日期和時間",
    "eng": "Please enter a valid end date and time",
    "hindi": "कृपया एक मान्य समाप्ति तिथि और समय दर्ज करें",
    "ja": "終了日時を正しく入力してください",
    "jp": null,
    "ky": "Жарактуу аяктоо күнүн жана убактысын киргизиңиз",
    "ru": "Введите допустимую дату и время окончания.",
    "uz": "Yaroqli tugash sanasi va vaqtini kiriting",
    "viet": "Vui lòng nhập ngày và giờ kết thúc hợp lệ"
  },
  "open-results-after-submission": {
    "arabic": "فتح النتائج بعد التقديم",
    "az": "Təqdim etdikdən sonra Nəticələri açın",
    "chinese": "提交後打開結果",
    "eng": "Open Results after submission",
    "hindi": "सबमिट करने के बाद परिणाम खोलें",
    "ja": "テスト結果を公開する",
    "jp": null,
    "ky": "Тапшырылгандан кийин жыйынтыктарды ачыңыз",
    "ru": "Открыть результаты после отправки",
    "uz": "Natijalarni topshirgandan keyin oching",
    "viet": "Hiển thị kết quả sau khi nộp bài"
  },
  "toggle-Off-to-delay-the-display-of-Test-results-immediately-on-final-submission": {
    "arabic": "قم بإيقاف تشغيله لتأخير عرض نتائج الاختبار فورًا عند التقديم النهائي",
    "az": "Sınaq nəticələrinin dərhal &#39;Son təqdimat&#39;da göstərilməsini gecikdirmək üçün Söndürün",
    "chinese": "關閉以延遲在“最終提交”時立即顯示測試結果",
    "eng": "Toggle Off to delay the display of Test results immediately on 'Final submission'",
    "hindi": "'अंतिम सबमिशन' पर तुरंत परीक्षा परिणामों के प्रदर्शन में देरी करने के लिए टॉगल करें",
    "ja": "オフに切り替えると、最終提出時に生徒にテスト結果がすぐ表示されません。",
    "jp": null,
    "ky": "&quot;Акыркы тапшыруу&quot; боюнча Сынактын натыйжаларын көрсөтүүнү кечиктирүү үчүн өчүрүү/өчүрүү",
    "ru": "Отключите, чтобы отложить отображение результатов теста сразу после «Окончательной отправки».",
    "uz": "“Yakuniy topshirish”da test natijalarini darhol koʻrsatishni kechiktirish uchun “Oʻchirish” tugmasini bosing.",
    "viet": "Tắt để trì hoãn việc hiển thị kết quả bài Kiểm tra trên “Nộp lần cuối”"
  },
  "test-results-available-on-final-submit": {
    "arabic": "نتائج الاختبار متاحة عند الإرسال النهائي",
    "az": "Sınaq Nəticələri &#39;Son təqdimat&#39;da mövcuddur",
    "chinese": "可在“最終提交”上獲得測試結果",
    "eng": "Test Results available on 'Final submit'",
    "hindi": "परीक्षा परिणाम 'फाइनल सबमिट' पर उपलब्ध",
    "ja": "最終提出を行い、テスト結果を表示する",
    "jp": null,
    "ky": "Сынактын натыйжалары &#39;Акыркы тапшырууда&#39; жеткиликтүү",
    "ru": "Результаты теста доступны на странице «Окончательная отправка»",
    "uz": "Test natijalari &quot;Yakuniy topshirish&quot; da mavjud",
    "viet": "Kết quả kiểm tra đã có trên “Nộp lần cuối”"
  },
  "result-data-is-always-set-to-end-date-by-default-please-select-an-appropriate-date-as-per-your-needs-after-the-end-date": {
    "arabic": "يتم تعيين بيانات النتيجة دائمًا على تاريخ الانتهاء افتراضيًا. يرجى تحديد تاريخ مناسب وفقًا لاحتياجاتك بعد تاريخ الانتهاء",
    "az": "Nəticə məlumatları həmişə defolt olaraq Bitmə tarixi olaraq təyin edilir. Lütfən, Bitmə tarixindən sonra ehtiyaclarınıza uyğun olaraq uyğun bir tarix seçin",
    "chinese": "默認情況下,結果數據始終設置為結束日期。請在結束日期之後根據您的需要選擇合適的日期",
    "eng": "Result data is always set to End-date by default. Please select an appropriate date as per your needs after the End-Date",
    "hindi": "परिणाम डेटा हमेशा डिफ़ॉल्ट रूप से समाप्ति तिथि पर सेट होता है। कृपया अंतिम तिथि के बाद अपनी आवश्यकताओं के अनुसार उपयुक्त तिथि का चयन करें",
    "ja": "結果データは「終了日」に初期設定されています。終了日以降、任意の日付を選択してください",
    "jp": null,
    "ky": "Натыйжа дайындары ар дайым демейки боюнча Аяктоо күнү деп коюлат. Аяктоо күнүнөн кийинки муктаждыктарыңызга ылайыктуу күндү тандаңыз",
    "ru": "Данные результатов всегда устанавливаются на дату окончания по умолчанию. Пожалуйста, выберите подходящую дату в соответствии с вашими потребностями после даты окончания",
    "uz": "Natija ma'lumotlari sukut bo'yicha har doim Tugash sanasiga o'rnatiladi. Tugash sanasidan keyin ehtiyojlaringizga mos sanani tanlang",
    "viet": "Dữ liệu kết quả luôn được đặt theo ngày Kết thúc theo mặc định. Vui lòng chọn một ngày phù hợp theo nhu cầu của bạn sau ngày Kết thúc."
  },
  "setting-results-date-will-enable-display-of-test-results-to-the-student-after-the-selected-date": {
    "arabic": "سيؤدي ضبط تاريخ النتائج إلى تمكين عرض نتائج الاختبار للطالب بعد التاريخ المحدد",
    "az": "Nəticələr tarixinin təyin edilməsi seçilmiş tarixdən sonra imtahan nəticələrinin tələbəyə göstərilməsinə imkan verəcək",
    "chinese": "設置結果日期將允許在選定日期之後向學生顯示測試結果",
    "eng": "Setting Results date will enable display of test results to the student after the selected date",
    "hindi": "परिणाम तिथि निर्धारित करने से चयनित तिथि के बाद छात्र को परीक्षा परिणाम प्रदर्शित करने में सक्षम हो जाएगा",
    "ja": "結果公開日を設定すると、設定日後は生徒がテスト結果を閲覧することができるようになります。",
    "jp": null,
    "ky": "Натыйжалар датасын коюу тандалган күндөн кийин студентке тесттин жыйынтыгын көрсөтүүгө мүмкүндүк берет",
    "ru": "Установка даты результатов позволит отображать результаты теста для студента после выбранной даты.",
    "uz": "Natijalar sanasini belgilash tanlangan sanadan keyin talabaga test natijalarini ko'rsatish imkonini beradi",
    "viet": "Bằng cách đặt Ngày Hiển thị kết quả, học sinh sẽ có thể xem kết quả bài kiểm tra vào sau ngày đã chọn."
  },
  "start-date": {
    "arabic": "تاريخ البدء",
    "az": "Başlama tarixi",
    "chinese": null,
    "eng": "Start Date",
    "hindi": null,
    "ja": "開始日",
    "jp": null,
    "ky": "Башталыш күнү",
    "ru": "Дата начала",
    "uz": "Boshlanish sanasi",
    "viet": null
  },
  "end-date": {
    "arabic": "تاريخ النهاية",
    "az": "Bitmə tarixi",
    "chinese": null,
    "eng": "End Date",
    "hindi": null,
    "ja": "終了日",
    "jp": null,
    "ky": "Аяктоо күнү",
    "ru": "Дата окончания",
    "uz": "Tugash sanasi",
    "viet": null
  },
  "welcome-to-cerebry": {
    "arabic": "مرحباً بكم في Cerebry",
    "az": "Cerebry-ə xoş gəlmisiniz",
    "chinese": "歡迎來到 Cerebry",
    "eng": "Welcome to Cerebry",
    "hindi": "सेरेब्री में आपका स्वागत है",
    "ja": "ようこそ",
    "jp": null,
    "ky": "Cerebry кош келиңиз",
    "ru": "Добро пожаловать в Cerebry",
    "uz": "Cerebry-ga xush kelibsiz",
    "viet": "Chào mừng đến với Kyons x Cerebry"
  },
  "two-more-quick-steps-to-get-started": {
    "arabic": "خطوتان سريعتان أخريان للبدء",
    "az": "Başlamaq üçün daha iki sürətli addım",
    "chinese": "兩個快速入門步驟",
    "eng": "Two more quick steps to get started",
    "hindi": "आरंभ करने के लिए दो और त्वरित चरण",
    "ja": "2つの簡単なステップですぐに使えます",
    "jp": null,
    "ky": "Баштоо үчүн дагы эки жөнөкөй кадам",
    "ru": "Еще два быстрых шага для начала работы",
    "uz": "Boshlash uchun yana ikki kichik bosqichdan o‘tish qoldi",
    "viet": "Chỉ cần hai bước nữa để có thể bắt đầu"
  },
  "please-enter-school-code": {
    "arabic": "الرجاء إدخال رمز المدرسة",
    "az": "Məktəb kodunu daxil edin",
    "chinese": "請輸入學校代碼",
    "eng": "Please enter school code",
    "hindi": "कृपया स्कूल कोड दर्ज करें",
    "ja": "学校コードを入力してください",
    "jp": null,
    "ky": "Мектеп кодун киргизиңиз",
    "ru": "Пожалуйста, введите код школы",
    "uz": "Iltimos, maktab kodini kiriting",
    "viet": "Vui lòng nhập mã của trường bạn"
  },
  "please-enter-school-pin": {
    "arabic": "الرجاء إدخال رقم المدرسة",
    "az": "Məktəb pin kodunu daxil edin",
    "chinese": "請輸入學校密碼",
    "eng": "Please enter school pin",
    "hindi": "कृपया स्कूल पिन दर्ज करें",
    "ja": "スクールPin（パスワード）を入力してください",
    "jp": null,
    "ky": "Мектептин кодун киргизиңиз",
    "ru": "Пожалуйста, введите пин-код школы",
    "uz": "Iltimos, maktab pin kodini kiriting",
    "viet": "Vui lòng nhập mã pin của trường"
  },
  "enter-your-school-code": {
    "arabic": "أدخل رمز مدرستك",
    "az": "Məktəb kodunuzu daxil edin",
    "chinese": "輸入您的學校代碼",
    "eng": "Enter your school code",
    "hindi": "अपना स्कूल कोड दर्ज करें",
    "ja": "学校コードを入力してください",
    "jp": null,
    "ky": "Мектеп кодун киргизиңиз",
    "ru": "Введите код вашей школы",
    "uz": "Maktab kodingizni kiriting",
    "viet": "Nhập mã của trường bạn"
  },
  "enter-school-pin": {
    "arabic": "أدخل رقم المدرسة",
    "az": "Məktəb pinini daxil edin",
    "chinese": "進校密碼",
    "eng": "Enter school pin",
    "hindi": "स्कूल पिन दर्ज करें",
    "ja": "スクールPin（パスワード）を入力してください",
    "jp": null,
    "ky": "Мектептин кодун киргизиңиз",
    "ru": "Введите пин-код школы",
    "uz": "Maktab pinini kiriting",
    "viet": "Nhập mã pin của trường"
  },
  "testing": {
    "arabic": "الاختبار",
    "az": "SINAQ",
    "chinese": "測試",
    "eng": "TESTING",
    "hindi": "परिक्षण",
    "ja": "テスト",
    "jp": null,
    "ky": "СЫНОО",
    "ru": "ТЕСТИРОВАНИЕ",
    "uz": "SINOV",
    "viet": "ĐANG KIỂM TRA"
  },
  "oops-link-is-invalid": {
    "arabic": "عفواً الرابط غير صالح",
    "az": "Vay!! link etibarsızdır",
    "chinese": "哎呀！！鏈接無效",
    "eng": "Oops!! link is invalid",
    "hindi": "उफ़ !! लिंक अमान्य है",
    "ja": "リンクが無効です",
    "jp": null,
    "ky": "Ой!! шилтеме жараксыз",
    "ru": "Упс!! ссылка недействительна",
    "uz": "Voy!! havola yaroqsiz",
    "viet": "Ôi không!! Liên kết không hợp lệ mất rồi"
  },
  "revision": {
    "arabic": "المراجعة",
    "az": "Reviziya",
    "chinese": "修訂",
    "eng": "Revision",
    "hindi": "संशोधन",
    "ja": "変更",
    "jp": null,
    "ky": "Ревизия",
    "ru": "Пересмотр",
    "uz": "Qayta ko'rib chiqish",
    "viet": "Ôn tập"
  },
  "invalid-email": {
    "arabic": "البريد الإلكتروني غير صالح!!!",
    "az": "Etibarsız e-poçt!!!",
    "chinese": "不合規電郵",
    "eng": "Invalid email!!!",
    "hindi": "अमान्य ईमेल",
    "ja": "無効なメールアドレス",
    "jp": null,
    "ky": "Жараксыз электрондук почта!!!",
    "ru": "Неверный адрес электронной почты!!!",
    "uz": "Yaroqsiz email",
    "viet": "Email không hợp lệ"
  },
  "password-should-contain-atleast-6-characters": {
    "arabic": "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل",
    "az": "Parol ən azı 6 simvoldan ibarət olmalıdır",
    "chinese": "密碼應至少包含 6 個字符",
    "eng": "Password should contain atleast 6 characters",
    "hindi": "पासवर्ड में कम से कम 6 अक्षर होने चाहिए",
    "ja": "パスワードは6文字以上にする必要があります",
    "jp": null,
    "ky": "Сырсөз кеминде 6 символдон турушу керек",
    "ru": "Пароль должен содержать не менее 6 символов.",
    "uz": "Parol eng kamida 6 ta belgidan iborat bo‘lishi kerak",
    "viet": "Mật khẩu phải chứa ít nhất 6 ký tự"
  },
  "email-id-or-phone-number": {
    "arabic": "معرف البريد الإلكتروني أو رقم الهاتف",
    "az": "E-poçt ünvanı və ya telefon nömrəsi",
    "chinese": "電子郵件 ID 或電話號碼",
    "eng": "Email ID or Phone Number",
    "hindi": "ईमेल आईडी या फोन नंबर",
    "ja": "メールアドレスまたは電話番号",
    "jp": null,
    "ky": "Электрондук почта ID же телефон номери",
    "ru": "Адрес электронной почты или номер телефона",
    "uz": "Elektron pochta manzili yoki telefon raqami",
    "viet": "Id email hoặc số điện thoại"
  },
  "passwords-must-be-at-least-6-characters": {
    "arabic": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    "az": "Parollar ən azı 6 simvoldan ibarət olmalıdır",
    "chinese": "密碼必須至少為 6 個字符",
    "eng": "Passwords must be at least 6 characters",
    "hindi": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
    "ja": "パスワードは6文字以上にする必要があります",
    "jp": null,
    "ky": "Сырсөздөр кеминде 6 белгиден турушу керек",
    "ru": "Пароли должны содержать не менее 6 символов.",
    "uz": "Parollar kamida 6 ta belgidan iborat bo'lishi kerak",
    "viet": "Mật khẩu phải có ít nhất 6 ký tự"
  },
  "create-an-account": {
    "arabic": "إنشاء حساب",
    "az": "Hesab yaradın",
    "chinese": "創建一個帳戶",
    "eng": "Create an Account",
    "hindi": "खाता बनाएं",
    "ja": "アカウントを作成する",
    "jp": null,
    "ky": "Каттоо эсебин түзүү",
    "ru": "Завести аккаунт",
    "uz": "Hisob ochish",
    "viet": "Tạo tài khoản"
  },
  "already-have-an-account": {
    "arabic": "لديك حساب بالفعل",
    "az": "Artıq hesabınız var",
    "chinese": "已有帳號",
    "eng": "Already have an account",
    "hindi": "पहले से ही एक खाता है",
    "ja": "すでにアカウントをお持ちですか",
    "jp": null,
    "ky": "Каттоо эсебиңиз бар",
    "ru": "У вас уже есть аккаунт",
    "uz": "Allaqachon hisobingiz bor",
    "viet": "Đã có tài khoản"
  },
  "overview": {
    "arabic": "ملخص",
    "az": "Ümumi baxış",
    "chinese": "概述",
    "eng": "Overview",
    "hindi": "अवलोकन",
    "ja": "概要",
    "jp": null,
    "ky": "Обзор",
    "ru": "Обзор",
    "uz": "Umumiy koʻrinish",
    "viet": "Tổng quan"
  },
  "dashboard": {
    "arabic": "لوحة القيادة",
    "az": "İdarə paneli",
    "chinese": "儀表板",
    "eng": "Dashboard",
    "hindi": "डैशबोर्ड",
    "ja": "進捗状況",
    "jp": null,
    "ky": "Куралдар тактасы",
    "ru": "Панель инструментов",
    "uz": "Boshqaruv paneli",
    "viet": "bảng điều khiển"
  },
  "class": {
    "arabic": "فصل",
    "az": "Sinif",
    "chinese": "班級",
    "eng": "Class",
    "hindi": "कक्षा",
    "ja": "クラス",
    "jp": null,
    "ky": "Класс",
    "ru": "Сорт",
    "uz": "Sinf",
    "viet": "Lớp học"
  },
  "students-in-this-class": {
    "arabic": "الطلاب في هذه الفئة",
    "az": "bu sinifdəki tələbələr",
    "chinese": "本班學生",
    "eng": "students in this class",
    "hindi": "इस कक्षा में छात्र",
    "ja": "人の生徒がこのクラスに所属しています",
    "jp": null,
    "ky": "бул класстын окуучулары",
    "ru": "учащиеся этого класса",
    "uz": "bu sinf o'quvchilari",
    "viet": "học sinh trong lớp này"
  },
  "no-students-have-started-this-yet": {
    "arabic": "لم يبدأ أي طالب هذا بعد",
    "az": "Hələ heç bir tələbə buna başlamayıb",
    "chinese": "還沒有學生開始這個",
    "eng": "No students have started this yet",
    "hindi": "अभी तक किसी छात्र ने इसे शुरू नहीं किया है",
    "ja": "学習を開始した生徒はいません",
    "jp": null,
    "ky": "Муну азырынча бир дагы студент баштаган жок",
    "ru": "Ни один студент еще не начал это",
    "uz": "Buni hali hech bir talaba boshlamagan",
    "viet": "Chưa có học sinh nào bắt đầu"
  },
  "students-have-not-started": {
    "arabic": "الطلاب لم يبدأوا",
    "az": "tələbələr başlamadı",
    "chinese": "學生還沒有開始",
    "eng": "students have not started",
    "hindi": "छात्रों ने शुरू नहीं किया है",
    "ja": "人の生徒が、まだこのトピックを開始していません",
    "jp": null,
    "ky": "студенттер баштала элек",
    "ru": "студенты еще не начали",
    "uz": "talabalar boshlamagan",
    "viet": "học sinh chưa bắt đầu"
  },
  "students-are-at-the": {
    "arabic": "الطلاب في",
    "az": "tələbələrdir",
    "chinese": "學生們在",
    "eng": "students are at the",
    "hindi": "छात्र हैं",
    "ja": "人の生徒が ",
    "jp": null,
    "ky": "студенттер бар",
    "ru": "студенты находятся в",
    "uz": "talabalar",
    "viet": "học sinh đang ở"
  },
  "of-them": {
    "arabic": "منهم",
    "az": "onlardan",
    "chinese": "其中",
    "eng": "of them",
    "hindi": "उनमें से",
    "ja": "人が",
    "jp": null,
    "ky": "алардын",
    "ru": "из них",
    "uz": "ulardan",
    "viet": "của họ"
  },
  "have-first-encountered-problems-at": {
    "arabic": "لقد واجهت مشاكل لأول مرة في",
    "az": "ilk olaraq problemlərlə qarşılaşdılar",
    "chinese": "第一次遇到問題",
    "eng": "have first encountered problems at",
    "hindi": "में पहली बार समस्याओं का सामना करना पड़ा है",
    "ja": "この問題で手が止まっています: ",
    "jp": null,
    "ky": "биринчи жолу көйгөйлөргө туш болдук",
    "ru": "впервые столкнулись с проблемами",
    "uz": "da birinchi marta muammolarga duch kelgan",
    "viet": "gặp vấn đề lần đầu tiên tại"
  },
  "are-stuck-at-these": {
    "arabic": "عالقون في هذه",
    "az": "bunlara ilişib qalıblar",
    "chinese": "被困在這些",
    "eng": "are stuck at these",
    "hindi": "इन पर अटके हुए हैं",
    "ja": "この問題でつまずいているようです: ",
    "jp": null,
    "ky": "буларга тыгылып калышты",
    "ru": "застряли на этих",
    "uz": "bularga yopishib qolishadi",
    "viet": "bị mắc kẹt ở đây"
  },
  "paused-voluntarily": {
    "arabic": "متوقف طوعا",
    "az": "könüllü olaraq fasilə verdi",
    "chinese": "自願暫停",
    "eng": "paused voluntarily",
    "hindi": "स्वेच्छा से रोका गया",
    "ja": "学習を休止中です",
    "jp": null,
    "ky": "өз ыктыяры менен токтоду",
    "ru": "приостановлено добровольно",
    "uz": "ixtiyoriy ravishda pauza qildi",
    "viet": "tạm dừng một cách tự nguyện"
  },
  "question-type": {
    "arabic": "نوع السؤال",
    "az": "Sual növü",
    "chinese": "問題類型",
    "eng": "Question Type",
    "hindi": "प्रश्न प्रकार",
    "ja": "問題タイプ",
    "jp": null,
    "ky": "Суроо түрү",
    "ru": "Тип вопроса",
    "uz": "Savol turi",
    "viet": "Loại câu hỏi"
  },
  "student(s)-encountered-problems-here": {
    "arabic": "واجه الطالب(ون) مشاكل هنا",
    "az": "tələbə(lər) burada problemlərlə üzləşib",
    "chinese": "學生在這裡遇到問題",
    "eng": "student(s) encountered problems here",
    "hindi": "छात्रों को यहां दिक्कत हुई",
    "ja": "生徒がこの問題でつまずいているようです:",
    "jp": null,
    "ky": "студенттер бул жерде көйгөйлөргө дуушар болушкан",
    "ru": "У студента(ов) возникли проблемы здесь",
    "uz": "talaba(lar) bu yerda muammolarga duch keldi",
    "viet": "học sinh gặp vấn đề ở đây"
  },
  "student(s)-stuck-here": {
    "arabic": "الطالب(ون) عالقون هنا",
    "az": "tələbə(lər) burada qalıb",
    "chinese": "學生被困在這裡",
    "eng": "student(s) stuck here",
    "hindi": "छात्र अटक गया यहां",
    "ja": "生徒がここでつまづいているようです",
    "jp": null,
    "ky": "студент(лер) бул жерде тыгылып калышты",
    "ru": "студент(ы) застрял(и) здесь",
    "uz": "talaba(lar) shu yerda qolib ketdi",
    "viet": "sinh viên bị mắc kẹt ở đây"
  },
  "sort-by-progress-(ascending)": {
    "arabic": "فرز حسب التقدم (تصاعدي)",
    "az": "Tərəqqiyə görə çeşidləyin (artan)",
    "chinese": "按進度排序(升序)",
    "eng": "Sort by progress (ascending)",
    "hindi": "प्रगति के आधार पर छाँटें (आरोही) ",
    "ja": "進捗順(昇順)",
    "jp": null,
    "ky": "Прогресс боюнча сорттоо (өсүү боюнча)",
    "ru": "Сортировать по прогрессу (по возрастанию)",
    "uz": "Rivojlanish bo'yicha saralash (ko'tarilish)",
    "viet": "Sắp xếp theo tiến độ (tăng dần)"
  },
  "sort-by-progress-(descending)": {
    "arabic": "فرز حسب التقدم (تنازلي)",
    "az": "Tərəqqiyə görə çeşidləyin (azalan)",
    "chinese": "按進度排序(降序)",
    "eng": "Sort by progress (descending)",
    "hindi": "प्रगति के आधार पर छाँटें (अवरोही)",
    "ja": "進捗順(降順)",
    "jp": null,
    "ky": "Прогресс боюнча сорттоо (төмөндөө)",
    "ru": "Сортировать по прогрессу (по убыванию)",
    "uz": "Rivojlanish bo'yicha saralash (kamayish bo'yicha)",
    "viet": "Sắp xếp theo tiến độ (giảm dần)"
  },
  "progress-(ascending)": {
    "arabic": "التقدم (تصاعدي)",
    "az": "tərəqqi (artan)",
    "chinese": "進步(升序)",
    "eng": "progress (ascending)",
    "hindi": "प्रगति के आधार पर छाँटें (आरोही) ",
    "ja": "進捗順(昇順)",
    "jp": null,
    "ky": "прогресс (өсүү)",
    "ru": "прогресс (по возрастанию)",
    "uz": "taraqqiyot (ko'tarilish)",
    "viet": "tiến độ (tăng dần)"
  },
  "progress-(descending)": {
    "arabic": "التقدم (تنازلي)",
    "az": "irəliləmə (azalan)",
    "chinese": "進度(降序)",
    "eng": "progress (descending)",
    "hindi": "प्रगति के आधार पर छाँटें (अवरोही)",
    "ja": "進捗順(降順)",
    "jp": null,
    "ky": "прогресс (төмөндөө)",
    "ru": "прогресс (по убыванию)",
    "uz": "taraqqiyot (pasayish)",
    "viet": "tiến độ (giảm dần)"
  },
  "progress": {
    "arabic": "تقدم",
    "az": "Tərəqqi",
    "chinese": "進步",
    "eng": "Progress",
    "hindi": "प्रगति",
    "ja": "進捗",
    "jp": null,
    "ky": "Прогресс",
    "ru": "Прогресс",
    "uz": "Taraqqiyot",
    "viet": "Tiến độ"
  },
  "need-help": {
    "arabic": "بحاجة الى مساعدة",
    "az": "köməyə ehtiyacı var",
    "chinese": "需要幫忙",
    "eng": "need-help",
    "hindi": "मदद की ज़रूरत है",
    "ja": "ヘルプが必要",
    "jp": null,
    "ky": "жардамга муктаж",
    "ru": "нужна помощь",
    "uz": "Yordam kerak",
    "viet": "cần giúp đỡ"
  },
  "details": {
    "arabic": "تفاصيل",
    "az": "Təfərrüatlar",
    "chinese": "細節",
    "eng": "Details",
    "hindi": "विवरण",
    "ja": "詳細",
    "jp": null,
    "ky": "Толук маалымат",
    "ru": "Подробности",
    "uz": "Tafsilotlar",
    "viet": "chi tiết"
  },
  "student-stuck": {
    "arabic": "طالب عالق",
    "az": "Tələbə ilişib",
    "chinese": "學生卡住",
    "eng": "Student Stuck",
    "hindi": "छात्र फंसा",
    "ja": "ヘルプが必要",
    "jp": null,
    "ky": "Студент тыгылып калды",
    "ru": "Студент застрял",
    "uz": "Talaba qotib qolgan",
    "viet": "sinh viên bị mắc kẹt"
  },
  "students-at": {
    "arabic": "الطلاب في",
    "az": "Tələbələr at",
    "chinese": "學生在",
    "eng": "Students at",
    "hindi": "पर छात्र",
    "ja": "人の生徒が学習中: ",
    "jp": null,
    "ky": "Студенттер дар",
    "ru": "Студенты в",
    "uz": "Talabalar",
    "viet": "học sinh tại"
  },
  "who-are-they": {
    "arabic": "من هم؟",
    "az": "Onlar kimlərdir",
    "chinese": "他們是誰",
    "eng": "Who are they",
    "hindi": "कौन हैं वे",
    "ja": "生徒一覧",
    "jp": null,
    "ky": "Алар кимдер",
    "ru": "Кто они",
    "uz": "Ular kim",
    "viet": "họ là ai"
  },
  "question-list": {
    "arabic": "قائمة الأسئلة",
    "az": "Sual siyahısı",
    "chinese": "問題清單",
    "eng": "Question list",
    "hindi": "प्रश्न सूची",
    "ja": "問題リスト",
    "jp": null,
    "ky": "Суроо тизмеси",
    "ru": "Список вопросов",
    "uz": "Savollar ro'yxati",
    "viet": "danh sách câu hỏi"
  },
  "progress-reversal-event": {
    "arabic": "حدث عكس التقدم",
    "az": "İrəliləyişin Geri qaytarılması hadisəsi",
    "chinese": "進度逆轉事件",
    "eng": "Progress Reversal Event",
    "hindi": "प्रगति उत्क्रमण घटना",
    "ja": "進捗反転イベント",
    "jp": null,
    "ky": "Прогрессти кайтаруу окуясы",
    "ru": "Событие отмены прогресса",
    "uz": "Taraqqiyotni qaytarish hodisasi",
    "viet": "Sự kiện bị đảo ngược tiến độ"
  },
  "a-misuse-of-appeal-function-was-detected-and-the-student-was-reset-back-to-where-the-abuse-happened-a(progress was also reversed)": {
    "arabic": "تم اكتشاف إساءة استخدام وظيفة الاستئناف وتم إعادة تعيين الطالب إلى المكان الذي حدث فيه الإساءة (تم أيضًا عكس التقدم)",
    "az": "Müraciət funksiyasından sui-istifadə halı aşkar edildi və tələbə sui-istifadənin baş verdiyi yerə qaytarıldı a(İrəliləyiş də geri qaytarıldı)",
    "chinese": "檢測到濫用申訴功能,學生被重置回濫用發生的地方(進度也被逆轉)",
    "eng": "A misuse of appeal function was detected and the student was reset back to where the abuse happened a(Progress was also reversed)",
    "hindi": "अपील समारोह के दुरुपयोग का पता चला था और छात्र को वापस उस स्थान पर रीसेट कर दिया गया था जहां दुरुपयोग हुआ था (प्रगति भी उलट दी गई थी)",
    "ja": "機能の誤使用が検知されました。生徒と進捗は問題が発生した場所に戻されました。",
    "jp": null,
    "ky": "Апелляциялык функциянын туура эмес колдонулушу аныкталды жана студент кыянаттык болгон жерге кайра коюлду a(Илгерилетүү да артка кайтарылды)",
    "ru": "Было обнаружено злоупотребление функцией апелляции, и ученик был возвращен к тому месту, где произошло злоупотребление (прогресс также был отменен)",
    "uz": "Apellyatsiya funktsiyasidan noto'g'ri foydalanish aniqlandi va talaba suiiste'mollik sodir bo'lgan joyga qaytarildi a (Taraqqiyot ham teskari bo'ldi)",
    "viet": "Đã phát hiện việc sử dụng chức năng kháng cáo sai mục đích và học sinh đã bị đặt lại về trạng thái phát hiện hành vi (Tiến độ cũng bị đảo ngược)"
  },
  "student-has-not-reached-to-this-level-yet": {
    "arabic": "الطالب لم يصل لهذا المستوى بعد",
    "az": "Tələbə hələ bu səviyyəyə çatmayıb",
    "chinese": "學生還沒有達到這個水平",
    "eng": "Student has not reached to this level yet",
    "hindi": "विद्यार्थी अभी तक इस स्तर तक नहीं पहुंचा है",
    "ja": "生徒がこの難易度に達していません。",
    "jp": null,
    "ky": "Студент бул деңгээлге жете элек",
    "ru": "Студент еще не достиг этого уровня",
    "uz": "Talaba hali bu darajaga yetmagan",
    "viet": "Học sinh chưa đạt đến cấp độ này"
  },
  "session-overview": {
    "arabic": "نظرة عامة على الجلسة",
    "az": "Sessiyaya baxış",
    "chinese": "會議概覽",
    "eng": "Session Overview",
    "hindi": "सत्र अवलोकन",
    "ja": "セッション概要",
    "jp": null,
    "ky": "Сеанс",
    "ru": "Обзор сессии",
    "uz": "Sessiyaga umumiy nuqtai",
    "viet": "Tổng quan buổi học"
  },
  "question-practiced": {
    "arabic": "سؤال تم التدرب عليه",
    "az": "Sual Təcrübə Edildi",
    "chinese": "習題",
    "eng": "Question practised",
    "hindi": "प्रश्न अभ्यास किया",
    "ja": "取り組んだ問題",
    "jp": null,
    "ky": "Практикаланган суроо",
    "ru": "Вопрос Практикуется",
    "uz": "Savol mashq qilindi",
    "viet": "câu hỏi luyện tập"
  },
  "practiced": {
    "arabic": "ممارس",
    "az": "Təcrübəli",
    "chinese": "練習",
    "eng": "practised",
    "hindi": "अभ्यास",
    "ja": "問題",
    "jp": null,
    "ky": "Машыгат",
    "ru": "Практикуется",
    "uz": "Mashq qilindi",
    "viet": "đã luyện tập"
  },
  "currently-solving": {
    "arabic": "جاري الحل",
    "az": "Hal-hazırda Həll olunur",
    "chinese": "目前正在解決",
    "eng": "Currently Solving",
    "hindi": "वर्तमान में समाधान कर रहा है",
    "ja": "今解いている問題",
    "jp": null,
    "ky": "Учурда чечилүүдө",
    "ru": "В настоящее время решается",
    "uz": "Hozirda hal qilinmoqda",
    "viet": "Đang giải quyết"
  },
  "attempt": {
    "arabic": "محاولة",
    "az": "cəhd",
    "chinese": "試圖",
    "eng": "Attempt",
    "hindi": "कोशिश करना",
    "ja": "解答",
    "jp": null,
    "ky": "аракет",
    "ru": "Пытаться",
    "uz": "Urinish",
    "viet": "thử"
  },
  "breakout-mode": {
    "arabic": "وضع الاختراق",
    "az": "Breakout rejimi",
    "chinese": "突破模式",
    "eng": "Breakout Mode",
    "hindi": "ब्रेकआउट मोड",
    "ja": "ブレイクアウトモード",
    "jp": null,
    "ky": "Breakout Mode",
    "ru": "Режим прорыва",
    "uz": "Breakout rejimi",
    "viet": "Chế độ đột phá"
  },
  "submitted-answer": {
    "arabic": "تم إرسال الإجابة",
    "az": "Göndərilən Cavab",
    "chinese": "提交的答案",
    "eng": "Submitted Answer",
    "hindi": "प्रस्तुत उत्तर",
    "ja": "提出された解答",
    "jp": null,
    "ky": "Жооп берилген",
    "ru": "Представленный ответ",
    "uz": "Taqdim etilgan javob",
    "viet": "Đã nộp câu trả lời"
  },
  "submitted": {
    "arabic": "مُقَدَّم",
    "az": "Təqdim edildi",
    "chinese": "已提交",
    "eng": "Submitted",
    "hindi": "प्रस्तुत",
    "ja": "提出済",
    "jp": null,
    "ky": "Тапшырылган",
    "ru": "Поданный",
    "uz": "Taqdim etilgan",
    "viet": "Đã nộp"
  },
  "add-student": {
    "arabic": "إضافة الطالب",
    "az": "şagird əlavə edin",
    "chinese": "添加學生",
    "eng": "Add Student",
    "hindi": "विद्यार्थी जोड़ें",
    "ja": "生徒を追加する",
    "jp": null,
    "ky": "Окуучу кошуу",
    "ru": "Добавить студента",
    "uz": "O‘quvchi qo‘shish",
    "viet": "Thêm học sinh"
  },
  "remove": {
    "arabic": "يزيل",
    "az": "Sil",
    "chinese": "消除",
    "eng": "Remove",
    "hindi": "निकालना",
    "ja": "削除",
    "jp": null,
    "ky": "Алып салуу",
    "ru": "Удалять",
    "uz": "Chiqarib tashlash",
    "viet": "Xoá"
  },
  "reset-password": {
    "arabic": "إعادة تعيين كلمة المرور",
    "az": "Parolun sıfırlanması",
    "chinese": "重设密码",
    "eng": "Reset Password",
    "hindi": "पासवर्ड रीसेट",
    "ja": "パスワードを再設定する",
    "jp": null,
    "ky": "Сырсөздү калыбына келтирүү",
    "ru": "Сбросить пароль",
    "uz": "Parolni tiklash",
    "viet": "Đặt lại mật khẩu"
  },
  "reset-practice": {
    "arabic": "إعادة تعيين التمرين",
    "az": "Təcrübəni sıfırlayın",
    "chinese": "重设练习",
    "eng": "Reset Round",
    "hindi": "अभ्यास रीसेट",  
    "ja": "練習をリセット",
    "jp": null,
    "ky": "Жүргүнү калыбына келтирүү",
    "ru": "Сбросить практику",
    "uz": "Mashqni tiklash",
    "viet": "Đặt lại bài tập"
  },
  "rounds": {
    "arabic": "جولات",
    "az": "Tur",
    "chinese": "回合",
    "eng": "Rounds",
    "hindi": "राउंड",
    "ja": "ラウンド",
    "jp": null,
    "ky": "Даирелер",
    "ru": "Раунды",
    "uz": "Raundlar",
    "viet": "vòng"
  },
  "attained-minimum-score?": {
    "arabic": "هل تحققت الحد الأدنى من الدرجة؟",
    "az": "Minimum bal əldə edildi?",
    "chinese": "达到最低分数了吗？",
    "eng": "Attained minimum score?",
    "hindi": "न्यूनतम स्कोर प्राप्त किया?",
    "ja": "最低スコアを達成しましたか？",
    "jp": null,
    "ky": "Минималдуу балды камтылганыңызбы?",
    "ru": "Достигнут минимальный балл?",
    "uz": "Eng kam bal to‘pladingizmi?",
    "viet": "Đạt được điểm tối thiểu?"
  },
  "reset": {
    "arabic": "إعادة تعيين",
    "az": "Sıfırla",
    "chinese": "重设",
    "eng": "Reset",
    "hindi": "रीसेट",
    "ja": "リセット",
    "jp": null,
    "ky": "Калыбына келтирүү",
    "ru": "Сбросить",
    "uz": "Tiklash",
    "viet": "Đặt lại"
  },
  "reset-this-round": {
    "arabic": "إعادة تعيين هذه الجولة",
    "az": "Bu turu sıfırla",
    "chinese": "重设本回合",
    "eng": "Reset This Round",
    "hindi": "इस राउंड को रीसेट करें",
    "ja": "このラウンドをリセット",
    "jp": null,
    "ky": "Бул дайрени калыбына келтирүү",
    "ru": "Сбросить этот раунд",
    "uz": "Bu raundni tiklash",
    "viet": "Đặt lại vòng này"
  },
  // This will permanently Delete All this student data for this round!
  "this-will-permanently-delete-all-this-student-data-for-this-round!": {
    "arabic": "هذا سيحذف جميع بيانات هذا الطالب لهذه الجولة بشكل دائم!",
    "az": "Bu, bu tur üçün bu tələbə məlumatlarının hamsilinəcəyini daimi olaraq siləcəkdir!",
    "chinese": "这将永久删除此学生的所有此回合数据！",
    "eng": "This will permanently delete all this student data for this round!",
    "hindi": "यह इस राउंड के लिए इस छात्र के सभी डेटा को स्थायी रूप से हटा देगा!",
    "ja": "これにより、このラウンドのこの生徒のすべてのデータが永久に削除されます！",
    "jp": null,
    "ky": "Бул, бул дайрени калыбына келтирүү үчүн бу студентди бардык маалыматтарын дайымдык менен жок кылар!",
    "ru": "Это навсегда удалит все данные этого студента для этого раунда!",
    "uz": "Bu, bu raund uchun bu talaba ma'lumotlarini doimiy ravishda o‘chiradi!",
    "viet": "Điều này sẽ xóa vĩnh viễn tất cả dữ liệu của học sinh này cho vòng này!"
  },
  "something-went-wrong!":{
    "arabic": "حدث خطأ ما!",
    "az": "Bir şeylər səhv oldu!",
    "chinese": "出了点问题！",
    "eng": "Something went wrong!",
    "hindi": "कुछ गलत हो गया!",
    "ja": "何かがうまくいかなかった！",
    "jp": null,
    "ky": "Негизде ката кетти!",
    "ru": "Что-то пошло не так!",
    "uz": "Nimadir noto'g'ri ketdi!",
    "viet": "Đã xảy ra lỗi!"
  },
  "the-student-data-for-this-round-has-been-permanently-deleted.-the-student-may-proceed-to-re-attempt-this-round.": {
    "arabic": "تم حذف بيانات الطالب لهذه الجولة بشكل دائم. يمكن للطالب المتابعة لإعادة محاولة هذه الجولة.",
    "az": "Bu tur üçün tələbə məlumatları daimi olaraq silindi. Tələbə bu turu yenidən cəhd edə bilər.",
    "chinese": "这个学生的这一轮数据已经被永久删除。学生可以继续尝试这一轮。",
    "eng": "The student data for this round has been permanently deleted. The student may proceed to re-attempt this round.",
    "hindi": "इस राउंड के लिए छात्र के डेटा को स्थायी रूप से हटा दिया गया है। छात्र इस राउंड को फिर से प्रयास कर सकता है।",
    "ja": "このラウンドの生徒データは永久に削除されました。生徒はこのラウンドを再度試すことができます。",
    "jp": null,
    "ky": "Bu dairе uchun talaba ma'lumotlari doimiy ravishda o‘chirildi. Talaba bu dairеni qayta urushishi mumkin.",
    "ru": "Данные студента для этого раунда были удалены навсегда. Студент может продолжить попытку этого раунда.",
    "uz": "Bu raund uchun talaba ma'lumotlari doimiy ravishda o‘chirildi. Talaba bu raundni qayta urushishi mumkin.",
    "viet": "Dữ liệu của học sinh cho vòng này đã bị xóa vĩnh viễn. Học sinh có thể tiếp tục thử lại vòng này."
  },
  "ok":{
    "arabic": "حسنا",
    "az": "Oldu",
    "chinese": "好",
    "eng": "Ok",
    "hindi": "ठीक",
    "ja": "OK",
    "jp": null,
    "ky": "Жакшы",
    "ru": "Хорошо",
    "uz": "Yaxshi",
    "viet": "Được"
  },
  "no-details-found!":{
    "arabic": "لم يتم العثور على تفاصيل!",
    "az": "Heç bir detallar tapılmadı!",
    "chinese": "未找到细节！",
    "eng": "No details found!",
    "hindi": "कोई विवरण नहीं मिला!",
    "ja": "詳細が見つかりませんでした！",
    "jp": null,
    "ky": "Маалыматтар табылган жок!",
    "ru": "Детали не найдены!",
    "uz": "Tafsilotlar topilmadi!",
    "viet": "Không tìm thấy chi tiết!"
  },
  "reset-test": {
    "arabic": "إعادة تعيين الاختبار",
    "az": "Testi Sıfırlayın",
    "chinese": "重设测试",
    "eng": "Reset Test",
    "hindi": "परीक्षा रीसेट",
    "ja": "テストをリセット",
    "jp": null,
    "ky": "Сыноону баштапкы абалга келтирүү",
    "ru": "Сброс теста",
    "uz": "Sinovni tiklash",
    "viet": "Đặt lại bài kiểm tra"
  },
  "no-student-in-this-class": {
    "arabic": "لا يوجد طالب في هذا الفصل",
    "az": "Bu sinifdə şagird yoxdur",
    "chinese": "這個班沒有學生",
    "eng": "No student in this class",
    "hindi": "इस कक्षा में कोई छात्र नहीं है",
    "ja": "このクラスにはまだ生徒がいません",
    "jp": null,
    "ky": "Бул класста окуучу жок",
    "ru": "В этом классе нет учеников",
    "uz": "Ushbu sinfda o‘quvchilar mavjud emas",
    "viet": "Không có học sinh nào trong lớp"
  },
  "the-student-is-already-registered-on-cerebry-but-not-in-this-class-do-you-want-add-the-student-to-this-class-(password-will-not-be-changed)": {
    "arabic": "تم تسجيل الطالب بالفعل في Cerebry ولكنه ليس في هذا الفصل, هل تريد إضافة الطالب إلى هذا الفصل؟ (لن يتم تغيير كلمة المرور)",
    "az": "Tələbə artıq Cerebry-də qeydiyyatdan keçib, lakin bu sinifdə deyil, Siz tələbəni bu sinfə əlavə etmək istəyirsiniz? (Parol dəyişdirilməyəcək)",
    "chinese": "該學生已在 Cerebry 上註冊,但未在該班級中註冊,是否要將該學生添加到該班級中？ (密碼不會更改)",
    "eng": "The Student is already registered on Cerebry but not in this class, Do you want add the student to this class? (Password will not be changed)",
    "hindi": "छात्र पहले से ही सेरेब्री पर पंजीकृत है लेकिन इसमें नहींकक्षा, क्या आप छात्र को इस कक्षा में जोड़ना चाहते हैं? (पासवर्ड होगा बदला नहीं जा सकता)",
    "ja": "生徒がこのクラスに登録されていません。生徒をこのクラスに追加しますか? (パスワードは変更されません)",
    "jp": null,
    "ky": "Студент мурунтан эле Cerebry&#39;де катталган, бирок бул класста эмес, студентти бул класска кошкуңуз келеби? (Сырсөз өзгөртүлбөйт)",
    "ru": "Студент уже зарегистрирован на Cerebry, но не в этом классе. Хотите добавить студента в этот класс? (Пароль не будет изменен)",
    "uz": "Talaba allaqachon Cerebry'da ro'yxatdan o'tgan, lekin bu sinfda emas, talabani shu sinfga qo'shishni xohlaysizmi? (Parol o'zgartirilmaydi)",
    "viet": "Tài khoản học sinh đã được đăng ký trên Cerebry nhưng chưa ở trong lớp học này, Bạn có muốn thêm học sinh vào lớp học này không? (Mật khẩu sẽ không bị thay đổi)"
  },
  "enter-details-of-the-student": {
    "arabic": "أدخل تفاصيل الطالب",
    "az": "Tələbənin təfərrüatlarını daxil edin",
    "chinese": "輸入學生的詳細信息",
    "eng": "Enter details of the Student",
    "hindi": "छात्र का विवरण दर्ज करें",
    "ja": "生徒の詳細を入力してください",
    "jp": null,
    "ky": "Студенттин чоо-жайын киргизиңиз",
    "ru": "Введите данные студента",
    "uz": "Talaba tafsilotlarini kiriting",
    "viet": "Nhập thông tin chi tiết của học sinh"
  },
  "email": {
    "arabic": "بريد إلكتروني",
    "az": "E-poçt",
    "chinese": "電子郵件",
    "eng": "Email",
    "hindi": "ईमेल",
    "ja": "メールアドレス",
    "jp": null,
    "ky": "Email",
    "ru": "Электронная почта",
    "uz": "Elektron pochta",
    "viet": "Email"
  },
  "enter-student-first-name": {
    "arabic": "أدخل الاسم الأول للطالب",
    "az": "Tələbə Adını daxil edin",
    "chinese": "輸入學生的名字",
    "eng": "Enter Student First Name",
    "hindi": "छात्र का पहला नाम दर्ज करें",
    "ja": "生徒名（名）を入力してください",
    "jp": null,
    "ky": "Студенттин атын киргизиңиз",
    "ru": "Введите имя студента",
    "uz": "Talaba ismini kiriting",
    "viet": "Nhập tên học sinh"
  },
  "student-name": {
    "arabic": "اسم الطالب",
    "az": "Tələbə adı",
    "chinese": "學生姓名",
    "eng": "Student Name",
    "hindi": "छात्र का नाम दर्ज करें",
    "ja": "生徒名",
    "jp": null,
    "ky": "Студенттин аты",
    "ru": "Имя студента",
    "uz": "O‘quvchining ismi va familiyasi",
    "viet": "Tên học sinh"
  },
  "enter-student-last-name": {
    "arabic": "أدخل اسم الطالب الأخير",
    "az": "Tələbə soyadını daxil edin",
    "chinese": "輸入學生姓氏",
    "eng": "Enter Student Last Name",
    "hindi": "छात्र का अंतिम नाम दर्ज करें",
    "ja": "生徒名（姓）を入力してください",
    "jp": null,
    "ky": "Студенттин фамилиясын киргизиңиз",
    "ru": "Введите фамилию студента",
    "uz": "Talaba familiyasini kiriting",
    "viet": "Nhập Họ của Học sinh"
  },
  "enter-student-email-id": {
    "arabic": "أدخل معرف البريد الإلكتروني للطالب",
    "az": "Tələbə E-poçt ID-sini daxil edin",
    "chinese": "輸入學生電子郵件 ID",
    "eng": "Enter Student Email ID",
    "hindi": "छात्र ईमेल आईडी दर्ज करें",
    "ja": "生徒のメールアドレスを入力してください",
    "jp": null,
    "ky": "Студенттик Email ID киргизиңиз",
    "ru": "Введите идентификатор электронной почты студента",
    "uz": "Talaba elektron pochta identifikatorini kiriting",
    "viet": "Nhập ID email học sinh"
  },
  "min-6-characters": {
    "arabic": "الحد الأدنى 6 أحرف",
    "az": "Min. 6 simvol",
    "chinese": "分鐘6個字符",
    "eng": "Min. 6 Characters",
    "hindi": "मिन। 6 वर्ण",
    "ja": "最小6文字",
    "jp": null,
    "ky": "Мин. 6 белги",
    "ru": "Мин. 6 символов",
    "uz": "Min. 6 ta belgi",
    "viet": "tối thiểu 6 ký tự"
  },
  "re-enter-your-password": {
    "arabic": "أعد إدخال كلمة المرور الخاصة بك",
    "az": "Şifrənizi yenidən daxil edin",
    "chinese": "重新輸入您的密碼",
    "eng": "Re-enter Your Password",
    "hindi": "दुबारापासवडृ िलखो",
    "ja": "パスワードを再入力してください",
    "jp": null,
    "ky": "Сырсөзүңүздү кайра киргизиңиз",
    "ru": "Повторите свой пароль",
    "uz": "Parolingizni qayta kiriting",
    "viet": "Nhập lại mật khẩu của bạn"
  },
  "continue-with-phone-number": {
    "arabic": "متابعة مع رقم الهاتف",
    "az": "Telefon nömrəsi ilə davam edin",
    "chinese": "繼續電話號碼",
    "eng": "Continue with Phone number",
    "hindi": "फ़ोन नंबर के साथ जारी रखें",
    "ja": "電話番号から追加",
    "jp": null,
    "ky": "Телефон номери менен улантыңыз",
    "ru": "Продолжить с номером телефона",
    "uz": "Telefon raqami bilan davom eting",
    "viet": "Tiếp tục với Số điện thoại"
  },
  "continue-with-email-id": {
    "arabic": "متابعة مع معرف البريد الإلكتروني",
    "az": "E-poçt ID ilə davam edin",
    "chinese": "繼續使用電子郵件 ID",
    "eng": "Continue with Email ID",
    "hindi": "ईमेल आईडी के साथ जारी रखें",
    "ja": "メールアドレスから追加",
    "jp": null,
    "ky": "Email ID менен улантыңыз",
    "ru": "Продолжить с идентификатором электронной почты",
    "uz": "Email ID bilan davom eting",
    "viet": "Tiếp tục với ID email"
  },
  "please-enter-valid-last-name": {
    "arabic": "الرجاء إدخال اسم أخير صالح",
    "az": "Zəhmət olmasa etibarlı soyad daxil edin",
    "chinese": "請輸入有效的姓氏",
    "eng": "Please enter valid last name",
    "hindi": "कृपया मान्य पहला नाम दर्ज करें",
    "ja": "有効な名前（姓）を入力してください",
    "jp": null,
    "ky": "Жарактуу фамилияны киргизиңиз",
    "ru": "Пожалуйста, введите правильную фамилию",
    "uz": "Iltimos, haqiqiy familiyani kiriting",
    "viet": "Vui lòng nhập một họ hợp lệ"
  },
  "please-enter-valid-first-name": {
    "arabic": "الرجاء إدخال الاسم الأول الصحيح",
    "az": "Zəhmət olmasa düzgün ad daxil edin",
    "chinese": "請輸入有效的名字",
    "eng": "Please enter valid first name",
    "hindi": "कृपया मान्य अंतिम नाम दर्ज करें",
    "ja": "有効な名前（名）を入力してください",
    "jp": null,
    "ky": "Жарактуу ысымды киргизиңиз",
    "ru": "Пожалуйста, введите действительное имя",
    "uz": "Iltimos, haqiqiy ismni kiriting",
    "viet": "Vui lòng nhập một tên hợp lệ"
  },
  "please-enter-a-valid-email-id": {
    "arabic": "الرجاء إدخال معرف بريد إلكتروني صالح",
    "az": "Zəhmət olmasa, etibarlı e-poçt ID-sini daxil edin",
    "chinese": "請輸入有效的電子郵件 ID",
    "eng": "Please-enter-a-valid-email-ID",
    "hindi": "कृपया मान्य ईमेल पता दर्ज करें",
    "ja": "有効なメールアドレスを入力してください",
    "jp": null,
    "ky": "Жарактуу-электрондук почта ID-ди киргизиңиз",
    "ru": "Пожалуйста, введите действительный адрес электронной почты",
    "uz": "Iltimos, yaroqli elektron pochta identifikatorini kiriting",
    "viet": "Vui lòng nhập một ID email hợp lệ"
  },
  "password-(minimum-6-characters)": {
    "arabic": "كلمة المرور (الحد الأدنى 6 أحرف)",
    "az": "Parol (minimum 6 simvol)",
    "chinese": "密碼(最少 6 個字符)",
    "eng": "Password (Minimum 6 characters)",
    "hindi": "पासवर्ड (न्यूनतम 6 वर्ण)",
    "ja": "パスワード（6文字以上）",
    "jp": null,
    "ky": "Сырсөз (кеминде 6 белги)",
    "ru": "Пароль (минимум 6 символов)",
    "uz": "Parol (kamida 6 ta belgi)",
    "viet": "Mật khẩu (Tối thiểu 6 ký tự)"
  },
  "please-enter-a-valid-password ": {
    "arabic": "الرجاء إدخال كلمة مرور صالحة ",
    "az": "Zəhmət olmasa etibarlı parol daxil edin ",
    "chinese": "請輸入有效密碼",
    "eng": "Please enter a valid password ",
    "hindi": "कृपया एक वैध पासवर्ड दर्ज करें",
    "ja": "有効なパスワードを入力して下さい",
    "jp": null,
    "ky": "Жарактуу сырсөздү киргизиңиз ",
    "ru": "Пожалуйста, введите действительный пароль ",
    "uz": "Yaroqli parolni kiriting ",
    "viet": "Vui lòng nhập mật khẩu hợp lệ"
  },
  "email-has-been-added-several-times-please-review-and-delete-the-duplicates": {
    "arabic": "لقد تمت إضافة البريد الإلكتروني عدة مرات. يرجى مراجعة وحذف التكرارات",
    "az": "E-poçt bir neçə dəfə əlavə edildi. Zəhmət olmasa dublikatları nəzərdən keçirin və silin",
    "chinese": "電子郵件已添加多次。請檢查並刪除重複項",
    "eng": "Email has been added several times. Please review and delete the duplicates",
    "hindi": "ईमेल कई बार जोड़ा गया है। कृपया समीक्षा करें और डुप्लीकेट हटाएं",
    "ja": "このメールアドレスは既に追加されています。重複を確認してください",
    "jp": null,
    "ky": "Электрондук почта бир нече жолу кошулган. Сураныч, дубликаттарды карап чыгып, жок кылыңыз",
    "ru": "Email был добавлен несколько раз. Пожалуйста, проверьте и удалите дубликаты",
    "uz": "Elektron pochta bir necha marta qo'shilgan. Iltimos, dublikatlarni ko'rib chiqing va o'chiring",
    "viet": "Email đã được thêm vào nhiều lần. Vui lòng xem lại và xóa các bản sao"
  },
  "student-exists-shall-be-added-to-the-class-and-the-password-will-not-be-changed": {
    "arabic": "الطالب موجود, سيتم إضافته إلى الفصل ولن يتم تغيير كلمة المرور",
    "az": "Şagird mövcuddur, sinfə əlavə olunacaq və parol dəyişdirilməyəcək",
    "chinese": "學生存在,應添加到班級,密碼不會更改",
    "eng": "Student exists, shall be added to the class and the password will not be changed",
    "hindi": "छात्र मौजूद है, कक्षा में जोड़ा जाएगा और पासवर्ड नहीं बदला जाएगा",
    "ja": "生徒が登録されています。自動的にクラスに追加され、パスワードは変更されません",
    "jp": null,
    "ky": "Окуучу катталган, класска кошулат жана сырсөз өзгөртүлбөйт.",
    "ru": "Студент существует, его следует добавить в класс, и пароль не будет изменен.",
    "uz": "Talaba bor, sinfga qo'shiladi va parol o'zgartirilmaydi",
    "viet": "Học sinh đã tồn tại sẽ được thêm vào lớp học và mật khẩu sẽ không được thay đổi"
  },
  "teacher-exists-shall-be-added-to-the-class-and-the-password-will-not-be-changed": {
    "arabic": "المعلم موجود, يجب إضافته إلى الفصل ولن يتم تغيير كلمة المرور",
    "az": "Müəllim mövcuddur, sinfə əlavə ediləcək və parol dəyişdirilməyəcək.",
    "chinese": "教師存在,應添加到班級,密碼不會更改",
    "eng": "Teacher exists, shall be added to the class and the password will not be changed",
    "hindi": "शिक्षक मौजूद है, कक्षा में जोड़ा जाएगा और पासवर्ड नहीं बदला जाएगा",
    "ja": "先生が登録されています。自動的にクラスに追加され、パスワードは変更されません",
    "jp": null,
    "ky": "Мугалим катталган, класска кошулат жана сырсөз өзгөртүлбөйт.",
    "ru": "Учитель существует, его следует добавить в класс, пароль не будет изменен.",
    "uz": "O'qituvchi bor, sinfga qo'shiladi va parol o'zgartirilmaydi",
    "viet": "Giáo viên đã tồn tại sẽ được thêm vào lớp học và mật khẩu sẽ không được thay đổi"
  },
  "please-enter-a-valid-phone-number": {
    "arabic": "الرجاء إدخال رقم هاتف صالح",
    "az": "Zəhmət olmasa etibarlı telefon nömrəsi daxil edin",
    "chinese": "請輸入一個有效的電話號碼",
    "eng": "Please enter a valid phone number",
    "hindi": "कृपया एक मान्य फोन नंबर दर्ज करें",
    "ja": "有効な電話番号を入力して下さい",
    "jp": null,
    "ky": "Жарактуу телефон номерин киргизиңиз",
    "ru": "Пожалуйста, введите действительный номер телефона",
    "uz": "Iltimos, yaroqli telefon raqamini kiriting",
    "viet": "Vui lòng nhập một số điện thoại hợp lệ"
  },
  "same-phone-number-has-been-added-several-times-please-review-and-delete-the-duplicates": {
    "arabic": "تم إضافة نفس رقم الهاتف عدة مرات. يرجى مراجعة وحذف التكرارات",
    "az": "Eyni telefon nömrəsi bir neçə dəfə əlavə edilib. Zəhmət olmasa dublikatları nəzərdən keçirin və silin",
    "chinese": "同一個電話號碼已添加多次。請檢查並刪除重複項",
    "eng": "Same phone number has been added several times. Please review and delete the duplicates",
    "hindi": "एक ही फोन नंबर को कई बार जोड़ा गया है। कृपया समीक्षा करें और डुप्लीकेट हटाएं",
    "ja": "同じ電話番号が何度か追加されています。重複を確認してください",
    "jp": null,
    "ky": "Бир эле телефон номери бир нече жолу кошулган. Сураныч, кайра карап чыгып, жок кылыңыз",
    "ru": "Один и тот же номер телефона был добавлен несколько раз. Пожалуйста, проверьте и удалите дубликаты",
    "uz": "Xuddi shu telefon raqami bir necha marta qo'shilgan. Iltimos, dublikatlarni ko'rib chiqing va o'chiring",
    "viet": "Số điện thoại này đã được thêm vào nhiều lần. Vui lòng xem lại và xóa các bản sao"
  },
  "student-already-exists-in-this-class-please-delete-this-row": {
    "arabic": "الطالب موجود بالفعل في هذا الفصل. يرجى حذف هذا الصف",
    "az": "Tələbə artıq bu sinifdə mövcuddur. Zəhmət olmasa bu sıranı silin",
    "chinese": "該班級中已存在學生。請刪除這一行",
    "eng": "Student already exists in this class. Please delete this row",
    "hindi": "विद्यार्थी इस कक्षा में पहले से मौजूद है। कृपया इस पंक्ति को हटा दें",
    "ja": "生徒はこのクラスに既に登録されています。この行を削除してください",
    "jp": null,
    "ky": "Бул класста студент мурунтан эле бар. Сураныч, бул катарды жок кылыңыз",
    "ru": "Студент уже есть в этом классе. Пожалуйста, удалите эту строку",
    "uz": "Bu sinfda talaba allaqachon mavjud. Iltimos, ushbu qatorni o'chirib tashlang",
    "viet": "Học sinh này đã tồn tại trong lớp học. Vui lòng xóa hàng này"
  },
  "teacher-already-exists-in-this-class-please-delete-this-row": {
    "arabic": "المعلم موجود بالفعل في هذا الفصل. يرجى حذف هذا الصف",
    "az": "Müəllim artıq bu sinifdə var. Zəhmət olmasa bu sıranı silin",
    "chinese": "該班級中已存在教師。請刪除這一行",
    "eng": "Teacher already exists in this class. Please delete this row",
    "hindi": "शिक्षक इस कक्षा में पहले से मौजूद है। कृपया इस पंक्ति को हटा दें",
    "ja": "先生はこのクラスに既に登録されています。この行を削除してください",
    "jp": null,
    "ky": "Мугалим бул класста мурунтан эле бар. Сураныч, бул катарды жок кылыңыз",
    "ru": "Учитель уже есть в этом классе. Пожалуйста, удалите эту строку",
    "uz": "O'qituvchi bu sinfda allaqachon mavjud. Iltimos, ushbu qatorni o'chirib tashlang",
    "viet": "Giáo viên này đã tồn tại trong lớp học. Vui lòng xóa hàng này"
  },
  "assessment-creation": {
    "arabic": "إنشاء التقييم",
    "az": "Qiymətləndirmənin yaradılması",
    "chinese": "評估創建",
    "eng": "Assessment Creation",
    "hindi": "आकलन निर्माण",
    "ja": "テストの作成",
    "jp": null,
    "ky": "Баалоо түзүү",
    "ru": "Создание оценки",
    "uz": "Baholashni yaratish",
    "viet": "Tạo bài kiểm tra"
  },
  "here-is-a-summary-of-your-selection-of-questions": {
    "arabic": "فيما يلي ملخص لاختيارك للأسئلة",
    "az": "Seçdiyiniz sualların xülasəsi budur",
    "chinese": "這是您選擇的問題的摘要",
    "eng": "Here is a summary of your selection of questions",
    "hindi": "यहां आपके द्वारा चुने गए प्रश्नों का सारांश दिया गया है",
    "ja": "選択した問題の概要",
    "jp": null,
    "ky": "Бул жерде сиздин тандооңуздун кыскача суроолору",
    "ru": "Ниже представлено краткое изложение выбранных вами вопросов.",
    "uz": "Bu yerda siz tanlagan savollarning qisqacha mazmuni",
    "viet": "Dưới đây là tóm tắt các câu hỏi được bạn lựa chọn"
  },
  "by-clicking-on-confirm-cerebry-will-create-the-assessment-for-you": {
    "arabic": "من خلال النقر فوق تأكيد, سيقوم Cerebry بإنشاء التقييم لك",
    "az": "Təsdiq et üzərinə klikləməklə, Cerebry sizin üçün qiymətləndirmə yaradacaq",
    "chinese": "點擊確認,Cerebry 將為您創建評估",
    "eng": "By Clicking on Confirm, Cerebry will create the assessment for you",
    "hindi": "कन्फर्म पर क्लिक करके, सेरेब्री आपके लिए मूल्यांकन तैयार करेगा",
    "ja": "確認をクリックすると、テストが作成されます",
    "jp": null,
    "ky": "Ырастоону чыкылдатуу менен, Cerebry сиз үчүн баа түзөт",
    "ru": "Нажав «Подтвердить», Cerebry создаст для вас оценку.",
    "uz": "Tasdiqlash tugmasini bosish orqali Cerebry siz uchun baho yaratadi",
    "viet": "Bằng cách bấm vào Xác nhận, Kyons x Cerebry sẽ tạo bài kiểm tra cho bạn"
  },
  "test-paper-submitted": {
    "arabic": "تم تقديم ورقة الاختبار",
    "az": "Test Sənədi Göndərilib",
    "chinese": "試卷提交",
    "eng": "Test Paper Submitted",
    "hindi": "टेस्ट पेपर सबमिट किया गया",
    "ja": "テストの提出",
    "jp": null,
    "ky": "Сыноо кагазы тапшырылды",
    "ru": "Тестовая работа представлена",
    "uz": "Test hujjati topshirildi",
    "viet": "Đã nộp bài kiểm tra"
  },
  "you-will-no-longer-be-able-to-edit-this-submission-but-you-can-view-this-draft-from-the-'test-mode'": {
    "arabic": "لن تتمكن بعد الآن من تعديل هذا الإرسال. ولكن يمكنك عرض هذه المسودة من وضع الاختبار",
    "az": "Siz daha bu təqdimatı redaktə edə bilməyəcəksiniz. Lakin siz bu qaralamaya &quot;Sınaq Rejimi&quot;ndən baxa bilərsiniz",
    "chinese": "您將無法再編輯此提交。但您可以從“測試模式”查看此草稿",
    "eng": "You will no longer be able to edit this submission. But you can view this draft from the 'Test Mode'",
    "hindi": "अब आप इस सबमिशन को संपादित नहीं कर पाएंगे। लेकिन आप इस मसौदे को 'टेस्ट मोड' से देख सकते हैं",
    "ja": "このテストの編集はできなくなります。ただし、下書きは「テストモード」から閲覧できます",
    "jp": null,
    "ky": "Бул тапшырууну мындан ары түзөтө албай каласыз. Бирок бул долбоорду &quot;Сыноо режиминен&quot; көрө аласыз",
    "ru": "Вы больше не сможете редактировать эту заявку. Но вы можете просмотреть этот черновик в «Тестовом режиме»",
    "uz": "Siz bu yuborilgan xabarni boshqa tahrirlay olmaysiz. Ammo siz ushbu qoralamani &quot;Sinov rejimi&quot; dan ko'rishingiz mumkin",
    "viet": "Bạn sẽ không thể chỉnh sửa nội dung gửi này nữa. Nhưng bạn có thể xem bản nháp này từ 'Chế độ thử nghiệm'"
  },
  "go-to-test-mode": {
    "arabic": "انتقل إلى وضع الاختبار",
    "az": "Test rejiminə keçin",
    "chinese": "進入測試模式",
    "eng": "Go to test mode",
    "hindi": "टेस्ट मोड में जाएं",
    "ja": "テストモードへ",
    "jp": null,
    "ky": "Сыноо режимине өтүңүз",
    "ru": "Перейти в тестовый режим",
    "uz": "Sinov rejimiga o'ting",
    "viet": "Chuyển sang chế độ kiểm tra"
  },
  "please-enter-a-valid-name": {
    "arabic": "الرجاء إدخال اسم صالح",
    "az": "Lütfən, düzgün ad daxil edin",
    "chinese": "請輸入一個有效的名字",
    "eng": "Please enter a valid name",
    "hindi": "कृपया कोई मान्य नाम दर्ज करें",
    "ja": "有効な名前を入力してください",
    "jp": null,
    "ky": "Жарактуу ат киргизиңиз",
    "ru": "Пожалуйста, введите действительное имя",
    "uz": "Yaroqli nom kiriting",
    "viet": "Xin vui lòng nhập tên hợp lệ"
  },
  "please-enter-a-valid-testduration": {
    "arabic": "الرجاء إدخال مدة اختبار صالحة",
    "az": "Lütfən, etibarlı testDuration daxil edin",
    "chinese": "請輸入有效的測試持續時間",
    "eng": "Please enter a valid testDuration",
    "hindi": "कृपया एक मान्य परीक्षण अवधि दर्ज करें",
    "ja": "有効な受験期間を入力してください",
    "jp": null,
    "ky": "Жарактуу testDuration киргизиңиз",
    "ru": "Пожалуйста, введите допустимую продолжительность теста.",
    "uz": "Iltimos, yaroqli testDuration kiriting",
    "viet": "Vui lòng nhập thời lượng kiểm tra hợp lệ"
  },
  "add-more-chapters": {
    "arabic": "إضافة المزيد من الفصول",
    "az": "Daha çox fəsil əlavə edin",
    "chinese": "添加更多章節",
    "eng": "Add More Chapters",
    "hindi": "अधिक अध्याय जोड़ें",
    "ja": "チャプターを追加",
    "jp": null,
    "ky": "Көбүрөөк бөлүмдөрдү кошуу",
    "ru": "Добавить больше глав",
    "uz": "Qo'shimcha bo'limlar qo'shing",
    "viet": "Thêm chương khác"
  },
  "create-mock-test": {
    "arabic": "إنشاء اختبار تجريبي",
    "az": "Sınaq Testi yaradın",
    "chinese": "創建模擬測試",
    "eng": "Create Mock Test",
    "hindi": "मॉक टेस्ट बनाएं",
    "ja": "テストを作成",
    "jp": null,
    "ky": "Жасалма тест түзүү",
    "ru": "Создать пробный тест",
    "uz": "Soxta test yaratish",
    "viet": "Tạo Bài kiểm tra thử"
  },
  "edit-mock-test": {
    "arabic": "تعديل الاختبار التجريبي",
    "az": "Sınaq Testini Redaktə edin",
    "chinese": "編輯模擬測試",
    "eng": "Edit Mock Test",
    "hindi": "मॉक टेस्ट संपादित करें",
    "ja": "テストを編集",
    "jp": null,
    "ky": "Жасалма тестти түзөтүү",
    "ru": "Редактировать пробный тест",
    "uz": "Soxta testni tahrirlash",
    "viet": "Chỉnh sửa Bài kiểm tra thử"
  },
  "min": {
    "arabic": "دقيقة",
    "az": "min",
    "chinese": "分鐘",
    "eng": "min",
    "hindi": "मिनट",
    "ja": "分",
    "jp": null,
    "ky": "мин",
    "ru": "мин",
    "uz": "min",
    "viet": "tối thiểu"
  },
  "mins": {
    "arabic": "بلدي (ق)",
    "az": "mənim(lərim)",
    "chinese": "分鐘",
    "eng": "min(s)",
    "hindi": "मिनट",
    "ja": "(分)",
    "jp": null,
    "ky": "менин(лерим)",
    "ru": "мои(а)",
    "uz": "mening(larim)",
    "viet": "phút"
  },
  "one-or-more-Chapter-questions-are-hidden-you-can-reorder-questions-only-if-all-chapters-are-made-visible-through-filters": {
    "arabic": "يتم إخفاء سؤال واحد أو أكثر من أسئلة الفصل. يمكنك إعادة ترتيب الأسئلة فقط إذا تم جعل جميع الفصول مرئية من خلال المرشحات",
    "az": "Bir və ya bir neçə Fəsil sualı gizlədilib. Sualları yalnız bütün fəsillər filtrlər vasitəsilə görünən olduqda yenidən sıralaya bilərsiniz",
    "chinese": "隱藏了一個或多個章節問題。只有當所有章節都通過過濾器可見時,您才能重新排序問題",
    "eng": "One or more Chapter questions are hidden. You can reorder questions only if all chapters are made visible through filters",
    "hindi": "एक या अधिक अध्याय प्रश्न छिपे हुए हैं। आप प्रश्नों का क्रम तभी बदल सकते हैं जब सभी अध्याय फिल्टर के माध्यम से दिखाई दें",
    "ja": "1つ以上のチャプターの問題が非表示になっています。すべてのチャプターがフィルターによって表示されるようになっている場合にのみ、問題を並べ替えることができます",
    "jp": null,
    "ky": "Бир же бир нече бөлүм суроолору жашырылган. Бардык бөлүмдөр чыпкалардан көрүнүп турганда гана суроолорду иретке келтире аласыз",
    "ru": "Один или несколько вопросов по главам скрыты. Вы можете изменить порядок вопросов, только если все главы будут видны через фильтры",
    "uz": "Bir yoki bir nechta bo'lim savollari yashirin. Agar barcha bo'limlar filtrlar orqali ko'rinadigan bo'lsa, savollarni qayta tartiblashingiz mumkin",
    "viet": "Một hoặc vài câu hỏi đã bị ẩn. Bạn chỉ có thể sắp xếp lại các câu hỏi nếu tất cả các chương được hiển thị thông qua các bộ lọc"
  },
  "toggle-Off-to-remove-from-mock-test": {
    "arabic": "قم بإيقاف تشغيله لإزالته من الاختبار التجريبي",
    "az": "Sınaq Testindən silmək üçün Söndürün",
    "chinese": "切換關閉以從模擬測試中刪除",
    "eng": "Toggle Off to remove from Mock Test",
    "hindi": "मॉक टेस्ट से निकालने के लिए टॉगल ऑफ करें",
    "ja": "テストから削除",
    "jp": null,
    "ky": "Жалган сыноодон алып салуу үчүн өчүрүү/өчүрүү",
    "ru": "Выключите, чтобы удалить из пробного теста",
    "uz": "Soxta sinovdan oʻchirish uchun “Oʻchirish” tugmasini bosing",
    "viet": "Tắt để xoá khỏi Bài kiểm tra thử"
  },
  "toggle-on-to-add-to-mock-test": {
    "arabic": "قم بتشغيله لإضافته إلى الاختبار التجريبي",
    "az": "Sınaq Testinə əlavə etmək üçün Aktivləşdirin",
    "chinese": "開啟以添加到模擬測試",
    "eng": "Toggle On to add to Mock Test",
    "hindi": "मॉक टेस्ट में जोड़ने के लिए टॉगल ऑन करें",
    "ja": "テストに追加",
    "jp": null,
    "ky": "Жалган тестке кошуу үчүн күйгүзүңүз",
    "ru": "Включите, чтобы добавить в пробный тест",
    "uz": "Soxta testga qo'shish uchun yoqing",
    "viet": "Bật để thêm vào Bài kiểm tra thử"
  },
  "bookmark": {
    "arabic": "علامة مرجعية",
    "az": "Əlfəcin",
    "chinese": "書籤",
    "eng": "Bookmark",
    "hindi": "बुकमार्क",
    "ja": "ブックマーク",
    "jp": null,
    "ky": "Кыстарма",
    "ru": "Закладка",
    "uz": "Xatcho‘p",
    "viet": "đánh dấu"
  },
  "bk-ques-can-be": {
    "arabic": "يمكن إضافة الأسئلة التي تم وضع إشارة مرجعية عليها إلى الاختبار التجريبي الخاص بك من شاشة عرض الأسئلة التي تم وضع إشارة مرجعية عليها",
    "az": "Əlfəcin qoyulmuş suallar &#39;Ətraflı Suallara Baxış&#39; Ekranından sınaq testinizə əlavə edilə bilər",
    "chinese": "可以從“已添加書籤的問題視圖”屏幕將已添加書籤的問題添加到您的模擬測試中",
    "eng": "Bookmarked questions can be added into your mock test from the 'Bookmarked Questions View' Screen",
    "hindi": "बुकमार्क किए गए प्रश्नों को 'बुकमार्क किए गए प्रश्न व्यू' स्क्रीन से आपके मॉक टेस्ट में जोड़ा जा सकता है",
    "ja": "ブックマークされた問題は、[ブックマークされた問題の表示] 画面からテストに追加できます。",
    "jp": null,
    "ky": "Кыстарылган суроолорду жасалма тестиңизге &quot;Белгиленген суроолорду кароо&quot; экранынан кошууга болот",
    "ru": "Вопросы, отмеченные закладками, можно добавить в пробный тест с экрана «Просмотр вопросов, отмеченных закладками».",
    "uz": "Xatcho‘p qo‘yilgan savollarni “Xatcho‘plangan savollarni ko‘rish” ekranidan soxta testingizga qo‘shish mumkin",
    "viet": "Các câu hỏi được đánh dấu có thể được thêm vào Bài kiểm tra thử của bạn bằng cách vào trang 'Xem các Câu hỏi được đánh dấu'"
  },
  "Hint": {
    "arabic": "تَلمِيح",
    "az": "İpucu",
    "chinese": "暗示",
    "eng": "Hint",
    "hindi": "संकेत देना",
    "ja": "ヒント",
    "jp": null,
    "ky": "Жөнөкөй түшүнүк",
    "ru": "Намекать",
    "uz": "Maslahat",
    "viet": "Gợi ý"
  },
  "toggle-on-to-enable-access-to-topic-now": {
    "arabic": "قم بتشغيله لتمكين الوصول إلى الموضوع الآن",
    "az": "Mövzuya girişi indi aktiv etmək üçün Aktivləşdirin",
    "chinese": "開啟以立即啟用對主題的訪問",
    "eng": "Toggle On to enable access to topic now",
    "hindi": "विषय पर अभी पहुंच सक्षम करने के लिए चालू करें",
    "ja": "オンに切り替えると、生徒がトピックを閲覧できるようになります。",
    "jp": null,
    "ky": "Темага азыр кирүү мүмкүнчүлүгүн иштетүү үчүн күйгүзүңүз",
    "ru": "Включите, чтобы включить доступ к теме сейчас",
    "uz": "Mavzuga hozir kirishni yoqish uchun yoqing",
    "viet": "Bật để cấp quyền truy cập vào chủ đề ngay bây giờ"
  },
  "end-date-is-required": {
    "arabic": "تاريخ النهاية مطلوب",
    "az": "Bitmə tarixi tələb olunur",
    "chinese": "結束日期是必需的",
    "eng": "End date is required",
    "hindi": "समाप्ति तिथि आवश्यक है",
    "ja": "終了日を設定する",
    "jp": null,
    "ky": "Аяктоо күнү талап кылынат",
    "ru": "Требуется дата окончания",
    "uz": "Tugash sanasi talab qilinadi",
    "viet": "Bắt buộc phải có ngày kết thúc"
  },
  "create-virtual-class": {
    "arabic": "إنشاء فصل دراسي افتراضي",
    "az": "Virtual sinif yaradın",
    "chinese": "創建虛擬課堂",
    "eng": "Create Virtual Class",
    "hindi": "वर्चुअल क्लास बनाएं",
    "ja": "バーチャルクラスの作成",
    "jp": null,
    "ky": "Виртуалдык класс түзүү",
    "ru": "Создать виртуальный класс",
    "uz": "Virtual sinf yarating",
    "viet": "Tạo lớp học ảo"
  },
  "see-attendance": {
    "arabic": "انظر الحضور",
    "az": "Davamiyyətə baxın",
    "chinese": "查看考勤",
    "eng": "See Attendance",
    "hindi": "उपस्थिति देखें",
    "ja": "出席を確認する",
    "jp": null,
    "ky": "Катышууну караңыз",
    "ru": "Посмотреть посещаемость",
    "uz": "Davomatga qarang",
    "viet": "xem điểm danh"
  },
  "click-the-button-below-to-launch-a-virtual-class-right-now": {
    "arabic": "انقر على الزر أدناه لبدء فصل دراسي افتراضي الآن",
    "az": "Hazırda virtual sinifə başlamaq üçün aşağıdakı düyməyə klikləyin",
    "chinese": "單擊下面的按鈕立即啟動虛擬課程",
    "eng": "Click the button below to launch a virtual class right now",
    "hindi": "अभी वर्चुअल क्लास शुरू करने के लिए नीचे दिए गए बटन पर क्लिक करें",
    "ja": "下のボタンをクリックして、今すぐバーチャルクラスを起動します",
    "jp": null,
    "ky": "Виртуалдык классты азыр баштоо үчүн төмөнкү баскычты басыңыз",
    "ru": "Нажмите кнопку ниже, чтобы запустить виртуальный класс прямо сейчас",
    "uz": "Hozirda virtual sinfni ishga tushirish uchun quyidagi tugmani bosing",
    "viet": "Nhấp vào nút bên dưới để bắt đầu một lớp học ảo ngay bây giờ"
  },
  "virtual-class": {
    "arabic": "الصف الافتراضي",
    "az": "Virtual sinif",
    "chinese": "虛擬課堂",
    "eng": "Virtual Class",
    "hindi": "वर्चुअल क्लास",
    "ja": "バーチャルクラス",
    "jp": null,
    "ky": "Виртуалдык класс",
    "ru": "Виртуальный класс",
    "uz": "Virtual sinf",
    "viet": "Lớp học ảo"
  },
  "class-selected": {
    "arabic": "تم اختيار الصف",
    "az": "Sinif Seçildi",
    "chinese": "所選班級",
    "eng": "Class Selected",
    "hindi": "वर्ग चयनित",
    "ja": "選択中のクラス",
    "jp": null,
    "ky": "Тандалган класс",
    "ru": "Класс выбран",
    "uz": "Tanlangan sinf",
    "viet": "Lớp đã chọn"
  },
  "hi": {
    "arabic": "أهلاً",
    "az": "salam",
    "chinese": "你好",
    "eng": "Hi",
    "hindi": "नमस्ते",
    "ja": "ようこそ",
    "jp": null,
    "ky": "Салам",
    "ru": "Привет",
    "uz": "Salom",
    "viet": "CHÀO"
  },
  "create-new-class": {
    "arabic": "إنشاء فئة جديدة",
    "az": "Yeni sinif yaradın",
    "chinese": "創建新類",
    "eng": "Create new class",
    "hindi": "नई कक्षा बनाएँ",
    "ja": "新しいクラスを作成",
    "jp": null,
    "ky": "Жаңы класс түзүү",
    "ru": "Создать новый класс",
    "uz": "Yangi sinf yaratish",
    "viet": "Tạo lớp mới"
  },
  "most-correct-solves": {
    "arabic": "الحلول الأكثر صحة",
    "az": "Ən Düzgün həll edir",
    "chinese": "最正確的解決方案",
    "eng": "Most Correct Solves",
    "hindi": "सबसे सही समाधान",
    "ja": "最も正しい解答",
    "jp": null,
    "ky": "Эң туура чечет",
    "ru": "Самые правильные решения",
    "uz": "Eng to'g'ri echimlar",
    "viet": "Lời giải chính xác nhất"
  },
  "class-list": {
    "arabic": "قائمة الفصول الدراسية",
    "az": "Sinif siyahısı",
    "chinese": "班級名單",
    "eng": "Class List",
    "hindi": "वर्ग सूची",
    "ja": "クラス一覧",
    "jp": null,
    "ky": "Класстардын тизмеси",
    "ru": "Список классов",
    "uz": "Sinf ro‘yxati",
    "viet": "Danh sách lớp"
  },
  "teach-now": {
    "arabic": "قم بالتدريس الآن",
    "az": "İndi öyrət",
    "chinese": "現在教",
    "eng": "Teach Now",
    "hindi": "अब सिखाओ",
    "ja": "今すぐ教える",
    "jp": null,
    "ky": "Азыр үйрөт",
    "ru": "Научите сейчас",
    "uz": "Hozir o'rgating",
    "viet": "dạy ngay"
  },
  "select-grade": {
    "arabic": "حدد الصف",
    "az": "Sinif seçin",
    "chinese": "選擇年級",
    "eng": "Select Grade",
    "hindi": "ग्रेड का चयन करें",
    "ja": "学年を選択",
    "jp": null,
    "ky": "Классты тандаңыз",
    "ru": "Выберите класс",
    "uz": "Sinfni tanlash",
    "viet": "Chọn lớp"
  },
  "few-or-more-students-have-started-the-practice-are-you-sure-you-want-to-save": {
    "arabic": "لقد بدأ عدد قليل أو أكثر من الطلاب التدريب, هل أنت متأكد من أنك تريد الحفظ؟",
    "az": "Təcrübəyə az və ya daha çox tələbə başlayıb, qənaət etmək istədiyinizə əminsiniz",
    "chinese": "幾個或更多的學生開始練習,你確定要保存嗎",
    "eng": "Few or more students have started the practise, are you sure you want to save",
    "hindi": "कुछ या अधिक छात्रों ने अभ्यास शुरू कर दिया है, क्या आप सुनिश्चित हैं कि आप बचत करना चाहते हैं",
    "ja": "複数の生徒が学習を開始しました。保存しますか?",
    "jp": null,
    "ky": "Бир нече же андан көп студенттер практиканы баштады, чын эле сактап калгыңыз келеби?",
    "ru": "Несколько или больше студентов приступили к практике, вы уверены, что хотите сохранить",
    "uz": "Amaliyotni bir necha yoki undan koʻp talaba boshladi, siz saqlamoqchimisiz",
    "viet": "Ít hoặc nhiều học viên đã bắt đầu luyện tập, bạn có chắc chắn muốn lưu"
  },
  "on": {
    "arabic": "على",
    "az": "Aktiv",
    "chinese": "在",
    "eng": "On",
    "hindi": "पर",
    "ja": "オン",
    "jp": null,
    "ky": "Күйүк",
    "ru": "На",
    "uz": "Yoniq",
    "viet": "TRÊN"
  },
  "off": {
    "arabic": "عن",
    "az": "Söndür",
    "chinese": "離開",
    "eng": "Off",
    "hindi": "बंद",
    "ja": "オフ",
    "jp": null,
    "ky": "Өчүк",
    "ru": "Выключенный",
    "uz": "Oʻchirilgan",
    "viet": "Tắt"
  },
  "saved": {
    "arabic": "أنقذ",
    "az": "Saxlandı",
    "chinese": "已保存",
    "eng": "Saved",
    "hindi": "बचाया",
    "ja": "保存済",
    "jp": null,
    "ky": "Сакталган",
    "ru": "Сохранено",
    "uz": "Saqlangan",
    "viet": "Đã lưu"
  },
  "sorted-by": {
    "arabic": "مرتبة حسب",
    "az": "Sıralama üzrə",
    "chinese": "排序",
    "eng": "Sorted by",
    "hindi": "आधार पर छाँटे",
    "ja": "並べ替え",
    "jp": null,
    "ky": "Сорттолгон",
    "ru": "Сортировать по",
    "uz": "Saralangan",
    "viet": "Sắp xếp theo"
  },
  "sort-by": {
    "arabic": "فرز حسب",
    "az": "Sırala",
    "chinese": "排序",
    "eng": "Sort by",
    "hindi": "आधार पर छाँटे",
    "ja": "並べ替え",
    "jp": null,
    "ky": "Сорттоо боюнча",
    "ru": "Сортировать по",
    "uz": "Saralash turi",
    "viet": "Sor bởi"
  },
  "initial-progress": {
    "arabic": "التقدم الأولي",
    "az": "İlkin tərəqqi",
    "chinese": "初步進展",
    "eng": "Initial Progress",
    "hindi": "प्रारंभिक प्रगति",
    "ja": "初期の進捗状況",
    "jp": null,
    "ky": "Баштапкы прогресс",
    "ru": "Начальный прогресс",
    "uz": "Dastlabki taraqqiyot",
    "viet": "Tiến độ ban đầu"
  },
  "progress-achieved": {
    "arabic": "التقدم المحرز",
    "az": "Əldə Edilən Tərəqqi",
    "chinese": "取得的進展",
    "eng": "Progress Achieved",
    "hindi": "प्रगति हासिल की",
    "ja": "進捗状況",
    "jp": null,
    "ky": "Прогресс жетишилди",
    "ru": "Прогресс достигнут",
    "uz": "Erishilgan taraqqiyot",
    "viet": "Tiến độ đạt được"
  },
  "topics-practiced": {
    "arabic": "المواضيع التي تم ممارستها",
    "az": "Təcrübə olunan mövzular",
    "chinese": "實踐主題",
    "eng": "Topics practised",
    "hindi": "विषयों का अभ्यास किया",
    "ja": "学習済のトピック",
    "jp": null,
    "ky": "Практикаланган темалар",
    "ru": "Практикуемые темы",
    "uz": "Amaliy mavzular",
    "viet": "chủ đề thực hành"
  },
  "levels": {
    "arabic": "المستويات",
    "az": "Səviyyələr",
    "chinese": "级别",
    "eng": "Levels",
    "hindi": "स्तरों",
    "ja": "レベル",
    "jp": null,
    "ky": "Деңгээлдер",
    "ru": "Уровни",
    "uz": "Darajalar",
    "viet": "cấp độ"
  },
  "set-levels": {
    "arabic": "تعيين المستويات",
    "az": "Səviyyələri təyin edin",
    "chinese": "设置级别",
    "eng": "Set Levels",
    "hindi": "स्तर निर्धारित करें",
    "ja": "レベルを設定する",
    "jp": null,
    "ky": "Деңгээлдерди коюу",
    "ru": "Установить уровни",
    "uz": "Darajani o'rnatish",
    "viet": "Đặt cấp độ"
  },
  "assign-ninjas": {
    "arabic": "تعيين النينجا",
    "az": "Ninjaları təyin edin",
    "chinese": "分配忍者",
    "eng": "Assign Ninjas",
    "hindi": "निन्जा को असाइन करें",
    "ja": "忍者を割り当てる",
    "jp": null,
    "ky": "Ниндзяларды дайындаңыз",
    "ru": "Назначить ниндзя",
    "uz": "Ninjalarni tayinlang",
    "viet": "Chỉ định Ninja"
  },
  "teams": {
    "arabic": "الفرق",
    "az": "Komandalar",
    "chinese": "团队",
    "eng": "Teams",
    "hindi": "टीमें",
    "ja": "チーム",
    "jp": null,
    "ky": "Командалар",
    "ru": "Команды",
    "uz": "Jamoalar",
    "viet": "Đội"
  },
  "search-students": {
    "arabic": "البحث عن الطلاب",
    "az": "Şagirdləri axtarın",
    "chinese": "搜索學生",
    "eng": "Search Students",
    "hindi": "छात्र खोजें",
    "ja": "生徒を検索する",
    "jp": null,
    "ky": "Окуучуларды издеңиз",
    "ru": "Поиск студентов",
    "uz": "O‘quvchilarni qidirish",
    "viet": "Tìm kiếm sinh viên"
  },
  "confirm-password": {
    "arabic": "تأكيد كلمة المرور",
    "az": "Şifrəni təsdiqləyin",
    "chinese": "確認密碼",
    "eng": "Confirm Password",
    "hindi": "पासवर्ड की पुष्टि कीजिये",
    "ja": "パスワードを認証する",
    "jp": null,
    "ky": "Сырсөздү ыраста",
    "ru": "Подтвердите пароль",
    "uz": "Parolni tasdiqlang",
    "viet": "Xác nhận mật khẩu"
  },
  "enter-test-name": {
    "arabic": "أدخل اسم الاختبار",
    "az": "Test adını daxil edin",
    "chinese": "輸入測試名稱",
    "eng": "Enter test name",
    "hindi": "परीक्षण नाम दर्ज करें",
    "ja": "テスト名を入力",
    "jp": null,
    "ky": "Сынактын атын киргизиңиз",
    "ru": "Введите название теста",
    "uz": "Test nomini kiriting",
    "viet": "Nhập tên kiểm tra"
  },
  "successfully-added-to-the-class": {
    "arabic": "تمت الإضافة إلى الفصل بنجاح",
    "az": "uğurla sinfə əlavə edildi",
    "chinese": "成功加入班級",
    "eng": "successfully added to the class",
    "hindi": "कक्षा में सफलतापूर्वक जोड़ा गया",
    "ja": "クラスに正常に追加されました",
    "jp": null,
    "ky": "класска ийгиликтүү кошулду",
    "ru": "успешно добавлен в класс",
    "uz": "sinfga muvaffaqiyatli qo'shildi",
    "viet": "đã thêm thành công vào lớp"
  },
  "and-their-credentials-have-been-emailed-to-them.": {
    "arabic": "وقد تم إرسال بيانات اعتمادهم إليهم عبر البريد الإلكتروني.",
    "az": "və etimadnamələri onlara e-poçt göndərilib.",
    "chinese": "他們的憑據已通過電子郵件發送給他們。",
    "eng": "and their credentials have been emailed to them.",
    "hindi": "और उनकी पहचान उन्हें ईमेल किया गया है।",
    "ja": "彼らの資格情報はメールで送信されました。",
    "jp": null,
    "ky": "жана алардын ишеним грамоталары аларга электрондук почта аркылуу жөнөтүлдү.",
    "ru": "и их учетные данные были отправлены им по электронной почте.",
    "uz": "va ularning hisob ma'lumotlari elektron pochta orqali yuborilgan.",
    "viet": "và thông tin đăng nhập của họ đã được gửi qua email cho họ."
  },
  "of-whom": {
    "arabic": "من منهم",
    "az": "kimdən",
    "chinese": "其中的",
    "eng": "of whom",
    "hindi": "जिनमें से",
    "ja": "誰の",
    "jp": null,
    "ky": "кимден",
    "ru": "из которых",
    "uz": "kimdan",
    "viet": "của ai"
  },
  "already-on-the-platform": {
    "arabic": "بالفعل على المنصة",
    "az": "artıq platformada",
    "chinese": "已經在平台上",
    "eng": "already on the platform",
    "hindi": "पहले से ही मंच पर",
    "ja": "すでにプラットフォームに",
    "jp": null,
    "ky": "платформада",
    "ru": "уже на платформе",
    "uz": "allaqachon platformada",
    "viet": "đã có trên nền tảng"
  },
  "was": {
    "arabic": "كان",
    "az": "idi",
    "chinese": "曾是",
    "eng": "was",
    "hindi": "था",
    "ja": "だった",
    "jp": null,
    "ky": "болгон",
    "ru": "был",
    "uz": "edi",
    "viet": "đã từng là"
  },
  "were": {
    "arabic": "كان",
    "az": "idi",
    "chinese": "是",
    "eng": "were",
    "hindi": "थे",
    "ja": "だった",
    "jp": null,
    "ky": "болгон",
    "ru": "были",
    "uz": "edi",
    "viet": "đã từng"
  },
  "o": {
    "arabic": "ال",
    "az": "the",
    "chinese": "歐",
    "eng": "o",
    "hindi": "थे",
    "ja": "〇",
    "jp": null,
    "ky": "the",
    "ru": "тот",
    "uz": "O",
    "viet": "Ô"
  },
  "password-and-confirm-password-do-not-match": {
    "arabic": "كلمة المرور وتأكيد كلمة المرور لا يتطابقان",
    "az": "Parol və Təsdiq Şifrə uyğun gəlmir",
    "chinese": "密碼和確認密碼不匹配",
    "eng": "Password and Confirm Password do not match",
    "hindi": "पासवर्ड और कन्फर्म पासवर्ड मेल नहीं खाते",
    "ja": "パスワードと確認用パスワードが一致しません",
    "jp": null,
    "ky": "Сырсөз менен Сырсөздү ырастоо дал келбейт",
    "ru": "Пароль и подтверждение пароля не совпадают",
    "uz": "Parol va parolni tasdiqlash mos kelmaydi",
    "viet": "Mật khẩu và Xác nhận mật khẩu không khớp"
  },
  "add-using-phone-number": {
    "arabic": "أضف باستخدام رقم الهاتف",
    "az": "Telefon nömrəsini istifadə edərək əlavə edin",
    "chinese": "使用電話號碼添加",
    "eng": "Add using phone number",
    "hindi": "फ़ोन नंबर का उपयोग करके जोड़ें",
    "ja": "電話番号を追加",
    "jp": null,
    "ky": "Телефон номерин колдонуп кошуу",
    "ru": "Добавить, используя номер телефона",
    "uz": "Telefon raqamidan foydalanib qo'shing",
    "viet": "Thêm bằng số điện thoại"
  },
  "add-using-email-id": {
    "arabic": "أضف باستخدام معرف البريد الإلكتروني",
    "az": "E-poçt ID istifadə edərək əlavə edin",
    "chinese": "使用電子郵件 ID 添加",
    "eng": "Add using Email ID",
    "hindi": "ईमेल आईडी का उपयोग कर जोड़ें",
    "ja": "メールアドレスを追加",
    "jp": null,
    "ky": "Email ID аркылуу кошуу",
    "ru": "Добавить, используя идентификатор электронной почты",
    "uz": "Email ID yordamida qo'shing",
    "viet": "Thêm bằng ID Email"
  },
  "add-using-username": {
    "arabic": "أضف باستخدام اسم المستخدم",
    "az": "İstifadəçi adı ilə əlavə edin",
    "chinese": "使用用戶名添加",
    "eng": "Add using Username",
    "hindi": "उपयोगकर्ता नाम का उपयोग करके जोड़ें",
    "ja": "ユーザー名を追加",
    "jp": null,
    "ky": "Колдонуучуну аты менен кошуу",
    "ru": "Добавить, используя имя пользователя",
    "uz": "Foydalanuvchi nomi orqali qo‘shish",
    "viet": "Thêm bằng tên người dùng"
  },
  "text": {
    "arabic": "نص",
    "az": "mətn",
    "chinese": "文本",
    "eng": "text",
    "hindi": "मूलपाठ",
    "ja": "本文",
    "jp": null,
    "ky": "текст",
    "ru": "текст",
    "uz": "matn",
    "viet": "chữ"
  },
  "day": {
    "arabic": "يوم",
    "az": "gün",
    "chinese": "天",
    "eng": "day",
    "hindi": "दिन",
    "ja": "日",
    "jp": null,
    "ky": "күн",
    "ru": "день",
    "uz": "kun",
    "viet": "ngày"
  },
  "days": {
    "arabic": "أيام",
    "az": "günlər",
    "chinese": "天",
    "eng": "days",
    "hindi": "दिन",
    "ja": "日",
    "jp": null,
    "ky": "күн",
    "ru": "дней",
    "uz": "kunlar",
    "viet": "ngày"
  },
  "hr": {
    "arabic": "ساعة",
    "az": "saat",
    "chinese": "小時",
    "eng": "hr",
    "hindi": "घंटा",
    "ja": "時間",
    "jp": null,
    "ky": "ч",
    "ru": "час",
    "uz": "soat",
    "viet": "giờ"
  },
  "not-started": {
    "arabic": "لم يتم البدء",
    "az": "Başlanmayıb",
    "chinese": "沒有開始",
    "eng": "Not Started",
    "hindi": "शुरू नहीं",
    "ja": "未開始",
    "jp": null,
    "ky": "Башталган жок",
    "ru": "Не начато",
    "uz": "Boshlanmagan",
    "viet": "Chưa bắt đầu"
  },
  "deadline-missed": {
    "arabic": "تم تفويت الموعد النهائي",
    "az": "Son tarix buraxıldı",
    "chinese": "錯過最後期限",
    "eng": "Deadline Missed",
    "hindi": "समय सीमा छूटी",
    "ja": "期限切れ",
    "jp": null,
    "ky": "Мөөнөтү өтүп кетти",
    "ru": "Срок пропущен",
    "uz": "Muddati o'tkazib yuborilgan",
    "viet": "Hạn chót bị bỏ lỡ"
  },
  "enable-partial-marking": {
    "arabic": "تمكين وضع العلامات الجزئية",
    "az": "Qismən işarələməni aktivləşdirin",
    "chinese": "啟用部分標記",
    "eng": "Enable Partial Marking",
    "hindi": "आंशिक अंकन सक्षम करें",
    "ja": "部分点を有効にする",
    "jp": null,
    "ky": "Жарым-жартылай белгилөө иштетүү",
    "ru": "Включить частичную маркировку",
    "uz": "Qisman belgilashni yoqing",
    "viet": "Kích hoạt đánh dấu một phần"
  },
  "enable-same-questions-for-all": {
    "arabic": "تمكين نفس الأسئلة للجميع",
    "az": "Hamı üçün eyni sualları aktivləşdirin",
    "chinese": "為所有人啟用相同的問題",
    "eng": "Enable same questions for all",
    "hindi": "सभी के लिए समान प्रश्न सक्षम करें",
    "ja": "すべての生徒に同じ問題を配信する",
    "jp": null,
    "ky": "Баары үчүн бирдей суроолорду иштетүү",
    "ru": "Включить одинаковые вопросы для всех",
    "uz": "Hamma uchun bir xil savollarni yoqing",
    "viet": "Bật cùng một câu hỏi cho tất cả"
  },
  "enable-corrective-practise": {
    "arabic": "تمكين الممارسة التصحيحية",
    "az": "Düzəliş Təcrübəsini aktivləşdirin",
    "chinese": "啟用糾正措施",
    "eng": "Enable Corrective Practise",
    "hindi": "सुधारात्मक अभ्यास सक्षम करें",
    "ja": "テスト完了後に復習問題を自動配信する",
    "jp": null,
    "ky": "Түзөтүүчү практиканы иштетүү",
    "ru": "Включить корректирующую практику",
    "uz": "Tuzatish amaliyotini yoqing",
    "viet": "Kích hoạt thực hành khắc phục"
  },
  "jan": {
    "arabic": "يناير",
    "az": "Yanvar",
    "chinese": "簡",
    "eng": "Jan",
    "hindi": "जनवरी",
    "ja": "1月",
    "jp": null,
    "ky": "январь",
    "ru": "Янв",
    "uz": "Yanvar",
    "viet": "Tháng một"
  },
  "feb": {
    "arabic": "فبراير",
    "az": "Fevral",
    "chinese": "二月",
    "eng": "Feb",
    "hindi": "फ़रवरी",
    "ja": "2月",
    "jp": null,
    "ky": "февраль",
    "ru": "февр.",
    "uz": "Fevral",
    "viet": "Tháng Hai"
  },
  "mar": {
    "arabic": "مارس",
    "az": "mart",
    "chinese": "三月",
    "eng": "Mar",
    "hindi": "मार्च",
    "ja": "3月",
    "jp": null,
    "ky": "Мар",
    "ru": "март",
    "uz": "mart",
    "viet": "tháng ba"
  },
  "apr": {
    "arabic": "أبريل",
    "az": "aprel",
    "chinese": "4月",
    "eng": "Apr",
    "hindi": "अप्रैल",
    "ja": "4月",
    "jp": null,
    "ky": "апрель",
    "ru": "Апрель",
    "uz": "aprel",
    "viet": "tháng tư"
  },
  "may": {
    "arabic": "يمكن",
    "az": "may",
    "chinese": "可能",
    "eng": "May",
    "hindi": "मई",
    "ja": "5月",
    "jp": null,
    "ky": "Май",
    "ru": "Может",
    "uz": "may",
    "viet": "Có thể"
  },
  "june": {
    "arabic": "يونيو",
    "az": "iyun",
    "chinese": "六月",
    "eng": "June",
    "hindi": "जून",
    "ja": "6月",
    "jp": null,
    "ky": "Июнь",
    "ru": "Июнь",
    "uz": "iyun",
    "viet": "Tháng sáu"
  },
  "july": {
    "arabic": "يوليو",
    "az": "iyul",
    "chinese": "七月",
    "eng": "July",
    "hindi": "जुलाई",
    "ja": "7月",
    "jp": null,
    "ky": "Июль",
    "ru": "Июль",
    "uz": "iyul",
    "viet": "Tháng bảy"
  },
  "aug": {
    "arabic": "أغسطس",
    "az": "avqust",
    "chinese": "八月",
    "eng": "Aug",
    "hindi": "अगस्त",
    "ja": "8月",
    "jp": null,
    "ky": "август",
    "ru": "авг.",
    "uz": "avgust",
    "viet": "tháng 8"
  },
  "sept": {
    "arabic": "سبتمبر",
    "az": "Sentyabr",
    "chinese": "九月",
    "eng": "Sept",
    "hindi": "सितंबर",
    "ja": "9月",
    "jp": null,
    "ky": "сентябрь",
    "ru": "сентябрь",
    "uz": "sentabr",
    "viet": "tháng 9"
  },
  "oct": {
    "arabic": "أكتوبر",
    "az": "Oktyabr",
    "chinese": "十月",
    "eng": "Oct",
    "hindi": "अक्टूबर",
    "ja": "10月",
    "jp": null,
    "ky": "октябрь",
    "ru": "октябрь",
    "uz": "Oktyabr",
    "viet": "tháng mười"
  },
  "nov": {
    "arabic": "نوفمبر",
    "az": "noyabr",
    "chinese": "十一月",
    "eng": "Nov",
    "hindi": "नवंबर",
    "ja": "11月",
    "jp": null,
    "ky": "ноябрь",
    "ru": "ноябрь",
    "uz": "Noyabr",
    "viet": "tháng 11"
  },
  "dec": {
    "arabic": "ديسمبر",
    "az": "dekabr",
    "chinese": "十二月",
    "eng": "Dec",
    "hindi": "दिसम्बर",
    "ja": "12月",
    "jp": null,
    "ky": "декабрь",
    "ru": "Декабрь",
    "uz": "dekabr",
    "viet": "Tháng mười hai"
  },
  "mon": {
    "arabic": "لي",
    "az": "mənim",
    "chinese": "我的",
    "eng": "Mon",
    "hindi": "सोमवार",
    "ja": "月",
    "jp": null,
    "ky": "менин",
    "ru": "Мой",
    "uz": "mening",
    "viet": "Của tôi"
  },
  "tue": {
    "arabic": "الثلاثاء",
    "az": "Çərşənbə axşamı",
    "chinese": "星期二",
    "eng": "Tue",
    "hindi": "मंगल",
    "ja": "火",
    "jp": null,
    "ky": "шей",
    "ru": "Вт",
    "uz": "Seshanba",
    "viet": "thứ ba"
  },
  "wed": {
    "arabic": "تزوج",
    "az": "Çərşənbə",
    "chinese": "星期三",
    "eng": "Wed",
    "hindi": "बुध",
    "ja": "水",
    "jp": null,
    "ky": "Шар",
    "ru": "Обвенчались",
    "uz": "Chorshanba",
    "viet": "Thứ Tư"
  },
  "thu": {
    "arabic": "يجمع",
    "az": "Toplayın",
    "chinese": "收集",
    "eng": "Thu",
    "hindi": "गुरु",
    "ja": "木",
    "jp": null,
    "ky": "чогултуу",
    "ru": "Собирать",
    "uz": "Yig'ish",
    "viet": "Thu"
  },
  "fri": {
    "arabic": "الجمعة",
    "az": "Cümə",
    "chinese": "星期五",
    "eng": "Fri",
    "hindi": "शुक्र",
    "ja": "金",
    "jp": null,
    "ky": "Жм",
    "ru": "пт",
    "uz": "Juma",
    "viet": "thứ sáu"
  },
  "concept": {
    "arabic": "مفهوم",
    "az": "Konsepsiya",
    "chinese": "概念",
    "eng": "Concept",
    "hindi": "अवधारणा",
    "ja": "コンセプト",
    "jp": null,
    "ky": "Концепция",
    "ru": "Концепция",
    "uz": "Kontseptsiya",
    "viet": "Ý tưởng"
  },
  "one": {
    "arabic": "مفهوم",
    "az": "Konsepsiya",
    "chinese": "概念",
    "eng": "Concept",
    "hindi": "एक",
    "ja": "コンセプト",
    "jp": null,
    "ky": "Концепция",
    "ru": "Концепция",
    "uz": "Kontseptsiya",
    "viet": "Ý tưởng"
  },
  "design-test": {
    "arabic": "اختبار التصميم",
    "az": "Dizayn Testi",
    "chinese": "设计测试",
    "eng": "Design Test",
    "hindi": "डिजाइन टेस्ट",
    "ja": "テストを作成",
    "jp": null,
    "ky": "Дизайн тести",
    "ru": "Тестирование конструкции",
    "uz": "Dizayn sinovi",
    "viet": "Kiểm tra thiết kế"
  },
  "Notification": {
    "arabic": "إشعار",
    "az": "Bildiriş",
    "chinese": null,
    "eng": "Notification",
    "hindi": null,
    "ja": "学習状況",
    "jp": null,
    "ky": "Эскертме",
    "ru": "Уведомление",
    "uz": "Bildirishnoma",
    "viet": null
  },
  "Date & Time": {
    "arabic": "التاريخ والوقت",
    "az": "Tarix &amp; Saat",
    "chinese": "约会时间",
    "eng": "Date & Time",
    "hindi": "दिनांक समय",
    "ja": "日時",
    "jp": null,
    "ky": "Дата жана убакыт",
    "ru": "Дата и время",
    "uz": "Sana va vaqt",
    "viet": "Ngày giờ"
  },
  "Reminder": {
    "arabic": "تذكيرات",
    "az": "Xatırlatma",
    "chinese": "提醒",
    "eng": "Reminder",
    "hindi": "अनुस्मारक",
    "ja": "種別",
    "jp": null,
    "ky": "Эскерткичтер",
    "ru": "Напоминание",
    "uz": "Eslatma",
    "viet": "Lời nhắc nhở"
  },
  "Status": {
    "arabic": "حالة",
    "az": "Vəziyyət",
    "chinese": "地位",
    "eng": "Status",
    "hindi": "स्थिति",
    "ja": "ステータス",
    "jp": null,
    "ky": "Статус",
    "ru": "Статус",
    "uz": "Holat",
    "viet": "Trạng thái"
  },
  "descriptions": {
    "arabic": "وصف",
    "az": "Təsvir",
    "chinese": "描述",
    "eng": "Description",
    "hindi": "विवरण",
    "ja": "詳細",
    "jp": null,
    "ky": "Description",
    "ru": "Описание",
    "uz": "Tavsif",
    "viet": "Sự miêu tả"
  },
  "alert": {
    "arabic": "يُحذًِر",
    "az": "Xəbərdarlıq",
    "chinese": null,
    "eng": "Alert",
    "hindi": null,
    "ja": "アラート",
    "jp": null,
    "ky": "Alert",
    "ru": "Тревога",
    "uz": "Ogohlantirish",
    "viet": null
  },
  "milestones": {
    "arabic": "المعالم البارزة",
    "az": "Mərhələlər",
    "chinese": null,
    "eng": "Milestones",
    "hindi": null,
    "ja": "マイルストン",
    "jp": null,
    "ky": "Этаптар",
    "ru": "Вехи",
    "uz": "Marosimlar",
    "viet": null
  },
  "updates": {
    "arabic": "التحديثات",
    "az": "Yeniləmələr",
    "chinese": null,
    "eng": "Updates",
    "hindi": null,
    "ja": "アップデート",
    "jp": null,
    "ky": "Жаңыртуулар",
    "ru": "Обновления",
    "uz": "Yangilanishlar",
    "viet": null
  },
  "currently-on": {
    "arabic": "حاليا على",
    "az": "Hazırda aktivdir",
    "chinese": "目前开启",
    "eng": "Currently on",
    "hindi": "फ़िलहाल चालू है",
    "ja": "現在学習中",
    "jp": null,
    "ky": "Учурда күйүп турат",
    "ru": "В настоящее время на",
    "uz": "Hozirda",
    "viet": "Hiện tại trên"
  },
  "Topic": {
    "arabic": "عنوان",
    "az": "Mövzu",
    "chinese": "话题 ",
    "eng": "Topic",
    "hindi": "विषय",
    "ja": "トピック",
    "jp": null,
    "ky": "Тема",
    "ru": "Тема",
    "uz": "Mavzu",
    "viet": "Đề tài"
  },
  "mastered": {
    "arabic": "مُتقن",
    "az": "mənimsəmiş",
    "chinese": "掌握了 ",
    "eng": "Mastered",
    "hindi": "महारत हासिल",
    "ja": "発展",
    "jp": null,
    "ky": "Өздөштүргөн",
    "ru": "Освоен",
    "uz": "O'zlashtirilgan",
    "viet": "làm chủ được"
  },
  "set-Levels-(multiple-students)": {
    "arabic": "تحديد المستويات (طلاب متعددون)",
    "az": "Səviyyələri təyin edin (birdən çox tələbə)",
    "chinese": null,
    "eng": "Set Levels (Multiple Students)",
    "hindi": null,
    "ja": "レベルを設定する (複数の生徒)",
    "jp": null,
    "ky": "Деңгээлдерди коюу (бир нече студент)",
    "ru": "Установить уровни (несколько студентов)",
    "uz": "Darajalarni belgilash (bir nechta talabalar)",
    "viet": null
  },
  "explored": {
    "arabic": "تم استكشافه",
    "az": "Tədqiq edilmişdir",
    "chinese": "探索 ",
    "eng": "Explored",
    "hindi": "पता लगाया",
    "ja": "標準",
    "jp": null,
    "ky": "изилденген",
    "ru": "Исследовано",
    "uz": "Tadqiq qilingan",
    "viet": "Đã khám phá"
  },
  "Learnt": {
    "arabic": "تعلمت",
    "az": "Öyrəndim",
    "chinese": "学到了 ",
    "eng": "Learnt",
    "hindi": "सीखा",
    "ja": "基本",
    "jp": null,
    "ky": "Үйрөнгөн",
    "ru": "Узнал",
    "uz": "O'rgangan",
    "viet": "Đã học"
  },
  "learnt": {
    "arabic": "تعلمت",
    "az": "Öyrəndim",
    "chinese": "学到了 ",
    "eng": "Learnt",
    "hindi": "सीखा",
    "ja": "基本",
    "jp": null,
    "ky": "Үйрөнгөн",
    "ru": "Узнал",
    "uz": "O'rgangan",
    "viet": "Đã học"
  },
  "pending": {
    "arabic": "قيد الانتظار",
    "az": "Gözlənir",
    "chinese": "待办的 ",
    "eng": "Pending",
    "hindi": "लंबित",
    "ja": "未完了",
    "jp": null,
    "ky": "Күтүүдө",
    "ru": "В ожидании",
    "uz": "Kutilmoqda",
    "viet": "Chưa giải quyết"
  },
  "Yet-to-master": {
    "arabic": "لم يتم تعلمه بعد",
    "az": "Hələ öyrənilməmiş",
    "chinese": "尚未掌握 ",
    "eng": "Yet-to-Learnt",
    "hindi": "अभी तक मास्टर करने के लिए",
    "ja": "未習熟",
    "jp": null,
    "ky": "Азырынча Үйрөнбөйт",
    "ru": "Еще не изучено",
    "uz": "Hali o'rganilmagan",
    "viet": "Chưa thành thạo"
  },
  "collapse-all-students-alerts": {
    "arabic": "انهيار جميع تنبيهات الطلاب",
    "az": "Bütün tələbələrin xəbərdarlıqlarını yığışdırın",
    "chinese": "折叠所有学生警报 ",
    "eng": "Collapse all students alerts",
    "hindi": "पतन-सभी-छात्र-अलर्ट",
    "ja": "すべて閉じる",
    "jp": null,
    "ky": "Бардык студенттер эскертүүлөрүн жыйыштыруу",
    "ru": "Свернуть все оповещения студентов",
    "uz": "Barcha talabalar ogohlantirishlarini yopish",
    "viet": "thu gọn-tất cả sinh viên-cảnh báo"
  },
  "collapse-response-&-solution": {
    "arabic": "الاستجابة للانهيار والحل",
    "az": "Cavab və Həllini yığışdırın",
    "chinese": "折叠响应和解决方案 ",
    "eng": "Collapse Response & Solution",
    "hindi": "पतन-प्रतिक्रिया-और-समाधान",
    "ja": "答案と解説を閉じる",
    "jp": null,
    "ky": "Жыйыштыруу Жооп жана Чечим",
    "ru": "Реакция и решение проблемы коллапса",
    "uz": "Yopish javobi va yechim",
    "viet": "thu gọn-phản hồi & giải pháp"
  },
  "expand-all-students-alerts": {
    "arabic": "توسيع جميع تنبيهات الطلاب",
    "az": "Bütün tələbələr xəbərdarlıqlarını genişləndirin",
    "chinese": "展开所有学生警报 ",
    "eng": "Expand all students alerts",
    "hindi": "विस्तार-सभी-छात्र-अलर्ट",
    "ja": "すべて開く",
    "jp": null,
    "ky": "Бардык студенттер эскертүүлөрүн кеңейтүү",
    "ru": "Развернуть все оповещения студентов",
    "uz": "Barcha talabalar ogohlantirishlarini kengaytirish",
    "viet": "mở rộng-tất cả-sinh viên-cảnh báo"
  },
  "expand-response-&-solution": {
    "arabic": "توسيع الاستجابة والحل",
    "az": "Cavab və Həll variantını genişləndirin",
    "chinese": "展开响应和解决方案 ",
    "eng": "Expand Response & Solution",
    "hindi": "विस्तार-प्रतिक्रिया-और-समाधान",
    "ja": "答案と解説を開く",
    "jp": null,
    "ky": "Жооп жана Чечимди жайыңыз",
    "ru": "Развернуть Ответ и Решение",
    "uz": "Javob va yechim ni kengaytiring",
    "viet": "mở rộng-phản hồi & giải pháp"
  },
  "unresolved": {
    "arabic": "لم يتم حلها",
    "az": "Həll olunmamış",
    "chinese": null,
    "eng": "Unresolved",
    "hindi": null,
    "ja": "未解決",
    "jp": null,
    "ky": "Чечилбеген",
    "ru": "Нерешенный",
    "uz": "Yechilmagan",
    "viet": null
  },
  "progress-in-skills": {
    "arabic": "التقدم في المهارات",
    "az": "Bacarıqlarda irəliləyiş",
    "chinese": "技能进步 ",
    "eng": "Progress-in-skills",
    "hindi": "कौशल में प्रगति",
    "ja": "学習の進捗",
    "jp": null,
    "ky": "Көндүмдөрдүн прогресси",
    "ru": "Прогресс в навыках",
    "uz": "Ko'nikmalarning rivojlanishi",
    "viet": "kỹ năng tiến bộ"
  },
  "this-day": {
    "arabic": "هذا اليوم",
    "az": "Bu gün",
    "chinese": null,
    "eng": "This day",
    "hindi": null,
    "ja": "今日",
    "jp": null,
    "ky": "Бул күн",
    "ru": "В этот день",
    "uz": "Shu kun",
    "viet": null
  },
  "this-week": {
    "arabic": "هذا الاسبوع",
    "az": "Bu həftə",
    "chinese": null,
    "eng": "This week",
    "hindi": null,
    "ja": "今週",
    "jp": null,
    "ky": "Ушул жумада",
    "ru": "На этой неделе",
    "uz": "Ushbu hafta",
    "viet": null
  },
  "this-month": {
    "arabic": "هذا الشهر",
    "az": "Bu ay",
    "chinese": null,
    "eng": "This month",
    "hindi": null,
    "ja": "今月",
    "jp": null,
    "ky": "Ушул айда",
    "ru": "В этом месяце",
    "uz": "Shu oy",
    "viet": null
  },
  "custom": {
    "arabic": "مخصص",
    "az": "Xüsusi",
    "chinese": null,
    "eng": "Custom",
    "hindi": null,
    "ja": "カスタム",
    "jp": null,
    "ky": "Ыңгайлаштырылган",
    "ru": "Обычай",
    "uz": "Maxsus",
    "viet": null
  },
  "total-learning-time-mins": {
    "arabic": "إجمالي وقت التعلم بالدقائق",
    "az": "Ümumi öyrənmə vaxtı dəq",
    "chinese": "总学习时间分钟",
    "eng": "Total learning time mins",
    "hindi": "कुल-सीखने-समय-मिनट",
    "ja": "合計学習時間(分)",
    "jp": null,
    "ky": "Жалпы окуу убактысы мин",
    "ru": "Общее время обучения мин.",
    "uz": "Jami o'rganish vaqti min",
    "viet": "Tổng thời gian học tập-phút"
  },
  "total-learning-time": {
    "arabic": "إجمالي وقت التعلم",
    "az": "Ümumi Öyrənmə Vaxtı",
    "chinese": "总学习时间分钟",
    "eng": "Total Learning Time",
    "hindi": "कुल-सीखने-समय-मिनट",
    "ja": "合計学習時間",
    "jp": null,
    "ky": "Жалпы окуу убактысы",
    "ru": "Общее время обучения",
    "uz": "Umumiy o'rganish vaqti",
    "viet": "Tổng thời gian học tập-phút"
  },
  "total-time-on-cerebry": {
    "arabic": "الوقت الإجمالي في Cerebry",
    "az": "Cerebry-də ümumi vaxt",
    "chinese": "大脑总时间",
    "eng": "Total time on Cerebry",
    "hindi": "सेरेब्री पर कुल समय",
    "ja": "これまでの累計学習時間",
    "jp": null,
    "ky": "Cerebry&#39;деги жалпы убакыт",
    "ru": "Общее время на Cerebry",
    "uz": "Cerebry-dagi umumiy vaqt",
    "viet": "Tổng thời gian trên não"
  },
  "total": {
    "arabic": "المجموع",
    "az": "Cəmi",
    "chinese": "全部的",
    "eng": "Total",
    "hindi": "कुल",
    "ja": "合計",
    "jp": null,
    "ky": "Бардыгы",
    "ru": "Общий",
    "uz": "Jami",
    "viet": "tổng cộng"
  },
  "learning": {
    "arabic": "تعلُّم",
    "az": "Öyrənmək",
    "chinese": "學習",
    "eng": "Learning",
    "hindi": "सीखना",
    "ja": "学ぶ",
    "jp": null,
    "ky": "Үйрөнүү",
    "ru": "Обучение",
    "uz": "O'rganish",
    "viet": "học hỏi"
  },
  "time": {
    "arabic": "وقت",
    "az": "Vaxt",
    "chinese": "時間",
    "eng": "Time",
    "hindi": "समय",
    "ja": "時間",
    "jp": null,
    "ky": "Убакыт",
    "ru": "Время",
    "uz": "Vaqt",
    "viet": "thời gian"
  },
  "q.no": {
    "arabic": "س.لا",
    "az": "Q.no",
    "chinese": "问号",
    "eng": "Q.no",
    "hindi": "प्र.सं",
    "ja": "問題番号",
    "jp": null,
    "ky": "Q.no",
    "ru": "Вопрос №",
    "uz": "Savol yo'q",
    "viet": "Q.không"
  },
  "difficulty": {
    "arabic": "صعوبة",
    "az": "Çətinlik",
    "chinese": "困难",
    "eng": "Difficulty",
    "hindi": "कठिनाई",
    "ja": "難易度",
    "jp": null,
    "ky": "Кыйынчылык",
    "ru": "Сложность",
    "uz": "Qiyinchilik",
    "viet": "Khó khăn"
  },
  "skill-associated": {
    "arabic": "المهارات المرتبطة",
    "az": "Skill Associated",
    "chinese": "技能相关",
    "eng": "Skill Associated",
    "hindi": "कौशल संबद्ध",
    "ja": "関連する学習目標",
    "jp": null,
    "ky": "Skill Associated",
    "ru": "Навык, связанный с",
    "uz": "Skill Associated",
    "viet": "Kỹ năng liên quan"
  },
  "number-of-attempts": {
    "arabic": "عدد المحاولات",
    "az": "Cəhdlərin sayı",
    "chinese": "尝试次数",
    "eng": "Number of Attempts",
    "hindi": "प्रयासों की संख्या",
    "ja": "解答回数",
    "jp": null,
    "ky": "Аракеттердин саны",
    "ru": "Количество попыток",
    "uz": "Urinishlar soni",
    "viet": " Số lần thử "
  },
  "time-per-attempt": {
    "arabic": "الوقت لكل محاولة",
    "az": "Hər cəhd üçün vaxt",
    "chinese": "每次尝试的时间",
    "eng": "Time Per Attempt",
    "hindi": "प्रति प्रयास समय",
    "ja": "解答時間",
    "jp": null,
    "ky": "Ар аракет үчүн убакыт",
    "ru": "Время на попытку",
    "uz": "Har bir urinish vaqti",
    "viet": " Thời gian mỗi lần thử"
  },
  "show-other-questions": {
    "arabic": "عرض أسئلة الآخرين",
    "az": "Başqalarına suallar göstərin",
    "chinese": "显示其他问题",
    "eng": "Show others questions",
    "hindi": "अन्य प्रश्न दिखाएँ",
    "ja": "他の問題を表示",
    "jp": null,
    "ky": "Башкаларга суроолорду көрсөтүү",
    "ru": "Показать другие вопросы",
    "uz": "Boshqalarga savollarni ko'rsating",
    "viet": " Hiển thị các câu hỏi khác"
  },
  "hide-other-questions": {
    "arabic": "إخفاء أسئلة الآخرين",
    "az": "Digər sualları gizlədin",
    "chinese": "显示其他问题",
    "eng": "Hide others questions",
    "hindi": "अन्य प्रश्न दिखाएँ",
    "ja": "他の問題を隠す",
    "jp": null,
    "ky": "Башка суроолорду жашыруу",
    "ru": "Скрыть другие вопросы",
    "uz": "Boshqa savollarni yashirish",
    "viet": " Hiển thị các câu hỏi khác"
  },
  "alert-notification-description": {
    "arabic": "وصف إشعار التنبيه؟",
    "az": "Xəbərdarlıq Bildirişinin Təsviri?",
    "chinese": "警报通知说明",
    "eng": "Alert Notification Description?",
    "hindi": "चेतावनी अधिसूचना विवरण",
    "ja": "詳細",
    "jp": null,
    "ky": "Эскертүү эскертмесинин сүрөттөлүшү?",
    "ru": "Описание оповещения?",
    "uz": "Ogohlantirish bildirishnomasi tavsifi?",
    "viet": " Mô tả thông báo cảnh báo"
  },
  "alert-milestone-description": {
    "arabic": "وصف التنبيه/الحدث المهم؟",
    "az": "Xəbərdarlıq/Milestone Təsviri?",
    "chinese": "警报通知说明",
    "eng": "Alert/Milestone Description?",
    "hindi": "चेतावनी अधिसूचना विवरण",
    "ja": "詳細",
    "jp": null,
    "ky": "Эскертүү/Белгилүү учурдун сүрөттөлүшү?",
    "ru": "Описание оповещения/этапа?",
    "uz": "Ogohlantirish/baza tavsifi?",
    "viet": " Mô tả thông báo cảnh báo"
  },
  "connect-to-google-class": {
    "arabic": "الاتصال بـ Google Classroom",
    "az": "Google Classroom-a qoşulun",
    "chinese": "连接到 Google 课堂",
    "eng": "Connect to Google Classroom",
    "hindi": "Google क्लास से कनेक्ट करें",
    "ja": "Googleクラスに接続する",
    "jp": null,
    "ky": "Google Класска туташуу",
    "ru": "Подключиться к Google Классу",
    "uz": "Google Classroom xizmatiga ulaning",
    "viet": "Kết nối với Lớp học Google"
  },
  "connect-to-google-classroom": {
    "arabic": "الاتصال بـ Google Classroom",
    "az": "Google Classroom-a qoşulun",
    "chinese": null,
    "eng": "Connect to Google Classroom",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Google Класска туташуу",
    "ru": "Подключиться к Google Классу",
    "uz": "Google Classroom xizmatiga ulaning",
    "viet": null
  },
  "select-google-classroom-classes": {
    "arabic": "حدد فصول Google Classroom",
    "az": "Google Classroom dərslərini seçin",
    "chinese": null,
    "eng": "Select Google Classroom classes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Google Класс класстарын тандаңыз",
    "ru": "Выберите классы Google Classroom",
    "uz": "Google Classroom kurslarini tanlang",
    "viet": null
  },
  "disconnect-google-classroom": {
    "arabic": "افصل خدمة Google Classroom",
    "az": "Google Classroom ilə əlaqəni kəsin",
    "chinese": null,
    "eng": "Disconnect Google Classroom",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Google Классты ажыратыңыз",
    "ru": "Отключить Google Класс",
    "uz": "Google Classroom-ni uzing",
    "viet": null
  },
  "are-you-sure-you-want-to-disconnect?": {
    "arabic": "هل أنت متأكد أنك تريد قطع الاتصال؟",
    "az": "Bağlantını kəsmək istədiyinizə əminsiniz?",
    "chinese": null,
    "eng": "Are you sure you want to disconnect?",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Чын эле ажыраткыңыз келеби?",
    "ru": "Вы уверены, что хотите отключиться?",
    "uz": "Haqiqatan ham aloqani uzmoqchimisiz?",
    "viet": null
  },
  "yes-go-ahead": {
    "arabic": "نعم تفضل",
    "az": "Bəli, davam edin",
    "chinese": null,
    "eng": "Yes Go ahead",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Ооба Алга",
    "ru": "Да Продолжайте",
    "uz": "Ha, davom eting",
    "viet": null
  },
  "published-to-google-classroom,-if-connected": {
    "arabic": "تم النشر على Google Classroom, إذا كان متصلاً",
    "az": "Əgər qoşulubsa, Google Classroom-da yayımlanır",
    "chinese": null,
    "eng": "Published to Google Classroom, if connected",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Эгер туташкан болсо, Google Класста жарыяланган",
    "ru": "Опубликовано в Google Classroom, если подключено",
    "uz": "Agar ulangan boʻlsa, Google Classroom’da chop etiladi",
    "viet": null
  },
  "no-student-report-found": {
    "arabic": "لم يتم العثور على تقرير الطالب",
    "az": "Heç bir tələbə hesabatı tapılmadı",
    "chinese": "未找到学生报告",
    "eng": "No student report found",
    "hindi": "किसी छात्र की रिपोर्ट नहीं मिली",
    "ja": "データが見つかりません",
    "jp": null,
    "ky": "Студенттик отчет табылган жок",
    "ru": "Отчет студента не найден",
    "uz": "Hech qanday talaba hisoboti topilmadi",
    "viet": " Không tìm thấy báo cáo của sinh viên"
  },
  "report-a-bug": {
    "arabic": "الإبلاغ عن خطأ",
    "az": "Xəta barədə məlumat verin",
    "chinese": "报告错误",
    "eng": "Report a bug",
    "hindi": "बग की रिपोर्ट करें",
    "ja": "バグを報告する",
    "jp": null,
    "ky": "Мүчүлүштүк тууралуу кабарлоо",
    "ru": "Сообщить об ошибке",
    "uz": "Muammo haqida xabar berish",
    "viet": "Báo cáo lỗi"
  },
  "please-check-your-student-filter": {
    "arabic": "يرجى التحقق من مرشح الطالب الخاص بك",
    "az": "Zəhmət olmasa Tələbə Filtrinizi yoxlayın",
    "chinese": "请检查您的学生过滤器",
    "eng": "Please Check Your Student Filter",
    "hindi": "कृपया अपना छात्र फ़िल्टर जांचें",
    "ja": "フィルターを確認し、再度お試しください",
    "jp": null,
    "ky": "Сураныч, студенттик чыпкаңызды текшериңиз",
    "ru": "Проверьте свой студенческий фильтр",
    "uz": "Iltimos, talaba filtringizni tekshiring",
    "viet": " Vui lòng kiểm tra bộ lọc sinh viên của bạn"
  },
  "view Attempt": {
    "arabic": "عرض المحاولة",
    "az": "Baxış cəhdi",
    "chinese": "查看尝试",
    "eng": "View Attempt",
    "hindi": "प्रयास देखें",
    "ja": "学習履歴",
    "jp": null,
    "ky": "Көрүү аракети",
    "ru": "Посмотреть попытку",
    "uz": "Ko'rish urinishi",
    "viet": " Xem lần thử"
  },
  "give Feedback": {
    "arabic": "تقديم ردود الفعل",
    "az": "Əlaqə verin",
    "chinese": "给予反馈",
    "eng": "Give Feedback",
    "hindi": "प्रतिक्रिया दें",
    "ja": "フィードバックする",
    "jp": null,
    "ky": "Пикир билдирүү",
    "ru": "Дать отзыв",
    "uz": "Fikr bildirish",
    "viet": "Cung cấp thông tin phản hồi"
  },
  "more": {
    "arabic": "أكثر",
    "az": "Daha çox",
    "chinese": "更多的",
    "eng": "More",
    "hindi": "अधिक",
    "ja": "さらに表示",
    "jp": null,
    "ky": "Дагы",
    "ru": "Более",
    "uz": "Ko'proq",
    "viet": "Hơn"
  },
  "less": {
    "arabic": "أقل",
    "az": "Daha az",
    "chinese": "更多的",
    "eng": "Less",
    "hindi": "अधिक",
    "ja": "少なく表示",
    "jp": null,
    "ky": "Азыраак",
    "ru": "Меньше",
    "uz": "Ozroq",
    "viet": "Hơn"
  },
  "Number-of-Attempts": {
    "arabic": "عدد المحاولات",
    "az": "Cəhdlərin sayı",
    "chinese": "尝试次数",
    "eng": "Number of Attempts",
    "hindi": "प्रयासों की संख्या",
    "ja": "解答回数",
    "jp": null,
    "ky": "Аракеттердин саны",
    "ru": "Количество попыток",
    "uz": "Urinishlar soni",
    "viet": "Số lần thử"
  },
  "question-attempts": {
    "arabic": "محاولات السؤال",
    "az": "Sual cəhdləri",
    "chinese": "提问尝试",
    "eng": "Question Attempts",
    "hindi": "प्रश्न प्रयास",
    "ja": "解答",
    "jp": null,
    "ky": "Суроо аракети",
    "ru": "Попытки задать вопрос",
    "uz": "Savolga urinishlar",
    "viet": "Câu hỏi cố gắng"
  },
  "Indicates-that-the-question-was-attempted-correctly": {
    "arabic": "يشير إلى أن السؤال تم طرحه بشكل صحيح.",
    "az": "Sualın düzgün sınaqdan keçirildiyini göstərir.",
    "chinese": "表明该问题已正确尝试。",
    "eng": "Indicates that the question was attempted correctly.",
    "hindi": "यह दर्शाता है कि प्रश्न का प्रयास सही ढंग से किया गया था।",
    "ja": "質問が正しく試みられたことを示します。",
    "jp": null,
    "ky": "Суроо туура берилгенин көрсөтөт.",
    "ru": "Указывает, что вопрос был задан правильно.",
    "uz": "Savol to'g'ri berilganligini bildiradi.",
    "viet": "Cho biết rằng câu hỏi đã được thử chính xác."
  },
  "Indicates-that-the-question-was-initially-passed-by-the-student": {
    "arabic": "يشير إلى أن السؤال تم اجتيازه في البداية من قبل الطالب",
    "az": "Sualın əvvəlcə tələbə tərəfindən keçdiyini göstərir",
    "chinese": "表示该问题最初由学生通过",
    "eng": "Indicates that the question was initially passed by the student",
    "hindi": "इंगित करता है कि प्रश्न प्रारंभ में छात्र द्वारा उत्तीर्ण किया गया था",
    "ja": "質問が最初に学生によって渡されたことを示します",
    "jp": null,
    "ky": "Суроону адегенде студент тапшырганын көрсөтөт",
    "ru": "Указывает, что вопрос был изначально пропущен студентом",
    "uz": "Savol dastlab talaba tomonidan berilganligini bildiradi",
    "viet": "Cho biết rằng câu hỏi ban đầu đã được học sinh thông qua"
  },
  "Indicates-that-the-question-was-attempted-wrong-The-student-may-have-eventually-gotten-this-question-correct-and-moved-forward": {
    "arabic": "يشير إلى أن السؤال قد تم طرحه بطريقة خاطئة. ربما يكون الطالب قد أجاب على السؤال بشكل صحيح في النهاية وانتقل إلى الأمام",
    "az": "Sualın səhv cəhd edildiyini göstərir. Tələbə sonda bu sualı düzgün qəbul edib irəli getmiş ola bilər",
    "chinese": "表明该问题尝试错误。学生可能最终答对了这个问题并继续前进",
    "eng": "Indicates that the question was attempted wrong. The student may have eventually gotten this question correct and moved forward",
    "hindi": "यह दर्शाता है कि प्रश्न का प्रयास गलत किया गया था। हो सकता है कि छात्र को अंततः यह प्रश्न सही मिल गया हो और वह आगे बढ़ गया हो",
    "ja": "質問の試みが間違っていたことを示します。生徒は最終的にこの問題を正解し、先に進むことができたかもしれません",
    "jp": null,
    "ky": "Суроонун туура эмес аракети болгонун көрсөтөт. Окуучу акыры бул суроону туура кабыл алып, алдыга жылгандыр",
    "ru": "Указывает, что вопрос был задан неправильно. Студент мог в конечном итоге ответить на этот вопрос правильно и продвинуться дальше",
    "uz": "Savol noto'g'ri berilganligini bildiradi. Oxir oqibat, talaba bu savolni to'g'ri qabul qilib, oldinga siljigan bo'lishi mumkin",
    "viet": "Cho biết rằng câu hỏi đã được thử sai. Học sinh cuối cùng có thể đã trả lời đúng câu hỏi này và tiếp tục"
  },
  "Indicates-that-the-question-was-attempted-wrong-in-all-attempts": {
    "arabic": "يشير إلى أن السؤال تم طرحه بشكل خاطئ في جميع المحاولات",
    "az": "Sualın bütün cəhdlərdə səhv cəhd edildiyini göstərir",
    "chinese": "表示该问题在所有尝试中均出现错误",
    "eng": "Indicates that the question was attempted wrong in all attempts",
    "hindi": "यह इंगित करता है कि सभी प्रयासों में प्रश्न गलत हल किया गया था",
    "ja": "質問がすべての試行で間違っていたことを示します",
    "jp": null,
    "ky": "Суроо бардык аракеттерде туура эмес жасалганын көрсөтөт",
    "ru": "Указывает, что вопрос был задан неправильно во всех попытках.",
    "uz": "Savol barcha urinishlarda noto‘g‘ri berilganligini bildiradi",
    "viet": "Cho biết rằng câu hỏi đã được thử sai trong tất cả các lần thử"
  },
  "Indicates-the-number-of-variant-questions-attempted-by-the-student": {
    "arabic": "يشير إلى &#39;n&#39;, عدد الأسئلة المتنوعة التي حاول الطالب الإجابة عليها",
    "az": "&#39;n&#39;, tələbənin cəhd etdiyi variant suallarının sayını göstərir",
    "chinese": "表示‘n’，学生尝试的不同问题的数量",
    "eng": "Indicates ‘n’, the number of variant questions attempted by the student",
    "hindi": "‘n’ को दर्शाता है, जो छात्र द्वारा हल किए गए विभिन्न प्रश्नों की संख्या है",
    "ja": "「n」は生徒が試みた変形質問の数を示します",
    "jp": null,
    "ky": "Студент аракет кылган вариант суроолорунун санын &quot;n&quot; көрсөтөт",
    "ru": "Указывает «n», количество вариантов вопросов, на которые ответил студент.",
    "uz": "&quot;n&quot; ni bildiradi, talaba tomonidan qo'yilgan variantli savollar soni",
    "viet": "Cho biết ‘n’, số lượng câu hỏi biến thể mà học sinh đã thử"
  },
  "Indicates-that-the-Question-7-was-attempted-incorrectly-in-all-of-the-12-attempts": {
    "arabic": "يشير إلى أن السؤال 7 تمت محاولته بشكل غير صحيح في جميع المحاولات الـ12.",
    "az": "7-ci sualın 12 cəhdin hamısında səhv cəhd edildiyini göstərir.",
    "chinese": "表明问题 7 在 12 次尝试中全部尝试错误。",
    "eng": "Indicates that the Question 7 was attempted incorrectly in all of the 12 attempts.",
    "hindi": "इंगित करता है कि प्रश्न 7 को सभी 12 प्रयासों में गलत तरीके से हल किया गया था।",
    "ja": "質問 7 は 12 回の試行すべてで不正解であったことを示します。",
    "jp": null,
    "ky": "7-суроо 12 аракеттин бардыгында туура эмес жасалганын көрсөтөт.",
    "ru": "Указывает, что вопрос 7 был задан неправильно во всех 12 попытках.",
    "uz": "12 ta urinishning barchasida 7-savol noto'g'ri qilinganligini ko'rsatadi.",
    "viet": "Cho biết rằng Câu hỏi 7 đã được thực hiện sai trong tất cả 12 lần thử."
  },
  "Indicates-that-the-Question-10-was-attempted-correctly-in-all-of-the-2-attempts": {
    "arabic": "يشير إلى أن السؤال 10 تم محاولته بشكل صحيح في كل المحاولتين.",
    "az": "10-cu sualın 2 cəhdin hamısında düzgün cəhd edildiyini göstərir.",
    "chinese": "表示问题 10 在 2 次尝试中全部正确。",
    "eng": "Indicates that the Question 10 was attempted correctly in all of the 2 attempts.",
    "hindi": "यह दर्शाता है कि प्रश्न 10 को सभी 2 प्रयासों में सही ढंग से हल किया गया था।",
    "ja": "質問 10 は 2 回すべて正解したことを示します。",
    "jp": null,
    "ky": "10-суроо 2 аракеттин бардыгында туура аракет болгондугун көрсөтөт.",
    "ru": "Указывает, что вопрос 10 был дан правильно во всех 2 попытках.",
    "uz": "10-savol 2 urinishning barchasida to'g'ri bajarilganligini ko'rsatadi.",
    "viet": "Cho biết rằng Câu hỏi 10 đã được thực hiện đúng trong cả 2 lần thực hiện."
  },
  "legend": {
    "arabic": "أسطورة",
    "az": "Əfsanə",
    "chinese": "传奇",
    "eng": "Legend",
    "hindi": "दंतकथा",
    "ja": "伝説",
    "jp": null,
    "ky": "Легенда",
    "ru": "Легенда",
    "uz": "Afsona",
    "viet": "Huyền thoại"
  },
  "examples": {
    "arabic": "أمثلة",
    "az": "Nümunələr",
    "chinese": "例子",
    "eng": "Examples",
    "hindi": "उदाहरण",
    "ja": "例",
    "jp": null,
    "ky": "Мисалдар",
    "ru": "Примеры",
    "uz": "Misollar",
    "viet": "Ví dụ"
  },
  "milestone": {
    "arabic": "منعطف",
    "az": "Mərhələ",
    "chinese": "里程碑",
    "eng": "Milestone",
    "hindi": "माइलस्टोन ",
    "ja": "マイルストン",
    "jp": null,
    "ky": "Мезгил",
    "ru": "Веха",
    "uz": "Muhim bosqich",
    "viet": "Cột mốc quan trọng"
  },
  "exploring": {
    "arabic": "استكشاف",
    "az": "Kəşf edilir",
    "chinese": "探索",
    "eng": "Exploring",
    "hindi": "तलाश",
    "ja": "探検する",
    "jp": null,
    "ky": "Изилдөө",
    "ru": "Исследуя",
    "uz": "Tadqiq qilish",
    "viet": "Khám phá"
  },
  "Exam-Name": {
    "arabic": "اسم الامتحان",
    "az": "İmtahan Adı",
    "chinese": "考试名称",
    "eng": "Exam Name",
    "hindi": "परीक्षा का नाम",
    "ja": "テスト名",
    "jp": null,
    "ky": "Экзамен аты",
    "ru": "Название экзамена",
    "uz": "Imtihon nomi",
    "viet": "Tên kỳ thi"
  },
  "Duration": {
    "arabic": "مدة",
    "az": "Müddət",
    "chinese": "期间",
    "eng": "Duration",
    "hindi": "अवधि",
    "ja": "制限時間",
    "jp": null,
    "ky": "Узактыгы",
    "ru": "Продолжительность",
    "uz": "Davomiyligi",
    "viet": "Khoảng thời gian"
  },
  "Upload-Logo": {
    "arabic": "تحميل الشعار",
    "az": "Loqo yükləyin",
    "chinese": "上传标志",
    "eng": "Upload Logo",
    "hindi": "लोगो अपलोड करें",
    "ja": "画像／ロゴのアップロード",
    "jp": null,
    "ky": "Логотип жүктөө",
    "ru": "Загрузить логотип",
    "uz": "Logotip yuklash",
    "viet": "Tải lên biểu trưng"
  },
  "Select-Font": {
    "arabic": "حدد الخط",
    "az": "Şrift seçin",
    "chinese": "选择字体",
    "eng": "Select Font",
    "hindi": "फ़ॉन्ट चुनें",
    "ja": "フォント",
    "jp": null,
    "ky": "Шрифт тандаңыз",
    "ru": "Выбрать шрифт",
    "uz": "Shrift-ni tanlang",
    "viet": "Chọn phông chữ"
  },
  "Custom-Heading-1": {
    "arabic": "عنوان مخصص 1",
    "az": "Fərdi Başlıq 1",
    "chinese": "自定义标题 1",
    "eng": "Custom Heading 1",
    "hindi": "कस्टम शीर्षक 1",
    "ja": "見出し１",
    "jp": null,
    "ky": "Ыңгайлаштырылган аталыш 1",
    "ru": "Пользовательский заголовок 1",
    "uz": "Maxsus sarlavha 1",
    "viet": "Tiêu đề tùy chỉnh 1"
  },
  "Custom-Heading-2": {
    "arabic": "عنوان مخصص 2",
    "az": "Fərdi başlıq 2",
    "chinese": "自定义标题 2",
    "eng": "Custom Heading 2",
    "hindi": "कस्टम शीर्षक 2",
    "ja": "見出し2",
    "jp": null,
    "ky": "Ыңгайлаштырылган аталыш 2",
    "ru": "Пользовательский заголовок 2",
    "uz": "Maxsus sarlavha 2",
    "viet": "Tiêu đề tùy chỉnh 2"
  },
  "Custom-Heading-3": {
    "arabic": "عنوان مخصص 3",
    "az": "Fərdi başlıq 3",
    "chinese": "自定义标题 3",
    "eng": "Custom Heading 3",
    "hindi": "कस्टम शीर्षक 3",
    "ja": "見出し3",
    "jp": null,
    "ky": "Ыңгайлаштырылган аталыш 3",
    "ru": "Пользовательский заголовок 3",
    "uz": "Maxsus sarlavha 3",
    "viet": "Tiêu đề tùy chỉnh 3"
  },
  "General-Instructions": {
    "arabic": "تعليمات عامة",
    "az": "Ümumi Təlimatlar",
    "chinese": "一般说明",
    "eng": "General Instructions",
    "hindi": "सामान्य निर्देश",
    "ja": "テストの指示",
    "jp": null,
    "ky": "Жалпы нускамалар",
    "ru": "Общие инструкции",
    "uz": "Umumiy ko'rsatmalar",
    "viet": "Hướng dẫn chung"
  },
  "total-n-marks": {
    "arabic": "مجموع {replace_rgx_1} علامة",
    "az": "Cəmi {replace_rgx_1} İşarə(lər)",
    "chinese": null,
    "eng": "Total {replace_rgx_1} Mark(s)",
    "hindi": null,
    "ja": "合計 {replace_rgx_1} 点",
    "jp": null,
    "ky": "Жалпы {replace_rgx_1} Белги(лер)",
    "ru": "Всего {replace_rgx_1} баллов",
    "uz": "Jami {replace_rgx_1} belgi(lar)",
    "viet": "Tổng số {replace_rgx_1} điểm"
  },
  "attempt-n": {
    "arabic": "محاولة {replace_rgx_1}",
    "az": "{replace_rgx_1} cəhdi",
    "chinese": "{replace_rgx_1}",
    "eng": "Attempt {replace_rgx_1}",
    "hindi": "{replace_rgx_1}",
    "ja": "{replace_rgx_1}回目",
    "jp": null,
    "ky": "{replace_rgx_1} аракети",
    "ru": "Попытка {replace_rgx_1}",
    "uz": "Urinish: {replace_rgx_1}",
    "viet": "{replace_rgx_1}"
  },
  "n-mark(s)": {
    "arabic": "<strong>{replace_rgx_1}</strong> علامة(علامات)",
    "az": "<strong>{replace_rgx_1}</strong> İşarə(lər)",
    "chinese": null,
    "eng": "<strong>{replace_rgx_1}</strong> Mark(s)",
    "hindi": null,
    "ja": "<strong>{replace_rgx_1}</strong> 点",
    "jp": null,
    "ky": "<strong>{replace_rgx_1}</strong> Белги(лер)",
    "ru": "<strong>{replace_rgx_1}</strong> Отметить(и)",
    "uz": "<strong>{replace_rgx_1}</strong> Belgi(lar)",
    "viet": "<strong>{replace_rgx_1}</strong> Điểm"
  },
  "on-time": {
    "arabic": "على {replace_rgx_1}",
    "az": "{replace_rgx_1} üzərində",
    "chinese": null,
    "eng": "On {replace_rgx_1}",
    "hindi": null,
    "ja": "{replace_rgx_1}",
    "jp": null,
    "ky": "{replace_rgx_1} боюнча",
    "ru": "На {replace_rgx_1}",
    "uz": "{replace_rgx_1} da",
    "viet": "TRÊN {replace_rgx_1}"
  },
  "obtained": {
    "arabic": "مُقتَنىً",
    "az": "Əldə edildi",
    "chinese": null,
    "eng": "Obtained",
    "hindi": null,
    "ja": "取得しました",
    "jp": null,
    "ky": "Алынган",
    "ru": "Полученный",
    "uz": "Olingan",
    "viet": "Thu được"
  },
  "publish-to-classes": {
    "arabic": "نشر إلى الفصول الدراسية",
    "az": "Dərslərə dərc edin",
    "chinese": null,
    "eng": "Publish to classes",
    "hindi": null,
    "ja": "テストを複数のクラスに配信",
    "jp": null,
    "ky": "класстарга жарыялоо",
    "ru": "Опубликовать в классах",
    "uz": "Sinflarga nashr qilish",
    "viet": null
  },
  "classes": {
    "arabic": "الفصول الدراسية",
    "az": "Dərslər",
    "chinese": null,
    "eng": "Classes",
    "hindi": null,
    "ja": "クラス",
    "jp": null,
    "ky": "Класстар",
    "ru": "Классы",
    "uz": "Sinflar",
    "viet": null
  },
  "recipient-classes": {
    "arabic": "فئات المستفيدين",
    "az": "Alıcı sinifləri",
    "chinese": null,
    "eng": "Recipient Classes",
    "hindi": null,
    "ja": "配信先のクラス",
    "jp": null,
    "ky": "Алуучу класстары",
    "ru": "Классы получателей",
    "uz": "Qabul qiluvchilar sinflari",
    "viet": null
  },
  "click-on": {
    "arabic": "انقر على",
    "az": "üzərinə klikləyin",
    "chinese": null,
    "eng": "Click on",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "чыкылдатыңыз",
    "ru": "Нажмите на",
    "uz": "ni bosing",
    "viet": null
  },
  "arrow-to-return-to-previous-dialog-to-confirm-the-publish-to-the-saved-Recipient-Classes": {
    "arabic": "السهم للعودة إلى مربع الحوار السابق لتأكيد النشر إلى فئات المستلمين المحفوظة",
    "az": "Yadda saxlanan Alıcı Siniflərində dərci təsdiqləmək üçün əvvəlki dialoqa qayıtmaq üçün oxu",
    "chinese": null,
    "eng": "arrow to return to previous dialog to confirm the publish to the saved Recipient Classes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сакталган Алуучу класстарына жарыялоону ырастоо үчүн мурунку диалогго кайтуу үчүн жебе",
    "ru": "стрелка для возврата в предыдущее диалоговое окно для подтверждения публикации в сохраненных классах получателей",
    "uz": "Saqlangan Qabul qiluvchilar sinflarida nashr qilishni tasdiqlash uchun oldingi dialog oynasiga qaytish uchun strelka",
    "viet": null
  },
  "ascending": {
    "arabic": "تصاعدي",
    "az": "Artan",
    "chinese": null,
    "eng": "Ascending",
    "hindi": null,
    "ja": "昇順",
    "jp": null,
    "ky": "Өтүү",
    "ru": "По возрастанию",
    "uz": "Ko'tarilish",
    "viet": null
  },
  "descending": {
    "arabic": "تنازلي",
    "az": "Azalan",
    "chinese": null,
    "eng": "Descending",
    "hindi": null,
    "ja": "降順",
    "jp": null,
    "ky": "Төмөндө",
    "ru": "По убыванию",
    "uz": "Pastga tushmoqda",
    "viet": null
  },
  "search-classes": {
    "arabic": "البحث عن الفصول الدراسية",
    "az": "Dərsləri axtarın",
    "chinese": null,
    "eng": "Search Classes",
    "hindi": null,
    "ja": "クラスを検索",
    "jp": null,
    "ky": "Класстарды издөө",
    "ru": "Поиск классов",
    "uz": "Sinflarni qidirish",
    "viet": null
  },
  "published-classes": {
    "arabic": "الفصول المنشورة",
    "az": "Dərslər dərc edilmişdir",
    "chinese": null,
    "eng": "Published Classes",
    "hindi": null,
    "ja": "配信済みクラス",
    "jp": null,
    "ky": "Жарыяланган класстар",
    "ru": "Опубликованные классы",
    "uz": "Nashr qilingan darslar",
    "viet": null
  },
  "ai-evaluation-in-progress": {
    "arabic": "تقييم الذكاء الاصطناعي قيد التقدم...",
    "az": "AI qiymətləndirməsi davam edir...",
    "chinese": null,
    "eng": "AI Evaluation in progress...",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "AI баалоо жүрүп жатат...",
    "ru": "Оценка ИИ продолжается...",
    "uz": "AI baholash davom etmoqda...",
    "viet": null
  },
  "answer": {
    "arabic": "إجابة",
    "az": "Cavab verin",
    "chinese": null,
    "eng": "Answer",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жооп",
    "ru": "Отвечать",
    "uz": "Javob",
    "viet": null
  },
  "ai-feedback": {
    "arabic": "ردود الفعل حول الذكاء الاصطناعي",
    "az": "AI Əlaqəsi",
    "chinese": null,
    "eng": "AI Feedback",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "AI пикири",
    "ru": "Обратная связь ИИ",
    "uz": "AI haqida fikr-mulohaza",
    "viet": null
  },
  "ai-and-teacher-evaluated-marks": {
    "arabic": "العلامات التي تم تقييمها بواسطة الذكاء الاصطناعي والمعلم",
    "az": "Süni intellekt və Müəllim tərəfindən qiymətləndirilmiş qiymət(lər)",
    "chinese": null,
    "eng": "AI and Teacher Evaluated Mark(s)",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "AI жана мугалим тарабынан бааланган белги(лер)",
    "ru": "Оценки, выставленные ИИ и учителем",
    "uz": "AI va o'qituvchi tomonidan baholangan baho(lar)",
    "viet": null
  },
  "ai-essay-grader-rubric": {
    "arabic": "مُقيِّم المقالات من AI - مقياس التقييم",
    "az": "AI Essay Grader - Rubrik",
    "chinese": null,
    "eng": "AI Essay Grader - Rubric",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "AI эссе грейдер - рубрика",
    "ru": "Оценщик эссе с помощью ИИ - Рубрика",
    "uz": "AI insho Greyder - Rubrika",
    "viet": null
  },
  "sign-in-with-google": {
    "arabic": "تسجيل الدخول باستخدام جوجل",
    "az": "Google ilə daxil olun",
    "chinese": "使用 Google 登录",
    "eng": "Sign in with Google",
    "hindi": "Google से साइन इन करें",
    "ja": "Googleでサインイン",
    "jp": null,
    "ky": "Google аркылуу кирүү",
    "ru": "Войти через Google",
    "uz": "Google orqali ro‘yxatdan o‘tish",
    "viet": "Đăng nhập bằng Google"
  },
  "sign-up-with-google": {
    "arabic": "سجل باستخدام جوجل",
    "az": "Google ilə qeydiyyatdan keçin",
    "chinese": "使用 Google 注册",
    "eng": "Sign up with Google",
    "hindi": "Google के साथ साइन अप करें",
    "ja": "Google に登録する",
    "jp": null,
    "ky": "Google менен катталыңыз",
    "ru": "Зарегистрироваться через Google",
    "uz": "Google bilan ro'yxatdan o'ting",
    "viet": "Đăng ký với Google"
  },
  "dont-have-an-account-?": {
    "arabic": "ليس لديك حساب؟",
    "az": "Hesabınız yoxdur?",
    "chinese": "没有帐户？",
    "eng": "Don't have an account?",
    "hindi": "कोई खाता नहीं है?",
    "ja": "アカウントをお持ちでない場合は、",
    "jp": null,
    "ky": "Каттоо эсебиңиз жокпу?",
    "ru": "У вас нет учетной записи?",
    "uz": "Hisobingiz yo'qmi?",
    "viet": "Bạn chưa có tài khoản?"
  },
  "already-have-an-account-?": {
    "arabic": "هل لديك حساب بالفعل؟",
    "az": "Artıq hesabınız var?",
    "chinese": "已经有帐户？",
    "eng": "Already have an account?",
    "hindi": "क्या आपके पास पहले से एक खाता मौजूद है?",
    "ja": "すでにアカウントをお持ちですか？",
    "jp": null,
    "ky": "Каттоо эсебиңиз барбы?",
    "ru": "У вас уже есть аккаунт?",
    "uz": "Hisobingiz bormi?",
    "viet": "Bạn co săn san để tạo một tai khoản?"
  },
  "create-new-account": {
    "arabic": "إنشاء حساب جديد",
    "az": "Yeni Hesab Yaradın",
    "chinese": "建立新帐户",
    "eng": "Create New Account",
    "hindi": "नया खाता बनाएँ",
    "ja": "新しいアカウントを作成する",
    "jp": null,
    "ky": "Жаңы каттоо эсебин түзүү",
    "ru": "Создать новую учетную запись",
    "uz": "Yangi akkaunt yaratish",
    "viet": "Tạo tài khoản mới"
  },
  "sign-in": {
    "arabic": "تسجيل الدخول",
    "az": "Daxil ol",
    "chinese": "登入",
    "eng": "Sign In",
    "hindi": "दाखिल करना",
    "ja": "サインイン",
    "jp": null,
    "ky": "Кирүү",
    "ru": "Войти",
    "uz": "Ro‘yxatdan o‘tish",
    "viet": "Đăng nhập"
  },
  "Last-Name": {
    "arabic": "اسم العائلة",
    "az": "Soyadı",
    "chinese": "姓",
    "eng": "Last Name",
    "hindi": "अंतिम नाम",
    "ja": "苗字",
    "jp": null,
    "ky": "Фамилиясы",
    "ru": "Фамилия",
    "uz": "Familiya",
    "viet": "Họ"
  },
  "First-Name": {
    "arabic": "الاسم الأول",
    "az": "Ad",
    "chinese": "名",
    "eng": "First Name",
    "hindi": "पहला नाम",
    "ja": "ファーストネーム",
    "jp": null,
    "ky": "Аты",
    "ru": "Имя",
    "uz": "Ism",
    "viet": "Tên đầu tiên"
  },
  "create-a-teacher-account-to-start": {
    "arabic": "قم بإنشاء حساب مدرس للبدء",
    "az": "Başlamaq üçün Müəllim hesabı yaradın",
    "chinese": "创建教师帐户以开始",
    "eng": "Create a Teacher account to start",
    "hindi": "आरंभ करने के लिए एक शिक्षक खाता बनाएँ",
    "ja": "始めるには教師アカウントを作成してください",
    "jp": null,
    "ky": "Баштоо үчүн Мугалим каттоо эсебин түзүңүз",
    "ru": "Создайте учетную запись учителя, чтобы начать",
    "uz": "Boshlash uchun o'qituvchi hisobini yarating",
    "viet": "Tạo tài khoản Giáo viên để bắt đầu"
  },
  "confirm-and-proceed": {
    "arabic": "تأكيد ومتابعة",
    "az": "Təsdiqləyin və davam edin",
    "chinese": "确认并继续",
    "eng": "Confirm and proceed",
    "hindi": "पुष्टि करें और आगे बढ़ें",
    "ja": "確認して次に進みます",
    "jp": null,
    "ky": "Ырастоо жана улантуу",
    "ru": "Подтвердите и продолжите",
    "uz": "Tasdiqlang va davom eting",
    "viet": "Xác nhận và tiến hành"
  },
  "securely-validate-your-information-,-ensuring-the-accuracy-of-your-details.": {
    "arabic": "قم بالتحقق من صحة معلوماتك بشكل آمن, وضمان دقة تفاصيلك.",
    "az": "Təfərrüatlarınızın düzgünlüyünü təmin edərək, məlumatlarınızı etibarlı şəkildə yoxlayın.",
    "chinese": "安全验证您的信息，确保您的详细信息的准确性。",
    "eng": "Securely Validate Your Information, ensuring the accuracy of your details.",
    "hindi": "अपने विवरण की सटीकता सुनिश्चित करते हुए, अपनी जानकारी को सुरक्षित रूप से मान्य करें।",
    "ja": "お客様の情報を安全に検証し、詳細の正確性を保証します。",
    "jp": null,
    "ky": "Маалыматыңыздын тактыгын камсыз кылуу менен маалыматыңызды коопсуз текшериңиз.",
    "ru": "Надежно проверяйте вашу информацию, гарантируя точность ваших данных.",
    "uz": "Ma'lumotlaringizning to'g'riligini ta'minlab, ma'lumotlaringizni ishonchli tarzda tasdiqlang.",
    "viet": "Xác thực thông tin của bạn một cách an toàn, đảm bảo tính chính xác của thông tin chi tiết của bạn."
  },
  "welcome-to-cerebry-!-press-confirm-to-verify-your-details": {
    "arabic": "مرحبًا بك في Cerebry! اضغط على تأكيد للتحقق من تفاصيلك",
    "az": "Cerebry-ə xoş gəlmisiniz! Təfərrüatlarınızı yoxlamaq üçün təsdiqləyin",
    "chinese": "欢迎来到塞雷布里！按确认以验证您的详细信息",
    "eng": "Welcome to Cerebry! Press confirm to verify your details",
    "hindi": "सेरेब्री में आपका स्वागत है! अपना विवरण सत्यापित करने के लिए पुष्टि दबाएँ",
    "ja": "セレブへようこそ！確認を押して詳細を確認してください",
    "jp": null,
    "ky": "Cerebry кош келиңиз! Маалыматыңызды текшерүү үчүн ырастоо баскычын басыңыз",
    "ru": "Добро пожаловать в Cerebry! Нажмите «Подтвердить», чтобы проверить свои данные",
    "uz": "Cerebry-ga xush kelibsiz! Tafsilotlaringizni tasdiqlash uchun tasdiqlash tugmasini bosing",
    "viet": "Chào mừng đến với Cerebry! Nhấn xác nhận để xác minh thông tin của bạn"
  },
  "switch-account": {
    "arabic": "تبديل الحساب",
    "az": "Hesabı dəyişin",
    "chinese": "切换账户",
    "eng": "Switch account",
    "hindi": "खाता स्थानांतरित करें",
    "ja": "アカウントを切り替える",
    "jp": null,
    "ky": "Аккаунтту которуштуруу",
    "ru": "Сменить аккаунт",
    "uz": "Hisobni almashtirish",
    "viet": "Chuyển tài khoản"
  },
  "login-via-email": {
    "arabic": "تسجيل الدخول عبر البريد الإلكتروني",
    "az": "E-poçt vasitəsilə daxil olun",
    "chinese": "通过电子邮件登录",
    "eng": "Login Via Email",
    "hindi": "ईमेल के माध्यम से लॉगिन करें",
    "ja": "電子メールによるログイン",
    "jp": null,
    "ky": "Электрондук почта аркылуу кирүү",
    "ru": "Войти через электронную почту",
    "uz": "Elektron pochta orqali kiring",
    "viet": "Đăng nhập qua email"
  },
  "please-choose-another-google-account-and-try-again-!": {
    "arabic": "يرجى اختيار حساب Google آخر والمحاولة مرة أخرى!",
    "az": "Lütfən, başqa Google hesabı seçin və yenidən cəhd edin!",
    "chinese": "请选择另一个 Google 帐户并重试！",
    "eng": "Please choose another Google account and try again!",
    "hindi": "कृपया कोई अन्य Google खाता चुनें और पुनः प्रयास करें!",
    "ja": "別の Google アカウントを選択して、もう一度お試しください。",
    "jp": null,
    "ky": "Башка Google аккаунтун тандап, кайра аракет кылыңыз!",
    "ru": "Пожалуйста, выберите другую учетную запись Google и повторите попытку!",
    "uz": "Boshqa Google hisobini tanlang va qaytadan urining!",
    "viet": "Vui lòng chọn một tài khoản Google khác và thử lại!"
  },
  "your-google-account-is-not-associated-with-cerebry-as-a-teacher.": {
    "arabic": "لا يرتبط حسابك في Google بـ Cerebry كمدرس.",
    "az": "Sizin Google hesabınız müəllim kimi Cerebry ilə əlaqəli deyil.",
    "chinese": "您的 Google 帐户未与 Cerebry as a Teacher 关联。",
    "eng": "Your Google account is not associated with Cerebry as a Teacher.",
    "hindi": "आपका Google खाता एक शिक्षक के रूप में सेरेब्री से संबद्ध नहीं है।",
    "ja": "あなたの Google アカウントは Cerebry as a Teacher に関連付けられていません。",
    "jp": null,
    "ky": "Сиздин Google аккаунтуңуз Cerebry Мугалим катары байланыштырылган эмес.",
    "ru": "Ваша учетная запись Google не связана с Cerebry как с учителем.",
    "uz": "Google hisobingiz Cerebry as a Teacher bilan bog‘lanmagan.",
    "viet": "Tài khoản Google của bạn không được liên kết với Cerebry với tư cách là Giáo viên."
  },
  "link-sent": {
    "arabic": "تم إرسال الرابط",
    "az": "Link göndərildi",
    "chinese": "链接已发送",
    "eng": "Link sent",
    "hindi": "लिंक भेजा गया",
    "ja": "リンクが送信されました",
    "jp": null,
    "ky": "Шилтеме жөнөтүлдү",
    "ru": "Ссылка отправлена",
    "uz": "Havola yuborildi",
    "viet": "Đã gửi liên kết"
  },
  "success": {
    "arabic": "نجاح",
    "az": "Uğur",
    "chinese": "成功",
    "eng": "Success",
    "hindi": "सफलता",
    "ja": "成功",
    "jp": null,
    "ky": "Ийгилик",
    "ru": "Успех",
    "uz": "Muvaffaqiyat",
    "viet": "Thành công"
  },
  "description-should-be-minimum-10-characters-long": {
    "arabic": "يجب أن يكون الوصف بحد أدنى 10 أحرف",
    "az": "Təsvir minimum 10 simvol uzunluğunda olmalıdır",
    "chinese": "描述长度至少为 10 个字符",
    "eng": "Description should be minimum 10 characters long",
    "hindi": "विवरण कम से कम 10 अक्षर लंबा होना चाहिए",
    "ja": "説明は 10 文字以上にする必要があります",
    "jp": null,
    "ky": "Сүрөттөмө кеминде 10 белгиден турушу керек",
    "ru": "Описание должно быть длиной не менее 10 символов.",
    "uz": "Tavsif kamida 10 ta belgidan iborat bo'lishi kerak",
    "viet": "Mô tả phải dài tối thiểu 10 ký tự"
  },
  "this-feature-allows-you-to-onboard-teachers-to-multiple-classes-at-once.": {
    "arabic": "تتيح لك هذه الميزة ضم المعلمين إلى فصول دراسية متعددة في وقت واحد.",
    "az": "Bu xüsusiyyət sizə müəllimləri eyni anda bir neçə sinifə daxil etməyə imkan verir.",
    "chinese": "此功能允许您一次将教师引入多个班级。",
    "eng": "This feature allows you to onboard teachers to multiple classes at once.",
    "hindi": "यह सुविधा आपको एक साथ कई कक्षाओं में शिक्षकों को बोर्ड करने की अनुमति देती है।",
    "ja": "この機能を使用すると、一度に複数のクラスに教師をオンボードできます。",
    "jp": null,
    "ky": "Бул функция бир эле учурда бир нече класстарга мугалимдерди кошууга мүмкүндүк берет.",
    "ru": "Эта функция позволяет вам подключать учителей к нескольким классам одновременно.",
    "uz": "Bu xususiyat sizga o'qituvchilarni bir vaqtda bir nechta sinflarga qo'shish imkonini beradi.",
    "viet": "Tính năng này cho phép bạn onboard giáo viên vào nhiều lớp cùng một lúc."
  },
  "no-teachers-in-this-class": {
    "arabic": "لا يوجد مدرسين في هذا الفصل",
    "az": "Bu sinifdə müəllim yoxdur",
    "chinese": "此班级中没有教师",
    "eng": "No teachers in this class",
    "hindi": "इस कक्षा में कोई शिक्षक नहीं है",
    "ja": "このクラスには教師がいません",
    "jp": null,
    "ky": "Бул класста мугалимдер жок",
    "ru": "В этом классе нет учителей",
    "uz": "Bu sinfda o'qituvchilar yo'q",
    "viet": "Không có giáo viên trong lớp này"
  },
  "are-you-sure-you-want-to-remove-the-teacher-from-this-class?": {
    "arabic": "هل أنت متأكد أنك تريد إزالة المعلم من هذا الفصل؟",
    "az": "Müəllimi bu sinifdən silmək istədiyinizə əminsiniz?",
    "chinese": "您确定要从此班级中删除教师吗？",
    "eng": "Are you sure you want to remove the teacher from this class?",
    "hindi": "क्या आप वाकई इस कक्षा से शिक्षक को हटाना चाहते हैं?",
    "ja": "このクラスから教師を削除してもよろしいですか？",
    "jp": null,
    "ky": "Бул мугалимди класстан алып салгыңыз келеби?",
    "ru": "Вы уверены, что хотите удалить учителя из этого класса?",
    "uz": "O‘qituvchini ushbu sinfdan chiqarib tashlamoqchi ekanligingizga ishonchingiz komilmi?",
    "viet": "Bạn có chắc chắn muốn xóa giáo viên khỏi lớp này không?"
  },
  "are-you-sure-you-want-to-remove-the-student-from-this-class?": {
    "arabic": "هل أنت متأكد أنك تريد إزالة الطالب من هذا الفصل؟",
    "az": "Tələbəni bu sinifdən silmək istədiyinizə əminsiniz?",
    "chinese": "您确定要从此班级中删除学生吗？",
    "eng": "Are you sure you want to remove the student from this class?",
    "hindi": "क्या आप वाकई इस कक्षा से छात्र को हटाना चाहते हैं?",
    "ja": "このクラスから学生を削除してもよろしいですか？",
    "jp": null,
    "ky": "Окуучуну бул класстан чын эле алып салгыңыз келеби?",
    "ru": "Вы уверены, что хотите удалить ученика из этого класса?",
    "uz": "O'quvchini ushbu sinfdan olib tashlashni istaysizmi?",
    "viet": "Bạn có chắc chắn muốn xóa học sinh khỏi lớp này không?"
  },
  "forgot-password?": {
    "arabic": "هل نسيت كلمة السر؟",
    "az": "Şifrəni unutmusunuz?",
    "chinese": null,
    "eng": "Forgot Password?",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сырсөзүңүздү унуттуңузбу?",
    "ru": "Забыли пароль?",
    "uz": "Parolni unutdingizmi?",
    "viet": null
  },
  "don't-have-an-account?": {
    "arabic": "ليس لديك حساب؟",
    "az": "Hesabınız yoxdur?",
    "chinese": null,
    "eng": "Don't have an Account?",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Каттоо эсебиңиз жокпу?",
    "ru": "У вас нет учетной записи?",
    "uz": "Akkauntingiz mavjud emasmi?",
    "viet": null
  },
  "enter-your-email-or-username-to-proceed-further": {
    "arabic": "أدخل بريدك الإلكتروني أو اسم المستخدم للمتابعة",
    "az": "Davam etmək üçün e-poçt və ya istifadəçi adınızı daxil edin",
    "chinese": null,
    "eng": "Enter your email or username to proceed further",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Улантуу үчүн электрондук почтаңызды же колдонуучу атыңызды киргизиңиз",
    "ru": "Введите свой адрес электронной почты или имя пользователя, чтобы продолжить",
    "uz": "Davom etish uchun elektron pochta manzilingiz yoki foydalanuvchi nomingizni kiriting",
    "viet": null
  },
  "email-id/username": {
    "arabic": "معرف البريد الإلكتروني/اسم المستخدم",
    "az": "E-poçt ünvanı/İstifadəçi adı",
    "chinese": null,
    "eng": "Email ID/Username",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Электрондук почта ID/Колдонуучунун аты",
    "ru": "Идентификатор электронной почты/Имя пользователя",
    "uz": "Elektron pochta manzili / Foydalanuvchi nomi",
    "viet": null
  },
  "exercises": {
    "arabic": "تمارين",
    "az": "Məşqlər",
    "chinese": null,
    "eng": "Exercises",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Тапшырмалар",
    "ru": "Упражнения",
    "uz": "Topshiriqlar",
    "viet": null
  },
  "this-name-is-seen-only-by-you.-it-is-to-help-you-label-your-classes.-eg--'9th-d'-or-'section-b-10th'": {
    "arabic": "هذا الاسم لا يراه أحد سواك, وهو يساعدك في تصنيف صفوفك. على سبيل المثال: الصف التاسع د أو القسم ب الصف العاشر",
    "az": "Bu adı ancaq siz görürsünüz. Bu sinfi adlandırmaq üçündür. Məsələn, 9d, 10b və s.",
    "chinese": null,
    "eng": "This name is seen only by you. It is to help you label your classes. Eg- '9th D' or 'section B 10th'",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бул атты бир гана сиз көрөсүз. Ал сиздин класстарыңызды аныктоого жардам берет. Мисалы: \"9-класс D\" же \"10-класс B секциясы\".",
    "ru": "Это имя видите только вы. Оно поможет вам маркировать ваши классы. Например, «9th D» или «section B 10th»",
    "uz": "Kiritilgan nom faqat sizga ko‘rinadi. Bu nom sizga sinflaringizni belgilashda yordam beradi. Sinflarni \"9-D\" yoki \"10-sinf B guruh\" tarzida nomlanishingiz mumkin.",
    "viet": null
  },
  "enter-class-name": {
    "arabic": "أدخل اسم الفصل",
    "az": "Sinif adını daxil edin",
    "chinese": null,
    "eng": "Enter Class name",
    "hindi": null,
    "ja": null,
    "jp": "クラス名を入力",
    "ky": "Класс атын киргизиңиз",
    "ru": "Введите название класса",
    "uz": "Sinf nomini kiriting",
    "viet": null
  },
  "create-classes": {
    "arabic": "إنشاء الفصول الدراسية",
    "az": "Siniflər yaradın",
    "chinese": null,
    "eng": "Create Classes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Класстарды түзүү",
    "ru": "Создать классы",
    "uz": "Sinflar yaratish",
    "viet": null
  },
  "exercises-practiced": {
    "arabic": "التمارين التي تم ممارستها",
    "az": "Təcrübəli Məşqlər",
    "chinese": null,
    "eng": "Exercises practised",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Тапшырмалар аткарылды",
    "ru": "Упражнения, которые практикуются",
    "uz": "Bajarilgan topshiriqlar",
    "viet": null
  },
  "download-the-excel-file-provided-by-cerebry-and-fill-up-the-student-details.": {
    "arabic": "قم بتنزيل ملف Excel المقدم من Cerebry واملأ تفاصيل الطالب.",
    "az": "Cerebry tərəfindən təqdim olunan excel faylını endirin və şagird məlumatlarını doldurun.",
    "chinese": null,
    "eng": "Download the excel file provided by Cerebry and fill up the student details.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Cerebry сунуштаган Excel файлын жүктөп, окуучулардын маалыматтарын толтуруңуз.",
    "ru": "Загрузите файл Excel, предоставленный Cerebry, и заполните данные студента.",
    "uz": "Cerebry taqdim etgan excel formatidagi faylni yuklab oling va o‘quvchi ma’lumotlarini kiriting",
    "viet": null
  },
  "file-downloaded-successfully": {
    "arabic": "تم تحميل الملف بنجاح",
    "az": "Fayl uğurla yükləndi",
    "chinese": null,
    "eng": "File downloaded Successfully",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Файл ийгиликтүү жүктөлдү",
    "ru": "Файл успешно загружен",
    "uz": "Fayl yuklab olindi",
    "viet": null
  },
  "upload-the-excel-file-here-provided-by-cerebry.": {
    "arabic": "قم بتحميل ملف Excel هنا المقدم من Cerebry.",
    "az": "Cerebry tərəfindən təqdim olunan excel faylını buraya yükləyin.",
    "chinese": null,
    "eng": "Upload the excel file here provided by Cerebry.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бул жерге Cerebry сунуштаган Excel файлын жүктөңүз.",
    "ru": "Загрузите файл Excel, предоставленный Cerebry, здесь.",
    "uz": "Cerebry taqdim etgan excel formatidagi faylni yuklang",
    "viet": null
  },
  "after-uploading-the-file,-you-will-receive-an-email-with-student-information-and-generated-credentials.": {
    "arabic": "بعد تحميل الملف, سوف تتلقى رسالة بريد إلكتروني تحتوي على معلومات الطالب وبيانات الاعتماد التي تم إنشاؤها.",
    "az": "Faylı yüklədikdən sonra şagird məlumatları və yaradılan giriş məlumatlarını ehtiva edən e-poçt alacaqsınız.",
    "chinese": null,
    "eng": "After uploading the file, you will receive an email with student information and generated credentials.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Файлды жүктөгөндөн кийин, окуучунун маалыматы жана түзүлгөн сырсөздөр менен электрондук кат аласыз.",
    "ru": "После загрузки файла вы получите электронное письмо с информацией о студенте и сгенерированными учетными данными.",
    "uz": "Fayl yuklangandan so‘ng, o‘quvchining shaxsiy ma’lumotlari va hisob ma’lumotlari ko‘rsatilgan elektron pochta xabari yuboriladi.",
    "viet": null
  },
  "file-uploaded-successfully.": {
    "arabic": "تم تحميل الملف بنجاح.",
    "az": "Fayl uğurla yükləndi.",
    "chinese": null,
    "eng": "File uploaded successfully.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Файл ийгиликтүү жүктөлдү",
    "ru": "Файл успешно загружен.",
    "uz": "Fayl yuklandi",
    "viet": null
  },
  "student-onboarding-is-in-progress.-you-will-receive-an-email-shortly-with-either-\"student-data-and-credentials\"-or-\"error-details-in-file\".": {
    "arabic": "جاري الآن إعداد الطلاب. ستتلقى رسالة بريد إلكتروني قريبًا تحتوي على بيانات الطلاب وبيانات الاعتماد أو تفاصيل الخطأ في الملف.",
    "az": "Şagirdlərin qeydiyyatı davam edir. Qısa müddət ərzində \"şagirdlərin giriş məlumatları\" və ya \"fayldakı xəta təfərrüatları\" ilə bağlı e-poçt alacaqsınız.",
    "chinese": null,
    "eng": "Student onboarding is in progress. You will receive an email shortly with either \"student data and credentials\" or \"error details in file\".",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучуларды кошуу жүрүп жатат. Көп узабай сизге электрондук почта менен \"окуучулардын маалыматы жана сырсөздөрү\" же \"файлдагы каталардын тизмеси\" келет.",
    "ru": "Идет процесс приема студентов. Вскоре вы получите электронное письмо с «данными и учетными данными студентов» или «сведениями об ошибках в файле».",
    "uz": "O‘quvchini ro‘yxatdan o‘tkazish jarayoni davom etmoqda. Birozdan so‘ng sizga \"o‘quvchining shaxsiy ma’lumotlari va hisob ma’lumotlari\" yoki \"fayldagi xatoliklar\" ko‘rsatilgan xabar yuboriladi.",
    "viet": null
  },
  "reset-new-password": {
    "arabic": "إعادة تعيين كلمة المرور الجديدة",
    "az": "Yeni Parolu Sıfırlayın",
    "chinese": null,
    "eng": "Reset New Password",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жаңы сырсөз киргизүү",
    "ru": "Сбросить новый пароль",
    "uz": "Yangi parol o‘rnatish",
    "viet": null
  },
  "confirm-new-password": {
    "arabic": "تأكيد كلمة المرور الجديدة",
    "az": "Yeni Şifrəni Təsdiqləyin",
    "chinese": null,
    "eng": "Confirm New Password",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жаңы сырсөздү ырастоо",
    "ru": "Подтвердите новый пароль",
    "uz": "Yangi parolni tasdiqlash",
    "viet": null
  },
  "a-link-will-be-sent-on-student-email-id.-student-can-reset-password-by-clicking-on-that-link.": {
    "arabic": "سيتم إرسال رابط إلى بريد الطالب الإلكتروني, ويمكن للطالب إعادة تعيين كلمة المرور بالنقر فوق هذا الرابط.",
    "az": "Link şagirdin e-poçt ünvanına göndəriləcək. Şagird həmin linkə klikləməklə parolu sıfırlaya bilər.",
    "chinese": null,
    "eng": "A link will be sent on student email id. Student can reset password by clicking on that link.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучунун электрондук почта ID дарегине шилтеме жөнөтүлөт. Окуучу ошол шилтеме аркылуу сырсөздү калыбына келтире алат.",
    "ru": "Ссылка будет отправлена на электронный адрес студента. Студент может сбросить пароль, нажав на эту ссылку.",
    "uz": "Parolni tiklash havolasi o‘quvchining elektron pochtasiga yuboriladi. Ko‘rsatilgan havola ustiga bosib, parolni tiklash mumkin.",
    "viet": null
  },
  "share-link": {
    "arabic": "شارك الرابط",
    "az": "Linki Paylaşın",
    "chinese": null,
    "eng": "Share Link",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Шилтемени бөлүшүү",
    "ru": "Поделиться ссылкой",
    "uz": "Havolani ulashish",
    "viet": null
  },
  "submit-&-share": {
    "arabic": "إرسال ومشاركة",
    "az": "Təqdim edin və paylaşın",
    "chinese": null,
    "eng": "Submit & Share",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жөнөтүү жана бөлүшүү",
    "ru": "Отправить и поделиться",
    "uz": "Yuborish va ulashish",
    "viet": null
  },
  "themes": {
    "arabic": "المواضيع",
    "az": "Mövzular",
    "chinese": null,
    "eng": "Themes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Темалар",
    "ru": "Темы",
    "uz": "Mavzular",
    "viet": null
  },
  "themes-practiced": {
    "arabic": "المواضيع التي تم ممارستها",
    "az": "Təcrübəli Mövzular",
    "chinese": null,
    "eng": "Themes practised",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Аткарылган темалар",
    "ru": "Темы, которые практикуются",
    "uz": "O‘zlashtirilgan mavzular",
    "viet": null
  },
  "theme-1": {
    "arabic": "الموضوع 1",
    "az": "Mövzu 1",
    "chinese": null,
    "eng": "Theme 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-тема",
    "ru": "Тема 1",
    "uz": "1-mavzu",
    "viet": null
  },
  "capable-level": {
    "arabic": "المستوى القادر",
    "az": "Qabiliyyət səviyyəsi",
    "chinese": null,
    "eng": "Capable Level",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Орточо деңгээл",
    "ru": "Уровень способностей",
    "uz": "1-qiyinlik darajasi",
    "viet": null
  },
  "strong-level": {
    "arabic": "مستوى قوي",
    "az": "Güclü Səviyyə",
    "chinese": null,
    "eng": "Strong Level",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жогорку деңгээл",
    "ru": "Сильный уровень",
    "uz": "2-qiyinlik darajasi",
    "viet": null
  },
  "ninja-level": {
    "arabic": "مستوى النينجا",
    "az": "Ninja Səviyyəsi",
    "chinese": null,
    "eng": "Ninja Level",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Өтө жогорку деңгээл",
    "ru": "Уровень ниндзя",
    "uz": "3-qiyinlik darajasi",
    "viet": null
  },
  "question-1": {
    "arabic": "السؤال 1",
    "az": "Sual 1",
    "chinese": null,
    "eng": "Question 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-суроо",
    "ru": "Вопрос 1",
    "uz": "1-savol",
    "viet": null
  },
  "theme": {
    "arabic": "سمة",
    "az": "Mövzu",
    "chinese": null,
    "eng": "Theme",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Тема",
    "ru": "Тема",
    "uz": "Mavzu",
    "viet": null
  },
  "are-you-sure-you-want-to-logout?": {
    "arabic": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "az": "Çıxmaq istədiyinizə əminsiniz?",
    "chinese": null,
    "eng": "Are you sure you want to logout?",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Чыгуу керектигин тастыктайсызбы?",
    "ru": "Вы уверены, что хотите выйти?",
    "uz": "Tizimdan chiqmoqchi ekanligingizga ishonchingiz komilmi?",
    "viet": null
  },
  "invalid-credentials.-please-try-again!": {
    "arabic": "بيانات الاعتماد غير صالحة. يرجى المحاولة مرة أخرى!",
    "az": "Etibarsız Etibarnamələr. Yenidən cəhd edin!",
    "chinese": null,
    "eng": "Invalid Credentials. Please Try Again!",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Туура эмес маалымат. Кайра аракет кылыңыз!",
    "ru": "Неверные учетные данные. Попробуйте еще раз!",
    "uz": "Hisob ma’lumotlari kerakli shaklda kiritilmadi. Iltimos, qaytadan urinib ko‘ring!",
    "viet": null
  },
  "teacher-already-exists-in-this-class.-please-delete-this-row.": {
    "arabic": "المعلم موجود بالفعل في هذا الفصل. يرجى حذف هذا الصف.",
    "az": "Müəllim artıq bu sinifdə mövcuddur. Zəhmət olmasa, bu sətiri silin.",
    "chinese": null,
    "eng": "Teacher already exists in this class. Please delete this row.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бул мугалим класс үчүн буга чейин катталган. Бул сапты өчүрүңүз.",
    "ru": "Учитель уже есть в этом классе. Пожалуйста, удалите эту строку.",
    "uz": "O‘qituvchi ushbu sinfda mavjud. Iltimos, ushbu ushbu qatorni o‘chiring.",
    "viet": null
  },
  "teacher-exists,-shall-be-added-to-the-class-and-the-password-will-not-be-changed": {
    "arabic": "المعلم موجود, يجب إضافته إلى الفصل ولن يتم تغيير كلمة المرور",
    "az": "Müəllim mövcuddur, sinfə əlavə ediləcək və parol dəyişdirilməyəcək.",
    "chinese": null,
    "eng": "Teacher exists, shall be added to the class and the password will not be changed",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалим катталган, класска кошулат жана сырсөз өзгөртүлбөйт.",
    "ru": "Учитель существует, его следует добавить в класс, пароль не будет изменен.",
    "uz": "O‘qituvchi mavjud, u tez orada sinfga biriktiriladi va parolni o‘zgartirish imkoni mavjud bo‘lmaydi",
    "viet": null
  },
  "yes,-remove": {
    "arabic": "نعم, قم بإزالة",
    "az": "Bəli, Sil",
    "chinese": null,
    "eng": "Yes, Remove",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Ооба, алып салуу",
    "ru": "Да, удалить",
    "uz": "Ha, chiqarib tashlang",
    "viet": null
  },
  "4-students-successfully-added-to-the-class,-and-their-credentials-have-been-emailed-to-them.": {
    "arabic": "تمت إضافة 4 طلاب إلى الفصل بنجاح, وتم إرسال بيانات اعتمادهم إليهم عبر البريد الإلكتروني.",
    "az": "4 şagird sinfə uğurla əlavə edildi və onların giriş məlumatları e-poçtlarına göndərildi.",
    "chinese": null,
    "eng": "4 students successfully added to the class, and their credentials have been emailed to them.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "4 окуучу ийгиликтүү класска кошулду жана алардын сырсөздөрү электрондук почта аркылуу жөнөтүлдү.",
    "ru": "4 ученика успешно добавлены в класс, и их учетные данные были отправлены им по электронной почте.",
    "uz": "4 nafar o‘quvchi sinfga muvaffaqiyatli tarzda qo‘shildi, ularning hisoblariga oid ma’lumotlari elektron pochta manzillariga yuborildi.",
    "viet": null
  },
  "student-already-exists-in-this-class.-please-delete-this-row.": {
    "arabic": "الطالب موجود بالفعل في هذا الفصل. يرجى حذف هذا الصف.",
    "az": "Bu sinifdə şagird artıq mövcuddur. Bu sətri silin.",
    "chinese": null,
    "eng": "Student already exists in this class. Please delete this row.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бул окуучу класста буга чейин бар. Бул сапты өчүрүңүз.",
    "ru": "Студент уже есть в этом классе. Пожалуйста, удалите эту строку.",
    "uz": "O‘quvchi ushbu sinfda mavjud. Iltimos, ushbu ushbu qatorni o‘chiring.",
    "viet": null
  },
  "student-exists,-shall-be-added-to-the-class-and-the-password-will-not-be-changed": {
    "arabic": "الطالب موجود, سيتم إضافته إلى الفصل ولن يتم تغيير كلمة المرور",
    "az": "Şagird mövcuddur, sinfə əlavə olunacaq və parol dəyişdirilməyəcək",
    "chinese": null,
    "eng": "Student exists, shall be added to the class and the password will not be changed",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучу катталган, класска кошулат жана сырсөз өзгөртүлбөйт.",
    "ru": "Студент существует, его следует добавить в класс, и пароль не будет изменен.",
    "uz": "O‘quvchi mavjud, u tez orada sinfga biriktiriladi va parolni o‘zgartirish imkoni mavjud bo‘lmaydi",
    "viet": null
  },
  "welcome-to-cerebry!": {
    "arabic": "مرحباً بكم في Cerebry!",
    "az": "Cerebry-ə xoş gəlmisiniz!",
    "chinese": null,
    "eng": "Welcome to Cerebry!",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Cerebry программасына кош келиңиз!",
    "ru": "Добро пожаловать в Серебри!",
    "uz": "Cerebry platformasiga Xush kelibsiz!",
    "viet": null
  },
  "create-an-acccount": {
    "arabic": "إنشاء حساب",
    "az": "Hesab yaradın",
    "chinese": null,
    "eng": "Create an acccount",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Каттоо эсебин түзүү",
    "ru": "Создать учетную запись",
    "uz": "Hisob yaratish",
    "viet": null
  },
  "join-a-school": {
    "arabic": "انضم إلى المدرسة",
    "az": "Məktəbə qoşul",
    "chinese": null,
    "eng": "Join a school",
    "hindi": null,
    "ja": null,
    "jp": "学校に参加",
    "ky": "Мектепке кошулуу",
    "ru": "Присоединиться к школе",
    "uz": "Maktabga qo'shilish",
    "viet": null
  },
  "class-setup": {
    "arabic": "إعداد الفصل",
    "az": "Sinfin qurulması",
    "chinese": null,
    "eng": "Class setup",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Классты орнотуу",
    "ru": "Настройка класса",
    "uz": "Sinf sozlamalari",
    "viet": null
  },
  "note:-if-you-wish-to-create-more-such-classes,-you-can-do-so-by-clicking-on-“create-new-class”-button-on-your-profile-within-the-teacher-dashboard": {
    "arabic": "ملاحظة: إذا كنت ترغب في إنشاء المزيد من هذه الفصول, يمكنك القيام بذلك من خلال النقر على زر إنشاء فصل جديد في ملفك الشخصي ضمن لوحة معلومات المعلم",
    "az": "Qeyd: Daha çox belə siniflər yaratmaq istəyirsinizsə, bunu müəllim panelində profilinizdəki “Yeni sinif yarat” düyməsini klikləməklə edə bilərsiniz.",
    "chinese": null,
    "eng": "Note: If you wish to create more such classes, you can do so by clicking on “Create new class” button on your profile within the teacher dashboard",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Эскертүү: Эгер дагы класстарды түзгүңүз келсе, мугалимдин профилиндеги “Жаңы класс түзүү” баскычын басыңыз.",
    "ru": "Примечание: Если вы хотите создать больше подобных классов, вы можете сделать это, нажав кнопку «Создать новый класс» в своем профиле на панели инструментов учителя.",
    "uz": "Eslatma: Shunday sinflardan yana bir nechtasini yaratmoqchi bo‘lsangiz, buni O‘qituvchi panelining o‘zida, Profilingizdagi \"Yangi sinf yaratish\" tugmasini bosish orqali bajarishingiz mumkin.",
    "viet": null
  },
  "press-confirm-to-get-the-code-for-the-classes.": {
    "arabic": "اضغط تأكيد للحصول على الكود الخاص بالفصول الدراسية.",
    "az": "Dərslər üçün kodu əldə etmək üçün təsdiqləyin.",
    "chinese": null,
    "eng": "Press confirm to get the code for the classes.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Код алуу үчүн ырастоо баскычын басыңыз.",
    "ru": "Нажмите «Подтвердить», чтобы получить код для занятий.",
    "uz": "Ushbu sinf(lar)ning kodini olish uchun tasdiqlash tugmasini bosing.",
    "viet": null
  },
  "share-this-code-with-your-student-to-join-the-classes.": {
    "arabic": "شارك هذا الرمز مع الطالب الخاص بك للانضمام إلى الفصول الدراسية.",
    "az": "Bu siniflərə qoşulmaları üçün kodu şagirdinizlə paylaşın.",
    "chinese": null,
    "eng": "Share this code with your student to join the classes.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бул кодду окуучуларга класска кошулуу үчүн бөлүшүңүз.",
    "ru": "Поделитесь этим кодом со своим учеником, чтобы присоединиться к занятиям.",
    "uz": "Sinf(lar)ga qo‘shilishlari uchun ushbu kodni o‘quvchilarga ulashing.",
    "viet": null
  },
  "class-you-have-created": {
    "arabic": "الصف الذي قمت بإنشائه",
    "az": "Yaratdığınız sinif",
    "chinese": null,
    "eng": "Class you have created",
    "hindi": null,
    "ja": null,
    "jp": "あなたが作成したクラス",
    "ky": "Сиз түзгөн класс",
    "ru": "Созданный вами класс",
    "uz": "Siz yaratgan sinf",
    "viet": null
  },
  "error-in-the-uploaded-file,-please-fill-in-the-missing-details-and-re-upload. ": {
    "arabic": "خطأ في الملف الذي تم تحميله, يرجى ملء التفاصيل المفقودة وإعادة التحميل.",
    "az": "Yüklənmiş faylda xəta var, Çatışmayan təfərrüatları doldurun və yenidən yükləyin.",
    "chinese": null,
    "eng": "Error in the uploaded file, Please fill in the missing details and re-upload. ",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жүктөлгөн файлда ката бар, маалыматтарды толуктап, кайра жүктөңүз.",
    "ru": "Ошибка в загруженном файле. Пожалуйста, заполните недостающие данные и повторите загрузку.",
    "uz": "Yuklangan faylda xatolik mavjud. Iltimos, qolib ketgan ma’lumotlarni kiriting va faylni qayta yuklang.",
    "viet": null
  },
  "add-teacher(s)": {
    "arabic": "إضافة المعلمين",
    "az": "Müəllimlər əlavə edin",
    "chinese": null,
    "eng": "Add teachers",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдерди кошуңуз",
    "ru": "Добавить учителей",
    "uz": "O'qituvchilarni  qo'shish",
    "viet": null
  },
  "search-the-teacher(s)-by-email-id": {
    "arabic": "البحث عن المعلمين عن طريق معرف البريد الإلكتروني",
    "az": "E-poçt ID-si ilə Müəllimlər axtarın",
    "chinese": null,
    "eng": "Search the teachers by Email ID",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Электрондук почта ID боюнча мугалимдерди изде",
    "ru": "Поиск yчителей по идентификатору электронной почты",
    "uz": "O'qituvchilarni Email ID bo'yicha qidiring",
    "viet": null
  },
  "search-teacher(s)-by-email-id-to-add-them-to-this-class": {
    "arabic": "ابحث عن المعلم(ين) عن طريق معرف البريد الإلكتروني لإضافتهم إلى هذه الفئة",
    "az": "Müəllimləri bu sinfə əlavə etmək üçün E-poçt ID-si ilə axtarın",
    "chinese": null,
    "eng": "Search teacher(s) by Email ID to add them to this class",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бул класска кошуу үчүн мугалимди электрондук почта ID аркылуу издөө",
    "ru": "Найдите учителя(ей) по идентификатору электронной почты, чтобы добавить их в этот класс",
    "uz": "Ushbu sinfga qo'shish uchun O'qituvchi(lar)ni Email ID bo'yicha qidiring",
    "viet": null
  },
  "___-teacher(s)-successfully-added-to-the-class,-and-their-credentials-have-been-emailed-to-them": {
    "arabic": "تم إضافة مدرس(ين) بنجاح إلى الفصل, وتم إرسال بيانات اعتمادهم إليهم عبر البريد الإلكتروني",
    "az": "___ müəllim(lər) uğurla sinfə əlavə edildi və onların etimadnamələri onlara e-poçtla göndərildi",
    "chinese": null,
    "eng": "___ teacher(s) successfully added to the class, and their credentials have been emailed to them",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "___ мугалим(лер) класска ийгиликтүү кошулду жана алардын грамоталары аларга электрондук почта аркылуу жөнөтүлдү",
    "ru": "___ учителей успешно добавлены в класс, и их учетные данные были отправлены им по электронной почте.",
    "uz": "___ o'qituvchi(lar) sinfga muvaffaqiyatli qo'shildi va ularning ma'lumotlari ularga email orqali yuborildi",
    "viet": null
  },
  "enter-the-students'-details-as-specified-in-the-excel-template-and-then-upload-the-file": {
    "arabic": "قم بإدخال بيانات الطلاب كما هو محدد في قالب Excel ثم قم برفع الملف",
    "az": "Excel şablonunda göstərildiyi kimi tələbələrin təfərrüatlarını daxil edin və sonra faylı yükləyin",
    "chinese": null,
    "eng": "Enter the students' details as specified in the Excel template and then upload the file",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Excel үлгүсүндө көрсөтүлгөндөй студенттердин маалыматын киргизип, анан файлды жүктөңүз",
    "ru": "Введите данные студентов, как указано в шаблоне Excel, а затем загрузите файл.",
    "uz": "Talabalar haqida ma'lumotni Excel shabloniga ko'ra kiriting va keyin faylni yuklang",
    "viet": null
  },
  "uploading": {
    "arabic": "جاري التحميل",
    "az": "Yüklənir",
    "chinese": null,
    "eng": "Uploading",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жүктөө жүрүп жатат",
    "ru": "Загрузка",
    "uz": "Yuklanmoqda",
    "viet": null
  },
  "english": {
    "arabic": "إنجليزي",
    "az": "İngilis dili",
    "chinese": null,
    "eng": "English",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Англисче",
    "ru": "Английский",
    "uz": "Ingliz tili",
    "viet": null
  },
  "uzbek": {
    "arabic": "الأوزبكية",
    "az": "özbək",
    "chinese": null,
    "eng": "Uzbek",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Өзбекче",
    "ru": "узбекский",
    "uz": "O'zbek tili",
    "viet": null
  },
  "russian": {
    "arabic": "الروسية",
    "az": "rus",
    "chinese": null,
    "eng": "Russian",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Орусча",
    "ru": "Русский",
    "uz": "Rus tili",
    "viet": null
  },
  "arabic": {
    "arabic": "عربي",
    "az": "ərəb",
    "chinese": null,
    "eng": "Arabic",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Арабча",
    "ru": "арабский",
    "uz": "Arab tili",
    "viet": null
  },
  "enter-the-teachers'-details-as-specified-in-the-excel-template-and-then-upload-the-file": {
    "arabic": "قم بإدخال بيانات المعلمين كما هو محدد في قالب Excel ثم قم برفع الملف",
    "az": "Excel şablonunda göstərildiyi kimi müəllimlərin təfərrüatlarını daxil edin və sonra faylı yükləyin",
    "chinese": null,
    "eng": "Enter the teachers' details as specified in the Excel template and then upload the file",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдердин маалыматтарын Excel үлгүсүндө көрсөтүлгөндөй киргизип, файлды жүктөңүз",
    "ru": "Введите данные учителей, как указано в шаблоне Excel, а затем загрузите файл.",
    "uz": "O'qituvchilar haqida ma'lumotni Excel shabloniga ko'ra kiriting va keyin faylni yuklang",
    "viet": null
  },
  "teacher-onboarding-is-in-progress.-you-will-receive-an-email-shortly-with-either-\"teacher-data-and-credentials\"-or-\"error-details-in-file\".": {
    "arabic": "جاري الآن إعداد المعلم. ستتلقى رسالة بريد إلكتروني قريبًا تحتوي على بيانات المعلم وبيانات الاعتماد أو تفاصيل الخطأ في الملف.",
    "az": "Müəllim qəbulu davam edir. Siz qısa müddətdə &quot;müəllim məlumatları və etimadnamələri&quot; və ya &quot;fayldakı xəta təfərrüatları&quot; ilə bir e-poçt alacaqsınız.",
    "chinese": null,
    "eng": "Teacher onboarding is in progress. You will receive an email shortly with either \"teacher data and credentials\" or \"error details in file\".",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдерди кошуу жүрүп жатат. Көп узабай электрондук почта менен \"мугалимдердин маалыматы жана сырсөздөрү\" же \"файлдагы каталардын тизмеси\" келет.",
    "ru": "Идет процесс адаптации учителей. Вскоре вы получите электронное письмо с «данными и учетными данными учителя» или «сведениями об ошибках в файле».",
    "uz": "O'qituvchilarni ro'yxatga olish davom etmoqda. Tez orada sizga \"o'qituvchi ma'lumotlari va akkreditatsiya\" yoki \"fayldagi xatolar haqida ma'lumot\" email orqali yuboriladi",
    "viet": null
  },
  "add-existing-teachers": {
    "arabic": "إضافة المعلمين الحاليين",
    "az": "Mövcud Müəllimləri əlavə edin",
    "chinese": null,
    "eng": "Add Existing Teachers",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мурда катталган мугалимдерди кошуу",
    "ru": "Добавить существующих учителей",
    "uz": "Mavjud O'qituvchilarni qo'shish",
    "viet": null
  },
  "azerbaijani": {
    "arabic": "أذربيجاني",
    "az": "Azərbaycan",
    "chinese": null,
    "eng": "Azerbaijani",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "азербайжан",
    "ru": "азербайджанский",
    "uz": "O'zbek tili",
    "viet": null
  },
  "some-emails-are-already-registered-with-another-school": {
    "arabic": "بعض رسائل البريد الإلكتروني مسجلة بالفعل لدى مدرسة أخرى",
    "az": "Bəzi e-poçtlar artıq başqa məktəbdə qeydə alınıb",
    "chinese": null,
    "eng": "Some emails are already registered with another school",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кээ бир электрондук почталар мурунтан эле башка мектепте катталган",
    "ru": "Некоторые адреса электронной почты уже зарегистрированы в другой школе.",
    "uz": "Ba'zi email-lar allaqachon boshqa maktabda ro'yxatdan o'tgan",
    "viet": null
  },
  "try-using-a-different-email": {
    "arabic": "حاول استخدام بريد إلكتروني مختلف",
    "az": "Fərqli e-poçtdan istifadə etməyə çalışın",
    "chinese": null,
    "eng": "Try using a different email",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Башка электрондук почтаны колдонуп көрүңүз",
    "ru": "Попробуйте использовать другой адрес электронной почты.",
    "uz": "Boshqa emailni ishlatishga harakat qiling",
    "viet": null
  },
  "login-issue": {
    "arabic": "مشكلة تسجيل الدخول",
    "az": "Giriş problemi",
    "chinese": null,
    "eng": "Login issue",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кирүү маселеси",
    "ru": "Проблема со входом",
    "uz": "Tizimga kirish bilan bog‘liq muammo",
    "viet": null
  },
  "add-classes": {
    "arabic": "إضافة الفصول الدراسية",
    "az": "Dərslər əlavə edin",
    "chinese": null,
    "eng": "Add classes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Класстарды кошуу",
    "ru": "Добавить классы",
    "uz": "Sinf(lar)ni qo‘shish",
    "viet": null
  },
  "add-or-remove-student": {
    "arabic": "إضافة أو إزالة الطالب",
    "az": "Şagird əlavə edin və ya silin",
    "chinese": null,
    "eng": "Add or remove student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Студент кошуу же алып салуу",
    "ru": "Добавить или удалить студента",
    "uz": "O‘quvchi(lar)ni qo‘shish yoki chiqarib tashlash",
    "viet": null
  },
  "technical-issue": {
    "arabic": "مشكلة فنية",
    "az": "Texniki Məsələ",
    "chinese": null,
    "eng": "Technical Issue",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Техникалык маселе",
    "ru": "Техническая проблема",
    "uz": "Texnik nosozlik",
    "viet": null
  },
  "need-changes-in-content": {
    "arabic": "بحاجة إلى تغييرات في المحتوى",
    "az": "Məzmunda dəyişiklik lazımdır",
    "chinese": null,
    "eng": "Need changes in content",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мазмунду өзгөртүү керек",
    "ru": "Нужны изменения в содержании",
    "uz": "Kontent o‘zgartirilishi kerak",
    "viet": null
  },
  "incorrect-language-[interface]": {
    "arabic": "لغة غير صحيحة [الواجهة]",
    "az": "Səhv dil [interfeys]",
    "chinese": null,
    "eng": "Incorrect language [interface]",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Туура эмес тил [интерфейс]",
    "ru": "Неправильный язык [интерфейс]",
    "uz": "[Interfeysda] noto‘g‘ri tildan foydalanilgan",
    "viet": null
  },
  "escalate-a-student-query": {
    "arabic": "تصعيد استفسار الطالب",
    "az": "Şagirdin müraciətini qeyd edin",
    "chinese": null,
    "eng": "Escalate a student query",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Студенттик суроону көтөрүү",
    "ru": "Эскалация запроса студента",
    "uz": "O‘quvchining so‘rovini tegishli joyga yo‘naltirish",
    "viet": null
  },
  "support": {
    "arabic": "يدعم",
    "az": "Dəstək",
    "chinese": null,
    "eng": "Support",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Колдоо",
    "ru": "Поддерживать",
    "uz": "Yordam",
    "viet": null
  },
  "enter-your-email-id-or-username-to-proceed-further": {
    "arabic": "أدخل معرف البريد الإلكتروني الخاص بك أو اسم المستخدم للمتابعة",
    "az": "Davam etmək üçün e-poçt ünvanınızı və ya istifadəçi adınızı daxil edin.",
    "chinese": null,
    "eng": "Enter your email ID or username to proceed further",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Улантуу үчүн электрондук почтаңыздын ID же колдонуучу атыңызды киргизиңиз",
    "ru": "Введите свой адрес электронной почты или имя пользователя, чтобы продолжить.",
    "uz": "Davom etish uchun elektron pochta manzilingiz yoki foydalanuvchi nomingizni kiriting\n",
    "viet": null
  },
  "we-have-notified-the-team-about-this-request.-reach-out-to-support@cerebry.co-for-further-assistance.": {
    "arabic": "لقد أبلغنا الفريق بهذا الطلب. تواصل معنا على support@cerebry.co للحصول على مزيد من المساعدة.",
    "az": "Bu sorğu ilə bağlı komandaya məlumat vermişik. Əlavə yardım üçün support@cerebry.co ilə əlaqə saxlayın.",
    "chinese": null,
    "eng": "We have notified the team about this request. Reach out to support@cerebry.co for further assistance.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Биз бул өтүнүч боюнча командага кабарладык. Кошумча жардам алуу үчүн support@cerebry.co дарегине кайрылыңыз.",
    "ru": "Мы уведомили команду об этом запросе. Обратитесь по адресу support@cerebry.co для получения дальнейшей помощи.",
    "uz": "Jamoamizni ushbu so‘rov haqida ogohlantirdik. Qo‘shimcha yordam olish uchun support@cerebry.co bilan bog‘laning.",
    "viet": null
  },
  "issue-type": {
    "arabic": "نوع المشكلة",
    "az": "Problem növü",
    "chinese": null,
    "eng": "Issue Type",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Issue Type",
    "ru": "Тип проблемы",
    "uz": "Muammo turi",
    "viet": null
  },
  "still-facing-an-issue,-describe-your-issue": {
    "arabic": "هل مازلت تواجه مشكلة, صف مشكلتك",
    "az": "Hələ də problemlə üzləşirsiniz, probleminizi təsvir edin",
    "chinese": null,
    "eng": "Still facing an issue, describe your issue",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Көйгөй дагы эле болсо, көйгөйүңүздү сүрөттөп бериңиз",
    "ru": "Все еще сталкиваетесь с проблемой? Опишите ее.",
    "uz": "Muammoga hali ham duch kelayotgan bo‘lsangiz, uni tavsiflab bering",
    "viet": null
  },
  "enter-the-description": {
    "arabic": "أدخل الوصف",
    "az": "Təsvir daxil edin",
    "chinese": null,
    "eng": "Enter the description",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сүрөттөмөнү киргизиңиз",
    "ru": "Введите описание",
    "uz": "Tavsifni kiriting",
    "viet": null
  },
  "guide-to-reset-password": {
    "arabic": "دليل إعادة تعيين كلمة المرور",
    "az": "Parolun sıfırlanması üçün təlimat",
    "chinese": null,
    "eng": "Guide to reset password",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сырсөздү калыбына келтирүү боюнча көрсөтмө",
    "ru": "Руководство по сбросу пароля",
    "uz": "Parolni tiklash bo‘yicha yo‘riqnoma",
    "viet": null
  },
  "guide-to-add-classes": {
    "arabic": "دليل إضافة الفصول الدراسية",
    "az": "Dərslər əlavə etmək üçün bələdçi",
    "chinese": null,
    "eng": "Guide to add classes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Класстарды кошуу үчүн колдонмо",
    "ru": "Руководство по добавлению классов",
    "uz": "Sinf(lar)ni qo‘shish bo‘yicha yo‘riqnoma",
    "viet": null
  },
  "guide-to-add-or-remove-students": {
    "arabic": "دليل إضافة أو إزالة الطلاب",
    "az": "Tələbələri əlavə etmək və ya silmək üçün bələdçi",
    "chinese": null,
    "eng": "Guide to add or remove students",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучуларды кошуу же алып салуу боюнча көрсөтмө",
    "ru": "Руководство по добавлению или удалению студентов",
    "uz": "O‘quvchi(lar)ni qo‘shish yoki chiqarib tashlash bo‘yicha yo‘riqnoma",
    "viet": null
  },
  "to-reset-password-for-your-account:\nclick-on-profile-dropdown->-change-password,-enter-your-old-password,-new-password-and-re-enter-the-new-password-to-change-the-password-of-your-account.-in-case-you-forgot-your-old-password,-you-can-reach-out-to-support@cerebry.co-for-more-help.\n\nto-reset-password-for-your-students:-\nclick-on-class-list->-student->-more-options->-reset-password-to-reset-the-password-for-your-students.-you-can-enter-the-new-password-and-share-it-with-students.-you-can-also-share-the-reset-link-with-your-students-which-they-can-use-to-change-their-account-password.": {
    "arabic": "لإعادة تعيين كلمة المرور لحسابك: انقر فوق القائمة المنسدلة الملف الشخصي &gt; تغيير كلمة المرور, وأدخل كلمة المرور القديمة وكلمة المرور الجديدة وأعد إدخال كلمة المرور الجديدة لتغيير كلمة مرور حسابك. في حالة نسيان كلمة المرور القديمة, يمكنك التواصل مع support@cerebry.co للحصول على مزيد من المساعدة. لإعادة تعيين كلمة المرور لطلابك: انقر فوق قائمة الفصول الدراسية &gt; الطلاب &gt; المزيد من الخيارات &gt; إعادة تعيين كلمة المرور لإعادة تعيين كلمة المرور لطلابك. يمكنك إدخال كلمة المرور الجديدة ومشاركتها مع الطلاب. يمكنك أيضًا مشاركة رابط إعادة التعيين مع طلابك والذي يمكنهم استخدامه لتغيير كلمة مرور حساباتهم.",
    "az": "Hesabınızın parolunu sıfırlamaq üçün:\nProfil açılan menyusu > Parolu dəyişin düyməsini klikləyin, hesabınızın parolunu dəyişmək üçün köhnə parolunuzu daxil edin, daha sonra yeni parolunuzu daxil edin və yeni parolu yenidən daxil edin. Köhnə parolunuzu unutmusunuzsa, əlavə yardım üçün support@cerebry.co ilə əlaqə saxlaya bilərsiniz.\n\nŞagirdləriniz üçün parolu sıfırlamaq üçün:\nŞagirdləriniz üçün parolu sıfırlamaq üçün Sinif siyahısı > Şagird > Daha çox seçim > Parolu sıfırlayın düyməsini klikləyin. Yeni parolu daxil edib şagirdlərlə paylaşa bilərsiniz. Şagirdlərinizlə həmçinin hesab parolunu dəyişmək üçün istifadə edə biləcəkləri sıfırlama linkini də paylaşa bilərsiniz.",
    "chinese": null,
    "eng": "To reset password for your account:\nClick on Profile dropdown > Change Password, enter your old password, new password and re-enter the new password to change the password of your account. In case you forgot your old password, you can reach out to support@cerebry.co for more help.\n\nTo reset password for your students: \nClick on Class List > Student > More Options > Reset Password to reset the password for your students. You can enter the new password and share it with students. You can also share the reset link with your students which they can use to change their account password.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Каттоо эсебиңиздин сырсөзүн баштапкы абалга келтирүү үчүн: Профиль ачылуучу ылдыйкы &gt; Сырсөздү өзгөртүүнү басыңыз, эски сырсөзүңүздү, жаңы сырсөзүңүздү киргизиңиз жана аккаунтуңуздун сырсөзүн өзгөртүү үчүн жаңы сырсөздү кайра киргизиңиз. Эски сырсөзүңүздү унутуп калсаңыз, көбүрөөк жардам алуу үчүн support@cerebry.co дарегине кайрылсаңыз болот. Студенттериңиздин сырсөзүн баштапкы абалга келтирүү үчүн: Студенттериңиздин сырсөзүн баштапкы абалга келтирүү үчүн Класс тизмеси &gt; Студент &gt; Көбүрөөк параметрлер &gt; Сырсөздү кайра орнотуу дегенди басыңыз. Сиз жаңы сырсөздү киргизип, аны студенттер менен бөлүшө аласыз. Сиз ошондой эле студенттериңиз менен аккаунтунун сырсөзүн өзгөртүү үчүн колдоно турган баштапкы абалга келтирүү шилтемесин бөлүшө аласыз.",
    "ru": "Чтобы сбросить пароль для вашей учетной записи: Нажмите на раскрывающееся меню Профиль &gt; Изменить пароль, введите старый пароль, новый пароль и повторно введите новый пароль, чтобы изменить пароль вашей учетной записи. Если вы забыли старый пароль, вы можете обратиться за помощью по адресу support@cerebry.co. Чтобы сбросить пароль для ваших учеников: Нажмите Список классов &gt; Ученик &gt; Дополнительные параметры &gt; Сбросить пароль, чтобы сбросить пароль для ваших учеников. Вы можете ввести новый пароль и поделиться им со своими учениками. Вы также можете поделиться ссылкой для сброса со своими учениками, с помощью которой они смогут изменить пароль своей учетной записи.",
    "uz": "Hisobingizning parolini tiklash uchun: Shaxsiy ma’lumotlar menyusidan Parolni o‘zgartirish bo‘limini tanlang, avval, eski parolingizni, keyin, yangi parolingizni kiriting va hisobingizning parolini o‘zgartirish uchun yangi parolni yana bir bor qayta kiriting. Eski parolingizni unutib qo‘ygan bo‘lsangiz, yordam uchun support@cerebry.co elektron pochta manzili bilan bog‘laning. \n\nO‘quvchilaringizning parollarni tiklash uchun bo‘limlarni quyidagi ketma-ketlikda tanlang: Sinf ro‘yxati > O‘quvchi > Qo‘shimcha parametrlar > Parolni tiklash. Siz yangi parolni kiritishingiz va uni o‘quvchilar bilan bo‘lishishingiz mumkin. Shuningdek, o‘quvchilar o‘z hisoblarining parolini o‘zlari tiklashlari uchun o‘zgartirish havolasini o‘quvchilaringizga yuborishingiz mumkin.",
    "viet": null
  },
  "you-can-create-a-class-directly-from-the-cerebry-teacher-dashboard---https://teacherdashboard.cerebry.co/.\nclick-on-profile-dropdown->-create-new-class-and-select-the-necessary-details-like-grade-and-name-for-the-class.-click-on-create-class-to-create-a-new-class.\nyou-can-create-multiple-classes-by-clicking-on-the-create-multiple-classes-button.-add-necessary-details-like-grade-and-a-name-for-the-class-to-be-created.-by-clicking-on-create-class(es),-you-can-create-multiple-classes-at-once.-all-these-classes-will-be-added-to-your-account-by-default.": {
    "arabic": "يمكنك إنشاء فصل دراسي مباشرةً من لوحة معلومات مدرس Cerebry - https://teacherdashboard.cerebry.co/. انقر فوق القائمة المنسدلة الملف الشخصي &gt; إنشاء فصل دراسي جديد وحدد التفاصيل الضرورية مثل الدرجة والاسم للفصل الدراسي. انقر فوق إنشاء فصل دراسي لإنشاء فصل دراسي جديد. يمكنك إنشاء فصول دراسية متعددة بالنقر فوق الزر إنشاء فصول دراسية متعددة. أضف التفاصيل الضرورية مثل الدرجة واسم الفصل الدراسي المراد إنشاؤه. بالنقر فوق إنشاء فصل دراسي, يمكنك إنشاء فصول دراسية متعددة في وقت واحد. سيتم إضافة كل هذه الفصول الدراسية إلى حسابك افتراضيًا.",
    "az": "Birbaşa Cerebry müəllim paneli - https://teacherdashboard.cerebry.co/ ünvanından sinif yarada bilərsiniz.\nProfil açılan menyusuna klikləyin > Yeni sinif yaradın və sinfin indeksi kimi lazımi təfərrüatları seçin. Yeni sinif yaratmaq üçün Sinif yaradın düyməsinə klikləyin.\nBir neçə sinif yaradın düyməsini klikləməklə birdən çox sinif yarada bilərsiniz. Yaradılacaq sinif üçün indeks kimi lazımi təfərrüatları əlavə edin. Sinif(lər) yaradın düyməsini klikləməklə eyni anda bir neçə sinif yarada bilərsiniz. Bütün bu siniflər avtomatik olaraq hesabınıza əlavə olunacaq.",
    "chinese": null,
    "eng": "You can create a class directly from the Cerebry Teacher Dashboard - https://teacherdashboard.cerebry.co/.\nClick on Profile dropdown > Create new class and select the necessary details like Grade and Name for the Class. Click on Create Class to create a new class.\nYou can create multiple classes by clicking on the Create Multiple Classes button. Add necessary details like grade and a name for the class to be created. By clicking on Create class(es), you can create multiple classes at once. All these classes will be added to your account by default.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сиз классты түз Cerebry Teacher Dashboard - https://teacherdashboard.cerebry.co/ түзө аласыз. Профилди чыкылдатыңыз &gt; Жаңы класс түзүңүз жана Класс үчүн Баа жана Аты сыяктуу керектүү маалыматтарды тандаңыз. Жаңы класс түзүү үчүн Класс түзүү дегенди басыңыз. Бир нече класстарды түзүү баскычын чыкылдатуу менен бир нече класстарды түзө аласыз. Баа жана түзүлө турган класстын аталышы сыяктуу керектүү маалыматтарды кошуңуз. Кластарды түзүү баскычын чыкылдатуу менен, бир эле учурда бир нече класстарды түзө аласыз. Бул класстардын баары демейки боюнча каттоо эсебиңизге кошулат.",
    "ru": "Вы можете создать класс непосредственно из панели инструментов учителя Cerebry - https://teacherdashboard.cerebry.co/. Нажмите раскрывающийся список Профиль &gt; Создать новый класс и выберите необходимые данные, такие как Оценка и Название для класса. Нажмите Создать класс, чтобы создать новый класс. Вы можете создать несколько классов, нажав кнопку Создать несколько классов. Добавьте необходимые данные, такие как оценка и название для создаваемого класса. Нажав Создать класс(ы), вы можете создать несколько классов одновременно. Все эти классы будут добавлены в вашу учетную запись по умолчанию.",
    "uz": "Cerebry O‘qituvchi boshqaruv panelida - https://teacherdashboard.cerebry.co/. -  Shaxsiy ma’lumotlar menyusidan Yangi sinf yaratish bo‘limini tanlash va Sinf hamda Sinf nomi kabi ma’lumotlarni kiritish orqali yangi sinf yaratishingiz mumkin. Sinfni yaratish tugmasi ustiga bosib, yangi sinf hosil qilasiz. Bir nechta sinflar yaratish tugmasi ustiga bosib, sinflar sonini ko‘paytirishingiz mumkin. Sinf va Sinf nomi kabi muhim ma’lumotlarni kiriting. Bir nechta sinf yaratish tugmasi ustiga bosib, bir urinishda bir qancha sinflar yaratishingiz mumkin. Ushbu yaratilgan sinflarning barchasi hisobingizga qo‘shiladi.",
    "viet": null
  },
  "you-can-add-or-remove-students-directly-from-the-cerebry-teacher-dashboard\n\nto-add-a-student:\n\nclick-on-class-list-→-add-student\n\nyou-can-add-students-using-username-by-entering-necessary-details-like-first-name,-last-name,-and-username.-to-add-multiple-students-using-excel-sheet,-download-the-format-using-the-\"download\"-button.-add-the-necessary-details-of-the-students-like-first-name,-last-name-and-unique-user-id.\n\nre-upload-the-excel-file-to-add-students-to-the-class.-upon-successful-upload,-students-will-be-added-to-this-class.\n\nto-remove-a-student:\n\nclick-on-class-list-→-student-→-more-options-(⋮)-→-remove\n\nupon-clicking-the-\"remove\"-button,-selected-student-will-be-deleted-from-the-class.": {
    "arabic": "يمكنك إضافة أو إزالة الطلاب مباشرة من لوحة معلومات مدرس Cerebry لإضافة طالب: انقر فوق قائمة الفصول → إضافة طالب يمكنك إضافة الطلاب باستخدام اسم المستخدم عن طريق إدخال التفاصيل الضرورية مثل الاسم الأول واسم العائلة واسم المستخدم. لإضافة طلاب متعددين باستخدام ورقة Excel, قم بتنزيل التنسيق باستخدام زر تنزيل. أضف التفاصيل الضرورية للطلاب مثل الاسم الأول واسم العائلة ومعرف المستخدم الفريد. أعد تحميل ملف Excel لإضافة الطلاب إلى الفصل. عند التحميل الناجح, سيتم إضافة الطلاب إلى هذا الفصل. لإزالة طالب: انقر فوق قائمة الفصول → الطالب → المزيد من الخيارات (⋮) → إزالة عند النقر فوق الزر إزالة, سيتم حذف الطالب المحدد من الفصل.",
    "az": "Şagirdləri birbaşa Cerebry müəllim panelindən əlavə edə və ya silə bilərsiniz\n\nŞagird əlavə etmək üçün:\n\nSinif siyahısına daxil olun → Şagird əlavə edin düyməsinə klikləyin\n\nAd, soyad və istifadəçi adı kimi lazımi məlumatları daxil edərək istifadəçi adı vasitəsilə şagirdləri əlavə edə bilərsiniz. Excel vərəqindən istifadə edərək bir neçə şagird əlavə etmək üçün Yükləyin düyməsi vasitəsilə formatı endirin. Şagirdlərin ad, soyad və qeydiyyat nömrəsi kimi lazımi məlumatlarını əlavə edin.\n\nQeyd: Yüklənmiş excel faylında əvvəlcədən doldurulmuş olan məktəb abbreviaturasını və sinif adına düzəliş etməyin.\n\nŞagirdləri sinfə əlavə etmək üçün excel faylını yenidən yükləyin. Yükləmə tamamlandıqda şagirdlər bu sinfə əlavə olunacaqlar.\n\nŞagirdi silmək üçün:\n\nSinif siyahısı → Şagird → Əlavə seçimlər (⋮) → Sil düyməsini klikləyin\n\nSil düyməsini kliklədikdən sonra seçilmiş şagird sinifdən silinəcək.",
    "chinese": null,
    "eng": "You can add or remove students directly from the Cerebry Teacher Dashboard\n\nTo add a student:\n\nClick on Class List → Add Student\n\nYou can add students using username by entering necessary details like First Name, Last Name, and Username. To add multiple students using excel sheet, download the format using the \"Download\" button. Add the necessary details of the students like first name, last name and unique user ID.\n\nRe-upload the excel file to add students to the class. Upon successful upload, students will be added to this class.\n\nTo remove a student:\n\nClick on Class List → Student → More Options (⋮) → Remove\n\nUpon clicking the \"Remove\" button, selected student will be deleted from the class.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сиз студенттерди түздөн-түз Cerebry Teacher Dashboard тактасынан кошуп же алып салсаңыз болот Студентти кошуу үчүн: Класс тизмеси → Студент кошуу дегенди басыңыз Аты, фамилиясы жана колдонуучунун аты сыяктуу керектүү маалыматтарды киргизүү менен студенттерди колдонуучу атын колдонуп кошо аласыз. Excel барагын колдонуп бир нече студентти кошуу үчүн, &quot;Жүктөө&quot; баскычын колдонуп форматты жүктөп алыңыз. Аты, фамилиясы жана уникалдуу колдонуучу ID сыяктуу студенттердин керектүү маалыматын кошуңуз. Окуучуларды класска кошуу үчүн excel файлын кайра жүктөңүз. Ийгиликтүү жүктөлгөндө студенттер бул класска кошулат. Окуучуну алып салуу үчүн: Класс тизмеси → Студент → Кошумча параметрлер (⋮) → Алып салуу баскычын чыкылдатыңыз &quot;Өчүрүү&quot; баскычын басканда, тандалган студент класстан жок кылынат.",
    "ru": "Вы можете добавлять или удалять учеников непосредственно из панели инструментов учителя Cerebry Чтобы добавить ученика: Нажмите Список классов → Добавить ученика Вы можете добавлять учеников, используя имя пользователя, введя необходимые данные, такие как Имя, Фамилия и Имя пользователя. Чтобы добавить нескольких учеников с помощью таблицы Excel, загрузите формат с помощью кнопки «Загрузить». Добавьте необходимые данные учеников, такие как имя, фамилия и уникальный идентификатор пользователя. Повторно загрузите файл Excel, чтобы добавить учеников в класс. После успешной загрузки ученики будут добавлены в этот класс. Чтобы удалить ученика: Нажмите Список классов → Ученик → Дополнительные параметры (⋮) → Удалить После нажатия кнопки «Удалить» выбранный ученик будет удален из класса.",
    "uz": "Cerebry O‘qituvchi boshqaruv panelining o‘zida ham o‘quvchi(lar)ni qo‘shish yoki chiqarib tashlash mumkin \n\nO‘quvchini qo‘shish uchun:\n\nSinf ro‘yxati → O‘quvchini kiritish tugmalarini bosing\n\nFoydalanuvchi nomidan foydalangan holda, Ism, Familiya va Foydalanuvchi nomi kabi muhim ma’lumotlarni kiritib, o‘quvchini qo‘shishingiz mumkin. Excel formatidagi fayldan foydalanib, bir qancha o‘quvchilarni qo‘shish uchun, kerakli formatni \"Yuklab olish\" tugmasini bosgan holda yuklab oling. O‘quvchilarning ismi, familiyasi va maxsus raqamlari kabi muhim ma’lumotlarini kiriting. \n\nEslatma: Yuklab olingan excel fayldagi oldindan to‘ldirib qo‘yilgan ma’lumotlarni (masalan, maktab nomining qisqartirilgan shakli va sinf nomini) tahrirlamang. \n\nO‘quvchilarni sinfga qo‘shish uchun excel formatidagi faylni qayta yuklang. Yuklash muvaffaqiyatli amalga oshirilganda, o‘quvchilar sinfga qo‘shiladi. \n\nO‘quvchini chiqarib tashlash uchun:\n\nSinf ro‘yxati → O‘quvchi → Qo‘shimcha parametrlar (:) → Chiqarib tashlash tugmalarini bosing\n\n\"Chiqarib tashlash\" tugmasi bosilganda, tanlangan o‘quvchi sinfdan chiqarib tashlashadi. \n\n",
    "viet": null
  },
  "Analysis": {
    "arabic": "تحليل",
    "az": "Təhlil",
    "chinese": null,
    "eng": "Analysis",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Анализ",
    "ru": "Aнализ",
    "uz": "Tahlil qilish",
    "viet": null
  },
  "change-language": {
    "arabic": "تغيير اللغة",
    "az": "Dili dəyişdirin",
    "chinese": "更改语言",
    "eng": "Change Language",
    "hindi": "भाषा बदलें",
    "ja": "言語を変更する",
    "jp": null,
    "ky": "Тилди өзгөртүү",
    "ru": "Изменить язык",
    "uz": "Tilni o'zgartirish",
    "viet": "Thay đổi ngôn ngữ"
  },
  "the-language-is-now-set-to": {
    "arabic": "تم ضبط اللغة الآن على",
    "az": "Dil indi təyin olunub",
    "chinese": "语言现在设置为",
    "eng": "The language is now set to",
    "hindi": "भाषा अब सेट हो गई है",
    "ja": "言語は現在次のように設定されています",
    "jp": null,
    "ky": "Тил азыр орнотулду",
    "ru": "Язык теперь установлен на",
    "uz": "Endi til sozlandi",
    "viet": "Ngôn ngữ bây giờ được đặt thành"
  },
  "share-these-class-codes-with-the-students-to invite-them-to-these-class(es).": {
    "arabic": "قم بمشاركة رموز الفصول الدراسية هذه مع الطلاب لدعوتهم إلى هذه الفصول الدراسية.",
    "az": "Şagirdləri bu siniflərə dəvət etmək üçün bu sinif kodlarını onlarla paylaşın",
    "chinese": "与学生分享这些班级代码，邀请他们参加这些班级。",
    "eng": "Share these class codes with the students to invite them to these class(es).",
    "hindi": "छात्रों को इन कक्षाओं में आमंत्रित करने के लिए इन कक्षा कोडों को उनके साथ साझा करें।",
    "ja": "これらのクラス コードを生徒と共有して、生徒をこれらのクラスに招待します。",
    "jp": null,
    "ky": "Бул класстын коддорун студенттер менен бөлүшүп, аларды ушул класстарга чакырыңыз.",
    "ru": "Поделитесь этими кодами классов с учащимися, чтобы пригласить их на эти курсы.",
    "uz": "Talabalarni ushbu sinf(lar)ga taklif qilish uchun ushbu sinf kodlarini ular bilan baham ko'ring.",
    "viet": "Chia sẻ các mã lớp này với học viên để mời họ vào (các) lớp này."
  },
  "submitting": {
    "arabic": "تقديم",
    "az": "Təqdim olunur",
    "chinese": "正在提交",
    "eng": "Submitting",
    "hindi": "भेजने से",
    "ja": "提出中",
    "jp": null,
    "ky": "Тапшыруу",
    "ru": "Отправка",
    "uz": "Yuborish",
    "viet": "Đang gửi"
  },
  "type-here": {
    "arabic": "اكتب هنا",
    "az": "Bura yazın",
    "chinese": "在此输入",
    "eng": "Type here",
    "hindi": "यहाँ टाइप करें",
    "ja": "ここに入力してください",
    "jp": null,
    "ky": "Бул жерге териңиз",
    "ru": "Введите здесь",
    "uz": "Bu yerga yozing",
    "viet": "Nhập vào đây"
  },
  "student-id": {
    "arabic": "رقم الطالب",
    "az": "Tələbə ID",
    "chinese": "学生证",
    "eng": "Student Id",
    "hindi": "स्टूडेंट आईडी",
    "ja": "学生証",
    "jp": null,
    "ky": "Студент ID",
    "ru": "Студенческий билет",
    "uz": "Talaba identifikatori",
    "viet": "Mã sinh viên"
  },
  "please-fill-all-the-required-fields": {
    "arabic": "يرجى ملء جميع الحقول المطلوبة",
    "az": "Zəhmət olmasa bütün tələb olunan sahələri doldurun",
    "chinese": "请填写所有必填字段",
    "eng": "Please fill all the required fields",
    "hindi": "कृपया सभी आवश्यक फ़ील्ड भरें",
    "ja": "必須フィールドをすべて入力してください",
    "jp": null,
    "ky": "Сураныч, бардык талап кылынган талааларды толтуруңуз",
    "ru": "Пожалуйста, заполните все обязательные поля",
    "uz": "Iltimos, barcha kerakli maydonlarni to'ldiring",
    "viet": "Vui lòng điền vào tất cả các trường bắt buộc"
  },
  "please-enter-username-id": {
    "arabic": "الرجاء إدخال اسم المستخدم أو معرفك",
    "az": "Zəhmət olmasa istifadəçi adınızı və ya ID-ni daxil edin",
    "chinese": null,
    "eng": "Please enter your username or ID",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сураныч, колдонуучу атыңызды же ID киргизиңиз",
    "ru": "Пожалуйста, введите ваше имя пользователя или ID",
    "uz": "Iltimos, foydalanuvchi nomingizni yoki ID raqamingizni kiriting",
    "viet": null
  },
  "please-enter-a-valid-username-id": {
    "arabic": "الرجاء إدخال اسم مستخدم أو معرف صالح",
    "az": "Zəhmət olmasa etibarlı istifadəçi adı və ya ID daxil edin",
    "chinese": null,
    "eng": "Please enter a valid username or ID",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жарактуу колдонуучунун атын же ID киргизиңиз",
    "ru": "Пожалуйста, введите действительное имя пользователя или ID",
    "uz": "Iltimos, haqiqiy foydalanuvchi nomi yoki ID raqamini kiriting",
    "viet": null
  },
  "password-should-be-minimum-6-characters-long": {
    "arabic": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
    "az": "Şifrə ən azı 6 simvoldan ibarət olmalıdır.",
    "chinese": null,
    "eng": "Password should be minimum 6 characters long.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сырсөз кеминде 6 белгиден турушу керек.",
    "ru": "Пароль должен содержать минимум 6 символов.",
    "uz": "Parol kamida 6 ta belgidan iborat bo‘lishi kerak.",
    "viet": null
  },
  "password-updated-!-student-new-password-has-been-saved-successfully": {
    "arabic": "تم تحديث كلمة المرور! تم حفظ كلمة المرور الجديدة للطالب بنجاح",
    "az": "Şifrə yeniləndi! Tələbənin yeni şifrəsi uğurla yadda saxlanıldı",
    "chinese": null,
    "eng": "Password Updated ! Student's new password has been saved successfully",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Сырсөз жаңырды! Студенттин жаңы сырсөзү ийгиликтүү сакталды",
    "ru": "Пароль обновлён! Новый пароль студента успешно сохранён",
    "uz": "Parol yangilandi! Talabaning yangi paroli muvaffaqiyatli saqlandi",
    "viet": null
  },
  "username-has-been-added-several-times-please-review-and-delete-the-duplicates": {
    "arabic": "لقد تمت إضافة اسم المستخدم عدة مرات, يرجى المراجعة وحذف التكرارات.",
    "az": "İstifadəçi adı bir neçə dəfə əlavə olunub, zəhmət olmasa, təkrarlara baxın və onları silin.",
    "chinese": null,
    "eng": "Username has been added several times, please review and delete the duplicates.",
    "hindi": null,
    "ja": "ユーザー名が複数回追加されましたので、確認して重複を削除してください。",
    "jp": null,
    "ky": "Колдонуучунун аты бир нече жолу кошулган. Сураныч, кайра карап чыгып, жок кылыңыз.",
    "ru": "Имя пользователя добавлено несколько раз, пожалуйста, проверьте и удалите дубликаты.",
    "uz": "Foydalanuvchi nomi bir necha marta qo'shilgan, iltimos, tekshirib, dublikatlarni o'chiring.",
    "viet": null
  },
  "please-upload-a-valid-excel-file": {
    "arabic": "الرجاء تحميل ملف Excel صالح.",
    "az": "Zəhmət olmasa, etibarlı bir Excel faylı yükləyin.",
    "chinese": "请上传有效的Excel文件。",
    "eng": "Please upload a valid Excel file.",
    "hindi": "कृपया एक मान्य Excel फ़ाइल अपलोड करें।",
    "ja": "有効なExcelファイルをアップロードしてください。",
    "jp": null,
    "ky": "Жарактуу Excel файлын жүктөңүз.",
    "ru": "Пожалуйста, загрузите действительный файл Excel.",
    "uz": "Iltimos, yaroqli Excel faylini yuklang.",
    "viet": "Vui lòng tải lên tệp Excel hợp lệ."
  },
  "Two": {
    "arabic": "اثنين",
    "az": "İki",
    "chinese": null,
    "eng": "Two",
    "hindi": null,
    "ja": null,
    "jp": "二",
    "ky": "Эки",
    "ru": "Два",
    "uz": "Ikki",
    "viet": null
  },
  "Three": {
    "arabic": "ثلاثة",
    "az": "Üç",
    "chinese": null,
    "eng": "Three",
    "hindi": null,
    "ja": null,
    "jp": "三",
    "ky": "Үч",
    "ru": "Три",
    "uz": "Uch",
    "viet": null
  },
  "more-quick-steps-to-get-started": {
    "arabic": "خطوات سريعة للبدء",
    "az": "Başlamaq üçün daha sürətli addımlar",
    "chinese": null,
    "eng": "more quick steps to get started",
    "hindi": null,
    "ja": null,
    "jp": "始めるためのさらに簡単な手順",
    "ky": "баштоо үчүн тезирээк кадамдар",
    "ru": "Больше быстрых шагов для начала",
    "uz": "Boshlash uchun yana tez qadamlar",
    "viet": null
  },
  "Create-an-account": {
    "arabic": "إنشاء حساب",
    "az": "Hesab yarat",
    "chinese": null,
    "eng": "Create an account",
    "hindi": null,
    "ja": null,
    "jp": "アカウントを作成",
    "ky": "Каттоо эсебин түзүү",
    "ru": "Создать аккаунт",
    "uz": "Hisob yaratish",
    "viet": null
  },
  "setup-class": {
    "arabic": "إعداد الفصل",
    "az": "Sinfi qur",
    "chinese": null,
    "eng": "Setup Class",
    "hindi": null,
    "ja": null,
    "jp": "クラスを設定",
    "ky": "Орнотуу классы",
    "ru": "Настройка класса",
    "uz": "Sinfni sozlash",
    "viet": null
  },
  "sync-students": {
    "arabic": "مزامنة الطلاب",
    "az": "Tələbələri sinxronlaşdır",
    "chinese": null,
    "eng": "Sync Students",
    "hindi": null,
    "ja": null,
    "jp": "学生を同期",
    "ky": "Студенттерди синхрондоштуруу",
    "ru": "Синхронизация учеников",
    "uz": "O'quvchilarni sinxronlash",
    "viet": null
  },
  "if-you-wish-to-create-more-such-classes,-you-can-do-so-by-clicking-on-“create-new-class”-button-on-your-profile-within-the-teacher-dashboard": {
    "arabic": "إذا كنت ترغب في إنشاء المزيد من هذه الفصول, يمكنك القيام بذلك من خلال النقر على زر إنشاء فصل جديد في ملفك الشخصي ضمن لوحة معلومات المعلم",
    "az": "Belə siniflərdən daha çox yaratmaq istəyirsinizsə, müəllim idarə panelinizdəki profilinizdə “Yeni sinif yarat” düyməsini basaraq bunu edə bilərsiniz",
    "chinese": null,
    "eng": "If you wish to create more such classes, you can do so by clicking on “Create new class” button on your profile within the teacher dashboard",
    "hindi": null,
    "ja": null,
    "jp": "さらに同様のクラスを作成したい場合は、教師ダッシュボードのプロファイル内の「新しいクラスを作成」ボタンをクリックして実行できます",
    "ky": "Эгер сиз дагы ушундай класстарды түзүүнү кааласаңыз, муну мугалим панелиндеги профилиңиздеги &quot;Жаңы класс түзүү&quot; баскычын чыкылдатуу менен жасай аласыз.",
    "ru": "Если вы хотите создать больше таких классов, вы можете сделать это, нажав кнопку «Создать новый класс» в вашем профиле на панели управления учителя",
    "uz": "Agar siz ko'proq shunday sinflarni yaratmoqchi bo'lsangiz, o'qituvchi boshqaruv panelidagi profilingizda “Yangi sinf yaratish” tugmasini bosish orqali buni amalga oshirishingiz mumkin",
    "viet": null
  },
  "sort": {
    "arabic": "نوع",
    "az": "Sıralamaq",
    "chinese": null,
    "eng": "Sort",
    "hindi": null,
    "ja": null,
    "jp": "並べ替え",
    "ky": "Сорттоо",
    "ru": "Сортировка",
    "uz": "Saralash",
    "viet": null
  },
  "skip-sync": {
    "arabic": "تخطي المزامنة",
    "az": "Sinxronizasiyanı keçin",
    "chinese": null,
    "eng": "Skip Sync",
    "hindi": null,
    "ja": null,
    "jp": "同期をスキップ",
    "ky": "Skip Sync",
    "ru": "Пропустить синхронизацию",
    "uz": "Sinxronizatsiyani o'tkazib yuborish",
    "viet": null
  },
  "mark-setup-as-complete": {
    "arabic": "وضع علامة على الإعداد على أنه مكتمل",
    "az": "Quraşdırmanı tamamlama kimi işarələyin",
    "chinese": null,
    "eng": "Mark Setup as Complete",
    "hindi": null,
    "ja": null,
    "jp": "セットアップを完了としてマークする",
    "ky": "Орнотууну аяктады деп белгилеңиз",
    "ru": "Отметить настройку как завершенную",
    "uz": "Sozlashni tugallangan deb belgilang",
    "viet": null
  },
  "you-cannot-proceed-with-account-sync-process-since-a-few-students-are-flagged-for-incomplete-information": {
    "arabic": "لا يمكنك متابعة عملية مزامنة الحساب نظرًا لوجود عدد قليل من الطلاب الذين تم وضع علامة عليهم بسبب عدم اكتمال المعلومات",
    "az": "Bir neçə tələbənin məlumatı tamamlanmadığı üçün hesab sinxronizasiyasını davam etdirə bilməzsiniz",
    "chinese": null,
    "eng": "You cannot proceed with account sync process since a few students are flagged for incomplete information",
    "hindi": null,
    "ja": null,
    "jp": "一部の学生の情報が不完全なため、アカウント同期プロセスを進めることができません",
    "ky": "Каттоо эсебин синхрондоштуруу процессин уланта албайсыз, анткени бир нече студент толук эмес маалымат үчүн белгиленет",
    "ru": "Вы не можете продолжить синхронизацию учетной записи, так как у нескольких студентов неполная информация",
    "uz": "Ba'zi talabalar haqida ma'lumot to'liq emasligi sababli hisobni sinxronizatsiya qilishni davom ettira olmaysiz",
    "viet": null
  },
  "yes": {
    "arabic": "نعم",
    "az": "Bəli",
    "chinese": null,
    "eng": "Yes",
    "hindi": null,
    "ja": null,
    "jp": "はい",
    "ky": "Ооба",
    "ru": "Да",
    "uz": "Ha",
    "viet": null
  },
  "no": {
    "arabic": "لا",
    "az": "Xeyr",
    "chinese": null,
    "eng": "No",
    "hindi": null,
    "ja": null,
    "jp": "いいえ",
    "ky": "Жок",
    "ru": "Нет",
    "uz": "Yo'q",
    "viet": null
  },
  "complete-setup": {
    "arabic": "الإعداد الكامل",
    "az": "Quraşdırmanı tamamla",
    "chinese": null,
    "eng": "Complete Setup",
    "hindi": null,
    "ja": null,
    "jp": "セットアップを完了する",
    "ky": "Орнотуу",
    "ru": "Завершить настройку",
    "uz": "Sozlashni yakunlang",
    "viet": null
  },
  "are-you-sure-you-want-to-proceed-with-the-account-sync-process": {
    "arabic": "هل أنت متأكد من أنك تريد المتابعة بعملية مزامنة الحساب؟",
    "az": "Hesab sinxronizasiya prosesini davam etdirmək istədiyinizə əminsiniz?",
    "chinese": null,
    "eng": "Are you sure you want to proceed with the account sync process",
    "hindi": null,
    "ja": null,
    "jp": "アカウント同期プロセスを進めてもよろしいですか？",
    "ky": "Каттоо эсебин синхрондоштуруу процессин уланткыңыз келеби?",
    "ru": "Вы уверены, что хотите продолжить процесс синхронизации учетной записи?",
    "uz": "Hisobni sinxronizatsiya qilish jarayonini davom ettirmoqchimisiz?",
    "viet": null
  },
  "once-student-information-has-been-synced,-you-will-no-longer-be-able-to-edit-their-information": {
    "arabic": "بمجرد مزامنة معلومات الطالب, لن تتمكن بعد الآن من تعديل معلوماته",
    "az": "Tələbə məlumatları sinxronizasiya edildikdən sonra məlumatlarını redaktə edə bilməyəcəksiniz",
    "chinese": null,
    "eng": "Once student information has been synced, you will no longer be able to edit their information",
    "hindi": null,
    "ja": null,
    "jp": "学生情報が同期されると、その情報を編集できなくなります",
    "ky": "Студенттик маалымат шайкештирилгенден кийин, сиз алардын маалыматын түзөтө албай каласыз",
    "ru": "После синхронизации информации о студентах вы больше не сможете её редактировать",
    "uz": "Talabalar ma'lumoti sinxronizatsiyalanganidan keyin ularning ma'lumotlarini o'zgartira olmaysiz",
    "viet": null
  },
  "google-classroom-classes": {
    "arabic": "فصول جوجل كلاس روم",
    "az": "Google Sinifləri",
    "chinese": null,
    "eng": "Google Classroom classes",
    "hindi": null,
    "ja": null,
    "jp": "Google クラスルーム クラス",
    "ky": "Google Classroom класстары",
    "ru": "Классы Google Classroom",
    "uz": "Google Sinf darslari",
    "viet": null
  },
  "something-went-wrong":{
    "arabic": "حدث خطأ ما",
    "az": "Nəsə səhv getdi",
    "chinese": "出错了",
    "eng": "Something went wrong",
    "hindi": "कुछ गलत हो गया",
    "ja": "何かがうまくいかなかった",
    "jp": "何かがうまくいかなかった",
    "ky": "Ноодоо ката болду",
    "ru": "Что-то пошло не так",
    "uz": "Nimadir noto'g'ri ketdi",
    "viet": "Đã xảy ra lỗi",    
  },
  "class-code-or-name":{
    "arabic": "رمز الفصل أو الاسم",
    "az": "Sinif kodu və ya adı",
    "chinese": "班级代码或名称",
    "eng": "Class code or name",
    "hindi": "कक्षा कोड या नाम",
    "ja": "クラス コードまたは名前",
    "jp": "クラス コードまたは名前",
    "ky": "Класстын коду же аты",
    "ru": "Код или название класса",
    "uz": "Sinf kodi yoki nomi",
    "viet": "Mã hoặc tên lớp",
  },
  "comparative-report":{
    "arabic": "تقرير مقارن",
    "az": "Müqayisəli hesabat",
    "chinese": "比较报告",
    "eng": "Comparative Report",
    "hindi": "तुलनात्मक रिपोर्ट",
    "ja": "比較レポート",
    "jp": "比較レポート",
    "ky": "Салыштырмалуу отчет",
    "ru": "Сравнительный отчет",
    "uz": "Taqqoslash hisobot",
    "viet": "Báo cáo so sánh",
  },
  "No comparative report available at the moment.":{
    "arabic": "لا يوجد تقرير مقارن متاح في الوقت الحالي.",
    "az": "Hal-hazırda mövcud olan müqayisəli hesabat yoxdur.",
    "chinese": "目前没有可用的比较报告。",
    "eng": "No comparative report available at the moment.",
    "hindi": "इस समय कोई तुलनात्मक रिपोर्ट उपलब्ध नहीं है।",
    "ja": "現在、比較レポートは利用できません。",
    "jp": "現在、比較レポートは利用できません。",
    "ky": "Азырынча салыштырмалуу отчет жок.",
    "ru": "В данный момент нет доступного сравнительного отчета.",
    "uz": "Hozirda mavjud bo'lgan taqqoslash hisobotlari yo'q.",
    "viet": "Hiện tại không có báo cáo so sánh nào khả dụng.",
  },
}